webpackJsonp([273],{

/***/ "++vR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("6oYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_cd27c0d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("tdNm");
function injectStyle (ssrContext) {
  __webpack_require__("NW4G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd27c0d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_cd27c0d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "+1re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalViberService_vue__ = __webpack_require__("iKIY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289994a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalViberService_vue__ = __webpack_require__("qyF3");
function injectStyle (ssrContext) {
  __webpack_require__("1Du3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalViberService_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289994a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalViberService_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+2Vk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+3qH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+BQL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+FAq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+KPY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeDeleteUsers_vue__ = __webpack_require__("/9wG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bff7dc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeDeleteUsers_vue__ = __webpack_require__("xqvE");
function injectStyle (ssrContext) {
  __webpack_require__("DSfs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeDeleteUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bff7dc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeDeleteUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+N1L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Message = __webpack_require__("PFUe");

var _Message2 = _interopRequireDefault(_Message);

var _chatIcon = __webpack_require__("d1QR");

var _chatIcon2 = _interopRequireDefault(_chatIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Message: _Message2.default
  },
  props: {
    participants: {
      type: Array,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    _scrollDown: function _scrollDown() {
      this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
    },
    shouldScrollToBottom: function shouldScrollToBottom() {
      return this.alwaysScrollToBottom || this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - 600;
    },
    profile: function profile(author) {
      var profile = this.participants.find(function (profile) {
        return profile.id === author;
      });

      return profile || { imageUrl: '', name: '' };
    },
    chatImageUrl: function chatImageUrl(author) {
      return this.profile(author).imageUrl;
    },
    authorName: function authorName(author) {
      return this.profile(author).name;
    }
  },
  computed: {
    defaultChatIcon: function defaultChatIcon() {
      return _chatIcon2.default;
    }
  },
  mounted: function mounted() {
    this._scrollDown();
  },
  updated: function updated() {
    if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
  }
};

/***/ }),

/***/ "+PH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-nalaz",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    samples: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    final: {
      type: Boolean,
      default: true
    },
    final_pdf: {
      type: Boolean,
      default: true
    },
    pdf: {
      type: String,
      default: ""
    },
    pacijent: {
      type: String,
      default: ""
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;
      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      var data = {};
      data.samples = this.samples;
      data.pdf = this.pdf;
      data.final = this.final;
      data.final_pdf = this.final_pdf;

      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Nalaz", data);
    },
    onHeaderClick: function onHeaderClick() {
      this.toggle();
      this.accordion.onChildChange(this, this.show);
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "+QO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "change-password",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      password: true,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("ChangePasswordModalHide", function () {
      _this.show = false;
    });
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("ChangePasswordModalHide");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    Password: function Password(event) {
      if (event === "password") {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("_ShowPassword");
        this.password = false;
      } else {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("_HidePassword");
        this.password = true;
      }
    },
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ChangePassword");
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ChangePasswordCancel");
      this.password = true;
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "+S+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Doughnut"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "+SDe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.cancelClass,attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.cancelText))]),_vm._v(" "),(!_vm.okText.includes('!SHOW'))?_c('button',{class:_vm.okClass,attrs:{"type":"button"},on:{"click":_vm.ok}},[_vm._v(" "+_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+UQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["HorizontalBar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "+Uuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__ = __webpack_require__("b6wd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c12f730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__ = __webpack_require__("9dzL");
function injectStyle (ssrContext) {
  __webpack_require__("WPif")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c12f730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+XJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tag',
  data: function data() {
    return {
      deleted: false
    };
  },

  props: {
    name: {
      type: String
    },
    removable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    tagClass: function tagClass() {
      return 'vuestic-tag-' + this.type + ' ' + (this.deleted ? 'vuestic-tag-deleted' : '');
    }
  },
  methods: {
    remove: function remove() {
      var _this = this;

      this.deleted = true;
      setTimeout(function () {
        _this.$emit('remove');
        _this.deleted = false;
      }, 500);
    }
  }
});

/***/ }),

/***/ "+gdQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+hx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-simple-select"},[_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown",value:({ isBlocked: true, onDropdownClose: _vm.onDropdownClose }),expression:"{ isBlocked: true, onDropdownClose: onDropdownClose }"}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle vuestic-simple-select__dropdown-toggle"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],class:{'has-value': !!_vm.value},attrs:{"onpaste":"return false;","autocomplete":"off","name":_vm.name,"options":_vm.options},domProps:{"value":(_vm.displayValue)},on:{"focus":function($event){_vm.showDropdown()},"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-arrow-down icon-right input-icon vuestic-simple-select__dropdown-arrow",on:{"click":_vm.showDropdown}})]),_vm._v(" "),(_vm.isClearable)?_c('div',[_c('i',{staticClass:"fa fa-close icon-cross icon-right input-icon vuestic-simple-select__unselect",on:{"click":_vm.unselectOption}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-menu vuestic-simple-select__dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content vuestic-simple-select__dropdown-menu-content"},_vm._l((_vm.filteredList),function(option,index){return _c('div',{key:index,staticClass:"dropdown-item vuestic-simple-select__dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))])])}))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+jAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalError_vue__ = __webpack_require__("Ynsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22eff08c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalError_vue__ = __webpack_require__("hELG");
function injectStyle (ssrContext) {
  __webpack_require__("FEF4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22eff08c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+mFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-comment-control",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      komentar: "",
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.Comment();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.GetComment();
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    GetComment: function GetComment() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].post("control/comment/get", {
        id: this.$store.state.sid,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        _this.komentar = res.data.komentar;
        _this.show = true;
      });
    },
    Comment: function Comment() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].post("control/comment/set", {
        id: this.$store.state.sid,
        komentar: this.komentar,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        _this2.show = false;
      });
    }
  }
});

/***/ }),

/***/ "+s3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),

/***/ "//tZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/7ZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__ = __webpack_require__("x2GM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6e8368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__ = __webpack_require__("azLP");
function injectStyle (ssrContext) {
  __webpack_require__("HFJv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6e8368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/9IN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-time","config":_vm.config},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range"}},[_vm._v(_vm._s('Datum i vrijeme'))])],1)])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/9wG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$comp;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$comp = {
  name: "postavke-delete-users",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("deleteUsersClose", function () {
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("CollapseAllUsers");
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("deleteUsersClose");
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("okDeleteUser");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$comp);

/***/ }),

/***/ "/AIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical"},[_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('height: ' + _vm.value + '%')})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/D4u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/DkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPartneriEdit_vue__ = __webpack_require__("54Af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4a6226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPartneriEdit_vue__ = __webpack_require__("KqAn");
function injectStyle (ssrContext) {
  __webpack_require__("G1fw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPartneriEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4a6226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPartneriEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/L/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "anaassay-edit-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("AnaAssayHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("AnaAssayHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("AnaAssayEdit");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("AnaAssayCancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "/LRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("vE+0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f1bf766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("pvi4");
function injectStyle (ssrContext) {
  __webpack_require__("yrBt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f1bf766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/QL9":
/***/ (function(module, exports) {

module.exports = [{"x":0,"y":0},{"x":8,"y":12},{"x":16,"y":24},{"x":24,"y":36},{"x":32,"y":48},{"x":40,"y":60},{"x":48,"y":72},{"x":60,"y":84},{"x":72,"y":72},{"x":80,"y":60},{"x":88,"y":48},{"x":96,"y":36},{"x":104,"y":24},{"x":112,"y":12},{"x":120,"y":0},{"x":104,"y":0},{"x":88,"y":0},{"x":80,"y":12},{"x":72,"y":24},{"x":60,"y":36},{"x":48,"y":24},{"x":40,"y":10},{"x":32,"y":0},{"x":16,"y":0}]

/***/ }),

/***/ "/RS4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/dqC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/fv5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/lWu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "093r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__ = __webpack_require__("dbim");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c44ec1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__ = __webpack_require__("p4Q/");
function injectStyle (ssrContext) {
  __webpack_require__("FnFL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c44ec1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0CkR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.password),expression:"password"}],staticClass:"fa fa-eye icon-right input-icon",staticStyle:{"color":"#4ae387"},on:{"click":function($event){$event.preventDefault();_vm.Password('password')}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.password),expression:"!password"}],staticClass:"fa fa-eye-slash icon-right input-icon",staticStyle:{"color":"#e34a4a"},on:{"click":function($event){$event.preventDefault();_vm.Password('!password')}}})])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0F0B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0GMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("kT3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_651eb6b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("ZzBL");
function injectStyle (ssrContext) {
  __webpack_require__("+gdQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-651eb6b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_651eb6b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0GQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticStyle:{"color":"#acb5be"}},[_vm._v("\n                  "+_vm._s(_vm.range)+"\n                ")]),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0H+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "labassay-delete",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("LabAssayHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("LabAssayHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("LabAssayDelete");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "0Hy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 200,
    'per_page': 50,
    'current_page': 1,
    'last_page': 4,
    'next_page_url': 'https://vuetable.ratiw.net/api/users?per_page=50&page=2',
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }, {
    'id': 2,
    'name': 'Mr. Enid Von PhD',
    'nickname': 'alias',
    'email': 'pollich.cecilia@example.com',
    'birthdate': '1990-09-18 00:00:00',
    'gender': 'M',
    'salary': '35978.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 2,
      'user_id': 2,
      'line1': '59732 Iva Spur Suite 468\nEast Hortenseton, VA 70087',
      'line2': 'Cayman Islands',
      'zipcode': '41967',
      'mobile': '1-913-407-7558x503',
      'fax': '(388)906-8002'
    }
  }, {
    'id': 3,
    'name': 'Colton Koch',
    'nickname': 'id',
    'email': 'little.myrna@example.net',
    'birthdate': '1968-10-29 00:00:00',
    'gender': 'F',
    'salary': '26278.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 3,
      'user_id': 3,
      'line1': '539 Conn Locks Suite 801\nTobinfort, IL 37047-5508',
      'line2': 'Antigua and Barbuda',
      'zipcode': '51722-4502',
      'mobile': '557.845.1830x844',
      'fax': '1-831-304-7444x73027'
    }
  }, {
    'id': 4,
    'name': 'Gregory Vandervort',
    'nickname': 'vel',
    'email': 'dock47@example.org',
    'birthdate': '1989-12-12 00:00:00',
    'gender': 'M',
    'salary': '25537.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 4,
      'user_id': 4,
      'line1': '916 Rosemary Forge\nKreigerton, MT 24207',
      'line2': 'Uganda',
      'zipcode': '67639-6707',
      'mobile': '766.431.9121',
      'fax': '(154)336-3674x08451'
    }
  }, {
    'id': 5,
    'name': 'Miss Rahsaan Heaney IV',
    'nickname': 'qui',
    'email': 'ugrady@example.org',
    'birthdate': '1995-11-27 00:00:00',
    'gender': 'F',
    'salary': '49003.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 21,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 5,
      'user_id': 5,
      'line1': '91792 Kertzmann Prairie Apt. 376\nLake Nakiaville, DC 98189',
      'line2': 'Jamaica',
      'zipcode': '10101-1450',
      'mobile': '07507519787',
      'fax': '+24(9)5120507985'
    }
  }, {
    'id': 6,
    'name': 'Ms. Crystel Zemlak IV',
    'nickname': 'reiciendis',
    'email': 'amari.rau@example.com',
    'birthdate': '1968-09-12 00:00:00',
    'gender': 'F',
    'salary': '12383.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 6,
      'user_id': 6,
      'line1': '97650 Scot Haven Apt. 160\nCrawfordmouth, ME 39767-7003',
      'line2': 'Finland',
      'zipcode': '88917',
      'mobile': '1-851-069-9234x9566',
      'fax': '(048)445-4691x33356'
    }
  }, {
    'id': 7,
    'name': 'Nona McDermott',
    'nickname': 'quaerat',
    'email': 'adrien.baumbach@example.org',
    'birthdate': '1985-10-01 00:00:00',
    'gender': 'F',
    'salary': '18512.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 31,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 7,
      'user_id': 7,
      'line1': '4332 Alvina Radial\nPort Darbyville, IA 63357',
      'line2': 'Barbados',
      'zipcode': '79679',
      'mobile': '(736)058-1324',
      'fax': '002.234.8466x49816'
    }
  }, {
    'id': 8,
    'name': 'Miss Genoveva Murazik V',
    'nickname': 'rerum',
    'email': 'ohettinger@example.net',
    'birthdate': '1988-10-19 00:00:00',
    'gender': 'F',
    'salary': '31209.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 28,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 8,
      'user_id': 8,
      'line1': '96418 Ritchie Mall Apt. 215\nLake Jessyca, VT 65970-8256',
      'line2': 'Netherlands Antilles',
      'zipcode': '94649-6628',
      'mobile': '472.825.7183',
      'fax': '400-507-7463'
    }
  }, {
    'id': 9,
    'name': 'Beulah Huels',
    'nickname': 'non',
    'email': 'stefan99@example.com',
    'birthdate': '1963-09-04 00:00:00',
    'gender': 'F',
    'salary': '36920.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 9,
      'user_id': 9,
      'line1': '18890 Carroll Lakes Suite 355\nUptonchester, UT 94878-0739',
      'line2': 'Hong Kong',
      'zipcode': '91204',
      'mobile': '831.652.0832',
      'fax': '(688)788-8947'
    }
  }, {
    'id': 10,
    'name': 'Zoe Klein',
    'nickname': 'ex',
    'email': 'ejacobson@example.org',
    'birthdate': '1990-04-19 00:00:00',
    'gender': 'F',
    'salary': '35616.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 10,
      'user_id': 10,
      'line1': '6721 Nader Summit\nLake Alana, MS 84476',
      'line2': 'Reunion',
      'zipcode': '77124-1459',
      'mobile': '1-129-438-6148',
      'fax': '(913)441-3846'
    }
  }, {
    'id': 11,
    'name': 'Vickie Kiehn',
    'nickname': 'assumenda',
    'email': 'ayost@example.com',
    'birthdate': '1988-04-20 00:00:00',
    'gender': 'F',
    'salary': '30790.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 11,
      'user_id': 11,
      'line1': '763 McCullough Ville\nNew Thomasstad, HI 64611',
      'line2': 'Oman',
      'zipcode': '00642',
      'mobile': '1-296-172-2126x275',
      'fax': '(559)203-8694'
    }
  }, {
    'id': 12,
    'name': 'Elwyn Herzog',
    'nickname': 'praesentium',
    'email': 'ckassulke@example.net',
    'birthdate': '1990-01-22 00:00:00',
    'gender': 'M',
    'salary': '35785.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 12,
      'user_id': 12,
      'line1': '65641 Baron Spurs Suite 988\nNorth Ivah, IA 92235',
      'line2': 'Nepal',
      'zipcode': '90316-7411',
      'mobile': '064.482.9432x9456',
      'fax': '05936098280'
    }
  }, {
    'id': 13,
    'name': 'Selena Hettinger',
    'nickname': 'et',
    'email': 'bashirian.hyman@example.net',
    'birthdate': '1981-10-01 00:00:00',
    'gender': 'F',
    'salary': '31836.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 13,
      'user_id': 13,
      'line1': '42272 Stoltenberg Points Suite 006\nLake Dustin, NH 70213-2043',
      'line2': 'Uganda',
      'zipcode': '60996-2982',
      'mobile': '(508)122-5892',
      'fax': '356-682-2023x07379'
    }
  }, {
    'id': 14,
    'name': 'Edwin Beier',
    'nickname': 'eos',
    'email': 'janis71@example.org',
    'birthdate': '1978-10-13 00:00:00',
    'gender': 'M',
    'salary': '11902.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 14,
      'user_id': 14,
      'line1': '362 Trantow Loop Apt. 150\nLake Marafurt, DC 27926',
      'line2': 'Gabon',
      'zipcode': '36943-1099',
      'mobile': '033-386-4972x26066',
      'fax': '1-363-037-1381'
    }
  }, {
    'id': 15,
    'name': 'Lexi Braun MD',
    'nickname': 'autem',
    'email': 'dusty74@example.net',
    'birthdate': '1971-12-07 00:00:00',
    'gender': 'F',
    'salary': '11927.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 45,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 15,
      'user_id': 15,
      'line1': '6737 Schimmel Crossing Suite 720\nShieldsberg, AK 44558',
      'line2': 'Tanzania',
      'zipcode': '75615',
      'mobile': '338.920.3112',
      'fax': '(467)912-6668'
    }
  }, {
    'id': 16,
    'name': 'Jovany Spencer',
    'nickname': 'fugit',
    'email': 'gbogisich@example.org',
    'birthdate': '1974-04-23 00:00:00',
    'gender': 'F',
    'salary': '44686.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 16,
      'user_id': 16,
      'line1': '97237 Emory Mission\nWelchview, DE 65827-8746',
      'line2': 'Turkmenistan',
      'zipcode': '17948',
      'mobile': '(163)991-1609x963',
      'fax': '104.893.7648'
    }
  }, {
    'id': 17,
    'name': 'Prof. Maci Anderson DVM',
    'nickname': 'dolorem',
    'email': 'btorp@example.com',
    'birthdate': '1988-03-30 00:00:00',
    'gender': 'M',
    'salary': '25055.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 17,
      'user_id': 17,
      'line1': '7584 Lucinda Mill\nNew Kaitlyn, WV 63380-4289',
      'line2': 'Gibraltar',
      'zipcode': '51150-2800',
      'mobile': '(977)115-7349',
      'fax': '652-788-4860x1180'
    }
  }, {
    'id': 18,
    'name': 'Joel Kulas MD',
    'nickname': 'sed',
    'email': 'phoebe.sauer@example.org',
    'birthdate': '1992-10-26 00:00:00',
    'gender': 'F',
    'salary': '11650.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 18,
      'user_id': 18,
      'line1': '992 Williamson Passage Apt. 910\nBradleyborough, MO 93100-9439',
      'line2': 'Cambodia',
      'zipcode': '20591-3066',
      'mobile': '+64(7)3402369877',
      'fax': '08960801902'
    }
  }, {
    'id': 19,
    'name': 'Mr. Dawson Greenholt',
    'nickname': 'nostrum',
    'email': 'asawayn@example.org',
    'birthdate': '1963-08-23 00:00:00',
    'gender': 'F',
    'salary': '46962.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 19,
      'user_id': 19,
      'line1': '8444 Abraham Isle\nEast Chaunceychester, HI 78625-4417',
      'line2': 'Qatar',
      'zipcode': '47870-8012',
      'mobile': '797-274-3187x45557',
      'fax': '(461)432-8205'
    }
  }, {
    'id': 20,
    'name': 'Prof. Lloyd Green',
    'nickname': 'velit',
    'email': 'laila.hintz@example.org',
    'birthdate': '1970-10-31 00:00:00',
    'gender': 'M',
    'salary': '12928.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 20,
      'user_id': 20,
      'line1': '89766 O\'Connell Falls\nSouth Kadenshire, NJ 78754-6650',
      'line2': 'Nigeria',
      'zipcode': '37859',
      'mobile': '1-457-536-1138',
      'fax': '+98(5)0101745942'
    }
  }, {
    'id': 21,
    'name': 'Shayna Morar',
    'nickname': 'rerum',
    'email': 'wfay@example.org',
    'birthdate': '1991-01-24 00:00:00',
    'gender': 'F',
    'salary': '22638.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 21,
      'user_id': 21,
      'line1': '6066 Weissnat Run Apt. 578\nMurazikmouth, SD 62877-3174',
      'line2': 'Brunei Darussalam',
      'zipcode': '69261',
      'mobile': '(487)423-0151x5127',
      'fax': '784-058-9197'
    }
  }, {
    'id': 22,
    'name': 'Krista Schulist',
    'nickname': 'qui',
    'email': 'gregoria.jakubowski@example.com',
    'birthdate': '1974-08-16 00:00:00',
    'gender': 'F',
    'salary': '49345.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 22,
      'user_id': 22,
      'line1': '331 Gerlach Course Suite 090\nKovacekchester, RI 18017',
      'line2': 'Sri Lanka',
      'zipcode': '37165',
      'mobile': '653-487-3061x91119',
      'fax': '370-709-1750'
    }
  }, {
    'id': 23,
    'name': 'Leone Lemke',
    'nickname': 'repellat',
    'email': 'ltorphy@example.com',
    'birthdate': '1975-06-27 00:00:00',
    'gender': 'M',
    'salary': '17560.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 23,
      'user_id': 23,
      'line1': '4371 Ward Village Suite 848\nLake Madalynton, IN 44643',
      'line2': 'Ukraine',
      'zipcode': '71848',
      'mobile': '174-502-0881x50649',
      'fax': '02683328099'
    }
  }, {
    'id': 24,
    'name': 'Dr. Willie Kemmer II',
    'nickname': 'quasi',
    'email': 'ivy51@example.net',
    'birthdate': '1987-04-06 00:00:00',
    'gender': 'F',
    'salary': '35370.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 30,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 24,
      'user_id': 24,
      'line1': '235 Hassie Mountain\nAnikaborough, ID 20678-4354',
      'line2': 'Thailand',
      'zipcode': '94264-9132',
      'mobile': '624.042.8382x12243',
      'fax': '274.716.7226x171'
    }
  }, {
    'id': 25,
    'name': 'Deonte Lebsack',
    'nickname': 'nesciunt',
    'email': 'alisa83@example.net',
    'birthdate': '1993-01-26 00:00:00',
    'gender': 'M',
    'salary': '32725.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 25,
      'user_id': 25,
      'line1': '793 Lakin Haven\nLake Citlalliborough, DE 85031-4862',
      'line2': 'Chad',
      'zipcode': '52396-8822',
      'mobile': '(950)170-8013',
      'fax': '119.675.5485x79062'
    }
  }, {
    'id': 26,
    'name': 'Prof. Shayne Nader',
    'nickname': 'voluptas',
    'email': 'bosco.shaina@example.net',
    'birthdate': '1993-10-26 00:00:00',
    'gender': 'F',
    'salary': '9844.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 23,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 26,
      'user_id': 26,
      'line1': '0330 Smith Mountains\nLorinetown, NY 96547-9723',
      'line2': 'Syrian Arab Republic',
      'zipcode': '85415',
      'mobile': '1-212-704-6685',
      'fax': '516-893-8515'
    }
  }, {
    'id': 27,
    'name': 'Prof. Kennith Kertzmann',
    'nickname': 'alias',
    'email': 'satterfield.jonathan@example.com',
    'birthdate': '1992-01-31 00:00:00',
    'gender': 'F',
    'salary': '41950.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 27,
      'user_id': 27,
      'line1': '901 Hauck Extensions\nKeaganborough, VA 47392',
      'line2': 'Comoros',
      'zipcode': '54147-7615',
      'mobile': '1-274-179-2031x915',
      'fax': '867-583-0812x6728'
    }
  }, {
    'id': 28,
    'name': 'Miss Meagan O\'Keefe',
    'nickname': 'corporis',
    'email': 'tracy.barrows@example.com',
    'birthdate': '1967-05-04 00:00:00',
    'gender': 'M',
    'salary': '41803.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 28,
      'user_id': 28,
      'line1': '29077 Avis Isle Apt. 208\nGrahamberg, MI 62485-6694',
      'line2': 'Cocos (Keeling) Islands',
      'zipcode': '56090-7671',
      'mobile': '(718)856-9319x55184',
      'fax': '(777)055-4685x56167'
    }
  }, {
    'id': 29,
    'name': 'Prof. Edward Pagac MD',
    'nickname': 'quia',
    'email': 'gerhard65@example.org',
    'birthdate': '1973-09-22 00:00:00',
    'gender': 'F',
    'salary': '22896.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 29,
      'user_id': 29,
      'line1': '697 Crona Mall\nPeteville, WA 54497',
      'line2': 'Saudi Arabia',
      'zipcode': '07560-8569',
      'mobile': '788-579-8208',
      'fax': '041-521-9215'
    }
  }, {
    'id': 30,
    'name': 'Samantha Weissnat',
    'nickname': 'est',
    'email': 'crystel66@example.net',
    'birthdate': '1974-07-11 00:00:00',
    'gender': 'M',
    'salary': '18805.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 30,
      'user_id': 30,
      'line1': '79984 Deckow Run\nEast Victoria, UT 33736',
      'line2': 'Lithuania',
      'zipcode': '95964-8864',
      'mobile': '681.200.3099',
      'fax': '(567)652-4322x61475'
    }
  }, {
    'id': 31,
    'name': 'Dr. Gilbert Ward',
    'nickname': 'dolorum',
    'email': 'sandrine06@example.net',
    'birthdate': '1984-08-22 00:00:00',
    'gender': 'F',
    'salary': '16644.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 32,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 31,
      'user_id': 31,
      'line1': '996 Schuppe Glen\nTurcottetown, ID 40821-7190',
      'line2': 'Thailand',
      'zipcode': '09965-7576',
      'mobile': '1-938-263-0257x47178',
      'fax': '1-997-727-3198x4363'
    }
  }, {
    'id': 32,
    'name': 'Mike West',
    'nickname': 'laudantium',
    'email': 'jborer@example.net',
    'birthdate': '1974-11-07 00:00:00',
    'gender': 'M',
    'salary': '35728.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 32,
      'user_id': 32,
      'line1': '69942 Leannon Glen\nEast Mathilde, IL 89584-5633',
      'line2': 'Afghanistan',
      'zipcode': '02041-8706',
      'mobile': '(506)349-9443x7244',
      'fax': '1-357-689-8479x3729'
    }
  }, {
    'id': 33,
    'name': 'Prof. Isabell Cruickshank I',
    'nickname': 'recusandae',
    'email': 'ondricka.lurline@example.org',
    'birthdate': '1982-06-15 00:00:00',
    'gender': 'F',
    'salary': '44574.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 33,
      'user_id': 33,
      'line1': '875 Logan Summit Suite 033\nJerodport, NY 45166',
      'line2': 'Kiribati',
      'zipcode': '64763',
      'mobile': '1-548-943-8405x460',
      'fax': '+88(4)9493664736'
    }
  }, {
    'id': 34,
    'name': 'Prof. Lonny Rath',
    'nickname': 'nihil',
    'email': 'rfeest@example.net',
    'birthdate': '1969-04-23 00:00:00',
    'gender': 'F',
    'salary': '19949.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 34,
      'user_id': 34,
      'line1': '43006 Gaylord Drives\nCummerataville, MA 14032-6378',
      'line2': 'Georgia',
      'zipcode': '88459',
      'mobile': '(877)526-6771',
      'fax': '(724)630-5418'
    }
  }, {
    'id': 35,
    'name': 'Santina Medhurst MD',
    'nickname': 'suscipit',
    'email': 'ila24@example.net',
    'birthdate': '1965-11-04 00:00:00',
    'gender': 'F',
    'salary': '36323.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 51,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 35,
      'user_id': 35,
      'line1': '47345 Imelda Mission Suite 257\nAllyshire, IA 85430-2783',
      'line2': 'Gambia',
      'zipcode': '26853',
      'mobile': '(441)229-8922',
      'fax': '(789)908-0620x15912'
    }
  }, {
    'id': 36,
    'name': 'Jeff Lehner',
    'nickname': 'quo',
    'email': 'jarred77@example.com',
    'birthdate': '1975-05-18 00:00:00',
    'gender': 'F',
    'salary': '48462.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 36,
      'user_id': 36,
      'line1': '49133 Tremaine Cape Suite 189\nQuitzonview, SC 07967-6920',
      'line2': 'Serbia',
      'zipcode': '96642',
      'mobile': '313.254.8635x06428',
      'fax': '194.681.7297x74202'
    }
  }, {
    'id': 37,
    'name': 'Samanta Pfeffer',
    'nickname': 'officia',
    'email': 'fgoyette@example.net',
    'birthdate': '1974-08-27 00:00:00',
    'gender': 'F',
    'salary': '19601.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 37,
      'user_id': 37,
      'line1': '1313 Verdie Square\nNorth Giovanna, MI 27962',
      'line2': 'Guyana',
      'zipcode': '77776',
      'mobile': '(321)705-8910',
      'fax': '(392)460-5663x665'
    }
  }, {
    'id': 38,
    'name': 'Ofelia Torp',
    'nickname': 'a',
    'email': 'ericka44@example.net',
    'birthdate': '1981-09-01 00:00:00',
    'gender': 'M',
    'salary': '33149.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 38,
      'user_id': 38,
      'line1': '45335 Albina View\nCharlottefort, AK 57789',
      'line2': 'Afghanistan',
      'zipcode': '54947-9310',
      'mobile': '09097085723',
      'fax': '1-567-446-3094'
    }
  }, {
    'id': 39,
    'name': 'Mrs. Margarete Raynor',
    'nickname': 'quia',
    'email': 'jlegros@example.net',
    'birthdate': '1977-03-12 00:00:00',
    'gender': 'M',
    'salary': '21951.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 40,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 39,
      'user_id': 39,
      'line1': '288 Hamill Knolls\nMaximoburgh, NC 50971',
      'line2': 'Zimbabwe',
      'zipcode': '00474',
      'mobile': '1-165-445-8956x699',
      'fax': '164-395-7526x1304'
    }
  }, {
    'id': 40,
    'name': 'Mr. Brant Howell V',
    'nickname': 'perspiciatis',
    'email': 'franecki.gerald@example.org',
    'birthdate': '1964-03-01 00:00:00',
    'gender': 'M',
    'salary': '41552.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 40,
      'user_id': 40,
      'line1': '3411 Deckow Crossing\nVernonport, MI 32272-8542',
      'line2': 'Bolivia',
      'zipcode': '00960',
      'mobile': '(998)729-9537',
      'fax': '(606)461-9736'
    }
  }, {
    'id': 41,
    'name': 'Reilly Ruecker DVM',
    'nickname': 'ad',
    'email': 'ldeckow@example.net',
    'birthdate': '1975-07-17 00:00:00',
    'gender': 'M',
    'salary': '22709.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 41,
      'user_id': 41,
      'line1': '39181 Runolfsson Pines Apt. 102\nCedrickchester, MD 73430-4755',
      'line2': 'Haiti',
      'zipcode': '08208-7956',
      'mobile': '625-483-9111x773',
      'fax': '196-367-9338'
    }
  }, {
    'id': 42,
    'name': 'Zachery McDermott',
    'nickname': 'molestiae',
    'email': 'gladyce84@example.com',
    'birthdate': '1992-04-17 00:00:00',
    'gender': 'F',
    'salary': '32354.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 42,
      'user_id': 42,
      'line1': '18735 Quigley Springs\nCarterview, NE 29126-7625',
      'line2': 'Chad',
      'zipcode': '61676-5075',
      'mobile': '172.676.4844x42744',
      'fax': '129.383.7365x233'
    }
  }, {
    'id': 43,
    'name': 'Heloise Kulas',
    'nickname': 'aut',
    'email': 'kessler.helen@example.net',
    'birthdate': '1962-12-11 00:00:00',
    'gender': 'M',
    'salary': '45086.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 54,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 43,
      'user_id': 43,
      'line1': '38208 Dolores Turnpike Apt. 887\nWintheiserton, FL 72054-2578',
      'line2': 'Lithuania',
      'zipcode': '51634-6449',
      'mobile': '1-161-626-3235x57765',
      'fax': '360-278-9045x9316'
    }
  }, {
    'id': 44,
    'name': 'Norma Dibbert',
    'nickname': 'amet',
    'email': 'eudora36@example.net',
    'birthdate': '1971-01-21 00:00:00',
    'gender': 'F',
    'salary': '15661.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 44,
      'user_id': 44,
      'line1': '15405 Haag Haven Suite 047\nBrakusland, WV 81778',
      'line2': 'British Virgin Islands',
      'zipcode': '56087-0885',
      'mobile': '08227730599',
      'fax': '1-079-566-2337x670'
    }
  }, {
    'id': 45,
    'name': 'Immanuel Auer',
    'nickname': 'quia',
    'email': 'halvorson.theodora@example.org',
    'birthdate': '1978-06-06 00:00:00',
    'gender': 'M',
    'salary': '15862.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 45,
      'user_id': 45,
      'line1': '59888 Dare Ridge\nSouth Annamaeton, CA 94659',
      'line2': 'Mexico',
      'zipcode': '56689-3824',
      'mobile': '523.579.8757x9825',
      'fax': '688.695.5156x073'
    }
  }, {
    'id': 46,
    'name': 'Lamont Borer',
    'nickname': 'expedita',
    'email': 'trantow.neoma@example.com',
    'birthdate': '1992-06-26 00:00:00',
    'gender': 'M',
    'salary': '12544.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 46,
      'user_id': 46,
      'line1': '974 Brannon Circle Suite 674\nSchroedermouth, NM 66911',
      'line2': 'Malawi',
      'zipcode': '74027',
      'mobile': '887.196.2530x875',
      'fax': '220.398.6969'
    }
  }, {
    'id': 47,
    'name': 'Brooke Purdy',
    'nickname': 'cupiditate',
    'email': 'bhermiston@example.net',
    'birthdate': '1966-11-19 00:00:00',
    'gender': 'M',
    'salary': '14457.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 47,
      'user_id': 47,
      'line1': '916 Durgan Harbor\nWest Tonyborough, MN 08368',
      'line2': 'Serbia',
      'zipcode': '25234',
      'mobile': '(821)777-8137x4048',
      'fax': '(398)917-7496x84537'
    }
  }, {
    'id': 48,
    'name': 'Dr. Leo Dach',
    'nickname': 'et',
    'email': 'camila.ward@example.com',
    'birthdate': '1968-01-11 00:00:00',
    'gender': 'F',
    'salary': '40278.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 49,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 48,
      'user_id': 48,
      'line1': '434 Dariana Terrace\nSouth Brettbury, NC 66080-2445',
      'line2': 'Latvia',
      'zipcode': '81749-2523',
      'mobile': '1-988-628-9566x4627',
      'fax': '916.932.2071x569'
    }
  }, {
    'id': 49,
    'name': 'Krystal Langosh',
    'nickname': 'voluptatum',
    'email': 'pacocha.yesenia@example.org',
    'birthdate': '1983-02-18 00:00:00',
    'gender': 'M',
    'salary': '9305.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 49,
      'user_id': 49,
      'line1': '012 Josiane Flats Suite 650\nKatelynntown, MD 70053',
      'line2': 'Rwanda',
      'zipcode': '75946-8166',
      'mobile': '(556)620-0323x81232',
      'fax': '1-466-040-3197x6274'
    }
  }, {
    'id': 50,
    'name': 'Florence Greenfelder',
    'nickname': 'odit',
    'email': 'kenyatta.oconnell@example.com',
    'birthdate': '1978-08-20 00:00:00',
    'gender': 'F',
    'salary': '36980.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 50,
      'user_id': 50,
      'line1': '295 Donna Plaza Apt. 186\nHintzview, GA 44706',
      'line2': 'Greenland',
      'zipcode': '03127',
      'mobile': '1-044-098-3635x9446',
      'fax': '1-753-472-6796'
    }
  }]
});

/***/ }),

/***/ "0Ohc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiPicker = __webpack_require__("ThK4");

var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiPicker: _EmojiPicker2.default
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  props: {
    onEmojiPicked: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    _openPicker: function _openPicker(e) {
      this.isActive = !this.isActive;
    },
    _handlePickerBlur: function _handlePickerBlur() {
      this.isActive = false;
    }
  }
};

/***/ }),

/***/ "0QRF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0okC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-primary' : _vm.analyser.selected, 
      'vuestic-collapse__header__button btn btn-secondary' : !_vm.analyser.selected},staticStyle:{"text-transform":"none"}},[_vm._t("header")],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0us4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0vre":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{ 'vuestic-collapse__header--no-header': _vm.noHeader },on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{
        'vuestic-collapse__header__button btn btn-primary':
          _vm.sample.status === 'ODOBREN' || _vm.sample.status === 'VERIFICIRAN',
        'vuestic-collapse__header__button btn btn-warning':
          _vm.sample.status === 'U OBRADI',
        'vuestic-collapse__header__button btn btn-danger':
          _vm.sample.status === 'ZAPRIMLJEN',
        'vuestic-collapse__header__button btn btn-info':
          _vm.sample.status === 'REALIZOVAN',
      },staticStyle:{"text-transform":"none"}},[_vm._t("header"),_vm._v("\n\n      "+_vm._s(" |")+"\n      "),(
          _vm.sample.status === 'VERIFICIRAN' &&
          !_vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px","color":"#f7cc36"},attrs:{"id":_vm.id}},[_c('span',{staticClass:"glyphicon glyphicon-object-align-bottom"}),_vm._v("\n\n        "+_vm._s(_vm.aparat.ime)+"\n        "),(false)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(
          _vm.sample.status != 'VERIFICIRAN' &&
          !_vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px"},attrs:{"id":_vm.id}},[_c('span',{staticClass:"glyphicon glyphicon-object-align-bottom"}),_vm._v("\n        "+_vm._s(_vm.aparat.ime)+"\n      ")]):_vm._e(),_vm._v(" "),(
          _vm.sample.status === 'VERIFICIRAN' &&
          _vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px","color":"#f7cc36"},attrs:{"id":_vm.id}},[_vm._v("\n        "+_vm._s(" | ")+_vm._s(_vm.sample.tip.match(/\(([^)]+)\)/)[1])+"\n        "),(false)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(
          _vm.sample.status != 'VERIFICIRAN' &&
          _vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px"},attrs:{"id":_vm.id}},[_vm._v(_vm._s(" | ")+_vm._s(_vm.sample.tip.match(/\(([^)]+)\)/)[1]))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-7 pull-right",staticStyle:{"margin-right":"20px"},attrs:{"id":"block"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            !_vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            !expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-forward fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"forward","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status === 'ZAPRIMLJEN'),expression:"show && expanded && sample.status === 'ZAPRIMLJEN'"}]},[_c('i',{staticClass:"fa fa-trash fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"trash","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status === 'ZAPRIMLJEN'),expression:"show && expanded && sample.status === 'ZAPRIMLJEN'"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-commenting fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"comment","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-barcode fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"barcode","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-step-backward fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"backward","title":""}})]),_vm._v(" "),(
            _vm.show &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          )?_c('span',[_c('i',{staticClass:"fa fa-check fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"check","title":""}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status === 'VERIFICIRAN' && _vm.sample.pdf_exists)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"pdf","ttitle":""}})]):_vm._e(),_vm._v(" "),(!_vm.show && _vm.sample.status === 'VERIFICIRAN' && _vm.sample.pdf_exists)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#f7cc36"},attrs:{"id":"pdf","title":""}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status === 'VERIFICIRAN' && !_vm.sample.pdf_exists)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#e34a4a"},attrs:{"id":"pdf","title":""}})]):_vm._e(),_vm._v(" "),(
            !_vm.show && _vm.sample.status === 'VERIFICIRAN' && !_vm.sample.pdf_exists
          )?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#e34a4a"},attrs:{"id":"pdf","title":""}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"col-md-3 pull-right",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),(_vm.show && _vm.sample.status === 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-lock fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"22px"},attrs:{"id":"unlock","title":""}})]):_vm._e(),_vm._v(" "),(!_vm.show && _vm.sample.status === 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-lock fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"22px","color":"#f7cc36"},attrs:{"id":"unlock","title":""}})]):_vm._e(),_vm._v(" "),(
            _vm.show &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN' &&
            !_vm.retest
          )?_c('span',[_c('i',{staticClass:"fa fa-save fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"save","title":""}})]):_vm._e(),_vm._v(" "),(
            _vm.show &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN' &&
            _vm.retest
          )?_c('span',[_c('i',{staticClass:"fa fa-refresh fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"retest","title":""}})]):_vm._e()])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "13SH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1893":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'square-with-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "1Du3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1GIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseNalaz_vue__ = __webpack_require__("+PH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008455c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseNalaz_vue__ = __webpack_require__("vY2X");
function injectStyle (ssrContext) {
  __webpack_require__("0F0B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseNalaz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008455c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseNalaz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1HAW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1It+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"orientation-handler",rawName:"v-orientation-handler",value:({ layout: _vm.wizardLayout,  breakPoint: _vm.orientationBreakPoint }),expression:"{ layout: wizardLayout,  breakPoint: orientationBreakPoint }"}],staticClass:"wizard",class:_vm.computedLayout},[(_vm.computedLayout === 'horizontal')?_c('div',{staticClass:"indicator-container indicator-container-horizontal"},[(_vm.wizardType === 'simple')?_c('simple-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'rich')?_c('rich-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.computedLayout === 'vertical')?_c('div',{staticClass:"indicator-container indicator-container-vertical"},[(_vm.wizardType === 'rich')?_c('rich-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'simple')?_c('simple-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wizard-body"},[_vm._l((_vm.steps),function(step){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isStepShown(step)),expression:"isStepShown(step)"}],key:step,staticClass:"wizard-body-step"},[_vm._t(step.slot)],2)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.wizardCompleted),expression:"wizardCompleted"}],staticClass:"wizard-body-step"},[_vm._t(_vm.wizardCompletedSlotName)],2),_vm._v(" "),(!_vm.wizardCompleted)?_c('div',{staticClass:"wizard-body-actions"},[(_vm.backEnabled)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-secondary wizard-back pull-left",on:{"click":function($event){_vm.goBack()}}},[_vm._v("\n          Back\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.isLastStep())?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right",on:{"click":function($event){_vm.goNext()}}},[_vm._v("\n          Next\n        ")])]):_vm._e(),_vm._v(" "),(_vm.currentStep == _vm.steps.length - 1)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right final-step",on:{"click":function($event){_vm.completeWizard()}}},[_vm._v("\n          "+_vm._s(_vm.lastStepLabel)+"\n        ")])]):_vm._e()]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1N8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"vuestic-tooltip-target"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1S2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"popover-class":_vm.popoverClass,"open":_vm.open,"disabled":_vm.disabled,"placement":_vm.placement,"auto-hide":_vm.autoHide}},[_vm._t("trigger"),_vm._v(" "),_c('template',{attrs:{"slot":"popover"},slot:"popover"},[(_vm.isIconPresent)?_c('div',{staticClass:"popover-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popover-content"},[_c('div',{staticClass:"popover-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"popover-body"},[_vm._t("body")],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1ZnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal-m',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'POTVRDI'
    },
    cancelText: {
      type: String,
      default: 'ODUSTANI'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary'
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    ok: function ok() {
      this.$emit('ok');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yes', true);
      this.show = false;
    },
    cancel: function cancel() {
      this.$emit('cancel');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('no', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseNo', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseKo', false);
      this.show = false;
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
    }
  }
});

/***/ }),

/***/ "1Zso":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1dsE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload",class:("vuestic-file-upload-" + _vm.type)},[(_vm.type === 'list')?_vm._l((_vm.filesList),function(file,index){return _c('vuestic-file-upload-list-item',{key:file.name,attrs:{"file":file},on:{"remove":function($event){_vm.$emit('remove', index)}}})}):_vm._e(),_vm._v(" "),(_vm.type === 'gallery')?[_c('div',{staticClass:"row"},_vm._l((_vm.filesList),function(file,index){return _c('div',{key:file.name,staticClass:"flex xl2 lg3 sm4"},[_c('vuestic-file-upload-gallery-item',{attrs:{"file":file},on:{"remove":function($event){_vm.$emit('remove', index)}}})],1)}))]:_vm._e(),_vm._v(" "),(_vm.type === 'single' && _vm.filesList.length)?_c('vuestic-file-upload-single-item',{attrs:{"file":_vm.filesList[_vm.filesList.length - 1]},on:{"remove":function($event){_vm.$emit('remove-single')}}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1k1c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1q7j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiIcon = __webpack_require__("kEJf");

var _EmojiIcon2 = _interopRequireDefault(_EmojiIcon);

var _FileIcons = __webpack_require__("aCP/");

var _FileIcons2 = _interopRequireDefault(_FileIcons);

var _SendIcon = __webpack_require__("7cnT");

var _SendIcon2 = _interopRequireDefault(_SendIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiIcon: _EmojiIcon2.default,
    FileIcons: _FileIcons2.default,
    SendIcon: _SendIcon2.default
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    showFile: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    onSubmit: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Write a reply'
    },
    colors: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      file: null,
      inputActive: false
    };
  },

  methods: {
    cancelFile: function cancelFile() {
      this.file = null;
    },
    setInputActive: function setInputActive(onoff) {
      this.inputActive = onoff;
    },
    handleKey: function handleKey(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        this._submitText(event);
        event.preventDefault();
      }
    },
    _submitText: function _submitText(event) {
      var text = this.$refs.userInput.textContent;
      var file = this.file;
      if (file) {
        if (text && text.length > 0) {
          this.onSubmit({
            author: 'me',
            type: 'file',
            data: { text: text, file: file }
          });
          this.file = null;
          this.$refs.userInput.innerHTML = '';
        } else {
          this.onSubmit({
            author: 'me',
            type: 'file',
            data: { file: file }
          });
          this.file = null;
        }
      } else {
        if (text && text.length > 0) {
          this.onSubmit({
            author: 'me',
            type: 'text',
            data: { text: text }
          });
          this.$refs.userInput.innerHTML = '';
        }
      }
    },
    _handleEmojiPicked: function _handleEmojiPicked(emoji) {
      this.onSubmit({
        author: 'me',
        type: 'emoji',
        data: { emoji: emoji }
      });
    },
    _handleFileSubmit: function _handleFileSubmit(file) {
      this.file = file;
    }
  }
};

/***/ }),

/***/ "1wn0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";
// export const apiUrlPatients = "http://localhost:5009/prijem/pacijenti/";
// export const apiUrlObradaPregled = "http://localhost:5009/obrada/pregled/";
// export const apiUrlObradaPregled_rt = "http://localhost:5009/obrada/pregled/rt/"; 
// export const apiUrlObradaPregled_lp = "http://localhost:5009/obrada/pregled/lp/"; 
// export const apiUrlObradaPregled_ag = "http://localhost:5009/obrada/pregled/ag/"; 
// export const apiUrlObradaPregled_at = "http://localhost:5009/obrada/pregled/at/"; 
// export const apiUrlNalaziPregled = "http://localhost:5009/nalazi/pregled";
// export const apiUrlNalaziPregled_rt = "http://localhost:5009/nalazi/pregled/rt/";
// export const apiUrlNalaziPregled_lp = "http://localhost:5009/nalazi/pregled/lp/";
// export const apiUrlNalaziPregled_ag = "http://localhost:5009/nalazi/pregled/ag/";
// export const apiUrlNalaziPregled_at = "http://localhost:5009/nalazi/pregled/at/";
// export const apiUrlNalaziOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlNalaziOutbox_rt = "http://localhost:5009/nalazi/outbox/rt/";
// export const apiUrlNalaziOutbox_lp = "http://localhost:5009/nalazi/outbox/lp/";
// export const apiUrlNalaziOutbox_ag = "http://localhost:5009/nalazi/outbox/ag/";
// export const apiUrlNalaziOutbox_at = "http://localhost:5009/nalazi/outbox/at/";
// export const apiUrlLabAssays = "http://localhost:5009/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5009/assays/ana";
// export const apiUrlControlClone = "http://localhost:5009/control/clone";
// export const apiUrlControlEdit = "http://localhost:5009/control/edit";
// export const apiUrlControlResults = "http://localhost:5009/control/results";
// export const apiUrlIntegration = "http://localhost:5009/api/pregled";
// export const apiUrlProdukt = "http://localhost:5009/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5009/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5009/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5009/inventar/narudzbenice";
// export const apiUrlUlaz = "http://localhost:5009/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5009/inventar/izlazpregled";

// Server Setup


const http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: "https://sars.ilab.ba/" });
/* harmony export (immutable) */ __webpack_exports__["C"] = http;

const barcode = "https://sars.ilab.ba/images/barcodes/";
/* harmony export (immutable) */ __webpack_exports__["B"] = barcode;

const server = "https://sars.ilab.ba/";
/* harmony export (immutable) */ __webpack_exports__["D"] = server;

const serverSocket = "https://sars.ilab.ba/";
/* unused harmony export serverSocket */

const apiUrlPatients = "https://sars.ilab.ba/prijem/pacijenti/";
/* harmony export (immutable) */ __webpack_exports__["w"] = apiUrlPatients;

const apiUrlObradaPregled = "https://sars.ilab.ba/obrada/pregled/";
/* harmony export (immutable) */ __webpack_exports__["r"] = apiUrlObradaPregled;

const apiUrlObradaPregled_rt = "https://sars.ilab.ba/obrada/pregled/rt/";
/* harmony export (immutable) */ __webpack_exports__["v"] = apiUrlObradaPregled_rt;
 
const apiUrlObradaPregled_lp = "https://sars.ilab.ba/obrada/pregled/lp/";
/* harmony export (immutable) */ __webpack_exports__["u"] = apiUrlObradaPregled_lp;

const apiUrlObradaPregled_ag = "https://sars.ilab.ba/obrada/pregled/ag/";
/* harmony export (immutable) */ __webpack_exports__["s"] = apiUrlObradaPregled_ag;

const apiUrlObradaPregled_at = "https://sars.ilab.ba/obrada/pregled/at/";
/* harmony export (immutable) */ __webpack_exports__["t"] = apiUrlObradaPregled_at;

const apiUrlNalaziPregled = "https://sars.ilab.ba/nalazi/pregled";
/* harmony export (immutable) */ __webpack_exports__["l"] = apiUrlNalaziPregled;

const apiUrlNalaziPregled_rt = "https://sars.ilab.ba/nalazi/pregled/rt/";
/* harmony export (immutable) */ __webpack_exports__["p"] = apiUrlNalaziPregled_rt;

const apiUrlNalaziPregled_lp = "https://sars.ilab.ba/nalazi/pregled/lp/";
/* harmony export (immutable) */ __webpack_exports__["o"] = apiUrlNalaziPregled_lp;

const apiUrlNalaziPregled_ag = "https://sars.ilab.ba/nalazi/pregled/ag/";
/* harmony export (immutable) */ __webpack_exports__["m"] = apiUrlNalaziPregled_ag;

const apiUrlNalaziPregled_at = "https://sars.ilab.ba/nalazi/pregled/at/";
/* harmony export (immutable) */ __webpack_exports__["n"] = apiUrlNalaziPregled_at;

const apiUrlNalaziOutbox = "https://sars.ilab.ba/nalazi/outbox";
/* harmony export (immutable) */ __webpack_exports__["g"] = apiUrlNalaziOutbox;

const apiUrlNalaziOutbox_rt = "https://sars.ilab.ba/nalazi/outbox/rt/";
/* harmony export (immutable) */ __webpack_exports__["k"] = apiUrlNalaziOutbox_rt;

const apiUrlNalaziOutbox_lp = "https://sars.ilab.ba/nalazi/outbox/lp/";
/* harmony export (immutable) */ __webpack_exports__["j"] = apiUrlNalaziOutbox_lp;

const apiUrlNalaziOutbox_ag = "https://sars.ilab.ba/nalazi/outbox/ag/";
/* harmony export (immutable) */ __webpack_exports__["h"] = apiUrlNalaziOutbox_ag;

const apiUrlNalaziOutbox_at = "https://sars.ilab.ba/nalazi/outbox/at/";
/* harmony export (immutable) */ __webpack_exports__["i"] = apiUrlNalaziOutbox_at;

const apiUrlLabAssays = "https://sars.ilab.ba/assays/lab";
/* harmony export (immutable) */ __webpack_exports__["f"] = apiUrlLabAssays;

const apiUrlAnaAssays = "https://sars.ilab.ba/assays/ana";
/* harmony export (immutable) */ __webpack_exports__["a"] = apiUrlAnaAssays;

const apiUrlControlClone = "https://sars.ilab.ba/control/clone";
/* unused harmony export apiUrlControlClone */

const apiUrlControlEdit = "https://sars.ilab.ba/control/edit";
/* harmony export (immutable) */ __webpack_exports__["b"] = apiUrlControlEdit;

const apiUrlControlResults = "https://sars.ilab.ba/control/results";
/* harmony export (immutable) */ __webpack_exports__["c"] = apiUrlControlResults;

const apiUrlIntegration = "https://sars.ilab.ba/api/pregled";
/* harmony export (immutable) */ __webpack_exports__["d"] = apiUrlIntegration;

const apiUrlProdukt = "https://sars.ilab.ba/inventar/produkti";
/* harmony export (immutable) */ __webpack_exports__["x"] = apiUrlProdukt;

const apiUrlUgovor = "https://sars.ilab.ba/inventar/ugovori";
/* harmony export (immutable) */ __webpack_exports__["z"] = apiUrlUgovor;

const apiUrlStanje = "https://sars.ilab.ba/inventar/stanje";
/* harmony export (immutable) */ __webpack_exports__["y"] = apiUrlStanje;

const apiUrlNarudzbenica = "https://sars.ilab.ba/inventar/narudzbenice";
/* harmony export (immutable) */ __webpack_exports__["q"] = apiUrlNarudzbenica;

const apiUrlUlaz = "https://sars.ilab.ba/inventar/ulazpregled";
/* harmony export (immutable) */ __webpack_exports__["A"] = apiUrlUlaz;

const apiUrlIzlaz = "https://sars.ilab.ba/inventar/izlazpregled";
/* harmony export (immutable) */ __webpack_exports__["e"] = apiUrlIzlaz;


/***/ }),

/***/ "2653":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__ = __webpack_require__("KzHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3faad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__ = __webpack_require__("egNy");
function injectStyle (ssrContext) {
  __webpack_require__("uQbW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3faad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "27Vx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("8xYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf5b64a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("ykC9");
function injectStyle (ssrContext) {
  __webpack_require__("w6B+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bf5b64a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf5b64a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "295n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Bcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "2EQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2V5g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Y6a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ab3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ "2c2N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__ = __webpack_require__("1893");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7018b97b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__ = __webpack_require__("3NeJ");
function injectStyle (ssrContext) {
  __webpack_require__("INR6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7018b97b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2iES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-user-input--picker-wrapper"},[(_vm.isActive)?_c('EmojiPicker',{attrs:{"onEmojiPicked":_vm.onEmojiPicked,"onBlur":_vm._handlePickerBlur}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"sc-user-input--emoji-icon-wrapper",on:{"click":function($event){$event.preventDefault();_vm._openPicker($event)}}},[_c('svg',{staticClass:"sc-user-input--emoji-icon",class:{active: _vm.isActive},attrs:{"version":"1.1","id":"Layer_2","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"37.393px","height":"37.393px","viewBox":"0 0 37.393 37.393","enableBackground":"new 0 0 37.393 37.393"}},[_c('g',[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M18.696,37.393C8.387,37.393,0,29.006,0,18.696C0,8.387,8.387,0,18.696,0c10.31,0,18.696,8.387,18.696,18.696\n            C37.393,29.006,29.006,37.393,18.696,37.393z M18.696,2C9.49,2,2,9.49,2,18.696c0,9.206,7.49,16.696,16.696,16.696\n            c9.206,0,16.696-7.49,16.696-16.696C35.393,9.49,27.902,2,18.696,2z"}})]),_vm._v(" "),_c('g',[_c('circle',{style:({fill: _vm.color}),attrs:{"cx":"12.379","cy":"14.359","r":"1.938"}})]),_vm._v(" "),_c('g',[_c('circle',{style:({fill: _vm.color}),attrs:{"cx":"24.371","cy":"14.414","r":"1.992"}})]),_vm._v(" "),_c('g',[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M18.035,27.453c-5.748,0-8.342-4.18-8.449-4.357c-0.286-0.473-0.135-1.087,0.338-1.373\n            c0.471-0.286,1.084-0.136,1.372,0.335c0.094,0.151,2.161,3.396,6.74,3.396c4.713,0,7.518-3.462,7.545-3.497\n            c0.343-0.432,0.973-0.504,1.405-0.161c0.433,0.344,0.505,0.973,0.161,1.405C27.009,23.374,23.703,27.453,18.035,27.453z"}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2u3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),

/***/ "2uoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--file",style:(_vm.messageColors)},[_c('div',{staticClass:"sc-message--file-icon"},[_c('a',{attrs:{"href":_vm.data.file.url || '#',"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("w+sz"),"alt":"generic file icon","height":"60"}})])]),_vm._v(" "),_c('div',{staticClass:"sc-message--file-name",style:(_vm.messageColors)},[_c('a',{attrs:{"href":_vm.data.file.url ? _vm.data.file.url : '#',"target":"_blank"}},[_vm._v(_vm._s(_vm.data.file.name || ''))])]),_vm._v(" "),_c('div',{staticClass:"sc-message--file-text",style:(_vm.messageColors)},[_vm._v(_vm._s(_vm.data.text)),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:(_vm.messageColors)},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3/Lv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Alh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "3Bfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadUndo_vue__ = __webpack_require__("Dz+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aafc4aca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadUndo_vue__ = __webpack_require__("Az3I");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadUndo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aafc4aca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadUndo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3IyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-multi-select",
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: "",
      validated: false
    };
  },

  props: {
    label: {
      type: String,
      default: ""
    },
    optionKey: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: "multiselect"
    }
  },
  mounted: function mounted() {
    this.$emit("input", this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    toggleSelection: function toggleSelection(option) {
      var newVal = this.isOptionSelected(option) ? this.deselectOption(option) : this.selectOption(option);
      this.updateDisplayValue(newVal);
      this.$emit("input", newVal);
    },
    isOptionSelected: function isOptionSelected(option) {
      return this.value.includes(option);
    },
    selectOption: function selectOption(option) {
      return this.value.concat(option);
    },
    deselectOption: function deselectOption(option) {
      return this.value.filter(function (item) {
        return item !== option;
      });
    },
    updateDisplayValue: function updateDisplayValue(newVal) {
      var _this = this;

      if (newVal.length > 2) {
        this.displayValue = newVal.length + " od " + this.options.length + " odabrana";
      } else {
        this.displayValue = (this.optionKey ? newVal.map(function (item) {
          return item[_this.optionKey];
        }) : newVal).join(", ");
      }
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return "The " + this.name + " field is required";
    }
  }
});

/***/ }),

/***/ "3JiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KalibracijaModal_vue__ = __webpack_require__("S34v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75bcdb55_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KalibracijaModal_vue__ = __webpack_require__("pxXL");
function injectStyle (ssrContext) {
  __webpack_require__("//tZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75bcdb55"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KalibracijaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75bcdb55_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KalibracijaModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3N/s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3NeJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-with-icon"},[_c('span',{staticClass:"icon"},[_c('i',{class:_vm.iconClass,attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3p4r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4/yE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_local_data__ = __webpack_require__("806z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_data_table_styles__ = __webpack_require__("bALl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datatable_components_FilterBar_vue__ = __webpack_require__("FqBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datatable_components_NewPatient_vue__ = __webpack_require__("fBe1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay_dist_vue_loading_css__);

















var originalData = __WEBPACK_IMPORTED_MODULE_4__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "pacijents-table",

  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_6__datatable_components_FilterBar_vue__["default"],
    NewPatient: __WEBPACK_IMPORTED_MODULE_7__datatable_components_NewPatient_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default.a
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      tableData: __WEBPACK_IMPORTED_MODULE_4__data_local_data__["a" /* default */],
      perPage: "",
      brStr: 10,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_5__data_data_table_styles__["a" /* default */],
      pacijent: {},
      show: true,
      potvrdi: "SAČUVAJ",
      odustani: "ZATVORI",
      patient_data: {
        _id: "",
        entry_disabled: false,
        izdavanje: "",
        duhan: "",
        dijabetes: "",
        symptoms: {
          pacijentbezsimptoma: true,
          povišenatjelesnatemperatura: false,
          suhikašalj: false,
          umor: false,
          bolovi: false,
          grlobolja: false,
          proljev: false,
          konjunktivitis: false,
          glavobolja: false,
          gubitakosjetaokusailimirisa: false,
          osipilipromjenabojeprstijunarukamailinogama: false,
          otežanodisanjeiligubitakdaha: false,
          bolilipritisakuprsima: false,
          gubitaksposobnostigovorailikretanja: false
        },
        purpose: "",
        analysis: "",
        referenca: "",
        note: "",
        passport: "",
        language: [""],
        telefon: "",
        email: "",
        adresa: "",
        created_at: null,
        updated_at: null,
        created_by: "",
        updated_by: "",
        jmbg: "",
        ime: "",
        prezime: "",
        spol: "",
        site: "",
        __v: 0
      },

      isLoading: false,
      fullPage: true,

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      timestamp: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.onFilterSet(this.$store.state.filter);
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("Set", function (data) {
      _this.onFilterSet(data.ime + " " + data.prezime);
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("Set");
  },

  watch: {},
  methods: {
    Test: function Test() {
      var _this2 = this;

      this.isLoading = true;

      setTimeout(function () {
        _this2.isLoading = false;
      }, 2000);
    },
    onCancel: function onCancel() {},
    unosPacijenta: function unosPacijenta() {
      if (this.$store.state.main === true && this.$store.state.site != "60ab76ecf68be9eab3d69e55") {
          this.$refs.staticModalNotAuthorizedEntry.open();
        } else {
        this.$refs.largeModalPatient.open();
      }
    },

    prikaziDetalje: function prikaziDetalje(args) {
      var _this3 = this;

      var niz = args[0];

      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "detalji") {
          this.pacijent = niz[0].id;
          this.patient_data = niz[0].patient;

          if (this.$store.state.main === true && this.$store.state.site != "60ab76ecf68be9eab3d69e55") {
              this.$refs.staticModalNotAuthorizedEdit.open();
            } else {
            this.isLoading = true;
            setTimeout(function () {
              _this3.isLoading = false;
              _this3.timestamp = (new Date().getTime() - new Date().getTimezoneOffset() * 60000).toString();
              _this3.$refs.modalPatientEdit.open();
            }, 500);
          }
        }
        if (niz[1].name === "prijem") {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(args[0][0].prijem).includes("disabled")) {} else {
            if (this.$store.state.main === true && this.$store.state.site != "60ab76ecf68be9eab3d69e55") {
                this.$refs.staticModalNotAuthorizedEdit.open();
              } else {
              __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/samples/" + args[0][0].id);
            }
          }
        }
        if (niz[1].name === "icon") {}
      }
    },
    onFilterSet: function onFilterSet(filterText, event) {
      var _this4 = this;

      this.filterString = "";

      this.filterString = filterText;

      if (event != undefined && filterText.trim() != "") {
        if (event.keyCode == 13) {
          if (this.apiMode) {
            this.moreParams = {
              filter: filterText
            };
          } else {
            var txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function (item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }

          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
            return _this4.$refs.vuetable.refresh();
          });
        } else {}
      } else {
        if (this.apiMode) {
          this.moreParams = {
            filter: filterText
          };
        } else {
          var _txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function (item) {
            return item.name.search(_txt) >= 0 || item.email.search(_txt) >= 0;
          });
        }
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
          return _this4.$refs.vuetable.refresh();
        });
      }
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "41de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var HORIZONTAL_LAYOUT = 'horizontal';
    var VERTICAL_LAYOUT = 'vertical';
    var initialLayout = binding.value.layout;
    var breakpoint = binding.value.breakPoint;

    var wizardLayout = initialLayout;

    var handleResize = function handleResize() {
      var width = window.innerWidth;
      var layout = width <= breakpoint ? HORIZONTAL_LAYOUT : VERTICAL_LAYOUT;
      if (wizardLayout !== layout) {
        wizardLayout = layout;
        vnode.context.$emit('wizardLayoutChange', wizardLayout);
      }
    };

    if (initialLayout === VERTICAL_LAYOUT) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
  }
});

/***/ }),

/***/ "43Js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "46z7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-uzorak",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;
      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      var data = {};
      data.sample = this.sample;
      data.pdf = 'samples/' + this.sample + '.pdf';
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("UzorakFromCollapse", data);
    },
    onHeaderClick: function onHeaderClick() {},
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "497r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalComment_vue__ = __webpack_require__("fQTI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ac01ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalComment_vue__ = __webpack_require__("LHMG");
function injectStyle (ssrContext) {
  __webpack_require__("SHli")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ac01ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4DkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-reports",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    range: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "4JfL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4S38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionSamplesEntry_vue__ = __webpack_require__("MMrO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7509d628_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionSamplesEntry_vue__ = __webpack_require__("wt/o");
function injectStyle (ssrContext) {
  __webpack_require__("F2Js")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionSamplesEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7509d628_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionSamplesEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4TJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__("2ab3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4W1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4ZaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteDropdown_vue__ = __webpack_require__("uM+q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bdc4536_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteDropdown_vue__ = __webpack_require__("UBYF");
function injectStyle (ssrContext) {
  __webpack_require__("xlst")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bdc4536_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4bUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("tcEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5529ee3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("9L4F");
function injectStyle (ssrContext) {
  __webpack_require__("jhTK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5529ee3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5529ee3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "4d+n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4dey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMulti_vue__ = __webpack_require__("ZTjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b278436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMulti_vue__ = __webpack_require__("kXTy");
function injectStyle (ssrContext) {
  __webpack_require__("PIt8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMulti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b278436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMulti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4j/T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "54Af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-partneri-edit",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("PotvrdiEdit", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("PotvrdiEdit");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("partneriEdit");
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ModalCancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "56vn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "577M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Bk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadListItem_vue__ = __webpack_require__("i50y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbd0b0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadListItem_vue__ = __webpack_require__("nuWd");
function injectStyle (ssrContext) {
  __webpack_require__("8lnn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbd0b0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5DLM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5H7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMicroResult_vue__ = __webpack_require__("ehbH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8b754a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMicroResult_vue__ = __webpack_require__("gXy1");
function injectStyle (ssrContext) {
  __webpack_require__("L2v+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMicroResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8b754a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMicroResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5JAS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-obrada",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    retest: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    sample: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      expanded: false,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("SetClientHeight", function (sid) {
      if (_this.$slots.header[0].elm.id === sid) {
        var bodyContent = _this.$refs.collapseBody;
        _this.clientHeight = _this.$slots.body[0].elm.clientHeight + 5 + "px";
        _this.onHeaderClick();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("SetClientHeight");
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      switch (event.target.id) {
        case "forward":
          this.expanded = true;
          break;
        case "trash":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("trash", this.sample);
          break;
        case "user-o":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("note-o", this.sample);
          break;
        case "calendar":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("openCalendarObrada", this.sample);
          break;
        case "edit":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("edit", this.sample);
          break;
        case "comment":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("comment", this.sample);
          break;
        case "barcode":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("barcode", this.sample);
          break;
        case "backward":
          this.expanded = false;
          break;
        case "save":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("save", this.sample);
          break;
        case "retest":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("retest", this.sample);
          break;
        case "check":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("check", this.sample);
          break;
        case "verify":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("verify", this.sample);
          break;

        case "handshake":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("handshake", this.sample);
          break;

        case "undo":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("undo", this.sample);
          break;
        case "unlock":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("unlock", this.sample);
          if (!this.show) {
            __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sample", this.sample);
          } else {}
          break;
        case "pdf":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("pdf", this.sample);
          break;
        case "block":
          break;
        case "":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sample", this.sample);
          break;
        default:
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sample", this.sample);
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("AllowClick", this.show);
          break;
      }
    },
    onHeaderClick: function onHeaderClick() {
      this.toggle();
      this.accordion.onChildChange(this, this.show);
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "5OGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-radio-button form-check radio abc-radio",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checkState},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5i1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-file-upload-container',
  props: {
    dropzone: {
      type: Boolean,
      default: false
    },
    fileTypes: {
      type: String
    },
    type: {
      type: String
    }
  },
  methods: {
    changeFieldValue: function changeFieldValue(e) {
      this.$emit('upload', e);
      this.$refs.fieldInput.value = '';
    }
  }
});

/***/ }),

/***/ "5kXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.removed)?_c('div',{staticClass:"file-upload-gallery-item"},[_c('vuestic-file-upload-undo',{staticClass:"file-upload-gallery-item-undo",on:{"recover":_vm.recoverImage}})],1):_c('div',{staticClass:"file-upload-gallery-item",class:_vm.notGalleryItemClass},[_c('img',{staticClass:"file-upload-gallery-item-image",attrs:{"src":_vm.previewImage,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"file-upload-gallery-item-overlay"},[_c('div',{staticClass:"file-upload-gallery-item-name",attrs:{"title":_vm.file.name}},[_vm._v("\n      "+_vm._s(_vm.file.name)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"file-upload-gallery-item-size"},[_vm._v("\n      "+_vm._s(_vm.file.size)+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn-text btn-text--secondary file-upload-gallery-item-button",attrs:{"type":"button"},on:{"click":_vm.removeImage}},[_vm._v("\n      "+_vm._s(_vm.$t('fileUpload.deleteFile'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5rtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--system",style:(_vm.messageColors)},[_vm._v(_vm._s(_vm.data.text)),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:({color: _vm.messageColors.color})},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "67kX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayDelete_vue__ = __webpack_require__("Q0RY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469c8900_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayDelete_vue__ = __webpack_require__("GW8J");
function injectStyle (ssrContext) {
  __webpack_require__("W7LE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-469c8900"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469c8900_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6Bok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "postavke-radio-button",
  props: {
    label: String,
    value: {
      type: String,
      default: "",
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      default: undefined
    },
    brandColor: {
      type: String,
      default: "danger",
      validator: function validator(value) {
        return ["primary", "secondary", "success", "info", "warning", "danger"].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: "modelValue",
    event: "input"
  },
  mounted: function mounted() {
    if (this.checked && !this.checkState) {
      this.toggle();
    }
  },

  methods: {
    NewEntry: function NewEntry() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("OpstePostavkeNoviUnos");
    },
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      this.$emit("input", this.checkState ? "" : this.value);
    }
  },
  computed: {
    checkState: function checkState() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    },
    additionalClasses: function additionalClasses() {
      if (this.label === "DATUM ROĐENJA" || this.label === "GODINA ROĐENJA" || this.label === "DATE OF BIRTH" || this.label === "YEAR OF BIRTH" || this.label === "GEBURTSDATUM" || this.label === "GEBURTSJAHR" || this.label === "Bosanski jezik" || this.label === "Engleski jezik" || this.label === "Njemački jezik" || this.label === "Bosnian language" || this.label === "English language" || this.label === "German language" || this.label === "Bosnische Sprache" || this.label === "Englische Sprache" || this.label === "Deutsche Sprache") {
        return ["abc-radio-" + this.brandColor];
      }
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.checkState) {
        this.toggle();
      }
    }
  }
});

/***/ }),

/***/ "6E+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitialPassword_vue__ = __webpack_require__("KJIA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a9dd34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitialPassword_vue__ = __webpack_require__("sbxJ");
function injectStyle (ssrContext) {
  __webpack_require__("Sdwi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InitialPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a9dd34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InitialPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6JMY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6SPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postavke-accordion',
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "6b69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },

  name: "vuestic-widget",

  props: {
    headerText: {
      type: String,
      default: ""
    },
    spol: {
      type: String,
      default: ""
    },
    pagination: {
      type: Boolean,
      default: false
    },
    main: {
      type: Boolean,
      default: false
    },
    forward_disabled: {
      type: Boolean,
      default: false
    },
    backward_disabled: {
      type: Boolean,
      default: false
    },
    data_length: {
      type: Number,
      default: 0
    },
    rezultati_length: {
      type: Number,
      default: 0
    },
    data_min: {
      type: Number,
      default: 1
    },
    data_pid: {
      type: Number,
      default: 0
    },
    datum: {
      type: String,
      default: ""
    },
    today: {
      type: String,
      default: ""
    }
  },
  created: function created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    Sljedeci: function Sljedeci() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sljedeci");
    },
    Prethodni: function Prethodni() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Prethodni");
    },
    Find: function Find() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Search");
    }
  }
});

/***/ }),

/***/ "6oRW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6oYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "74xX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__ = __webpack_require__("dRu4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e9733ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__ = __webpack_require__("Vhfj");
function injectStyle (ssrContext) {
  __webpack_require__("0QRF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e9733ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "77C1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__("mUJ2")("./" + name + (index ? "/index" : "") + ".vue");
  };
});

/***/ }),

/***/ "7CmO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapse_vue__ = __webpack_require__("glDe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b4ae27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapse_vue__ = __webpack_require__("LjDm");
function injectStyle (ssrContext) {
  __webpack_require__("/lWu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b4ae27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7F3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__("4TJE");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ "7S+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7cnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue__ = __webpack_require__("DSl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2c72b30a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SendIcon_vue__ = __webpack_require__("MRU1");
function injectStyle (ssrContext) {
  __webpack_require__("bFkE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c72b30a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2c72b30a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SendIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7ksE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7mIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-chat-window",class:{opened: _vm.isOpen, closed: !_vm.isOpen}},[_c('Zaglavlje',{attrs:{"title":_vm.title,"imageUrl":_vm.titleImageUrl,"onClose":_vm.onClose,"colors":_vm.colors},on:{"userList":_vm.handleUserListToggle}}),_vm._v(" "),(_vm.showUserList)?_c('UserList',{attrs:{"participants":_vm.participants}}):_vm._e(),_vm._v(" "),(!_vm.showUserList)?_c('MessageList',{attrs:{"messages":_vm.messages,"participants":_vm.participants,"showTypingIndicator":_vm.showTypingIndicator,"colors":_vm.colors,"alwaysScrollToBottom":_vm.alwaysScrollToBottom}}):_vm._e(),_vm._v(" "),(!_vm.showUserList)?_c('UserInput',{attrs:{"showEmoji":_vm.showEmoji,"onSubmit":_vm.onUserInputSubmit,"showFile":_vm.showFile,"placeholder":_vm.placeholder,"colors":_vm.colors}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8/T/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__ = __webpack_require__("mpwI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccccb3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__ = __webpack_require__("1It+");
function injectStyle (ssrContext) {
  __webpack_require__("Xvo4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ccccb3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccccb3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "806z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 1,
    'per_page': 10,
    'current_page': 1,
    'last_page': 1,
    'next_page_url': null,
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }]
});

/***/ }),

/***/ "86YC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circles-to-rhombuses-spinner",style:(_vm.spinnertStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8E1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__ = __webpack_require__("Rdfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05018cae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__ = __webpack_require__("YcSw");
function injectStyle (ssrContext) {
  __webpack_require__("eT2/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05018cae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05018cae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8EQH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8UFG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "8VRF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8X6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.window.width > 800)?_c('div',{staticClass:"col-md-4",staticStyle:{"position":"relative","right":"0px","top":"20px"}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-time-od","config":_vm.configOd},on:{"on-close":function($event){_vm.timeOdClosed($event)}},model:{value:(_vm.timeRange.timeOd),callback:function ($$v) {_vm.$set(_vm.timeRange, "timeOd", $$v)},expression:"timeRange.timeOd"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range-odT"}},[_vm._v(_vm._s('Od'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1),_vm._v("  \n                      "),_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-time-do","config":_vm.configDo},on:{"on-close":function($event){_vm.timeDoClosed($event)}},model:{value:(_vm.timeRange.timeDo),callback:function ($$v) {_vm.$set(_vm.timeRange, "timeDo", $$v)},expression:"timeRange.timeDo"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range-doT"}},[_vm._v(_vm._s('Do'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1)])])]):_vm._e()])],2),_vm._v(" "),(_vm.window.width < 800)?_c('div',{staticClass:"modal-header",staticStyle:{"position":"relative","right":"0px","top":"20px"}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-basic","config":_vm.configBasics},model:{value:(_vm.dateBasics),callback:function ($$v) {_vm.dateBasics=$$v},expression:"dateBasics"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-basic"}},[_vm._v(_vm._s('Izaberite datum'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Z44":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8cWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-simple-select"},[_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.isBlocked",modifiers:{"isBlocked":true}}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle vuestic-simple-select__dropdown-toggle"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],class:{'has-value': !!_vm.value},attrs:{"name":_vm.name,"options":_vm.options},domProps:{"value":(_vm.displayValue)},on:{"focus":function($event){_vm.showDropdown()},"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v("\n          "+_vm._s(_vm.showRequiredError())+"\n        ")])]),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-arrow-down icon-right input-icon vuestic-simple-select__dropdown-arrow",on:{"click":_vm.showDropdown}})]),_vm._v(" "),(_vm.isClearable)?_c('div',[_c('i',{staticClass:"fa fa-close icon-cross icon-right input-icon vuestic-simple-select__unselect",on:{"click":_vm.unselectOption}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-menu vuestic-simple-select__dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content vuestic-simple-select__dropdown-menu-content"},_vm._l((_vm.filteredList),function(option){return _c('div',{staticClass:"dropdown-item vuestic-simple-select__dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))])])}))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8lnn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ovZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "8pBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"beforeEnter":_vm.beforeEnter,"afterEnter":_vm.afterEnter,"beforeLeave":_vm.beforeLeave,"afterLeave":_vm.afterLeave}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8sJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal-s',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'CONFIRM'
    },
    cancelText: {
      type: String,
      default: 'CANCEL'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary'
    },
    closeIconShown: {
      type: Boolean,
      default: true
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit('ok');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yesNalaz', true, this.transition);
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener('keyup', this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "8t2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message"},[_c('div',{staticClass:"sc-message--content",class:{
      sent: _vm.message.author === 'me',
      received: _vm.message.author !== 'me' && _vm.message.type !== 'system',
      system: _vm.message.type === 'system'
    }},[(_vm.message.type !== 'system')?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.message.author),expression:"message.author"}],staticClass:"sc-message--avatar",style:({
      backgroundImage: ("url(" + _vm.chatImageUrl + ")")
    }),attrs:{"title":_vm.authorName}}):_vm._e(),_vm._v(" "),(_vm.message.type === 'text')?_c('TextMessage',{attrs:{"data":_vm.message.data,"messageColors":_vm.determineMessageColors()}}):(_vm.message.type === 'emoji')?_c('EmojiMessage',{attrs:{"data":_vm.message.data}}):(_vm.message.type === 'file')?_c('FileMessage',{attrs:{"data":_vm.message.data,"messageColors":_vm.determineMessageColors()}}):(_vm.message.type === 'typing')?_c('TypingMessage',{attrs:{"messageColors":_vm.determineMessageColors()}}):(_vm.message.type === 'system')?_c('SystemMessage',{attrs:{"data":_vm.message.data,"messageColors":_vm.determineMessageColors()}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8xYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__ = __webpack_require__("Aw6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__ = __webpack_require__("Q+RX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_local_data__ = __webpack_require__("KX+Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__ = __webpack_require__("CHUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__("NHnr");












var originalData = __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-data-table-anaassays",
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__["default"]
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      tableData: __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */],
      perPage: 10,
      colorClasses: {},
      moreParams: { access: this.$store.state.access.level },
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__["a" /* default */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$on("AnaAssayRefresh", function () {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$off("AnaAssayRefresh");
  },

  methods: {
    Akcija: function Akcija(args) {
      var niz = args[0];

      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "reference") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("AnaAssayReference", niz[0]);
        } else if (niz[1].name === "uredi") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("AnaAssayUredi", niz[0]);
        } else if (niz[1].name === "akcija") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("AnaAssayAkcija", niz[0]);
        } else {}
      }
    },

    onFilterSet: function onFilterSet(filterText) {
      var _this2 = this;

      if (this.apiMode) {
        this.moreParams = {
          filter: filterText,
          access: this.$store.state.access.level
        };
      } else {
        var txt = new RegExp(filterText, "i");
        this.tableData.data = originalData.filter(function (item) {
          return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
        });
      }
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this3 = this;

      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "8yMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-root',
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "9/Le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.window.width > 800)?_c('div',{staticClass:"col-md-4",staticStyle:{"position":"relative","right":"0px","top":"20px"}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-time-od","config":_vm.configOd},on:{"on-close":function($event){_vm.timeOdClosed($event)}},model:{value:(_vm.timeRange.timeOd),callback:function ($$v) {_vm.$set(_vm.timeRange, "timeOd", $$v)},expression:"timeRange.timeOd"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range"}},[_vm._v(_vm._s('Od'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1),_vm._v("  \n                      "),_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-time-do","config":_vm.configDo},on:{"on-close":function($event){_vm.timeDoClosed($event)}},model:{value:(_vm.timeRange.timeDo),callback:function ($$v) {_vm.$set(_vm.timeRange, "timeDo", $$v)},expression:"timeRange.timeDo"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range"}},[_vm._v(_vm._s('Do'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1)])])]):_vm._e()])],2),_vm._v(" "),(_vm.window.width < 800)?_c('div',{staticClass:"modal-header",staticStyle:{"position":"relative","right":"0px","top":"20px"}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-basic","config":_vm.configBasics},model:{value:(_vm.dateBasics),callback:function ($$v) {_vm.dateBasics=$$v},expression:"dateBasics"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-basic"}},[_vm._v(_vm._s('Izaberite datum'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "97Tl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "97fV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9AED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "9L4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-bouncing-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9LJy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9QRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalTable_vue__ = __webpack_require__("QJEt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26aa6a9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalTable_vue__ = __webpack_require__("8X6l");
function injectStyle (ssrContext) {
  __webpack_require__("qI/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26aa6a9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9QaW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "9ULZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9V83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{
      'vuestic-collapse__header--no-header': _vm.noHeader,
    },on:{"click":function($event){_vm.onHeaderClick()}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{staticClass:"vuestic-collapse__header__button btn btn-primary",staticStyle:{"height":"40px","padding-top":"0.6rem"}},[_vm._t("header"),_vm._v(" "),_vm._m(0)],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 pull-right"},[_c('span',{staticStyle:{"text-align":"right","padding-top":"0"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9aYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__ = __webpack_require__("Scc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce006678_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__ = __webpack_require__("Up4Z");
function injectStyle (ssrContext) {
  __webpack_require__("zHy1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce006678"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce006678_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9dzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chart"},[(_vm.type === 'pie')?_c('pie-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'donut')?_c('donut-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'bubble')?_c('bubble-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'line')?_c('line-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'horizontal-bar')?_c('horizontal-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'vertical-bar')?_c('vertical-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9gYv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9iQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-file-upload-single-item',
  props: {
    file: {
      type: Object
    }
  }
});

/***/ }),

/***/ "9k8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "filterBar",
  data: function data() {
    return {
      filterText: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("SetFilterFromAnaAssay", function (data) {
      if (_this.filterText != data) {
        _this.filterText = data;
        _this.doFilter(_this.filterText);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("SetFilterFromAnaAssay");
  },

  methods: {
    doFilter: function doFilter() {
      this.$emit("filter", this.filterText);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SetFilterFromLabAssay", this.filterText);
    }
  }
});

/***/ }),

/***/ "9lA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "filterBar",
  data: function data() {
    return {
      filterText: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("Filter", function (data) {
      _this.filterText = data;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("Filter");
  },

  methods: {
    doFilter: function doFilter(event) {
      this.$emit("filter", this.filterText, event);
    }
  }
});

/***/ }),

/***/ "9xgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabsBactery_vue__ = __webpack_require__("Xkgh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507d3bd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabsBactery_vue__ = __webpack_require__("BzR3");
function injectStyle (ssrContext) {
  __webpack_require__("h93A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-507d3bd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabsBactery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507d3bd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabsBactery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "A05I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"fil-input-icon-left","title":" ","name":"fil-input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"fil-input-icon-left"}},[_vm._v(_vm._s('Pretraga'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AFOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPartneriDelete_vue__ = __webpack_require__("CJJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39bf3047_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPartneriDelete_vue__ = __webpack_require__("jzbh");
function injectStyle (ssrContext) {
  __webpack_require__("TTyb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPartneriDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39bf3047_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPartneriDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AGve":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AKm5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bubble"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "AO3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__ = __webpack_require__("9AED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1174e964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__ = __webpack_require__("Cbfa");
function injectStyle (ssrContext) {
  __webpack_require__("Hc7Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1174e964"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1174e964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "AUKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-node",class:{'vuestic-tree-node-selected': _vm.selected}},[(_vm.$slots.checkbox)?_c('div',{staticClass:"vuestic-tree-node-checkbox"},[_vm._t("checkbox")],2):_vm._e(),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-node-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-node-label"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.iconRight)?_c('div',{staticClass:"vuestic-tree-node-icon-right"},[_vm._t("iconRight")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AWw/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-popover',

  components: { VPopover: __WEBPACK_IMPORTED_MODULE_0_v_tooltip__["VPopover"] },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'auto'
    },
    popoverClass: {
      type: [String, Array],
      default: 'vuestic-tooltip'
    },
    autoHide: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isIconPresent: function isIconPresent() {
      return !!this.$slots.icon;
    }
  }
});

/***/ }),

/***/ "AgBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-delete",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.DeleteSample();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("DeletedCancel", this.$store.state.sid);

      this.show = false;

      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    DeleteSample: function DeleteSample() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].post("uzorci/delete", {
        id: this.$store.state.sid,
        email: this.$store.state.user,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Deleted", _this.$store.state.sid);

        _this.show = false;
      });
    }
  }
});

/***/ }),

/***/ "Ai/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AprI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Av+w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aw6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("glov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c797d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("YPtf");
function injectStyle (ssrContext) {
  __webpack_require__("tFDZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72c797d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c797d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AyHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__ = __webpack_require__("8ovZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0ab8e2ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__ = __webpack_require__("DAE9");
function injectStyle (ssrContext) {
  __webpack_require__("UFbH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ab8e2ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0ab8e2ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Az3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload-undo"},[_vm._v("\n  "+_vm._s(_vm.$t('fileUpload.fileDeleted'))+"\n  "),_c('button',{staticClass:"btn-text btn-text--primary",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('recover')}}},[_vm._v("\n    "+_vm._s(_vm.$t('fileUpload.undo'))+"?\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B4Pl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swapping-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B58c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalDelete_vue__ = __webpack_require__("AgBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87247aa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalDelete_vue__ = __webpack_require__("cmXp");
function injectStyle (ssrContext) {
  __webpack_require__("qCsd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87247aa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BAbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.file)?_c('div',{staticClass:"file-container",style:({backgroundColor: _vm.colors.userInput.text, color: _vm.colors.userInput.bg})},[_vm._m(0),_vm._v("\n    "+_vm._s(_vm.file.name)+"\n    "),_c('span',{staticClass:"delete-file-message",on:{"click":function($event){_vm.cancelFile()}}},[_c('img',{attrs:{"src":__webpack_require__("aLFs"),"alt":"close icon","height":"10","title":"Remove the file"}})])]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"sc-user-input",class:{active: _vm.inputActive},style:({background: _vm.colors.userInput.bg})},[_c('div',{ref:"userInput",staticClass:"sc-user-input--text",style:({color: _vm.colors.userInput.text}),attrs:{"role":"button","tabIndex":"0","contentEditable":"true","placeholder":_vm.placeholder},on:{"focus":function($event){_vm.setInputActive(true)},"blur":function($event){_vm.setInputActive(false)},"keydown":_vm.handleKey}}),_vm._v(" "),_c('div',{staticClass:"sc-user-input--buttons"},[_c('div',{staticClass:"sc-user-input--button"}),_vm._v(" "),(_vm.showEmoji)?_c('div',{staticClass:"sc-user-input--button"},[_c('EmojiIcon',{attrs:{"onEmojiPicked":_vm._handleEmojiPicked,"color":_vm.colors.userInput.text}})],1):_vm._e(),_vm._v(" "),(_vm.showFile)?_c('div',{staticClass:"sc-user-input--button"},[_c('FileIcons',{attrs:{"onChange":_vm._handleFileSubmit,"color":_vm.colors.userInput.text}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sc-user-input--button"},[_c('SendIcon',{attrs:{"onClick":_vm._submitText,"color":_vm.colors.userInput.text}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-file-message"},[_c('img',{attrs:{"src":__webpack_require__("w+sz"),"alt":"genericFileIcon","height":"15"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BHhe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BKK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("r8Mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c9256052_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("tP2f");
function injectStyle (ssrContext) {
  __webpack_require__("Vlq6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9256052"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c9256052_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "BOqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__ = __webpack_require__("7F3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f615c518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__ = __webpack_require__("sjuo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f615c518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BUP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-error",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "BfMS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bg4O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bmn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "anaassay-ref-multi",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("AnaAssayHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("AnaAssayHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("AnaAssayEditRefMulti");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("AnaAssayCancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "BzR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tabs"},[_c('div',{staticClass:"d-none d-md-block dm-lg-block dm-xl-block"},[_c('nav',{staticClass:"nav nav-pills row"},_vm._l((_vm.names),function(name){return _c('div',{key:name,staticClass:"nav-item col",class:{active: name === _vm.currentActive},on:{"click":function($event){_vm.setActive(name)}}},[(name === _vm.currentActive)?_c('span',{staticClass:"nav-link"},[_c('h6',[_c('span',[_vm._v(_vm._s(name))]),_vm._v("  \n            "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.prikazi),expression:"prikazi"}],staticClass:"fa fa-font",staticStyle:{"color":"#4ae387"},on:{"click":function($event){$event.preventDefault();_vm.Antibiotik()}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.prikazi),expression:"!prikazi"}],staticClass:"fa fa-font",staticStyle:{"color":"#acb5be"}})])]):_vm._e(),_vm._v(" "),(name != _vm.currentActive)?_c('span',{staticClass:"nav-link"},[_c('h6',[_vm._v(_vm._s(name))])]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"track"},[_c('div',{class:_vm.underscoreClass})])]),_vm._v(" "),_c('vuestic-simple-select',{staticClass:"d-flex d-md-none d-lg-none d-xl-none simple-select",attrs:{"options":_vm.names},model:{value:(_vm.currentActive),callback:function ($$v) {_vm.currentActive=$$v},expression:"currentActive"}}),_vm._v(" "),_c('div',{staticClass:"tab-content"},_vm._l((_vm.names),function(name){return _c('div',{key:name,staticClass:"tab-pane",class:{active: name === _vm.currentActive}},[_vm._t(name)],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C/sP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Pretraga'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CHUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: 'table table-striped',
    ascendingIcon: 'entypo entypo-up-dir',
    descendingIcon: 'entypo entypo-down-dir'
  },
  pagination: {
    wrapperClass: 'btn-group',
    activeClass: 'focus',
    disabledClass: 'disabled',
    pageClass: 'btn btn-primary hide-not-focused-btn',
    linkClass: 'btn btn-primary pagination-link-btn',
    icons: {
      first: 'fa fa-angle-double-left',
      prev: 'fa fa-angle-left',
      next: 'fa fa-angle-right',
      last: 'fa fa-angle-double-right'
    }
  }
});

/***/ }),

/***/ "CI71":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CJJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-partneri-delete",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("PotvrdiDelete", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("PotvrdiDelete");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("partneriDelete");
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ModalCancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "CTCf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CZ96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "control-edit-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("ControlEditModalHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("ControlEditModalHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("KontroleUrediConfirm");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("UređivanjeRefresh");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "Cbfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orbit-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"orbit one",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit two",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit three",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CiJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CmQI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CneO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__ = __webpack_require__("pr2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2eac04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__ = __webpack_require__("u0yM");
function injectStyle (ssrContext) {
  __webpack_require__("OM6/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2eac04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Cs+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trinity-rings-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle1",style:(_vm.ring1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle2",style:(_vm.ring2Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle3",style:(_vm.ring3Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D2Jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-produkt",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,

      izbor: "LN",
      jmbg: "",
      dateofb: "",
      godiste: "",

      ime: "",
      prezime: "",
      spol: "",

      chosenAdress: "",
      cities: [],
      telefon: "",
      email: "",

      postoji: false,
      invalid: false,
      patient_id: "",
      patient_data: "",
      error_msg: "",

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      LN: "",
      opis: "",
      jedinica: "",
      jedinice: ["test", "mL", "L", "kom", "g", "kg"],
      nivo: "",
      danadoroka: "",
      sadrzaj: "",
      zasnaziv: "",
      zemlja: "",
      chosenZemlja: "",
      chosenKlasa: "",
      chosenProgram: "",
      chosenPlatforma: "",
      chosenOJ: "",
      programi: [],
      klase: [],
      platforme: [],
      OJs: [],
      backKlase: [],
      backProgrami: [],
      backPlatforme: [],
      backOJs: [],
      produkt_data: "",
      zemlje: ["NJEMAČKA", "IRSKA", "SAD", "POLJSKA", "ŠVICARSKA", "JAPAN"],
      chosenProizvodjac: "",
      proizvodjaci: [],
      backProizvodjaci: [],
      produkt: {
        LN: "",
        opis: "",
        zasticeni_naziv: "",
        zemlja_porijekla: "",
        jedinica_mjere: "",
        pakovanje: "",
        upozorenje: "",
        klasa: "",
        program: "",
        platforma: "",
        proizvodjac: "",
        oj: ""
      }
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].get("inventar/listklasa?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
      if (res.data.success) {
        _this.backKlase = res.data.klase;
        res.data.klase.forEach(function (element) {
          _this.klase.push(element.naziv);
        });
        if (_this.klase.length === 1) {
          _this.chosenKlasa = _this.klase[0];
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].get("inventar/listprogram?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
      if (res.data.success) {
        _this.backProgrami = res.data.programi;
        res.data.programi.forEach(function (element) {
          _this.programi.push(element.naziv);
        });
        if (_this.programi.length === 1) {
          _this.chosenProgram = _this.programi[0];
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].get("inventar/listplatforma?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
      if (res.data.success) {
        _this.backPlatforme = res.data.platforme;
        res.data.platforme.forEach(function (element) {
          _this.platforme.push(element.naziv);
        });
        if (_this.platforme.length === 1) {
          _this.chosenPlatforma = _this.platforme[0];
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].get("inventar/listoj?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
      if (res.data.success) {
        _this.backOJs = res.data.list;
        res.data.list.forEach(function (element) {
          _this.OJs.push(element.naziv);
        });
        if (_this.OJs.length === 1) {
          _this.chosenOJ = _this.OJs[0];
        }
      }
    });
    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].get("inventar/listproizvodjac?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
      if (res.data.success) {
        _this.proizvodjaci = res.data.proizvodjaci;
        res.data.proizvodjaci.forEach(function (element) {
          _this.backProizvodjaci.push(element.naziv);
        });
        if (_this.OJs.length === 1) {
          _this.chosenOJ = _this.OJs[0];
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("/postavke/sajtovi/" + this.$store.state.site, {
      token: this.$store.state.token
    }).then(function (res) {
      if (res.data.sajt.mjesta != undefined) {
        res.data.sajt.mjesta.forEach(function (element) {
          if (element != "") {
            _this.cities.push(element);
          }
        });
      }
    }).then(function (res) {
      _this.cities.sort(function (a, b) {
        return a.toLowerCase() == b.toLowerCase() ? 0 : +(a.toLowerCase() > b.toLowerCase()) || -1;
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    },
    izbor: function izbor() {
      switch (this.izbor) {
        case "LN":

          break;
        case "opis":

          break;

      }
    },
    LN: function LN() {
      var _this2 = this;

      if (this.LN.length > 3) {
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("/inventar/readprodukt", {
          LN: this.LN,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            _this2.postoji = true;
            _this2.produkt_data = res.data.produkt.opis + " " + res.data.produkt.pakovanje + " " + res.data.produkt.jedinica_mjere;
          } else {
            _this2.postoji = false;
          }
        });
      }
    }

  },
  methods: {
    setFocus: function setFocus() {

      this.$refs.search.focus();
    },
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.Save();
    },
    Prijem: function Prijem() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/samples/" + this.patient_id);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    getRandomInt: function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);

      return Math.floor(Math.random() * (max - min)) + min;
    },

    validateEmail: function validateEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
      } else {
        return false;
      }
    },
    validateJMBG: function validateJMBG(jmbg) {
      return (/^\d{4}[9,0]{1}\d{8}$/.test(String(jmbg)) || /^\d{4}[9,0]{1}\d{7}[P]{1}$/.test(String(jmbg))
      );
    },
    validateYear: function validateYear(year) {
      var text = /^[0-9]+$/;
      if (year != 0) {
        if (year != "" && !text.test(year)) {
          return false;
        }

        if (year.length != 4) {
          return false;
        }
        var current_year = new Date().getFullYear();
        if (year < 1921 || year > current_year) {
          return false;
        }
        return true;
      }
    },
    validateDate: function validateDate(inputText) {

      return true;
    },
    validateDateOfBirth: function validateDateOfBirth(inputText) {
      var godiste = inputText[4] + inputText[5] + inputText[6] + inputText[7];
      inputText = inputText[0] + inputText[1] + "-" + inputText[2] + inputText[3] + "-" + godiste;

      if (!this.validateYear(godiste)) {
        return false;
      }

      var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

      if (inputText.match(dateformat)) {
        var opera1 = inputText.split("/");
        var opera2 = inputText.split("-");
        var lopera1 = opera1.length;
        var lopera2 = opera2.length;

        if (lopera1 > 1) {
          var pdate = inputText.split("/");
        } else if (lopera2 > 1) {
          var pdate = inputText.split("-");
        }
        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);

        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            return false;
          }
          if (lyear == true && dd > 29) {
            return false;
          }
        }
      } else {
        return false;
      }
      return true;
    },
    Save: function Save() {
      var _this3 = this;

      if (this.LN.trim() === "" || this.opis.trim() === "" || this.sadrzaj.trim() === "" || this.jedinica.trim() === "") {
        this.toastText = "Unesite obavezna polja.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else {

        if (this.nivo.trim() === "") {
          this.nivo = "0";
        }
        if (this.danadoroka.trim() === "") {
          this.danadoroka = "30";
        }
        if (this.zasnaziv.trim() === "") {
          this.zasnaziv = "";
        }
        if (this.zemlja.trim() === "") {
          this.zemlja = "";
        }
        if (this.chosenZemlja.trim() === "") {
          this.chosenZemlja = "";
        }
        if (this.chosenKlasa.trim() === "") {
          this.chosenKlasa = "";
        }
        if (this.chosenProgram.trim() === "") {
          this.chosenProgram = "";
        }
        if (this.chosenPlatforma.trim() === "") {
          this.chosenPlatforma = "";
        }
        if (this.chosenOJ.trim() === "") {
          this.chosenOJ = this.$store.state.site;
        }

        this.produkt.LN = this.LN;
        this.produkt.opis = this.opis;
        this.produkt.zasticeni_naziv = this.zasnaziv;
        this.produkt.jedinica_mjere = this.jedinica;
        this.produkt.zemlja_porijekla = this.chosenZemlja;
        this.produkt.pakovanje = this.sadrzaj;
        this.produkt.upozorenje = this.nivo;
        this.produkt.danadoroka = this.danadoroka;
        this.backKlase.forEach(function (element) {
          if (element.naziv === _this3.chosenKlasa) {
            _this3.produkt.klasa = element._id;
          }
        });
        this.backProgrami.forEach(function (element) {
          if (element.naziv === _this3.chosenProgram) {
            _this3.produkt.program = element._id;
          }
        });
        this.backPlatforme.forEach(function (element) {
          if (element.naziv === _this3.chosenPlatforma) {
            _this3.produkt.platforma = element._id;
          }
        });
        this.backOJs.forEach(function (element) {
          if (element.naziv === _this3.chosenOJ) {
            _this3.produkt.oj = element._id;
          }
        });
        this.proizvodjaci.forEach(function (element) {
          if (element.naziv === _this3.chosenProizvodjac) {
            _this3.produkt.proizvodjac = element._id;
          }
        });
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("inventar/createprodukt", {
          produkt: this.produkt,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success === false) {
            _this3.toastText = "Greška prilikom upisa!";
            _this3.toastIcon = "fa-remove";
            _this3.toastPosition = "top-right";
            _this3.className = "vuestic-toast-danger";

            _this3.showToast(_this3.toastText, {
              icon: _this3.toastIcon,
              position: _this3.toastPosition,
              duration: _this3.toastDuration,
              fullWidth: _this3.isToastFullWidth,
              className: _this3.className
            });
          } else {
            _this3.LN = "";
            _this3.opis = "";
            _this3.sadrzaj = "";
            _this3.jedinica = "";
            _this3.postoji = false;
            _this3.invalid = false;
            _this3.error_msg = "";

            _this3.show = false;
            window.removeEventListener("keyup", _this3.listenKeyUp);

            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/inventar/produkti");
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "D4l/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D92/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DAE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fingerprint-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"spinner-ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DLuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DSfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DSl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    onClick: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
};

/***/ }),

/***/ "Dgy8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('new-patient',{on:{"new-patient":_vm.unosPacijenta}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.brStr,"datum":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:cell-clicked":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.prikaziDetalje([args]);
},"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1),_vm._v(" "),_c('vuestic-modal-patient',{ref:"largeModalPatient",attrs:{"show":_vm.show,"medium":true,"okText":_vm.potvrdi,"cancelText":_vm.odustani},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s("NOVI PRIJEM"))]),_vm._v(" "),_c('div',{staticClass:"form-elements"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"})])])]),_vm._v(" "),_c('patient-edit',{ref:"modalPatientEdit",attrs:{"show":_vm.show,"medium":true,"okText":_vm.potvrdi,"timestamp":_vm.timestamp,"cancelText":_vm.odustani,"patient":_vm.patient_data},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("UREĐIVANJE PODATAKA")+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-elements"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"})])])]),_vm._v(" "),_c('vuestic-modal-error',{ref:"staticModalNotAuthorizedEntry",attrs:{"show":_vm.show,"cancelText":"ZATVORI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("")+"\n      "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("401: Not Authorized"))])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s("Nemate odgovarajuće privilegije."))])])]),_vm._v(" "),_c('vuestic-modal-error',{ref:"staticModalNotAuthorizedEdit",attrs:{"show":_vm.show,"cancelText":"ZATVORI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("")+"\n      "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("401: Not Authorized"))])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s("Nemate odgovarajuće privilegije."))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"on-cancel":_vm.onCancel,"color":"#4ae387","is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(false)?_c('button',{on:{"click":function($event){$event.preventDefault();_vm.Test($event)}}},[_vm._v(_vm._s("Loading..."))]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dmbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__ = __webpack_require__("6b69");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0044e958_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__ = __webpack_require__("RDsl");
function injectStyle (ssrContext) {
  __webpack_require__("BHhe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0044e958"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0044e958_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DrVx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$comp;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$comp = {
  name: "vuestic-modal-control-delete",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("ControlSampleDeleted", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("ControlSampleDeleted");
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("ControlSampleDelete");

    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$comp);

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_EXPAND_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_WITHOUT_ANIMATION; });
var TOGGLE_EXPAND_MENU_ITEM = 'TOGGLE_EXPAND_MENU_ITEM';

var CLOSE_MENU = 'CLOSE_MENU';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION';

/***/ }),

/***/ "Dvia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('date-range',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],on:{"date-range":_vm.onDateRangeSet}}),_vm._v(" "),_c('items-per-page',{attrs:{"range_max":this.date_range.max,"range_min":this.date_range.min,"options":_vm.itemsPerPage,"defaultPerPage":_vm.perPage},on:{"items-per-page":_vm.onItemsPerPage}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.brStr,"datum":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:cell-clicked":function () {
                          var args = [], len = arguments.length;
                          while ( len-- ) args[ len ] = arguments[ len ];

                          return this$1.prikaziDetalje([args]);
},"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1),_vm._v(" "),_c('vuestic-modal',{ref:"largeModalComment",attrs:{"show":_vm.show,"large":true,"okText":_vm.potvrdi,"cancelText":_vm.odustani,"transition":_vm.patient},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped first-td-padding"},[_c('thead',[_c('tr',[_c('td',[_vm._v("ID UZORKA")]),_vm._v(" "),_c('td',[_vm._v("datum")]),_vm._v(" "),_c('td',[_vm._v("vrijeme")]),_vm._v(" "),_c('td',[_vm._v("izbor")]),_vm._v(" "),_c('td')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.samples),function(sample){return _c('tr',{key:sample.id},[_c('td',[_vm._v(_vm._s(sample.id))]),_vm._v(" "),(
                            _vm.danas ===
                            sample.updated_at.slice(8, 10) +
                              '.' +
                              sample.updated_at.slice(5, 7) +
                              '.' +
                              sample.updated_at.slice(0, 4)
                          )?_c('td',[_c('strong',[_vm._v("\n                            "+_vm._s(sample.updated_at.slice(8, 10) +
                              "." +
                              sample.updated_at.slice(5, 7) +
                              "." +
                              sample.updated_at.slice(0, 4))+"\n                          ")])]):_vm._e(),_vm._v(" "),(
                            _vm.danas !=
                            sample.updated_at.slice(8, 10) +
                              '.' +
                              sample.updated_at.slice(5, 7) +
                              '.' +
                              sample.updated_at.slice(0, 4)
                          )?_c('td',[_vm._v("\n                          "+_vm._s(sample.updated_at.slice(8, 10) +
                            "." +
                            sample.updated_at.slice(5, 7) +
                            "." +
                            sample.updated_at.slice(0, 4))+"\n                        ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.Test(sample.updated_at)))]),_vm._v(" "),_c('td',[(
                              _vm.danas ===
                              sample.updated_at.slice(8, 10) +
                                '.' +
                                sample.updated_at.slice(5, 7) +
                                '.' +
                                sample.updated_at.slice(0, 4)
                            )?_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{staticClass:"form-check-input",attrs:{"id":sample._id,"type":"checkbox","checked":""},on:{"click":_vm.UpdateSamples}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":sample._id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v("Uključi u predračun")])])]):_vm._e(),_vm._v(" "),(
                              _vm.danas !=
                              sample.updated_at.slice(8, 10) +
                                '.' +
                                sample.updated_at.slice(5, 7) +
                                '.' +
                                sample.updated_at.slice(0, 4)
                            )?_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{staticClass:"form-check-input",attrs:{"id":sample._id,"type":"checkbox"},on:{"click":_vm.UpdateSamples}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":sample._id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v("Uključi u predračun")])])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"valid",attrs:{"align":"middle"}},[_c('i',{class:{
                              'fa fa-check success-icon icon-right input-icon': false,
                            }})])])}))])])])])])])])])]),_vm._v(" "),_c('vuestic-modal-s',{ref:"upozoriModal",attrs:{"force":true,"show":_vm.show,"closeIconShown":false,"okText":"nastavi","cancelText":_vm.odustani,"transition":_vm.patient,"cancelClass":'btn btn-sm btn-warning',"okClass":'btn btn-sm btn-primary'},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("\n                Pacijent:\n                "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.klijent))])]),_vm._v(" "),_c('h5',[_vm._v("Nisu kompletirani uzorci:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped first-td-padding"},[_c('thead',[_c('tr',[_c('td',[_vm._v("ID UZORKA")]),_vm._v(" "),_c('td',[_vm._v("STATUS")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.samples),function(sample){return _c('tr',{key:sample.id},[_c('td',[_vm._v(_vm._s(sample.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(sample.status))])])}))])])])])])])])])]),_vm._v(" "),_c('vuestic-modal-uzorci',{ref:"staticModalUzorci",attrs:{"show":_vm.show,"cancelText":"ODUSTANI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("Pacijent: ")+"\n      "),_c('span',{staticStyle:{"color":"#4ae387"}},[_vm._v(_vm._s(_vm.partials.pacijent))])]),_vm._v(" "),_c('div',[_c('vuestic-accordion-obrada',_vm._l((_vm.partials_array),function(element){return _c('vuestic-collapse-uzorak',{key:element,attrs:{"sample":element}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(element))]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"va-row"})])])}))],1)]),_vm._v(" "),_c('vuestic-modal-viber-service',{ref:"staticModalViberService",attrs:{"show":_vm.show,"viberData":_vm.viberData,"cancelText":"ODUSTANI","okText":"POŠALJI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("")+"\n      "),(_vm.$store.state.viber === true)?_c('span',[_vm._v(_vm._s("Slanje nalaza na ‎Viber Messenger"))]):_vm._e(),_vm._v(" "),(_vm.$store.state.viber === false)?_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("401: Not Authorized"))]):_vm._e()]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('vuestic-modal-email-service',{ref:"staticModalEmailService",attrs:{"show":_vm.show,"emailData":_vm.emailData,"cancelText":"ODUSTANI","okText":"POŠALJI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("")+"\n      "),(true)?_c('span',[_vm._v(_vm._s("Slanje nalaza na e-mail adresu"))]):_vm._e(),_vm._v(" "),(false)?_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("401: Not Authorized"))]):_vm._e()]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('vuestic-modal-error',{ref:"staticModalNotAuthorizedEdit",attrs:{"show":_vm.show,"cancelText":"ZATVORI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("")+"\n      "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("401: Not Authorized"))])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s("Nemate odgovarajuće privilegije."))])])]),_vm._v(" "),_c('vuestic-modal-data',{ref:"staticModalData",attrs:{"show":_vm.show,"cancelText":"ZATVORI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("")+"\n      "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.pacIme + " " + _vm.pacPrezime))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{attrs:{"id":"god-input-icon-left","title":" ","name":"god-input-icon-left","disabled":""}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"god-input-icon-left"}},[_vm._v(_vm._s("Godište: ")+"\n\n            "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.pacGodiste))])]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{attrs:{"id":"adr-input-icon-left","title":" ","name":"adr-input-icon-left","disabled":""}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"adr-input-icon-left"}},[_vm._v(_vm._s("Adresa stanovanja: ")+"\n            "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.pacAdresa))])]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{attrs:{"id":"lok-input-icon-left","title":" ","name":"lok-input-icon-left","disabled":""}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"lok-input-icon-left"}},[_vm._v(_vm._s("Pošiljaoc pacijenta: ")+"\n            "),_c('span',{staticStyle:{"color":"#4ae387"}},[_vm._v(_vm._s(_vm.pacLokacija))])]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),(_vm.$store.state.note && _vm.note != '')?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],attrs:{"type":"text"},domProps:{"value":(_vm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s("Bilješka o pacijentu"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e()])]),_vm._v(" "),_c('vuestic-modal-data',{ref:"staticModalDataSymptoms",attrs:{"show":_vm.show,"cancelText":"ZATVORI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s("")+"\n      "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.pacIme + " " + _vm.pacPrezime))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"col-md-2"}),_vm._v(" "),(_vm.symptoms != undefined)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.povišenatjelesnatemperatura),expression:"symptoms.povišenatjelesnatemperatura"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"povišenatjelesnatemperatura","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.povišenatjelesnatemperatura)?_vm._i(_vm.symptoms.povišenatjelesnatemperatura,null)>-1:(_vm.symptoms.povišenatjelesnatemperatura)},on:{"change":function($event){var $$a=_vm.symptoms.povišenatjelesnatemperatura,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.povišenatjelesnatemperatura=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.povišenatjelesnatemperatura=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "povišenatjelesnatemperatura", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"povišenatjelesnatemperatura"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("povišena tjelesna temperatura"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.suhikašalj),expression:"symptoms.suhikašalj"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"suhikašalj","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.suhikašalj)?_vm._i(_vm.symptoms.suhikašalj,null)>-1:(_vm.symptoms.suhikašalj)},on:{"change":function($event){var $$a=_vm.symptoms.suhikašalj,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.suhikašalj=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.suhikašalj=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "suhikašalj", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"suhikašalj"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("suhi kašalj"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.umor),expression:"symptoms.umor"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"umor","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.umor)?_vm._i(_vm.symptoms.umor,null)>-1:(_vm.symptoms.umor)},on:{"change":function($event){var $$a=_vm.symptoms.umor,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.umor=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.umor=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "umor", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"umor"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("umor"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.bolovi),expression:"symptoms.bolovi"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"bolovi","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.bolovi)?_vm._i(_vm.symptoms.bolovi,null)>-1:(_vm.symptoms.bolovi)},on:{"change":function($event){var $$a=_vm.symptoms.bolovi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.bolovi=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.bolovi=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "bolovi", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"bolovi"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("bolovi"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.grlobolja),expression:"symptoms.grlobolja"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"grlobolja","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.grlobolja)?_vm._i(_vm.symptoms.grlobolja,null)>-1:(_vm.symptoms.grlobolja)},on:{"change":function($event){var $$a=_vm.symptoms.grlobolja,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.grlobolja=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.grlobolja=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "grlobolja", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"grlobolja"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("grlobolja"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.proljev),expression:"symptoms.proljev"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"proljev","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.proljev)?_vm._i(_vm.symptoms.proljev,null)>-1:(_vm.symptoms.proljev)},on:{"change":function($event){var $$a=_vm.symptoms.proljev,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.proljev=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.proljev=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "proljev", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"proljev"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("proljev"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.gubitakosjetaokusailimirisa),expression:"symptoms.gubitakosjetaokusailimirisa"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"gubitakosjetaokusailimirisa","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.gubitakosjetaokusailimirisa)?_vm._i(_vm.symptoms.gubitakosjetaokusailimirisa,null)>-1:(_vm.symptoms.gubitakosjetaokusailimirisa)},on:{"change":function($event){var $$a=_vm.symptoms.gubitakosjetaokusailimirisa,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.gubitakosjetaokusailimirisa=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.gubitakosjetaokusailimirisa=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "gubitakosjetaokusailimirisa", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"gubitakosjetaokusailimirisa"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("gubitak osjeta okusa ili mirisa"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.otežanodisanjeiligubitakdaha),expression:"symptoms.otežanodisanjeiligubitakdaha"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"otežanodisanjeiligubitakdaha","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.otežanodisanjeiligubitakdaha)?_vm._i(_vm.symptoms.otežanodisanjeiligubitakdaha,null)>-1:(_vm.symptoms.otežanodisanjeiligubitakdaha)},on:{"change":function($event){var $$a=_vm.symptoms.otežanodisanjeiligubitakdaha,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.otežanodisanjeiligubitakdaha=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.otežanodisanjeiligubitakdaha=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "otežanodisanjeiligubitakdaha", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"otežanodisanjeiligubitakdaha"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("otežano disanje ili gubitak daha"))])])]),_vm._v(" "),_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.symptoms.bolilipritisakuprsima),expression:"symptoms.bolilipritisakuprsima"}],staticClass:"form-check-input",attrs:{"disabled":true,"id":"bolilipritisakuprsima","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.symptoms.bolilipritisakuprsima)?_vm._i(_vm.symptoms.bolilipritisakuprsima,null)>-1:(_vm.symptoms.bolilipritisakuprsima)},on:{"change":function($event){var $$a=_vm.symptoms.bolilipritisakuprsima,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.symptoms.bolilipritisakuprsima=$$a.concat([$$v]))}else{$$i>-1&&(_vm.symptoms.bolilipritisakuprsima=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.symptoms, "bolilipritisakuprsima", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"bolilipritisakuprsima"}},[_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s("bol ili pritisak u prsima"))])])])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dz+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-file-upload-undo'
});

/***/ }),

/***/ "E1Kv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E72U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"input-icon-left","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter()},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Pretraga'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E8+3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eioc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-sm dropdown-toggle",attrs:{"id":"itemsPerPageBtn","type":"button","data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+" per page\n    "),_c('i',{staticClass:"ion-ios-arrow-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value)+" per page")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EqRg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EysA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUpload_vue__ = __webpack_require__("iXN+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776fcc9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUpload_vue__ = __webpack_require__("qgs9");
function injectStyle (ssrContext) {
  __webpack_require__("m+st")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776fcc9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F//X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F2Js":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F78L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)},[_c('div',{staticClass:"circle-inner-container",style:(_vm.circleInnerContainerStyle)},[_c('div',{staticClass:"circle-inner",style:(_vm.circleInnerStyle)})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FEF4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FJtU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-root"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FUSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.removed)?_c('div',{staticClass:"file-upload-gallery-item"},[_c('vuestic-file-upload-undo',{staticClass:"file-upload-gallery-item-undo",on:{"recover":_vm.recoverImage}})],1):_c('div',{staticClass:"file-upload-gallery-item",class:_vm.notGalleryItemClass},[_c('img',{staticClass:"file-upload-gallery-item-image",attrs:{"src":_vm.previewImage,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"file-upload-gallery-item-overlay"},[_c('div',{staticClass:"file-upload-gallery-item-name",attrs:{"title":_vm.file.name}},[_vm._v(_vm._s(_vm.file.name))]),_vm._v(" "),_c('div',{staticClass:"file-upload-gallery-item-size"},[_vm._v(_vm._s(_vm.file.size))]),_vm._v(" "),_c('button',{staticClass:"btn-text btn-text--secondary file-upload-gallery-item-button",attrs:{"type":"button"},on:{"click":_vm.removeImage}},[_vm._v(_vm._s(_vm.$t('fileUpload.deleteFile')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FWGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "novi-produkt",
  data: function data() {
    return {
      show: true
    };
  },


  methods: {
    NewProdukt: function NewProdukt() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("novi-produkt");
    }
  }
});

/***/ }),

/***/ "FY6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__ = __webpack_require__("cWTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dcffe88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__ = __webpack_require__("AUKn");
function injectStyle (ssrContext) {
  __webpack_require__("sNHN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dcffe88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FiEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FmeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadList__ = __webpack_require__("maDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadContainer__ = __webpack_require__("z0Ym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-file-upload',
  components: {
    VuesticFileUploadList: __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadList__["default"],
    VuesticFileUploadContainer: __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadContainer__["default"]
  },
  props: {
    type: {
      type: String,
      default: 'list',
      validator: function validator(value) {
        return ['list', 'gallery', 'single'].indexOf(value) !== -1;
      }
    },
    fileTypes: {
      type: String,
      default: ''
    },
    dropzone: {
      type: Boolean,
      default: false
    },
    value: {
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    uploadFile: function uploadFile(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (this.fileTypes) {
        files = this.validateFileTypes(files);
      }
      this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files));
    },
    removeFile: function removeFile(index) {
      this.files.splice(index, 1);
    },
    removeSingleFile: function removeSingleFile() {
      this.files = [];
    },
    validateFileTypes: function validateFileTypes(files) {
      var _this = this;

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)).filter(function (file) {
        var fileName = file.name;
        var extn = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
        if (_this.fileTypes.indexOf(extn) === -1) {
          __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("FileUploadError");
          _this.$refs.mediumModal.open();
        }
        return _this.fileTypes.indexOf(extn) !== -1;
      });
    }
  },
  computed: {
    files: {
      get: function get() {
        return this.value;
      },
      set: function set(files) {
        this.$emit('input', files);
      }
    }
  }
});

/***/ }),

/***/ "FnFL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fp4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FqBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("ISdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc2d7fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("xM51");
function injectStyle (ssrContext) {
  __webpack_require__("BfMS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecc2d7fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc2d7fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FriM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadListItem__ = __webpack_require__("5Bk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadGalleryItem__ = __webpack_require__("u0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadSingleItem__ = __webpack_require__("S0HY");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-file-upload-list",
  components: {
    VuesticFileUploadListItem: __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadListItem__["default"],
    VuesticFileUploadGalleryItem: __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadGalleryItem__["default"],
    VuesticFileUploadSingleItem: __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadSingleItem__["default"]
  },
  props: {
    type: {
      type: String
    },
    files: {
      default: null
    }
  },
  computed: {
    filesList: function filesList() {
      return this.files.map(this.convertFile);
    }
  },
  methods: {
    convertFile: function convertFile(file) {
      return {
        name: file.name,
        size: this.formatSize(file.size),
        date: this.formatDate(new Date()),
        image: file
      };
    },
    formatSize: function formatSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      var k = 1024;
      var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
    formatDate: function formatDate(date) {
      if (!date) return "";
      return date.toLocaleDateString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        month: "short",
        day: "numeric",
        year: "numeric"
      });
    }
  }
});

/***/ }),

/***/ "Fv2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('items-per-page',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"options":_vm.itemsPerPage,"defaultPerPage":_vm.perPage},on:{"items-per-page":_vm.onItemsPerPage}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:pagination-data":_vm.onPaginationData,"vuetable:cell-clicked":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.Akcija([args]);
},"vuetable:cell-dblclicked":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.Double([args]);
}}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G+1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalHandshake_vue__ = __webpack_require__("WM4b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d99228ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalHandshake_vue__ = __webpack_require__("43Js");
function injectStyle (ssrContext) {
  __webpack_require__("OyUw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalHandshake_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d99228ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalHandshake_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "G+DE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G/Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{staticClass:"vuestic-collapse__header__button btn btn-primary",staticStyle:{"text-transform":"none"}},[_vm._t("header")],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G1fw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GB0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "auth-layout"
});

/***/ }),

/***/ "GI4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "GUrv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"nav d-lg-none"},[_c('router-link',{staticClass:"i-vuestic",attrs:{"to":{path: '/'}}})],1),_vm._v(" "),_c('div',{staticClass:"main row"},[_c('div',{staticClass:"auth-content col-lg-6 col-12"},[_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('div',{staticClass:"auth-wallpaper col-6 d-none d-lg-flex"},[_c('div',{staticClass:"oblique"}),_vm._v(" "),_c('router-link',{staticClass:"i-vuestic",attrs:{"to":{path: '/'}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GW8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons && _vm.$store.state.access.level > 0)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s('ZATVORI'))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.$store.state.access.level < 1)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.$store.state.access.level < 1)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GnSh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$comp;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$comp = {
  name: "postavke-delete-sites",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("deleteSitesClose", function () {
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("CollapseAllSites");
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("deleteSitesClose");
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("okDeleteSite");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$comp);

/***/ }),

/***/ "GslS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__ = __webpack_require__("cfdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__ = __webpack_require__("+Uuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__ = __webpack_require__("oXux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__ = __webpack_require__("2653");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__ = __webpack_require__("tZ2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_labassays_vuestic_datatable_VuesticDataTable_vue__ = __webpack_require__("SsKA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_anaassays_vuestic_datatable_VuesticDataTable_vue__ = __webpack_require__("27Vx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_kontrole_definicija_Table_edit_datatable_VuesticDataTable_vue__ = __webpack_require__("y4Rm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_file_upload_VuesticFileUpload__ = __webpack_require__("sELh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_excel_vuestic_file_upload_VuesticFileUpload__ = __webpack_require__("EysA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_02_prijem_PacijentsTable_vue__ = __webpack_require__("o4Af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_inventar_produkti_ProduktTable_vue__ = __webpack_require__("w5Sz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__ = __webpack_require__("Q4Rp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__ = __webpack_require__("NG7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_02_samples_DrugoStanje_vue__ = __webpack_require__("cdlS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_modal_VuesticModalMedium_vue__ = __webpack_require__("Wvsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_modal_VuesticModalStatic_vue__ = __webpack_require__("aXvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_02_samples_Patient_vue__ = __webpack_require__("uCDW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_inventar_produkti_Produkt_vue__ = __webpack_require__("oxgk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_layout_navbar_ChangePassword_vue__ = __webpack_require__("MwJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_layout_navbar_InitialPassword_vue__ = __webpack_require__("6E+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_02_prijem_PatientEdit_vue__ = __webpack_require__("i1PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_02_samples_Commenting_vue__ = __webpack_require__("aF9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_02_samples_Calendar_vue__ = __webpack_require__("XFNM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_obrada_Calendar_vue__ = __webpack_require__("mzx/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_obrada_components_VuesticModalDelete__ = __webpack_require__("B58c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_obrada_components_VuesticModalEdit__ = __webpack_require__("X44x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_reports_VuesticModal__ = __webpack_require__("shI0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_obrada_components_VuesticModalMulti__ = __webpack_require__("4dey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_obrada_components_VuesticModalComment__ = __webpack_require__("497r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_obrada_components_VuesticModalFind__ = __webpack_require__("xAIc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_obrada_components_VuesticModalReference__ = __webpack_require__("jDO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_obrada_components_VuesticModalMail__ = __webpack_require__("x5pt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_obrada_components_VuesticModalError__ = __webpack_require__("nXZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_obrada_components_VuesticModalHandshake__ = __webpack_require__("G+1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_nalazi_pregled_VuesticModalData__ = __webpack_require__("n9rL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_nalazi_pregled_VuesticModalViberService__ = __webpack_require__("+1re");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_nalazi_pregled_VuesticModalEmailService__ = __webpack_require__("ex6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_obrada_components_VuesticModalExclamation__ = __webpack_require__("LijO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_obrada_components_VuesticModalUzorci__ = __webpack_require__("YCi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_obrada_components_VuesticModalAparati__ = __webpack_require__("aHZh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_obrada_components_VuesticModalEvaluationSingle__ = __webpack_require__("xYBa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_obrada_components_VuesticModalEvaluationMulti__ = __webpack_require__("qQ6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_obrada_components_VuesticModalAllResults__ = __webpack_require__("noGi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_obrada_components_VuesticModalResultsMulti__ = __webpack_require__("ip1w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_labassays_LabAssayEditModal__ = __webpack_require__("kHgk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_postavke_SiteModal__ = __webpack_require__("t9OK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_components_postavke_UserModal__ = __webpack_require__("we+w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_components_postavke_RadioButton__ = __webpack_require__("YZh0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_components_postavke_PostavkeModal__ = __webpack_require__("oIp1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_components_labassays_MultiModal__ = __webpack_require__("NA/e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_components_labassays_LabAssayDelete__ = __webpack_require__("kdSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_components_anaassays_AnaAssayDelete__ = __webpack_require__("67kX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_components_anaassays_AnaAssayEditModal__ = __webpack_require__("I2KX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_components_anaassays_AnaAssayRefSingle__ = __webpack_require__("p8Pd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_components_anaassays_AnaAssayRefMulti__ = __webpack_require__("rsSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("VAWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__ = __webpack_require__("74xX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__ = __webpack_require__("XznE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__ = __webpack_require__("/LRh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_components_evaluation_VuesticSimpleSelect_vue__ = __webpack_require__("emdL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__ = __webpack_require__("IqWy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_src_components_vuestic_components_vuestic_input_select_VuesticInputSelect_vue__ = __webpack_require__("P2Ka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__ = __webpack_require__("anct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__ = __webpack_require__("rhzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__ = __webpack_require__("LtNJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_src_components_vuestic_components_vuestic_tag_VuesticTag__ = __webpack_require__("aTa4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_src_components_vuestic_components_vuestic_tag_VuesticTagGroup__ = __webpack_require__("L2/I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_src_components_vuestic_components_vuestic_tooltip_VuesticTooltip_vue__ = __webpack_require__("PpPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_src_components_vuestic_components_vuestic_popover_VuesticPopover_vue__ = __webpack_require__("wf/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__ = __webpack_require__("Dmbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_src_components_evaluation_VuesticWidget_vue__ = __webpack_require__("093r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_src_components_vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__ = __webpack_require__("d4/x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_src_components_vuestic_mixins_VuesticToasted__ = __webpack_require__("bhip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_src_components_vuestic_components_vuestic_site_SiteDropdown_vue__ = __webpack_require__("4ZaD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_src_components_vuestic_directives_Dropdown__ = __webpack_require__("SRTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_src_components_vuestic_components_vuestic_date_picker_VuesticDatePicker__ = __webpack_require__("UfMP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_src_components_vuestic_components_vuestic_tree_view_VuesticTreeRoot__ = __webpack_require__("hF5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_src_components_vuestic_components_vuestic_tree_view_VuesticTreeNode__ = __webpack_require__("FY6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_src_components_vuestic_components_vuestic_tree_view_VuesticTreeCategory__ = __webpack_require__("MCoA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_src_components_vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__ = __webpack_require__("aj+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_src_components_vuestic_components_vuestic_collapse_VuesticAccordionPatientInfo__ = __webpack_require__("xAVG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_src_components_vuestic_components_vuestic_collapse_VuesticAccordionSamplesEntry__ = __webpack_require__("4S38");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_src_components_obrada_components_VuesticAccordionObrada__ = __webpack_require__("zrkU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_src_components_vuestic_components_vuestic_collapse_VuesticCollapsePatientInfo__ = __webpack_require__("TS+I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_src_components_vuestic_components_vuestic_collapse_VuesticCollapseSamplesEntry__ = __webpack_require__("pmVg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_src_components_obrada_components_VuesticCollapseObrada__ = __webpack_require__("w6AR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_src_components_obrada_components_VuesticCollapseNalaz__ = __webpack_require__("1GIG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_src_components_obrada_components_VuesticCollapseUzorak__ = __webpack_require__("plIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_src_components_obrada_components_VuesticCollapseAparati__ = __webpack_require__("rJt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__ = __webpack_require__("8/T/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_src_components_labassays_JsonEdit_vue__ = __webpack_require__("8E1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_src_components_postavke_JsonEdit_vue__ = __webpack_require__("aWyB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_src_components_analysers_JsonEdit_vue__ = __webpack_require__("iuWn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_src_components_loger_postavke_JsonEdit_vue__ = __webpack_require__("bD1Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_src_components_loger_postavke_KalibracijaModal_vue__ = __webpack_require__("3JiH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_src_components_loger_pregled_VuesticModalGraph_vue__ = __webpack_require__("MRkw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_src_components_loger_pregled_VuesticModalTable_vue__ = __webpack_require__("9QRd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_src_components_postavke_postavkeAccordion_vue__ = __webpack_require__("dJjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_src_components_postavke_postavkeCollapse_vue__ = __webpack_require__("tPNP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_src_components_postavke_postavkeDeleteSites_vue__ = __webpack_require__("Z4em");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_src_components_postavke_postavkeDeleteUsers_vue__ = __webpack_require__("+KPY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_src_components_mikrobiologija_MikrobiologijaEdit_vue__ = __webpack_require__("l/ha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_src_components_obrada_components_VuesticModalMicroReset__ = __webpack_require__("IHTr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_src_components_obrada_components_VuesticModalMicroResult__ = __webpack_require__("5H7z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_src_components_obrada_components_VuesticModalMicroBactery__ = __webpack_require__("d9vy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_src_components_obrada_components_VuesticTabsBactery__ = __webpack_require__("9xgs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_src_components_obrada_components_RadioButtonBactery__ = __webpack_require__("niIE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_src_components_kontrole_definicija_components_ControlDeleteModal__ = __webpack_require__("RBqZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_src_components_kontrole_definicija_components_ControlEditModal__ = __webpack_require__("nDS2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_src_components_kontrole_definicija_components_ControlReferences__ = __webpack_require__("Tea9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_src_components_kontrole_definicija_components_VuesticModalControlAparati__ = __webpack_require__("PLYV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_src_components_kontrole_definicija_components_VuesticAccordionControlAparati__ = __webpack_require__("vaSp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_src_components_kontrole_definicija_components_VuesticCollapseControlAparati__ = __webpack_require__("aOf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_src_components_kontrole_unos_components_VuesticAccordion__ = __webpack_require__("ow+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_src_components_kontrole_unos_components_VuesticCollapse__ = __webpack_require__("7CmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_src_components_kontrole_pregled_components_AccordionObrada__ = __webpack_require__("dbhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_src_components_kontrole_pregled_components_CollapseObrada__ = __webpack_require__("nYBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_src_components_kontrole_pregled_components_ModalComment__ = __webpack_require__("OMi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_src_components_kontrole_pregled_components_ModalDelete__ = __webpack_require__("TsB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_src_components_kontrole_pregled_components_ModalError__ = __webpack_require__("+jAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_src_components_kontrole_pregled_components_VuesticModalMail__ = __webpack_require__("xq+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_src_components_kontrole_pregled_components_VuesticWidget__ = __webpack_require__("9aYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_src_components_partneri_VuesticModalPartneriDelete__ = __webpack_require__("AFOn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_src_components_partneri_VuesticModalPartneriEdit__ = __webpack_require__("/DkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_src_components_partneri_VuesticModalPartneriInfo__ = __webpack_require__("dpoI");






































































































































var VuesticComponentsPlugin = {
    install: function install(Vue, options) {

        Vue.component(__WEBPACK_IMPORTED_MODULE_124_src_components_partneri_VuesticModalPartneriDelete__["default"].name, __WEBPACK_IMPORTED_MODULE_124_src_components_partneri_VuesticModalPartneriDelete__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_125_src_components_partneri_VuesticModalPartneriEdit__["default"].name, __WEBPACK_IMPORTED_MODULE_125_src_components_partneri_VuesticModalPartneriEdit__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_126_src_components_partneri_VuesticModalPartneriInfo__["default"].name, __WEBPACK_IMPORTED_MODULE_126_src_components_partneri_VuesticModalPartneriInfo__["default"]);

        Vue.component(__WEBPACK_IMPORTED_MODULE_109_src_components_kontrole_definicija_components_ControlDeleteModal__["default"].name, __WEBPACK_IMPORTED_MODULE_109_src_components_kontrole_definicija_components_ControlDeleteModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_110_src_components_kontrole_definicija_components_ControlEditModal__["default"].name, __WEBPACK_IMPORTED_MODULE_110_src_components_kontrole_definicija_components_ControlEditModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_111_src_components_kontrole_definicija_components_ControlReferences__["default"].name, __WEBPACK_IMPORTED_MODULE_111_src_components_kontrole_definicija_components_ControlReferences__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_112_src_components_kontrole_definicija_components_VuesticModalControlAparati__["default"].name, __WEBPACK_IMPORTED_MODULE_112_src_components_kontrole_definicija_components_VuesticModalControlAparati__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_113_src_components_kontrole_definicija_components_VuesticAccordionControlAparati__["default"].name, __WEBPACK_IMPORTED_MODULE_113_src_components_kontrole_definicija_components_VuesticAccordionControlAparati__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_114_src_components_kontrole_definicija_components_VuesticCollapseControlAparati__["default"].name, __WEBPACK_IMPORTED_MODULE_114_src_components_kontrole_definicija_components_VuesticCollapseControlAparati__["default"]);

        Vue.component(__WEBPACK_IMPORTED_MODULE_115_src_components_kontrole_unos_components_VuesticAccordion__["default"].name, __WEBPACK_IMPORTED_MODULE_115_src_components_kontrole_unos_components_VuesticAccordion__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_116_src_components_kontrole_unos_components_VuesticCollapse__["default"].name, __WEBPACK_IMPORTED_MODULE_116_src_components_kontrole_unos_components_VuesticCollapse__["default"]);

        Vue.component(__WEBPACK_IMPORTED_MODULE_117_src_components_kontrole_pregled_components_AccordionObrada__["default"].name, __WEBPACK_IMPORTED_MODULE_117_src_components_kontrole_pregled_components_AccordionObrada__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_118_src_components_kontrole_pregled_components_CollapseObrada__["default"].name, __WEBPACK_IMPORTED_MODULE_118_src_components_kontrole_pregled_components_CollapseObrada__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_119_src_components_kontrole_pregled_components_ModalComment__["default"].name, __WEBPACK_IMPORTED_MODULE_119_src_components_kontrole_pregled_components_ModalComment__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_120_src_components_kontrole_pregled_components_ModalDelete__["default"].name, __WEBPACK_IMPORTED_MODULE_120_src_components_kontrole_pregled_components_ModalDelete__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_121_src_components_kontrole_pregled_components_ModalError__["default"].name, __WEBPACK_IMPORTED_MODULE_121_src_components_kontrole_pregled_components_ModalError__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_122_src_components_kontrole_pregled_components_VuesticModalMail__["default"].name, __WEBPACK_IMPORTED_MODULE_122_src_components_kontrole_pregled_components_VuesticModalMail__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_123_src_components_kontrole_pregled_components_VuesticWidget__["default"].name, __WEBPACK_IMPORTED_MODULE_123_src_components_kontrole_pregled_components_VuesticWidget__["default"]);

        Vue.component(__WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_5_src_components_labassays_vuestic_datatable_VuesticDataTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_5_src_components_labassays_vuestic_datatable_VuesticDataTable_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_6_src_components_anaassays_vuestic_datatable_VuesticDataTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_6_src_components_anaassays_vuestic_datatable_VuesticDataTable_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_7_src_components_kontrole_definicija_Table_edit_datatable_VuesticDataTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_7_src_components_kontrole_definicija_Table_edit_datatable_VuesticDataTable_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_file_upload_VuesticFileUpload__["default"].name, __WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_file_upload_VuesticFileUpload__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_9_src_components_excel_vuestic_file_upload_VuesticFileUpload__["default"].name, __WEBPACK_IMPORTED_MODULE_9_src_components_excel_vuestic_file_upload_VuesticFileUpload__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_10_src_components_02_prijem_PacijentsTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_10_src_components_02_prijem_PacijentsTable_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_11_src_components_inventar_produkti_ProduktTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_11_src_components_inventar_produkti_ProduktTable_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_12_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_12_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_modal_VuesticModalMedium_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_modal_VuesticModalMedium_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_19_src_components_layout_navbar_ChangePassword_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_19_src_components_layout_navbar_ChangePassword_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_20_src_components_layout_navbar_InitialPassword_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_20_src_components_layout_navbar_InitialPassword_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_17_src_components_02_samples_Patient_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_17_src_components_02_samples_Patient_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_18_src_components_inventar_produkti_Produkt_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_18_src_components_inventar_produkti_Produkt_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_27_src_components_reports_VuesticModal__["default"].name, __WEBPACK_IMPORTED_MODULE_27_src_components_reports_VuesticModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_21_src_components_02_prijem_PatientEdit_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_21_src_components_02_prijem_PatientEdit_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_22_src_components_02_samples_Commenting_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_22_src_components_02_samples_Commenting_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_23_src_components_02_samples_Calendar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_23_src_components_02_samples_Calendar_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_24_src_components_obrada_Calendar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_24_src_components_obrada_Calendar_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_51_src_components_labassays_LabAssayDelete__["default"].name, __WEBPACK_IMPORTED_MODULE_51_src_components_labassays_LabAssayDelete__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_52_src_components_anaassays_AnaAssayDelete__["default"].name, __WEBPACK_IMPORTED_MODULE_52_src_components_anaassays_AnaAssayDelete__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_modal_VuesticModalStatic_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_modal_VuesticModalStatic_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_14_src_components_02_samples_DrugoStanje_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_14_src_components_02_samples_DrugoStanje_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_25_src_components_obrada_components_VuesticModalDelete__["default"].name, __WEBPACK_IMPORTED_MODULE_25_src_components_obrada_components_VuesticModalDelete__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_26_src_components_obrada_components_VuesticModalEdit__["default"].name, __WEBPACK_IMPORTED_MODULE_26_src_components_obrada_components_VuesticModalEdit__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_28_src_components_obrada_components_VuesticModalMulti__["default"].name, __WEBPACK_IMPORTED_MODULE_28_src_components_obrada_components_VuesticModalMulti__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_29_src_components_obrada_components_VuesticModalComment__["default"].name, __WEBPACK_IMPORTED_MODULE_29_src_components_obrada_components_VuesticModalComment__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_30_src_components_obrada_components_VuesticModalFind__["default"].name, __WEBPACK_IMPORTED_MODULE_30_src_components_obrada_components_VuesticModalFind__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_31_src_components_obrada_components_VuesticModalReference__["default"].name, __WEBPACK_IMPORTED_MODULE_31_src_components_obrada_components_VuesticModalReference__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_32_src_components_obrada_components_VuesticModalMail__["default"].name, __WEBPACK_IMPORTED_MODULE_32_src_components_obrada_components_VuesticModalMail__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_33_src_components_obrada_components_VuesticModalError__["default"].name, __WEBPACK_IMPORTED_MODULE_33_src_components_obrada_components_VuesticModalError__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_34_src_components_obrada_components_VuesticModalHandshake__["default"].name, __WEBPACK_IMPORTED_MODULE_34_src_components_obrada_components_VuesticModalHandshake__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_35_src_components_nalazi_pregled_VuesticModalData__["default"].name, __WEBPACK_IMPORTED_MODULE_35_src_components_nalazi_pregled_VuesticModalData__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_36_src_components_nalazi_pregled_VuesticModalViberService__["default"].name, __WEBPACK_IMPORTED_MODULE_36_src_components_nalazi_pregled_VuesticModalViberService__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_37_src_components_nalazi_pregled_VuesticModalEmailService__["default"].name, __WEBPACK_IMPORTED_MODULE_37_src_components_nalazi_pregled_VuesticModalEmailService__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_38_src_components_obrada_components_VuesticModalExclamation__["default"].name, __WEBPACK_IMPORTED_MODULE_38_src_components_obrada_components_VuesticModalExclamation__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_39_src_components_obrada_components_VuesticModalUzorci__["default"].name, __WEBPACK_IMPORTED_MODULE_39_src_components_obrada_components_VuesticModalUzorci__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_40_src_components_obrada_components_VuesticModalAparati__["default"].name, __WEBPACK_IMPORTED_MODULE_40_src_components_obrada_components_VuesticModalAparati__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_41_src_components_obrada_components_VuesticModalEvaluationSingle__["default"].name, __WEBPACK_IMPORTED_MODULE_41_src_components_obrada_components_VuesticModalEvaluationSingle__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_42_src_components_obrada_components_VuesticModalEvaluationMulti__["default"].name, __WEBPACK_IMPORTED_MODULE_42_src_components_obrada_components_VuesticModalEvaluationMulti__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_43_src_components_obrada_components_VuesticModalAllResults__["default"].name, __WEBPACK_IMPORTED_MODULE_43_src_components_obrada_components_VuesticModalAllResults__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_44_src_components_obrada_components_VuesticModalResultsMulti__["default"].name, __WEBPACK_IMPORTED_MODULE_44_src_components_obrada_components_VuesticModalResultsMulti__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_45_src_components_labassays_LabAssayEditModal__["default"].name, __WEBPACK_IMPORTED_MODULE_45_src_components_labassays_LabAssayEditModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_46_src_components_postavke_SiteModal__["default"].name, __WEBPACK_IMPORTED_MODULE_46_src_components_postavke_SiteModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_47_src_components_postavke_UserModal__["default"].name, __WEBPACK_IMPORTED_MODULE_47_src_components_postavke_UserModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_48_src_components_postavke_RadioButton__["default"].name, __WEBPACK_IMPORTED_MODULE_48_src_components_postavke_RadioButton__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_49_src_components_postavke_PostavkeModal__["default"].name, __WEBPACK_IMPORTED_MODULE_49_src_components_postavke_PostavkeModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_53_src_components_anaassays_AnaAssayEditModal__["default"].name, __WEBPACK_IMPORTED_MODULE_53_src_components_anaassays_AnaAssayEditModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_54_src_components_anaassays_AnaAssayRefSingle__["default"].name, __WEBPACK_IMPORTED_MODULE_54_src_components_anaassays_AnaAssayRefSingle__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_55_src_components_anaassays_AnaAssayRefMulti__["default"].name, __WEBPACK_IMPORTED_MODULE_55_src_components_anaassays_AnaAssayRefMulti__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_50_src_components_labassays_MultiModal__["default"].name, __WEBPACK_IMPORTED_MODULE_50_src_components_labassays_MultiModal__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_56_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_56_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_57_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_57_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_58_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_58_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_59_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_59_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_60_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_60_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_61_src_components_evaluation_VuesticSimpleSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_61_src_components_evaluation_VuesticSimpleSelect_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_62_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_62_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_63_src_components_vuestic_components_vuestic_input_select_VuesticInputSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_63_src_components_vuestic_components_vuestic_input_select_VuesticInputSelect_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_64_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_64_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_65_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_65_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_66_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_66_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_67_src_components_vuestic_components_vuestic_tag_VuesticTag__["default"].name, __WEBPACK_IMPORTED_MODULE_67_src_components_vuestic_components_vuestic_tag_VuesticTag__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_68_src_components_vuestic_components_vuestic_tag_VuesticTagGroup__["default"].name, __WEBPACK_IMPORTED_MODULE_68_src_components_vuestic_components_vuestic_tag_VuesticTagGroup__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_69_src_components_vuestic_components_vuestic_tooltip_VuesticTooltip_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_69_src_components_vuestic_components_vuestic_tooltip_VuesticTooltip_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_70_src_components_vuestic_components_vuestic_popover_VuesticPopover_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_70_src_components_vuestic_components_vuestic_popover_VuesticPopover_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_71_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_71_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_72_src_components_evaluation_VuesticWidget_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_72_src_components_evaluation_VuesticWidget_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_73_src_components_vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_73_src_components_vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_75_src_components_vuestic_components_vuestic_site_SiteDropdown_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_75_src_components_vuestic_components_vuestic_site_SiteDropdown_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_77_src_components_vuestic_components_vuestic_date_picker_VuesticDatePicker__["default"].name, __WEBPACK_IMPORTED_MODULE_77_src_components_vuestic_components_vuestic_date_picker_VuesticDatePicker__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_78_src_components_vuestic_components_vuestic_tree_view_VuesticTreeRoot__["default"].name, __WEBPACK_IMPORTED_MODULE_78_src_components_vuestic_components_vuestic_tree_view_VuesticTreeRoot__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_79_src_components_vuestic_components_vuestic_tree_view_VuesticTreeNode__["default"].name, __WEBPACK_IMPORTED_MODULE_79_src_components_vuestic_components_vuestic_tree_view_VuesticTreeNode__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_80_src_components_vuestic_components_vuestic_tree_view_VuesticTreeCategory__["default"].name, __WEBPACK_IMPORTED_MODULE_80_src_components_vuestic_components_vuestic_tree_view_VuesticTreeCategory__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_81_src_components_vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_81_src_components_vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_82_src_components_vuestic_components_vuestic_collapse_VuesticAccordionPatientInfo__["default"].name, __WEBPACK_IMPORTED_MODULE_82_src_components_vuestic_components_vuestic_collapse_VuesticAccordionPatientInfo__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_83_src_components_vuestic_components_vuestic_collapse_VuesticAccordionSamplesEntry__["default"].name, __WEBPACK_IMPORTED_MODULE_83_src_components_vuestic_components_vuestic_collapse_VuesticAccordionSamplesEntry__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_84_src_components_obrada_components_VuesticAccordionObrada__["default"].name, __WEBPACK_IMPORTED_MODULE_84_src_components_obrada_components_VuesticAccordionObrada__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_85_src_components_vuestic_components_vuestic_collapse_VuesticCollapsePatientInfo__["default"].name, __WEBPACK_IMPORTED_MODULE_85_src_components_vuestic_components_vuestic_collapse_VuesticCollapsePatientInfo__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_86_src_components_vuestic_components_vuestic_collapse_VuesticCollapseSamplesEntry__["default"].name, __WEBPACK_IMPORTED_MODULE_86_src_components_vuestic_components_vuestic_collapse_VuesticCollapseSamplesEntry__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_87_src_components_obrada_components_VuesticCollapseObrada__["default"].name, __WEBPACK_IMPORTED_MODULE_87_src_components_obrada_components_VuesticCollapseObrada__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_88_src_components_obrada_components_VuesticCollapseNalaz__["default"].name, __WEBPACK_IMPORTED_MODULE_88_src_components_obrada_components_VuesticCollapseNalaz__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_89_src_components_obrada_components_VuesticCollapseUzorak__["default"].name, __WEBPACK_IMPORTED_MODULE_89_src_components_obrada_components_VuesticCollapseUzorak__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_90_src_components_obrada_components_VuesticCollapseAparati__["default"].name, __WEBPACK_IMPORTED_MODULE_90_src_components_obrada_components_VuesticCollapseAparati__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_91_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_91_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_92_src_components_labassays_JsonEdit_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_92_src_components_labassays_JsonEdit_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_93_src_components_postavke_JsonEdit_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_93_src_components_postavke_JsonEdit_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_94_src_components_analysers_JsonEdit_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_94_src_components_analysers_JsonEdit_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_95_src_components_loger_postavke_JsonEdit_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_95_src_components_loger_postavke_JsonEdit_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_96_src_components_loger_postavke_KalibracijaModal_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_96_src_components_loger_postavke_KalibracijaModal_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_97_src_components_loger_pregled_VuesticModalGraph_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_97_src_components_loger_pregled_VuesticModalGraph_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_98_src_components_loger_pregled_VuesticModalTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_98_src_components_loger_pregled_VuesticModalTable_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_100_src_components_postavke_postavkeCollapse_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_100_src_components_postavke_postavkeCollapse_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_99_src_components_postavke_postavkeAccordion_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_99_src_components_postavke_postavkeAccordion_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_101_src_components_postavke_postavkeDeleteSites_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_101_src_components_postavke_postavkeDeleteSites_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_102_src_components_postavke_postavkeDeleteUsers_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_102_src_components_postavke_postavkeDeleteUsers_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_103_src_components_mikrobiologija_MikrobiologijaEdit_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_103_src_components_mikrobiologija_MikrobiologijaEdit_vue__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_104_src_components_obrada_components_VuesticModalMicroReset__["default"].name, __WEBPACK_IMPORTED_MODULE_104_src_components_obrada_components_VuesticModalMicroReset__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_105_src_components_obrada_components_VuesticModalMicroResult__["default"].name, __WEBPACK_IMPORTED_MODULE_105_src_components_obrada_components_VuesticModalMicroResult__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_106_src_components_obrada_components_VuesticModalMicroBactery__["default"].name, __WEBPACK_IMPORTED_MODULE_106_src_components_obrada_components_VuesticModalMicroBactery__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_107_src_components_obrada_components_VuesticTabsBactery__["default"].name, __WEBPACK_IMPORTED_MODULE_107_src_components_obrada_components_VuesticTabsBactery__["default"]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_108_src_components_obrada_components_RadioButtonBactery__["default"].name, __WEBPACK_IMPORTED_MODULE_108_src_components_obrada_components_RadioButtonBactery__["default"]);
        Vue.mixin(__WEBPACK_IMPORTED_MODULE_74_src_components_vuestic_mixins_VuesticToasted__["a" /* default */]);
        Vue.directive("dropdown", __WEBPACK_IMPORTED_MODULE_76_src_components_vuestic_directives_Dropdown__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (VuesticComponentsPlugin);

/***/ }),

/***/ "H65f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "H7sF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"form-group with-icon-right dropdown select-form-group multiselect-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","required":""},domProps:{"value":_vm.displayValue}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{key:option,staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))]),_vm._v(" "),_c('i',{staticClass:"fa fa-check selected-icon"})])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HDUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-email-service",
  props: {
    emailData: {
      type: Object,
      default: function _default() {
        return {
          timestamp: "",
          uzorak: "",
          email: "",
          valid: false,
          protokol: "",
          ime: "",
          prezime: "",
          godiste: "",
          spol: ""
        };
      }
    },
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      isLoading: false,
      fullPage: true,

      ba: true,
      en: true,
      de: true,

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    Test: function Test() {
      var _this = this;

      this.isLoading = true;

      setTimeout(function () {
        _this.isLoading = false;
      }, 2000);
    },
    onCancel: function onCancel() {},
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      var _this2 = this;

      this.$emit("ok");

      this.isLoading = true;

      console.log(this.emailData);

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].post("nalazi/mail", {
        token: this.$store.state.token,
        site: this.$store.state.site,
        email: this.emailData.email,
        timestamp: this.emailData.timestamp,
        location: "/",
        naziv: this.emailData.timestamp
      }).then(function (res) {

        _this2.show = false;
        _this2.isLoading = false;
        window.removeEventListener("keyup", _this2.listenKeyUp);

        if (res.data.success) {
          _this2.toastText = "Nalaz uspješno poslan.";
          _this2.toastIcon = "fa-check";
          _this2.toastPosition = "top-right";
          _this2.className = "vuestic-toast-primary";

          _this2.showToast(_this2.toastText, {
            icon: _this2.toastIcon,
            position: _this2.toastPosition,
            duration: 1500,
            fullWidth: _this2.false,
            className: _this2.className
          });
        } else {
          _this2.toastText = "Greška prilikom slanja nalaza!";
          _this2.toastIcon = "fa-remove";
          _this2.toastPosition = "top-right";
          _this2.className = "vuestic-toast-danger";

          _this2.showToast(_this2.toastText, {
            icon: _this2.toastIcon,
            position: _this2.toastPosition,
            duration: 1500,
            fullWidth: _this2.false,
            className: _this2.className
          });
        }
      });
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      this.isLoading = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.ba = true;
      this.en = true;
      this.de = true;
      this.show = true;

      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "HFJv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HPkg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hc7Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HcFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HmjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "nalazi",
  meta: {
    expanded: false,
    title: "Pregled nalaza",
    class: "primary",
    show: false,
    iconClass: "vuestic-icon vuestic-icon-files"
  },
  children: [{
    name: "rt-nalazi-pregled",
    path: "/rtnalazi/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("rtnalazi/pregled/pregled"),
    meta: {
      title: "CoV2 RT PCR nalazi",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "lp-nalazi-pregled",
    path: "/lpnalazi/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("lpnalazi/pregled/pregled"),
    meta: {
      title: "CoV2 RT LAMP nalazi",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "ag-nalazi-pregled",
    path: "/agnalazi/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("agnalazi/pregled/pregled"),
    meta: {
      title: "CoV2 Antigen nalazi",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "at-nalazi-pregled",
    path: "/atnalazi/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("atnalazi/pregled/pregled"),
    meta: {
      title: "CoV2 Antitijela nalazi",
      show: false,
      requiredAuth: true
    }
  }]
});

/***/ }),

/***/ "Hwjq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hwru":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hy37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HzoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: true
    };
  },


  methods: {
    NewPatient: function NewPatient() {
      this.$emit("new-patient");
    }
  }
});

/***/ }),

/***/ "I2KX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayEditModal_vue__ = __webpack_require__("/L/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171f487e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayEditModal_vue__ = __webpack_require__("X14r");
function injectStyle (ssrContext) {
  __webpack_require__("oft1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171f487e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "I32p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4TD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.emailData.valid),expression:"!emailData.valid"}]},[_c('strong',[_vm._v(_vm._s("E-mail adresa nije validna."))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailData.valid),expression:"emailData.valid"}]},[_c('strong',[_vm._v(_vm._s("E-mail adresa:")+"  \n                   \n                   \n                   "),_c('span',{staticStyle:{"color":"#4ab2e3"}},[_vm._v(_vm._s(_vm.emailData.email))])]),_vm._v(" "),_c('div',{staticStyle:{"min-height":"12px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ba),expression:"ba"}],staticClass:"form-check-input",attrs:{"id":"ba","type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.ba)?_vm._i(_vm.ba,null)>-1:(_vm.ba)},on:{"change":function($event){var $$a=_vm.ba,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ba=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ba=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ba=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"ba"}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s("Bosanski jezik"))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.en),expression:"en"}],staticClass:"form-check-input",attrs:{"id":"en","type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.en)?_vm._i(_vm.en,null)>-1:(_vm.en)},on:{"change":function($event){var $$a=_vm.en,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.en=$$a.concat([$$v]))}else{$$i>-1&&(_vm.en=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.en=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"en"}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s("Engleski jezik"))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.de),expression:"de"}],staticClass:"form-check-input",attrs:{"id":"de","type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.de)?_vm._i(_vm.de,null)>-1:(_vm.de)},on:{"change":function($event){var $$a=_vm.de,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.de=$$a.concat([$$v]))}else{$$i>-1&&(_vm.de=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.de=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"de"}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s("Njemački jezik"))])])])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons && !_vm.emailData.valid)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s("ZATVORI"))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.emailData.valid)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled || !_vm.emailData.valid || _vm.isLoading || (!_vm.ba && !_vm.en && !_vm.de)},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"on-cancel":_vm.onCancel,"color":"#4ae387","is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(false)?_c('button',{on:{"click":function($event){$event.preventDefault();_vm.Test($event)}}},[_vm._v(_vm._s("Loading..."))]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I8H2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("P8Jp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e880e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("Q8YL");
function injectStyle (ssrContext) {
  __webpack_require__("S5Qx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e880e5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e880e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IAGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-data",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "IEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons && _vm.$store.state.access.level > 0)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s('ZATVORI'))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.$store.state.access.level < 1)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.$store.state.access.level < 1)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IHTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMicroReset_vue__ = __webpack_require__("fCl3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c5c4fef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMicroReset_vue__ = __webpack_require__("k09c");
function injectStyle (ssrContext) {
  __webpack_require__("Y97U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMicroReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c5c4fef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMicroReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "INR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IPD5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IPbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_directives_Dropdown__ = __webpack_require__("SRTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-input-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0__vuestic_directives_Dropdown__["a" /* default */]
  },
  props: {
    label: String,
    options: Array,
    value: {
      default: '',
      required: true
    },
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: 'simple-select'
    }
  },
  data: function data() {
    return {
      validated: false,
      displayValue: this.value,
      selectedValue: this.value
    };
  },

  watch: {
    value: {
      handler: function handler(value) {
        if (this.optionKey) {
          this.selectedValue = value[this.optionKey];
          this.displayValue = value[this.optionKey];
        } else {
          this.displayValue = value || '';
          this.selectedValue = value || '';
        }
      },

      immediate: true
    }
  },
  computed: {
    filteredList: function filteredList() {
      var optionKey = this.optionKey;
      var displayValue = this.displayValue;
      if (displayValue === '') {
        return this.options;
      } else {
        return this.options.filter(function (item) {
          if (optionKey && item[optionKey]) {
            if (displayValue) {
              return item[optionKey].toLowerCase().search(displayValue.toLowerCase()) === 0;
            }
          } else {
            return item.toLowerCase().search(displayValue.toLowerCase()) === 0;
          }
        });
      }
    },
    isClearable: function isClearable() {
      return this.clearable && this.selectedValue !== '' && this.displayValue !== '' && this.selectedValue !== undefined;
    },
    placeholder: function placeholder() {
      if (this.optionKey && this.selectedValue) {
        return this.selectedValue[this.optionKey];
      } else {
        return this.selectedValue;
      }
    }
  },
  methods: {
    toggleSelection: function toggleSelection(option) {
      this.isOptionSelected(option) ? this.unselectOption() : this.selectOption(option);
    },
    unselectOption: function unselectOption() {
      this.selectedValue = '';
      this.$emit('input', this.selectedValue);
    },
    showDropdown: function showDropdown() {
      this.displayValue = '';
    },
    isOptionSelected: function isOptionSelected(option) {
      if (this.optionKey) {
        return this.selectedValue === option[this.optionKey];
      } else {
        return this.selectedValue === option;
      }
    },
    selectOption: function selectOption(option) {
      this.displayValue = option;
      this.selectedValue = this.displayValue;
      this.$emit('input', this.selectedValue);
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.value;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.value;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "ISdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "filterBar",
  data: function data() {
    return {
      filterText: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("Filter", function (data) {
      console.log("FilterBar (Patients): " + data);
      _this.filterText = data;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("Filter");
  },

  methods: {
    doFilter: function doFilter(event) {
      this.$emit("filter", this.filterText, event);
    }
  }
});

/***/ }),

/***/ "IWDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{class:{'btn btn-primary btn-sm dropdown-toggle' : _vm.range_max === '',
    'btn btn-pale btn-sm dropdown-toggle' : _vm.range_max != ''
    },staticStyle:{"text-transform":"none"},attrs:{"id":"itemsPerPageBtn","type":"button","disabled":false,"data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+"\n    "),_c('i',{staticClass:"ion-ios-arrow-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{key:option.value,staticClass:"dropdown-item",staticStyle:{"text-transform":"none"},on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iai+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IbS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("iZBt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a38d132_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("IWDB");
function injectStyle (ssrContext) {
  __webpack_require__("/fv5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a38d132"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a38d132_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__("kmDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_menu__ = __webpack_require__("ZEli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getters__ = __webpack_require__("UjVw");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  getters: __WEBPACK_IMPORTED_MODULE_8__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_4__modules_menu__["a" /* default */]
  },
  state: {
    userId: null,
    main: false,
    language: null,
    customer: false,
    token: null,
    password: null,
    expired: false,
    site: null,
    idleTime: null,
    pid_bcode: null,
    note: false,
    access: { level: null },
    reports: {
      fpodanu: false,
      ppodanu: false,
      ppomjestu: false,
      ppolokaciji: false,
      protokol: false,
      tatpopacijentu: false,
      worklists: false
    },

    dashboard: {
      PVM: false,
      ATR: false,
      ATG: false,
      BHC: false,
      BHS: false,
      BHT: false,
      BHK: false,
      BHJ: false,
      BHL: false,
      BLS: false,
      LBS: false,
      AHM: false,
      PMB: false,
      PSZ: false,
      GCK: false,
      ADK: false
    },

    prijem: 1,
    viber: false,

    configuration: {
      delete: false,
      report: false,
      unos: {
        rt: false,
        lp: false,
        ag: false,
        at: false
      },
      obrada: {
        rt: false,
        lp: false,
        ag: false,
        at: false
      },
      protokol: {
        rt: false,
        lp: false,
        ag: false,
        at: false
      },
      sampled: {
        rt: false,
        lp: false,
        ag: false,
        at: false
      },
      verify: {
        rt: false,
        lp: false,
        ag: false,
        at: false
      }
    },

    default_route: "/statistika",
    display: { list: "15", show: "20", columns: "7", rows: "1" },
    connect: false,
    notify: false,
    notifym: false,
    alarms: [["Nema pristiglih odobrenja.", "Test"]],
    messages: [["Nema kompletiranih rezultata.", "Test"]],
    temperatura: [],
    counter: 0,
    korisnici: 0,

    dropdown: "RADNA LISTA",
    filter: "",
    odobriSID: "",
    Sidebar: [],
    sid: "",

    pretraga: {
      filterBar: "",
      itemsPerPage: "DANAS",
      dateRange: {
        from: ["", ""],
        to: ["", ""]
      },
      paginationPage: "1"
    }
  },
  mutations: {
    RETRIEVE_DATA: function RETRIEVE_DATA(state, data) {},
    layoutSidebar: function layoutSidebar(state, data) {
      state.Sidebar = [];
      state.note = false;
      state.Sidebar = data.sidebar;

      store.getters.menuItems.forEach(function (item) {
        item.meta.show = false;
        item.meta.expanded = false;
        item.meta.default = false;
      });

      store.getters.menuItems.forEach(function (item) {
        if (item.path === state.default_route) {
          item.meta.default = true;
        }
      });

      var Niz = [];

      state.Sidebar.forEach(function (property) {
        store.getters.menuItems.forEach(function (item) {

          if (item.meta.title == property) {

            if (property === "Pregled nalaza" && state.userId.includes("@nalazi")) {
              item.meta.expanded = true;
            }

            if (item.children != undefined && item.children.length > 0) {

              var exists = false;

              item.children.forEach(function (child) {

                exists = false;

                state.Sidebar.forEach(function (element) {
                  if (element === child.meta.title) {

                    exists = true;
                    child.meta.show = true;
                  }
                });


                if (exists === false) {
                  child.meta.show = false;
                }
              });
            }

            item.meta.show = true;
            item.meta.class = "primary";

            if (item.meta.title == "Provjera nalaza" || item.meta.title == "Change Log" || item.meta.title == "Izvještaji" || item.meta.title == "Group email") {
              item.meta.show = true;
              state.note = true;
              item.meta.class = "info";
            }

            if (item.meta.title == "Postavke analiza") {
              item.meta.show = true;
              state.note = true;
              item.meta.class = "info";
            }
          }
        });
      });

      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push(state.default_route);
    },
    changeSid: function changeSid(state, noviSID) {
      state.odobriSID = noviSID;
    },
    SID: function SID(state, sid) {
      state.sid = sid;
    },
    authUser: function authUser(state, userData) {
      state.userId = userData.userId;
      state.language = userData.language;
      state.customer = userData.customer;
      state.token = userData.token;
      state.site = userData.site;

      if (state.site === "60ab76ecf68be9eab3d69e55") {
        state.main = true;
      } else {
        state.main = false;
      }

      state.idleTime = userData.idleTime;
      state.pid_bcode = userData.pid_bcode;
      state.default_route = userData.default_route;
      state.dashboard = userData.dashboard;
      state.prijem = userData.prijem;
      state.configuration = userData.configuration;
      state.viber = userData.viber;
      state.access = userData.access;
      state.display = userData.display;
      state.reports = userData.reports;
      state.sites = userData.sites;

      state.password = userData.password;

      var day_start = new Date(new Date(userData.changed_at).toString().substring(4, 15));
      var day_end = new Date(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toString().substring(4, 15));
      var total_days = (day_end - day_start) / (1000 * 60 * 60 * 24);


      if (!isNaN(total_days)) {}

      if (total_days > 365) {
        state.expired = true;
      } else {
        state.expired = false;
      }

      if (state.alarms[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.alarms = [["Нема пристиглих одобрења.", "Test"]];
        } else if (state.language === "en") {
          state.alarms = [["There are no approved results.", "Test"]];
        } else {
          state.alarms = [["Nema pristiglih odobrenja.", "Test"]];
        }
      }

      if (state.messages[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.messages = [["Нема комплетираних резултата.", "Test"]];
        } else if (state.language === "en") {
          state.messages = [["There are no completed results.", "Test"]];
        } else {
          state.messages = [["Nema kompletiranih rezultata.", "Test"]];
        }
      }
    },
    clearAuthData: function clearAuthData(state) {
      state.password = null;
    },
    changeSite: function changeSite(state, site) {
      state.site = site;
    },
    changeDropdown: function changeDropdown(state, dropdown) {
      state.dropdown = dropdown;
    },
    changeFilter: function changeFilter(state, filter) {
      state.filter = filter;
      if (filter != "") {}
    },
    changeDateRange: function changeDateRange(state, data) {
      state.pretraga.dateRange.from[0] = data.od;
      state.pretraga.dateRange.from[1] = data.from;
      state.pretraga.dateRange.to[0] = data.do;
      state.pretraga.dateRange.to[1] = data.to;

      if (data.od != "" || data.do != "") {
        state.pretraga.itemsPerPage = "Svi Rezultati";
      }
    },
    changeFilterBar: function changeFilterBar(state, data) {
      state.pretraga.filterBar = data;
    },
    changeItemsPerPage: function changeItemsPerPage(state, data) {
      state.pretraga.itemsPerPage = data;
    },
    changePaginationPage: function changePaginationPage(state, data) {
      state.pretraga.paginationPage = data;
    },
    resetSite: function resetSite(state) {
      state.alarms = [];
      state.messages = [];

      if (state.language === "rs") {
        state.alarms = [["Нема пристиглих одобрења.", "Test"]];
        state.messages = [["Нема комплетираних резултата.", "Test"]];
      } else if (state.language === "en") {
        state.alarms = [["There are no approved results.", "Test"]];
        state.messages = [["There are no completed results.", "Test"]];
      } else {
        state.alarms = [["Nema pristiglih odobrenja.", "Test"]];
        state.messages = [["Nema kompletiranih rezultata.", "Test"]];
      }

      state.notify = false;
      state.notifym = false;
    },
    resetLanguage: function resetLanguage(state, lng) {
      state.language = lng;

      if (state.alarms[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.alarms = [["Нема пристиглих одобрења.", "Test"]];
        } else if (state.language === "en") {
          state.alarms = [["There are no approved results.", "Test"]];
        } else {
          state.alarms = [["Nema pristiglih odobrenja.", "Test"]];
        }
      }

      if (state.messages[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.messages = [["Нема комплетираних резултата.", "Test"]];
        } else if (state.language === "en") {
          state.messages = [["There are no completed results.", "Test"]];
        } else {
          state.messages = [["Nema kompletiranih rezultata.", "Test"]];
        }
      }
    },
    resetidleTime: function resetidleTime(state, tm) {
      state.idleTime = tm;
    },

    SOCKET_CONNECT: function SOCKET_CONNECT(state, status) {
      state.connect = true;
    },
    SOCKET_ODOBREN: function SOCKET_ODOBREN(state, alarm) {
      if (alarm[1] === localStorage.getItem("site")) {
        var uslov = true;

        if (state.alarms[0][0].toString().length > 10) {
          state.alarms = [];
        }

        state.notify = true;
        var niz = [];

        state.alarms.forEach(function (member) {
          if (member[0] === alarm[0]) {
            uslov = false;
          }
        });

        if (uslov) {
          niz.push(alarm[0]);
          niz.push(alarm[2]);
          if (alarm[1] === localStorage.getItem("site")) {
            state.alarms.push(niz);
          } else {
            state.notify = false;
          }
        }
      }
    },
    SOCKET_TEMPERATURA: function SOCKET_TEMPERATURA(state, message) {
      state.counter++;

      if (!state.temperatura.length) {
        state.temperatura.push({
          slave_id: message[0].slave_id,
          active: true,
          time: message[3],
          temperatura: message[1],
          vlaznost: message[2],
          naziv: message[0].ime,
          _id: message[0]._id,
          frizider: message[0]
        });
      } else {
        var found = false;
        state.temperatura.forEach(function (device) {
          if (device.slave_id === message[0].slave_id) {
            device.active = true;
            device.time = message[3];
            device.temperatura = message[1];
            device.vlaznost = message[2];
            found = true;
          }
        });
        if (!found) {
          state.temperatura.push({
            slave_id: message[0].slave_id,
            active: true,
            time: message[3],
            temperatura: message[1],
            vlaznost: message[2],
            naziv: message[0].ime,
            _id: message[0]._id,
            frizider: message[0]
          });
        }
      }
    },
    SOCKET_KOMPLETIRAN: function SOCKET_KOMPLETIRAN(state, message) {
      if (message[1] === localStorage.getItem("site")) {
        var usl = true;

        if (state.messages[0][0].toString().length > 10) {
          state.messages = [];
        }

        state.notifym = true;
        var niz = [];

        state.messages.forEach(function (clan) {
          if (clan[0] === message[0]) {
            usl = false;
          }
        });

        if (usl) {
          niz.push(message[0]);
          niz.push(message[2]);

          if (message[1] === localStorage.getItem("site")) {
            state.messages.push(niz);
          } else {
            state.notifym = false;
          }
        }
      }
    },
    setujAlarme: function setujAlarme(state, element) {
      var niz = [];

      state.alarms.forEach(function (member) {
        if (member[0] != element[0]) {
          niz.push(member);
        }
      });

      state.alarms = niz;
      if (!niz.length) {
        state.notify = false;
        if (state.language === "rs") {
          var a = ["Нема пристиглих одобрења.", "Test"];
        } else if (state.language === "en") {
          var a = ["There are no approved results.", "Test"];
        } else {
          var a = ["Nema pristiglih odobrenja.", "Test"];
        }

        state.alarms.push(a);
      }
    },
    setujMessage: function setujMessage(state, element) {
      var niz = [];

      state.messages.forEach(function (member) {
        if (member[0] != element[0]) {
          niz.push(member);
        }
      });

      state.messages = niz;
      if (!niz.length) {
        state.notifym = false;
        if (state.language === "rs") {
          var b = ["Нема комплетираних резултата.", "Test"];
        } else if (state.language === "en") {
          var b = ["There are no completed results.", "Test"];
        } else {
          var b = ["Nema kompletiranih rezultata.", "Test"];
        }

        state.messages.push(b);
      }
    },
    SOCKET_GET: function SOCKET_GET(state, korisnici) {
      state.korisnici = korisnici;
    }
  },
  actions: {
    RETRIEVE_DATA_FROM_STORE: function RETRIEVE_DATA_FROM_STORE(_ref, element) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit("RETRIEVE_DATA", element);
    },
    setSID: function setSID(_ref2, element) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      commit("changeSid", element);
    },
    SetSample: function SetSample(_ref3, element) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit("SID", element);
    },
    dohvatiKorisnike: function dohvatiKorisnike(_ref4) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      this.emit("dohvati");
    },
    izbaciElement: function izbaciElement(_ref5, element) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit("setujAlarme", element);
    },
    izbaciElement2: function izbaciElement2(_ref6, element) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit("setujMessage", element);
    },
    setLogoutTimer: function setLogoutTimer(_ref7, expirationTime) {
      var commit = _ref7.commit;

      setTimeout(function () {
        commit("clearAuthData");
        __WEBPACK_IMPORTED_MODULE_5__config_config_js__["C" /* http */].post("logout/users", {
          user: localStorage.getItem("userId"),
          language: localStorage.getItem("language"),
          token: localStorage.getItem("token"),
          site: localStorage.getItem("site"),
          idleTime: localStorage.getItem("idleTime"),
          type: "automatic"
        }).then(function (res) {
          localStorage.removeItem("userId");
          localStorage.removeItem("language");
          localStorage.removeItem("token");
          localStorage.removeItem("site");
          localStorage.removeItem("idleTime");

          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/auth/login");
        });
      }, expirationTime * 1000);
    },
    login: function login(_ref8, authData) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      __WEBPACK_IMPORTED_MODULE_5__config_config_js__["C" /* http */].post("login/users", {
        email: authData.email,
        password: authData.password,
        returnSecureToken: true
      }).then(function (res) {
        var UserLoginPass = null;

        if (authData.password == "Proba123") {
          UserLoginPass = false;
        } else {
          UserLoginPass = true;
        }

        if (res.data.success === true) {
          if (!UserLoginPass) {}

          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set(res.data.data.language);
          localStorage.setItem("userId", res.data.data.localId);
          localStorage.setItem("language", res.data.data.language);
          localStorage.setItem("token", res.data.data.idToken);
          localStorage.setItem("site", res.data.data.site);
          localStorage.setItem("idleTime", res.data.data.idleTime);

          commit("authUser", {
            changed_at: res.data.data.changed_at,

            userId: res.data.data.localId,
            language: res.data.data.language,
            customer: res.data.data.customer,
            token: res.data.data.idToken,
            site: res.data.data.site,
            idleTime: res.data.data.idleTime,
            pid_bcode: res.data.data.pid_bcode,
            default_route: res.data.data.default_route,
            dashboard: res.data.data.dashboard,
            prijem: res.data.data.prijem,
            configuration: res.data.data.configuration,
            viber: res.data.data.viber,
            access: res.data.data.access,
            display: res.data.data.display,
            reports: res.data.data.reports,
            sites: res.data.data.sites,

            password: UserLoginPass
          });

          commit("layoutSidebar", {
            sidebar: res.data.data.sidebar
          });
        } else {
          if (res.data.message === "Greška prilikom konekcije na DB.") {
            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("UserLoginDB", res.data.message);
          }
          if (res.data.message === "Korisnik nije pronađen.") {
            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("UserLoginFind", res.data.message);
          }
          if (res.data.message === "Pogrešna šifra.") {
            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("UserLoginPass", res.data.message);
          }
          if (res.data.message === "User Account has Expired.") {
            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("AccountExpired", res.data.message);
          }
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    autoLogin: function autoLogin(_ref9) {
      var commit = _ref9.commit;

      var userId = localStorage.getItem("userId");
      var language = localStorage.getItem("language");
      var site = localStorage.getItem("site");
      var idleTime = localStorage.getItem("idleTime");
      var token = localStorage.getItem("token");

      if (!token) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/");
      commit("authUser", {
        userId: userId,
        language: language,
        token: token,
        site: site,
        idleTime: idleTime
      });
    },
    logout: function logout(_ref10, state) {
      var commit = _ref10.commit;

      commit("clearAuthData");

      __WEBPACK_IMPORTED_MODULE_5__config_config_js__["C" /* http */].post("logout/users", {
        user: localStorage.getItem("userId"),
        language: localStorage.getItem("language"),
        token: localStorage.getItem("token"),
        site: localStorage.getItem("site"),
        idleTime: localStorage.getItem("idleTime"),
        type: "manual"
      }).then(function (res) {
        localStorage.removeItem("userId");
        localStorage.removeItem("language");
        localStorage.removeItem("token");
        localStorage.removeItem("site");
        localStorage.removeItem("idleTime");

        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace("/auth/login");
      });
    },
    siteChange: function siteChange(_ref11, site) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;

      localStorage.setItem("site", site);
      commit("changeSite", site);
    },
    dropdownChange: function dropdownChange(_ref12, dropdown) {
      var commit = _ref12.commit,
          dispatch = _ref12.dispatch;

      commit("changeDropdown", dropdown);
    },
    filterChange: function filterChange(_ref13, filter) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;

      commit("changeFilter", filter);
    },
    siteClear: function siteClear(_ref14, site) {
      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;

      commit("resetSite");
    },
    languageChange: function languageChange(_ref15, lng) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;

      commit("resetLanguage", lng);
    },
    idleTimeChange: function idleTimeChange(_ref16, tm) {
      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;

      commit("resetidleTime", tm);
    },
    DateRangeChange: function DateRangeChange(_ref17, data) {
      var commit = _ref17.commit,
          dispatch = _ref17.dispatch;

      commit("changeDateRange", data);
    },
    FilterBarChange: function FilterBarChange(_ref18, data) {
      var commit = _ref18.commit,
          dispatch = _ref18.dispatch;

      commit("changeFilterBar", data);
    },
    ItemsPerPageChange: function ItemsPerPageChange(_ref19, data) {
      var commit = _ref19.commit,
          dispatch = _ref19.dispatch;

      commit("changeItemsPerPage", data);
    },
    PaginationPageChange: function PaginationPageChange(_ref20, data) {
      var commit = _ref20.commit,
          dispatch = _ref20.dispatch;

      commit("changePaginationPage", data);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, store);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IqWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__ = __webpack_require__("3IyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c844f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__ = __webpack_require__("H7sF");
function injectStyle (ssrContext) {
  __webpack_require__("+2Vk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c844f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ItL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-find",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    data_length: {
      type: Number,
      default: 0
    },
    data_pid: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      pid: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Push", this.pid);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "IwWG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-mail",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Mail");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "IyLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__ = __webpack_require__("3Bfb");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'file-upload-gallery-item',
  components: {
    VuesticFileUploadUndo: __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__["default"]
  },
  data: function data() {
    return {
      previewImage: '',
      removed: false
    };
  },

  props: {
    file: {
      default: {}
    }
  },
  watch: {
    file: function file() {
      this.convertToImg();
    }
  },
  methods: {
    removeImage: function removeImage() {
      var _this = this;

      this.removed = true;
      setTimeout(function () {
        if (_this.removed) {
          _this.$emit('remove');
          _this.removed = false;
        }
      }, 2000);
    },
    recoverImage: function recoverImage() {
      this.removed = false;
    },
    convertToImg: function convertToImg() {
      var _this2 = this;

      var reader = new FileReader();
      var imageFileTypes = ['/png', '/jpg', '/jpeg', '/gif'];
      reader.readAsDataURL(this.file.image);
      reader.onload = function (e) {
        for (var i = 0; i < imageFileTypes.length; i++) {
          if (e.target.result.indexOf(imageFileTypes[i]) >= 0) {
            _this2.previewImage = e.target.result;
          }
        }
      };
    }
  },
  computed: {
    notGalleryItemClass: function notGalleryItemClass() {
      return {
        'file-upload-gallery-item_not-image': !this.previewImage
      };
    }
  },
  mounted: function mounted() {
    this.convertToImg();
  }
});

/***/ }),

/***/ "JC9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip__ = __webpack_require__("VN6J");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tooltip',

  directives: { tooltip: __WEBPACK_IMPORTED_MODULE_1_v_tooltip__["VTooltip"] },

  computed: {
    tooltipOptions: function tooltipOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultOptions, this.options);
    }
  },

  props: {
    options: {
      type: Object,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      defaultOptions: {
        classes: 'vuestic-tooltip'
      }
    };
  }
});

/***/ }),

/***/ "JT6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("2Bcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e5857ad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("86YC");
function injectStyle (ssrContext) {
  __webpack_require__("OzME")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5857ad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e5857ad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Jf5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__ = __webpack_require__("Loij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e1cc491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ChatWindow_vue__ = __webpack_require__("7mIc");
function injectStyle (ssrContext) {
  __webpack_require__("qwLI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e1cc491"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e1cc491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ChatWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JfBS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jhtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollList",staticClass:"sc-message-list",style:({backgroundColor: _vm.colors.messageList.bg})},[_vm._l((_vm.messages),function(message,idx){return _c('Message',{key:idx,attrs:{"message":message,"chatImageUrl":_vm.chatImageUrl(message.author),"authorName":_vm.authorName(message.author),"colors":_vm.colors}})}),_vm._v(" "),_c('Message',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTypingIndicator !== ''),expression:"showTypingIndicator !== ''"}],attrs:{"message":{author: _vm.showTypingIndicator, type: 'typing'},"chatImageUrl":_vm.chatImageUrl(_vm.showTypingIndicator),"colors":_vm.colors}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JlW8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K+Y1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-file-upload-container",
  props: {
    dropzone: {
      type: Boolean,
      default: false
    },
    fileTypes: {
      type: String
    },
    type: {
      type: String
    }
  },
  methods: {
    changeFieldValue: function changeFieldValue(e) {
      this.$emit("upload", e);
      this.$refs.fieldInput.value = "";
    }
  }
});

/***/ }),

/***/ "K/BQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__ = __webpack_require__("XEVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bca29d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TextMessage_vue__ = __webpack_require__("fNWn");
function injectStyle (ssrContext) {
  __webpack_require__("XviT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bca29d7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bca29d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TextMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "K4gw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K64j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KGMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__("2QDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__ = __webpack_require__("CneO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__ = __webpack_require__("axM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__ = __webpack_require__("pqzW");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-progress-bar",
  components: {
    HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__["default"],
    VerticalBar: __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__["default"],
    CircleBar: __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__["default"]
  },
  props: {
    type: {
      type: String,
      default: "horizontal"
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: "basic"
    },
    colorName: {
      type: String,
      default: "primary"
    },
    startColorName: {
      type: String,
      default: "lighterGray"
    },
    backgroundColorName: {
      type: String,
      default: "white"
    }
  },
  watch: {
    value: function value() {
      this.animateValue();
    }
  },
  methods: {
    animateValue: function animateValue() {
      var _this = this;

      var startValue = this.value;
      var valueMsecs = this.valueAnimationInterval / this.max;
      var delta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(this.value - this.animatedValue);
      var valueInterval = setInterval(function () {
        if (!_this.$refs.bar) {
          clearInterval(valueInterval);
          return;
        }
        if (startValue !== _this.value || _this.animatedValue === _this.value) {
          clearInterval(valueInterval);
          if (_this.value === _this.max) {
            _this.isActive = false;
          }
        } else {
          _this.animatedValue += delta;
        }
      }, valueMsecs);
    }
  },
  data: function data() {
    return {
      value: 0,
      valueAnimationInterval: 2000,
      animatedValue: 0,
      isActive: false,
      startColor: this.$store.state.app.config.palette[this.startColorName],
      color: this.$store.state.app.config.palette[this.colorName],
      backgroundColor: this.$store.state.app.config.palette[this.backgroundColorName]
    };
  }
});

/***/ }),

/***/ "KIUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KJIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "initial-password",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      password: true,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("ChangePasswordModalHide", function () {
      _this.show = false;
    });
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("ChangePasswordModalHide");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    Password: function Password(event) {
      if (event === "password") {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("_ShowPasswordInit");
        this.password = false;
      } else {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("_HidePasswordInit");
        this.password = true;
      }
    },
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ChangePasswordInit");
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ChangePasswordCancel");
      this.password = true;
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "KX+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 200,
    'per_page': 50,
    'current_page': 1,
    'last_page': 4,
    'next_page_url': 'https://vuetable.ratiw.net/api/users?per_page=50&page=2',
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }, {
    'id': 2,
    'name': 'Mr. Enid Von PhD',
    'nickname': 'alias',
    'email': 'pollich.cecilia@example.com',
    'birthdate': '1990-09-18 00:00:00',
    'gender': 'M',
    'salary': '35978.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 2,
      'user_id': 2,
      'line1': '59732 Iva Spur Suite 468\nEast Hortenseton, VA 70087',
      'line2': 'Cayman Islands',
      'zipcode': '41967',
      'mobile': '1-913-407-7558x503',
      'fax': '(388)906-8002'
    }
  }, {
    'id': 3,
    'name': 'Colton Koch',
    'nickname': 'id',
    'email': 'little.myrna@example.net',
    'birthdate': '1968-10-29 00:00:00',
    'gender': 'F',
    'salary': '26278.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 3,
      'user_id': 3,
      'line1': '539 Conn Locks Suite 801\nTobinfort, IL 37047-5508',
      'line2': 'Antigua and Barbuda',
      'zipcode': '51722-4502',
      'mobile': '557.845.1830x844',
      'fax': '1-831-304-7444x73027'
    }
  }, {
    'id': 4,
    'name': 'Gregory Vandervort',
    'nickname': 'vel',
    'email': 'dock47@example.org',
    'birthdate': '1989-12-12 00:00:00',
    'gender': 'M',
    'salary': '25537.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 4,
      'user_id': 4,
      'line1': '916 Rosemary Forge\nKreigerton, MT 24207',
      'line2': 'Uganda',
      'zipcode': '67639-6707',
      'mobile': '766.431.9121',
      'fax': '(154)336-3674x08451'
    }
  }, {
    'id': 5,
    'name': 'Miss Rahsaan Heaney IV',
    'nickname': 'qui',
    'email': 'ugrady@example.org',
    'birthdate': '1995-11-27 00:00:00',
    'gender': 'F',
    'salary': '49003.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 21,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 5,
      'user_id': 5,
      'line1': '91792 Kertzmann Prairie Apt. 376\nLake Nakiaville, DC 98189',
      'line2': 'Jamaica',
      'zipcode': '10101-1450',
      'mobile': '07507519787',
      'fax': '+24(9)5120507985'
    }
  }, {
    'id': 6,
    'name': 'Ms. Crystel Zemlak IV',
    'nickname': 'reiciendis',
    'email': 'amari.rau@example.com',
    'birthdate': '1968-09-12 00:00:00',
    'gender': 'F',
    'salary': '12383.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 6,
      'user_id': 6,
      'line1': '97650 Scot Haven Apt. 160\nCrawfordmouth, ME 39767-7003',
      'line2': 'Finland',
      'zipcode': '88917',
      'mobile': '1-851-069-9234x9566',
      'fax': '(048)445-4691x33356'
    }
  }, {
    'id': 7,
    'name': 'Nona McDermott',
    'nickname': 'quaerat',
    'email': 'adrien.baumbach@example.org',
    'birthdate': '1985-10-01 00:00:00',
    'gender': 'F',
    'salary': '18512.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 31,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 7,
      'user_id': 7,
      'line1': '4332 Alvina Radial\nPort Darbyville, IA 63357',
      'line2': 'Barbados',
      'zipcode': '79679',
      'mobile': '(736)058-1324',
      'fax': '002.234.8466x49816'
    }
  }, {
    'id': 8,
    'name': 'Miss Genoveva Murazik V',
    'nickname': 'rerum',
    'email': 'ohettinger@example.net',
    'birthdate': '1988-10-19 00:00:00',
    'gender': 'F',
    'salary': '31209.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 28,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 8,
      'user_id': 8,
      'line1': '96418 Ritchie Mall Apt. 215\nLake Jessyca, VT 65970-8256',
      'line2': 'Netherlands Antilles',
      'zipcode': '94649-6628',
      'mobile': '472.825.7183',
      'fax': '400-507-7463'
    }
  }, {
    'id': 9,
    'name': 'Beulah Huels',
    'nickname': 'non',
    'email': 'stefan99@example.com',
    'birthdate': '1963-09-04 00:00:00',
    'gender': 'F',
    'salary': '36920.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 9,
      'user_id': 9,
      'line1': '18890 Carroll Lakes Suite 355\nUptonchester, UT 94878-0739',
      'line2': 'Hong Kong',
      'zipcode': '91204',
      'mobile': '831.652.0832',
      'fax': '(688)788-8947'
    }
  }, {
    'id': 10,
    'name': 'Zoe Klein',
    'nickname': 'ex',
    'email': 'ejacobson@example.org',
    'birthdate': '1990-04-19 00:00:00',
    'gender': 'F',
    'salary': '35616.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 10,
      'user_id': 10,
      'line1': '6721 Nader Summit\nLake Alana, MS 84476',
      'line2': 'Reunion',
      'zipcode': '77124-1459',
      'mobile': '1-129-438-6148',
      'fax': '(913)441-3846'
    }
  }, {
    'id': 11,
    'name': 'Vickie Kiehn',
    'nickname': 'assumenda',
    'email': 'ayost@example.com',
    'birthdate': '1988-04-20 00:00:00',
    'gender': 'F',
    'salary': '30790.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 11,
      'user_id': 11,
      'line1': '763 McCullough Ville\nNew Thomasstad, HI 64611',
      'line2': 'Oman',
      'zipcode': '00642',
      'mobile': '1-296-172-2126x275',
      'fax': '(559)203-8694'
    }
  }, {
    'id': 12,
    'name': 'Elwyn Herzog',
    'nickname': 'praesentium',
    'email': 'ckassulke@example.net',
    'birthdate': '1990-01-22 00:00:00',
    'gender': 'M',
    'salary': '35785.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 12,
      'user_id': 12,
      'line1': '65641 Baron Spurs Suite 988\nNorth Ivah, IA 92235',
      'line2': 'Nepal',
      'zipcode': '90316-7411',
      'mobile': '064.482.9432x9456',
      'fax': '05936098280'
    }
  }, {
    'id': 13,
    'name': 'Selena Hettinger',
    'nickname': 'et',
    'email': 'bashirian.hyman@example.net',
    'birthdate': '1981-10-01 00:00:00',
    'gender': 'F',
    'salary': '31836.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 13,
      'user_id': 13,
      'line1': '42272 Stoltenberg Points Suite 006\nLake Dustin, NH 70213-2043',
      'line2': 'Uganda',
      'zipcode': '60996-2982',
      'mobile': '(508)122-5892',
      'fax': '356-682-2023x07379'
    }
  }, {
    'id': 14,
    'name': 'Edwin Beier',
    'nickname': 'eos',
    'email': 'janis71@example.org',
    'birthdate': '1978-10-13 00:00:00',
    'gender': 'M',
    'salary': '11902.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 14,
      'user_id': 14,
      'line1': '362 Trantow Loop Apt. 150\nLake Marafurt, DC 27926',
      'line2': 'Gabon',
      'zipcode': '36943-1099',
      'mobile': '033-386-4972x26066',
      'fax': '1-363-037-1381'
    }
  }, {
    'id': 15,
    'name': 'Lexi Braun MD',
    'nickname': 'autem',
    'email': 'dusty74@example.net',
    'birthdate': '1971-12-07 00:00:00',
    'gender': 'F',
    'salary': '11927.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 45,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 15,
      'user_id': 15,
      'line1': '6737 Schimmel Crossing Suite 720\nShieldsberg, AK 44558',
      'line2': 'Tanzania',
      'zipcode': '75615',
      'mobile': '338.920.3112',
      'fax': '(467)912-6668'
    }
  }, {
    'id': 16,
    'name': 'Jovany Spencer',
    'nickname': 'fugit',
    'email': 'gbogisich@example.org',
    'birthdate': '1974-04-23 00:00:00',
    'gender': 'F',
    'salary': '44686.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 16,
      'user_id': 16,
      'line1': '97237 Emory Mission\nWelchview, DE 65827-8746',
      'line2': 'Turkmenistan',
      'zipcode': '17948',
      'mobile': '(163)991-1609x963',
      'fax': '104.893.7648'
    }
  }, {
    'id': 17,
    'name': 'Prof. Maci Anderson DVM',
    'nickname': 'dolorem',
    'email': 'btorp@example.com',
    'birthdate': '1988-03-30 00:00:00',
    'gender': 'M',
    'salary': '25055.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 17,
      'user_id': 17,
      'line1': '7584 Lucinda Mill\nNew Kaitlyn, WV 63380-4289',
      'line2': 'Gibraltar',
      'zipcode': '51150-2800',
      'mobile': '(977)115-7349',
      'fax': '652-788-4860x1180'
    }
  }, {
    'id': 18,
    'name': 'Joel Kulas MD',
    'nickname': 'sed',
    'email': 'phoebe.sauer@example.org',
    'birthdate': '1992-10-26 00:00:00',
    'gender': 'F',
    'salary': '11650.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 18,
      'user_id': 18,
      'line1': '992 Williamson Passage Apt. 910\nBradleyborough, MO 93100-9439',
      'line2': 'Cambodia',
      'zipcode': '20591-3066',
      'mobile': '+64(7)3402369877',
      'fax': '08960801902'
    }
  }, {
    'id': 19,
    'name': 'Mr. Dawson Greenholt',
    'nickname': 'nostrum',
    'email': 'asawayn@example.org',
    'birthdate': '1963-08-23 00:00:00',
    'gender': 'F',
    'salary': '46962.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 19,
      'user_id': 19,
      'line1': '8444 Abraham Isle\nEast Chaunceychester, HI 78625-4417',
      'line2': 'Qatar',
      'zipcode': '47870-8012',
      'mobile': '797-274-3187x45557',
      'fax': '(461)432-8205'
    }
  }, {
    'id': 20,
    'name': 'Prof. Lloyd Green',
    'nickname': 'velit',
    'email': 'laila.hintz@example.org',
    'birthdate': '1970-10-31 00:00:00',
    'gender': 'M',
    'salary': '12928.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 20,
      'user_id': 20,
      'line1': '89766 O\'Connell Falls\nSouth Kadenshire, NJ 78754-6650',
      'line2': 'Nigeria',
      'zipcode': '37859',
      'mobile': '1-457-536-1138',
      'fax': '+98(5)0101745942'
    }
  }, {
    'id': 21,
    'name': 'Shayna Morar',
    'nickname': 'rerum',
    'email': 'wfay@example.org',
    'birthdate': '1991-01-24 00:00:00',
    'gender': 'F',
    'salary': '22638.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 21,
      'user_id': 21,
      'line1': '6066 Weissnat Run Apt. 578\nMurazikmouth, SD 62877-3174',
      'line2': 'Brunei Darussalam',
      'zipcode': '69261',
      'mobile': '(487)423-0151x5127',
      'fax': '784-058-9197'
    }
  }, {
    'id': 22,
    'name': 'Krista Schulist',
    'nickname': 'qui',
    'email': 'gregoria.jakubowski@example.com',
    'birthdate': '1974-08-16 00:00:00',
    'gender': 'F',
    'salary': '49345.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 22,
      'user_id': 22,
      'line1': '331 Gerlach Course Suite 090\nKovacekchester, RI 18017',
      'line2': 'Sri Lanka',
      'zipcode': '37165',
      'mobile': '653-487-3061x91119',
      'fax': '370-709-1750'
    }
  }, {
    'id': 23,
    'name': 'Leone Lemke',
    'nickname': 'repellat',
    'email': 'ltorphy@example.com',
    'birthdate': '1975-06-27 00:00:00',
    'gender': 'M',
    'salary': '17560.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 23,
      'user_id': 23,
      'line1': '4371 Ward Village Suite 848\nLake Madalynton, IN 44643',
      'line2': 'Ukraine',
      'zipcode': '71848',
      'mobile': '174-502-0881x50649',
      'fax': '02683328099'
    }
  }, {
    'id': 24,
    'name': 'Dr. Willie Kemmer II',
    'nickname': 'quasi',
    'email': 'ivy51@example.net',
    'birthdate': '1987-04-06 00:00:00',
    'gender': 'F',
    'salary': '35370.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 30,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 24,
      'user_id': 24,
      'line1': '235 Hassie Mountain\nAnikaborough, ID 20678-4354',
      'line2': 'Thailand',
      'zipcode': '94264-9132',
      'mobile': '624.042.8382x12243',
      'fax': '274.716.7226x171'
    }
  }, {
    'id': 25,
    'name': 'Deonte Lebsack',
    'nickname': 'nesciunt',
    'email': 'alisa83@example.net',
    'birthdate': '1993-01-26 00:00:00',
    'gender': 'M',
    'salary': '32725.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 25,
      'user_id': 25,
      'line1': '793 Lakin Haven\nLake Citlalliborough, DE 85031-4862',
      'line2': 'Chad',
      'zipcode': '52396-8822',
      'mobile': '(950)170-8013',
      'fax': '119.675.5485x79062'
    }
  }, {
    'id': 26,
    'name': 'Prof. Shayne Nader',
    'nickname': 'voluptas',
    'email': 'bosco.shaina@example.net',
    'birthdate': '1993-10-26 00:00:00',
    'gender': 'F',
    'salary': '9844.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 23,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 26,
      'user_id': 26,
      'line1': '0330 Smith Mountains\nLorinetown, NY 96547-9723',
      'line2': 'Syrian Arab Republic',
      'zipcode': '85415',
      'mobile': '1-212-704-6685',
      'fax': '516-893-8515'
    }
  }, {
    'id': 27,
    'name': 'Prof. Kennith Kertzmann',
    'nickname': 'alias',
    'email': 'satterfield.jonathan@example.com',
    'birthdate': '1992-01-31 00:00:00',
    'gender': 'F',
    'salary': '41950.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 27,
      'user_id': 27,
      'line1': '901 Hauck Extensions\nKeaganborough, VA 47392',
      'line2': 'Comoros',
      'zipcode': '54147-7615',
      'mobile': '1-274-179-2031x915',
      'fax': '867-583-0812x6728'
    }
  }, {
    'id': 28,
    'name': 'Miss Meagan O\'Keefe',
    'nickname': 'corporis',
    'email': 'tracy.barrows@example.com',
    'birthdate': '1967-05-04 00:00:00',
    'gender': 'M',
    'salary': '41803.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 28,
      'user_id': 28,
      'line1': '29077 Avis Isle Apt. 208\nGrahamberg, MI 62485-6694',
      'line2': 'Cocos (Keeling) Islands',
      'zipcode': '56090-7671',
      'mobile': '(718)856-9319x55184',
      'fax': '(777)055-4685x56167'
    }
  }, {
    'id': 29,
    'name': 'Prof. Edward Pagac MD',
    'nickname': 'quia',
    'email': 'gerhard65@example.org',
    'birthdate': '1973-09-22 00:00:00',
    'gender': 'F',
    'salary': '22896.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 29,
      'user_id': 29,
      'line1': '697 Crona Mall\nPeteville, WA 54497',
      'line2': 'Saudi Arabia',
      'zipcode': '07560-8569',
      'mobile': '788-579-8208',
      'fax': '041-521-9215'
    }
  }, {
    'id': 30,
    'name': 'Samantha Weissnat',
    'nickname': 'est',
    'email': 'crystel66@example.net',
    'birthdate': '1974-07-11 00:00:00',
    'gender': 'M',
    'salary': '18805.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 30,
      'user_id': 30,
      'line1': '79984 Deckow Run\nEast Victoria, UT 33736',
      'line2': 'Lithuania',
      'zipcode': '95964-8864',
      'mobile': '681.200.3099',
      'fax': '(567)652-4322x61475'
    }
  }, {
    'id': 31,
    'name': 'Dr. Gilbert Ward',
    'nickname': 'dolorum',
    'email': 'sandrine06@example.net',
    'birthdate': '1984-08-22 00:00:00',
    'gender': 'F',
    'salary': '16644.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 32,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 31,
      'user_id': 31,
      'line1': '996 Schuppe Glen\nTurcottetown, ID 40821-7190',
      'line2': 'Thailand',
      'zipcode': '09965-7576',
      'mobile': '1-938-263-0257x47178',
      'fax': '1-997-727-3198x4363'
    }
  }, {
    'id': 32,
    'name': 'Mike West',
    'nickname': 'laudantium',
    'email': 'jborer@example.net',
    'birthdate': '1974-11-07 00:00:00',
    'gender': 'M',
    'salary': '35728.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 32,
      'user_id': 32,
      'line1': '69942 Leannon Glen\nEast Mathilde, IL 89584-5633',
      'line2': 'Afghanistan',
      'zipcode': '02041-8706',
      'mobile': '(506)349-9443x7244',
      'fax': '1-357-689-8479x3729'
    }
  }, {
    'id': 33,
    'name': 'Prof. Isabell Cruickshank I',
    'nickname': 'recusandae',
    'email': 'ondricka.lurline@example.org',
    'birthdate': '1982-06-15 00:00:00',
    'gender': 'F',
    'salary': '44574.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 33,
      'user_id': 33,
      'line1': '875 Logan Summit Suite 033\nJerodport, NY 45166',
      'line2': 'Kiribati',
      'zipcode': '64763',
      'mobile': '1-548-943-8405x460',
      'fax': '+88(4)9493664736'
    }
  }, {
    'id': 34,
    'name': 'Prof. Lonny Rath',
    'nickname': 'nihil',
    'email': 'rfeest@example.net',
    'birthdate': '1969-04-23 00:00:00',
    'gender': 'F',
    'salary': '19949.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 34,
      'user_id': 34,
      'line1': '43006 Gaylord Drives\nCummerataville, MA 14032-6378',
      'line2': 'Georgia',
      'zipcode': '88459',
      'mobile': '(877)526-6771',
      'fax': '(724)630-5418'
    }
  }, {
    'id': 35,
    'name': 'Santina Medhurst MD',
    'nickname': 'suscipit',
    'email': 'ila24@example.net',
    'birthdate': '1965-11-04 00:00:00',
    'gender': 'F',
    'salary': '36323.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 51,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 35,
      'user_id': 35,
      'line1': '47345 Imelda Mission Suite 257\nAllyshire, IA 85430-2783',
      'line2': 'Gambia',
      'zipcode': '26853',
      'mobile': '(441)229-8922',
      'fax': '(789)908-0620x15912'
    }
  }, {
    'id': 36,
    'name': 'Jeff Lehner',
    'nickname': 'quo',
    'email': 'jarred77@example.com',
    'birthdate': '1975-05-18 00:00:00',
    'gender': 'F',
    'salary': '48462.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 36,
      'user_id': 36,
      'line1': '49133 Tremaine Cape Suite 189\nQuitzonview, SC 07967-6920',
      'line2': 'Serbia',
      'zipcode': '96642',
      'mobile': '313.254.8635x06428',
      'fax': '194.681.7297x74202'
    }
  }, {
    'id': 37,
    'name': 'Samanta Pfeffer',
    'nickname': 'officia',
    'email': 'fgoyette@example.net',
    'birthdate': '1974-08-27 00:00:00',
    'gender': 'F',
    'salary': '19601.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 37,
      'user_id': 37,
      'line1': '1313 Verdie Square\nNorth Giovanna, MI 27962',
      'line2': 'Guyana',
      'zipcode': '77776',
      'mobile': '(321)705-8910',
      'fax': '(392)460-5663x665'
    }
  }, {
    'id': 38,
    'name': 'Ofelia Torp',
    'nickname': 'a',
    'email': 'ericka44@example.net',
    'birthdate': '1981-09-01 00:00:00',
    'gender': 'M',
    'salary': '33149.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 38,
      'user_id': 38,
      'line1': '45335 Albina View\nCharlottefort, AK 57789',
      'line2': 'Afghanistan',
      'zipcode': '54947-9310',
      'mobile': '09097085723',
      'fax': '1-567-446-3094'
    }
  }, {
    'id': 39,
    'name': 'Mrs. Margarete Raynor',
    'nickname': 'quia',
    'email': 'jlegros@example.net',
    'birthdate': '1977-03-12 00:00:00',
    'gender': 'M',
    'salary': '21951.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 40,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 39,
      'user_id': 39,
      'line1': '288 Hamill Knolls\nMaximoburgh, NC 50971',
      'line2': 'Zimbabwe',
      'zipcode': '00474',
      'mobile': '1-165-445-8956x699',
      'fax': '164-395-7526x1304'
    }
  }, {
    'id': 40,
    'name': 'Mr. Brant Howell V',
    'nickname': 'perspiciatis',
    'email': 'franecki.gerald@example.org',
    'birthdate': '1964-03-01 00:00:00',
    'gender': 'M',
    'salary': '41552.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 40,
      'user_id': 40,
      'line1': '3411 Deckow Crossing\nVernonport, MI 32272-8542',
      'line2': 'Bolivia',
      'zipcode': '00960',
      'mobile': '(998)729-9537',
      'fax': '(606)461-9736'
    }
  }, {
    'id': 41,
    'name': 'Reilly Ruecker DVM',
    'nickname': 'ad',
    'email': 'ldeckow@example.net',
    'birthdate': '1975-07-17 00:00:00',
    'gender': 'M',
    'salary': '22709.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 41,
      'user_id': 41,
      'line1': '39181 Runolfsson Pines Apt. 102\nCedrickchester, MD 73430-4755',
      'line2': 'Haiti',
      'zipcode': '08208-7956',
      'mobile': '625-483-9111x773',
      'fax': '196-367-9338'
    }
  }, {
    'id': 42,
    'name': 'Zachery McDermott',
    'nickname': 'molestiae',
    'email': 'gladyce84@example.com',
    'birthdate': '1992-04-17 00:00:00',
    'gender': 'F',
    'salary': '32354.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 42,
      'user_id': 42,
      'line1': '18735 Quigley Springs\nCarterview, NE 29126-7625',
      'line2': 'Chad',
      'zipcode': '61676-5075',
      'mobile': '172.676.4844x42744',
      'fax': '129.383.7365x233'
    }
  }, {
    'id': 43,
    'name': 'Heloise Kulas',
    'nickname': 'aut',
    'email': 'kessler.helen@example.net',
    'birthdate': '1962-12-11 00:00:00',
    'gender': 'M',
    'salary': '45086.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 54,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 43,
      'user_id': 43,
      'line1': '38208 Dolores Turnpike Apt. 887\nWintheiserton, FL 72054-2578',
      'line2': 'Lithuania',
      'zipcode': '51634-6449',
      'mobile': '1-161-626-3235x57765',
      'fax': '360-278-9045x9316'
    }
  }, {
    'id': 44,
    'name': 'Norma Dibbert',
    'nickname': 'amet',
    'email': 'eudora36@example.net',
    'birthdate': '1971-01-21 00:00:00',
    'gender': 'F',
    'salary': '15661.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 44,
      'user_id': 44,
      'line1': '15405 Haag Haven Suite 047\nBrakusland, WV 81778',
      'line2': 'British Virgin Islands',
      'zipcode': '56087-0885',
      'mobile': '08227730599',
      'fax': '1-079-566-2337x670'
    }
  }, {
    'id': 45,
    'name': 'Immanuel Auer',
    'nickname': 'quia',
    'email': 'halvorson.theodora@example.org',
    'birthdate': '1978-06-06 00:00:00',
    'gender': 'M',
    'salary': '15862.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 45,
      'user_id': 45,
      'line1': '59888 Dare Ridge\nSouth Annamaeton, CA 94659',
      'line2': 'Mexico',
      'zipcode': '56689-3824',
      'mobile': '523.579.8757x9825',
      'fax': '688.695.5156x073'
    }
  }, {
    'id': 46,
    'name': 'Lamont Borer',
    'nickname': 'expedita',
    'email': 'trantow.neoma@example.com',
    'birthdate': '1992-06-26 00:00:00',
    'gender': 'M',
    'salary': '12544.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 46,
      'user_id': 46,
      'line1': '974 Brannon Circle Suite 674\nSchroedermouth, NM 66911',
      'line2': 'Malawi',
      'zipcode': '74027',
      'mobile': '887.196.2530x875',
      'fax': '220.398.6969'
    }
  }, {
    'id': 47,
    'name': 'Brooke Purdy',
    'nickname': 'cupiditate',
    'email': 'bhermiston@example.net',
    'birthdate': '1966-11-19 00:00:00',
    'gender': 'M',
    'salary': '14457.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 47,
      'user_id': 47,
      'line1': '916 Durgan Harbor\nWest Tonyborough, MN 08368',
      'line2': 'Serbia',
      'zipcode': '25234',
      'mobile': '(821)777-8137x4048',
      'fax': '(398)917-7496x84537'
    }
  }, {
    'id': 48,
    'name': 'Dr. Leo Dach',
    'nickname': 'et',
    'email': 'camila.ward@example.com',
    'birthdate': '1968-01-11 00:00:00',
    'gender': 'F',
    'salary': '40278.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 49,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 48,
      'user_id': 48,
      'line1': '434 Dariana Terrace\nSouth Brettbury, NC 66080-2445',
      'line2': 'Latvia',
      'zipcode': '81749-2523',
      'mobile': '1-988-628-9566x4627',
      'fax': '916.932.2071x569'
    }
  }, {
    'id': 49,
    'name': 'Krystal Langosh',
    'nickname': 'voluptatum',
    'email': 'pacocha.yesenia@example.org',
    'birthdate': '1983-02-18 00:00:00',
    'gender': 'M',
    'salary': '9305.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 49,
      'user_id': 49,
      'line1': '012 Josiane Flats Suite 650\nKatelynntown, MD 70053',
      'line2': 'Rwanda',
      'zipcode': '75946-8166',
      'mobile': '(556)620-0323x81232',
      'fax': '1-466-040-3197x6274'
    }
  }, {
    'id': 50,
    'name': 'Florence Greenfelder',
    'nickname': 'odit',
    'email': 'kenyatta.oconnell@example.com',
    'birthdate': '1978-08-20 00:00:00',
    'gender': 'F',
    'salary': '36980.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 50,
      'user_id': 50,
      'line1': '295 Donna Plaza Apt. 186\nHintzview, GA 44706',
      'line2': 'Greenland',
      'zipcode': '03127',
      'mobile': '1-044-098-3635x9446',
      'fax': '1-753-472-6796'
    }
  }]
});

/***/ }),

/***/ "KXyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.isAuth)?_c('auth-layout'):_c('layout')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KfMx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KlZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KqAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KzHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function generateRandomId() {
  return Math.floor(Math.random() * Math.pow(10, 10));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-checkbox',
  props: {
    label: String,
    id: {
      type: String,
      default: function _default() {
        return 'label-' + generateRandomId();
      }
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  mounted: function mounted() {
    this.$emit('change', this.checked);
  },

  methods: {
    onChange: function onChange(event) {
      this.$emit('change', event.target.checked);
    }
  },
  computed: {
    additionalClasses: function additionalClasses() {
      return [this.isCircle ? 'abc-checkbox-circle' : false, 'abc-checkbox-' + this.brandColor];
    }
  }
});

/***/ }),

/***/ "L2/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTagGroup_vue__ = __webpack_require__("UWEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668f7227_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTagGroup_vue__ = __webpack_require__("WoVe");
function injectStyle (ssrContext) {
  __webpack_require__("KfMx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTagGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668f7227_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTagGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "L2v+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LG8r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-simple-select',{ref:"komentarSelect",attrs:{"label":'Izaberite željeni komentar',"name":"komentar","title":" ","options":_vm.komentari},model:{value:(_vm.komentar),callback:function ($$v) {_vm.komentar=$$v},expression:"komentar"}})],1)])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v("\n                  "+_vm._s(_vm.cancelText)+"\n                ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v("\n                  "+_vm._s(_vm.okText)+"\n                ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LTOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "protokol",
  path: "/protokol",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("protokol/protokol"),
  meta: {
    default: false,
    title: "Provjera nalaza",
    class: "primary",
    show: false,
    iconClass: "fa fa-check-square-o",
    requiredAuth: true
  }
});

/***/ }),

/***/ "LTu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"domNode",staticClass:"sc-emoji-picker",attrs:{"tabIndex":"0"},on:{"blur":_vm.onBlur}},[_c('div',{staticClass:"sc-emoji-picker--content"},_vm._l((_vm.emojiData),function(category){return _c('div',{key:category.name,staticClass:"sc-emoji-picker--category"},[_c('div',{staticClass:"sc-emoji-picker--category-title"},[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.emojis),function(emoji){return _c('span',{key:emoji,staticClass:"sc-emoji-picker--emoji",on:{"click":function($event){_vm.emojiClicked(emoji)}}},[_vm._v("\n          "+_vm._s(emoji)+"\n        ")])})],2)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LWtl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "filterBar",
  data: function data() {
    return {
      filterText: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("SetFilterFromLabAssay", function (data) {
      if (_this.filterText != data) {
        _this.filterText = data;
        _this.doFilter(_this.filterText);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("SetFilterFromLabAssay");
  },

  methods: {
    doFilter: function doFilter() {
      this.$emit("filter", this.filterText);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SetFilterFromAnaAssay", this.filterText);
    }
  }
});

/***/ }),

/***/ "LYnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__ = __webpack_require__("MXoe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a12873f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SystemMessage_vue__ = __webpack_require__("5rtu");
function injectStyle (ssrContext) {
  __webpack_require__("E1Kv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a12873f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a12873f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SystemMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Lbox":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LijO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalExclamation_vue__ = __webpack_require__("hb4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12a9c219_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalExclamation_vue__ = __webpack_require__("YoOX");
function injectStyle (ssrContext) {
  __webpack_require__("tjYl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalExclamation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12a9c219_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalExclamation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LjDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){$event.preventDefault();_vm.onHeaderClick($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{staticClass:"vuestic-collapse__header__button btn btn-warning",staticStyle:{"height":"40px","padding-top":"0.6rem","text-transform":"none"}},[_vm._t("header"),_vm._v(" "),_vm._m(0)],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-7 icon-bar pull-right"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-remove",attrs:{"id":"remove"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LkEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-feed"},[(_vm.posts.length == 0)?_c('div',{staticClass:"empty"},[_vm._v("Your feed is empty.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('div',{staticClass:"post",class:{last: _vm.posts.indexOf(post) === _vm.posts.length - 1}},[_c('div',{staticClass:"photo-container"},[_c('div',{staticClass:"photo",style:(("background: url(" + (post.photoURL) + ")"))})]),_vm._v(" "),_c('div',{staticClass:"underscored"},[_c('span',{staticClass:"text"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(post.name))]),_vm._v(" "+_vm._s(post.text)+".")]),_vm._v(" "),_c('button',{staticClass:"btn btn-micro btn-primary btn-with-icon close-btn rounded-icon",on:{"click":function($event){_vm.removePost(post)}}},[_c('i',{staticClass:"ion-md-close ion"})])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LmDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vuestic-tag",class:_vm.tagClass},[_vm._v("\n  "+_vm._s(_vm.name)+"\n  "),(_vm.removable)?_c('span',{staticClass:"vuestic-tag-button",on:{"click":_vm.remove}},[_c('i',{staticClass:"ion-md-close ion"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Loij":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__("lwql");

var _Header2 = _interopRequireDefault(_Header);

var _MessageList = __webpack_require__("wyO6");

var _MessageList2 = _interopRequireDefault(_MessageList);

var _UserInput = __webpack_require__("WQZp");

var _UserInput2 = _interopRequireDefault(_UserInput);

var _UserList = __webpack_require__("uezS");

var _UserList2 = _interopRequireDefault(_UserList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Zaglavlje: _Header2.default,
    MessageList: _MessageList2.default,
    UserInput: _UserInput2.default,
    UserList: _UserList2.default
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: false
    },
    showFile: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    titleImageUrl: {
      type: String,
      default: ''
    },
    onUserInputSubmit: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isOpen: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    placeholder: {
      type: String,
      default: 'Write a reply'
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      showUserList: false
    };
  },

  computed: {
    messages: function messages() {
      var messages = this.messageList;

      return messages;
    }
  },
  methods: {
    handleUserListToggle: function handleUserListToggle(showUserList) {
      this.showUserList = showUserList;
    }
  }
};

/***/ }),

/***/ "Lt1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-category"},[_c('div',{staticClass:"vuestic-tree-category__header",on:{"click":function($event){_vm.isOpenCached = ! _vm.isOpenCached}}},[_c('div',{staticClass:"vuestic-tree-category__header-checkbox"},[_c('square-with-icon',{attrs:{"iconClass":_vm.checkboxIconClass}})],1),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-category__header-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-category__header-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])]),_vm._v(" "),(_vm.isOpenCached)?_c('div',{staticClass:"vuestic-tree-category__list-container"},[_c('div',{staticClass:"vuestic-tree-category__list-internal-container"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LtNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__ = __webpack_require__("MhID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26afd970_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__ = __webpack_require__("vAM5");
function injectStyle (ssrContext) {
  __webpack_require__("V85T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26afd970_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LteM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "statistika",
  path: "/statistika",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("statistika/Dashboard"),
  meta: {
    default: true,
    title: "Statistika",
    class: "primary",
    show: false,
    iconClass: "vuestic-icon vuestic-icon-dashboard",
    requiredAuth: true
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e1c737_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KXyf");
function injectStyle (ssrContext) {
  __webpack_require__("hwPc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e1c737_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MCoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__ = __webpack_require__("Rn6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cdd0b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__ = __webpack_require__("Lt1H");
function injectStyle (ssrContext) {
  __webpack_require__("PRyy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cdd0b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MCxg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MD5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MEVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__ = __webpack_require__("QI9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__ = __webpack_require__("jEUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__ = __webpack_require__("noQ4");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "layout",

  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__["default"],
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__["default"]
  },
  directives: {
    resize: __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["sidebarOpened", "toggleWithoutAnimation", "isLoading"]), {
    classObject: function classObject() {
      return {
        "sidebar-hidden": !this.toggleWithoutAnimation && !this.sidebarOpened,
        "sidebar-hidden sidebar-hidden_without-animation": this.toggleWithoutAnimation && !this.sidebarOpened
      };
    }
  })
});

/***/ }),

/***/ "MGEg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MHMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: "table table-striped",
    ascendingIcon: "entypo entypo-up-dir",
    descendingIcon: "entypo entypo-down-dir"
  },
  pagination: {
    wrapperClass: "btn-group",
    activeClass: "focus",
    disabledClass: "disabled",
    pageClass: "btn btn-primary hide-not-focused-btn",
    linkClass: "btn btn-primary pagination-link-btn",
    icons: {
      first: "fa fa-angle-double-left",
      prev: "fa fa-angle-left",
      next: "fa fa-angle-right",
      last: "fa fa-angle-double-right"
    }
  }
});

/***/ }),

/***/ "MMrO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-accordion-samples-entry',
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "MPEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MRU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sc-user-input--send-icon-wrapper",on:{"click":function($event){$event.preventDefault();_vm.onClick($event)}}},[_c('svg',{staticClass:"sc-user-input--send-icon",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"37.393px","height":"37.393px","viewBox":"0 0 37.393 37.393","enableBackground":"new 0 0 37.393 37.393"}},[_c('g',{attrs:{"id":"Layer_2"}},[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M36.511,17.594L2.371,2.932c-0.374-0.161-0.81-0.079-1.1,0.21C0.982,3.43,0.896,3.865,1.055,4.241l5.613,13.263\n        L2.082,32.295c-0.115,0.372-0.004,0.777,0.285,1.038c0.188,0.169,0.427,0.258,0.67,0.258c0.132,0,0.266-0.026,0.392-0.08\n        l33.079-14.078c0.368-0.157,0.607-0.519,0.608-0.919S36.879,17.752,36.511,17.594z M4.632,30.825L8.469,18.45h8.061\n        c0.552,0,1-0.448,1-1s-0.448-1-1-1H8.395L3.866,5.751l29.706,12.757L4.632,30.825z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MRkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalGraph_vue__ = __webpack_require__("nhR7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573c301d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalGraph_vue__ = __webpack_require__("9/Le");
function injectStyle (ssrContext) {
  __webpack_require__("1HAW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573c301d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MSY6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MSuV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MV/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "site-registration",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    labassay: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("SiteRegistrationHide", function () {
      _this.show = false;
    });
  },


  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("SiteRegistrationHide");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");

      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("SiteRegistrationInsert");

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("SiteRegistrationCancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "MXoe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "MhID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-tabs",
  props: ["names", "tab"],
  computed: {
    underscoreClass: function underscoreClass() {
      return "underscore-" + this.names.length + "-" + this.names.indexOf(this.currentActive);
    }
  },
  created: function created() {},

  watch: {
    currentActive: function currentActive() {
      if (this.currentActive != "name") {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("tabChanged", this.currentActive);
      } else {}
    }
  },
  methods: {
    setActive: function setActive(name) {
      this.currentActive = name;
    }
  },
  data: function data() {
    return {
      currentActive: this.tab
    };
  }
});

/***/ }),

/***/ "Mv1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v("\n                    "+_vm._s(_vm.okText)+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v("\n                    "+_vm._s(_vm.cancelText)+"\n                  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MwJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__("+QO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc558558_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__("0CkR");
function injectStyle (ssrContext) {
  __webpack_require__("rh3O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc558558_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Mwi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "analize",
  path: "/postavke/analize",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("analize/Analize"),
  meta: {
    default: false,
    expanded: false,
    title: "Postavke analiza",
    class: "primary",
    show: false,
    iconClass: "vuestic-icon vuestic-icon-settings",
    requiredAuth: true
  }
});

/***/ }),

/***/ "N6Uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallerDotAnimationBaseName: 'flower-spinner-smaller-dot-animation',
      biggerDotAnimationBaseName: 'flower-spinner-bigger-dot-animation',
      currentSmallerDotAnimationBaseName: '',
      currentBiggerDotAnimationBaseName: ''
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentSmallerDotAnimationBaseName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentBiggerDotAnimationBaseName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentSmallerDotAnimationBaseName, this.generateSmallerDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentBiggerDotAnimationBaseName, this.generateBiggerDotKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentSmallerDotAnimationBaseName = this.smallerDotAnimationBaseName + '-' + Date.now();
      this.currentBiggerDotAnimationBaseName = this.biggerDotAnimationBaseName + '-' + Date.now();
    },
    generateSmallerDotKeyframes: function generateSmallerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    },
    generateBiggerDotKeyframes: function generateBiggerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                50% {\n                  transform: rotate(180deg);\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  transform: rotate(360deg);\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    }
  }
});

/***/ }),

/***/ "NA/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiModal_vue__ = __webpack_require__("n/7Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e9aacb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiModal_vue__ = __webpack_require__("TIR+");
function injectStyle (ssrContext) {
  __webpack_require__("Uf0Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02e9aacb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e9aacb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NEvL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.cancelClass,attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.cancelText))])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NG7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-aparati",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    analyser: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;
      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Analyser", this.analyser);
    },
    onHeaderClick: function onHeaderClick() {},
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "NG7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__ = __webpack_require__("dtfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60789cc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__ = __webpack_require__("+SDe");
function injectStyle (ssrContext) {
  __webpack_require__("fDiC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60789cc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60789cc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_components_plugin__ = __webpack_require__("GslS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_idle_vue__ = __webpack_require__("VsiT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_idle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_idle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_dialog__ = __webpack_require__("7VfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_liquor_tree__ = __webpack_require__("ZIfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_crip_vue_notice__ = __webpack_require__("sLv0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_crip_vue_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_crip_vue_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_flatpickr_component__ = __webpack_require__("B+20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_flatpickr_dist_flatpickr_css__ = __webpack_require__("K4gw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_spinkit__ = __webpack_require__("iclY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_spinkit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_spinkit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_lodash__ = __webpack_require__("NETs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_beautiful_chat__ = __webpack_require__("zUV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_beautiful_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_beautiful_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_chartjs_plugin_annotation__ = __webpack_require__("+WEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_chartjs_plugin_annotation__);






















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_crip_vue_notice___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_components_plugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_liquor_tree__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_chartjs_plugin_annotation___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_flatpickr_component___default.a);

var options = {
  name: "lodash"
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_lodash___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("multiselect", __WEBPACK_IMPORTED_MODULE_18_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("Spinner", __WEBPACK_IMPORTED_MODULE_15_vue_spinkit___default.a);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate___default.a, { fieldsBagName: "formFields" });

var eventsHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_idle_vue___default.a, {
  eventEmitter: eventsHub,
  idleTime: 28800000
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_beautiful_chat___default.a);

Object(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

var mediaHandler = function mediaHandler() {
  if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.config.windowMatchSizeLg).matches) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch("toggleSidebar", true);
  } else {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch("toggleSidebar", false);
  }
};

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("setLoading", true);
  next();
});

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].afterEach(function (to, from) {
  mediaHandler();
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("setLoading", false);
});

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
}));

/***/ }),

/***/ "NKsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "drugo-stanje",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    zatvori: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      zatvor: this.zatvori
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    ok: function ok() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("DrugoStanjeOn");

      this.$emit("ok");

      this.show = false;
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("DrugoStanjeOff");
      this.$emit("cancel");

      this.show = false;
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
    }
  }
});

/***/ }),

/***/ "NNPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ruler),expression:"ruler"}],staticClass:"col-md-12"},[_c('div',{staticClass:"testoviDiv",staticStyle:{"text-align":"center"}},[_vm._l((_vm.testovi),function(test){return _c('div',{key:test.labassay,class:{
                    'btn btn-primary btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab'), 
                    'btn btn-warning btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc'), 
                    'btn btn-secondary btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'),
                    'disabled btn btn-primary btn-micro' : ((test.disable) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab'), 
                    'disabled btn btn-warning btn-micro' : ((test.disable ) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc'), 
                    'disabled btn btn-secondary btn-micro' : ((test.disable) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man')},attrs:{"name":test.labassay},on:{"click":function($event){_vm.izbaciTest($event, test.disable)}}},[_vm._v(_vm._s(test.ime_testa))])}),_vm._v("  \n                  "),_c('hr')],2),_vm._v(" "),_c('div',_vm._l((Math.ceil(_vm.sviTestovi.length/100)),function(index){return _c('div',{key:index,staticClass:"table",staticStyle:{"text-align":"center"}},_vm._l(((_vm.sviTestovi.slice((index-1)*100,index*100))),function(test){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTest(_vm.$store.state.site, test.analit, _vm.ukGodina, _vm.spol, _vm.drstanje, _vm.menopauza, test.manual, test.calculated)[2] && !test.disabled),expression:"showTest($store.state.site, test.analit, ukGodina, spol, drstanje, menopauza, test.manual, test.calculated)[2] && !test.disabled"}],key:test.labassay,class:{'btn btn-primary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab', 'btn btn-warning btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc', 'btn btn-secondary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'},attrs:{"title":test.analit,"align":"middle","id":test.labassay},on:{"click":function($event){_vm.dodajTest($event, test)}}},[_vm._v(_vm._s(test.ime_testa))])}))})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},_vm._l((Math.ceil(_vm.basSviTestovi.length/100)),function(index){return _c('div',{key:index,staticClass:"table",staticStyle:{"text-align":"center"}},_vm._l(((_vm.basSviTestovi.slice((index-1)*100,index*100))),function(test){return _c('div',{key:test.labassay,class:{'btn btn-primary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab', 'btn btn-warning btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc', 'btn btn-secondary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'},attrs:{"title":test.analit,"align":"middle","id":test.labassay},on:{"click":function($event){_vm.dodajTest($event, test)}}},[_vm._v(_vm._s(test.ime_testa))])}))}))])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NNU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NOeY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "labassay-edit-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    labassay: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("LabAssayHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("LabAssayHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");

    if (this.labassay.analit.length > 30) {
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("LabAssayLength", this.labassay.analit);
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("LabAssayEdit");
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("LabAssayEdit");
    }

    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("LabAssayCancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "NPbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("3Alh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_65908005_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("NZI2");
function injectStyle (ssrContext) {
  __webpack_require__("T7xy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65908005"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_65908005_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "NS1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var duration = binding.value.duration || 500;
    var isAnimated = binding.value.animate;

    var observer = new MutationObserver(scrollToBottom);
    var config = { childList: true };
    observer.observe(el, config);

    function animateScroll(duration) {
      var start = el.scrollTop;
      var end = el.scrollHeight;
      var change = end - start;
      var increment = 20;

      function easeInOut(currentTime, start, change, duration) {
        currentTime /= duration / 2;
        if (currentTime < 1) {
          return change / 2 * currentTime * currentTime + start;
        }
        currentTime -= 1;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
      }

      function animate(elapsedTime) {
        elapsedTime += increment;
        var position = easeInOut(elapsedTime, start, change, duration);
        el.scrollTop = position;

        if (elapsedTime < duration) {
          setTimeout(function () {
            animate(elapsedTime);
          }, increment);
        }
      }

      animate(0);
    }

    function scrollToBottom() {
      if (isAnimated) {
        animateScroll(duration);
      } else {
        el.scrollTop = el.scrollHeight;
      }
    }
  }
});

/***/ }),

/***/ "NSkb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NW4G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NXUR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NZI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scaling-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NoHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Pie"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "NpL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "O/de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('vue-json-editor',{attrs:{"show-btns":false},on:{"json-change":_vm.onJsonChange},model:{value:(_vm.jsonData),callback:function ($$v) {_vm.jsonData=$$v},expression:"jsonData"}})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O1gf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-social-news"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center text-w-btn"},[_c('span',{staticClass:"text"},[_vm._v("That what users have posted about your business.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('button',{staticClass:"btn btn-micro btn-primary"},[_vm._v("VIEW")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-around photos"},_vm._l((_vm.news),function(pieceOfNews){return _c('div',{staticClass:"photo",style:(("background: url(" + (pieceOfNews.photoURL) + ")"))})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O3lU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__("mUJ2")("./" + name + (index ? "/index" : "") + ".vue");
  };
});

/***/ }),

/***/ "O5J4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OAnZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OBvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__ = __webpack_require__("gVv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");


var _name$components$prop;





/* harmony default export */ __webpack_exports__["a"] = (_name$components$prop = {
  name: "json-edit-analysers",
  components: {
    vueJsonEditor: __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__["a" /* default */]
  },
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      jsonData: {},
      tab: "",
      obj: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$on("JsonEditAnalysersOpen", function (data) {
      _this.jsonData = data;
      _this.obj = data;
      _this.show = true;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$off("JsonEditAnalysersOpen");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "methods", {
  onJsonChange: function onJsonChange(value) {
    this.obj = value;
  },
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    this.AnalyserEdit();
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  AnalyserEdit: function AnalyserEdit() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/analysers/edit", {
      analyser: this.obj,
      token: this.$store.state.token,
      site: this.$store.state.site
    }).then(function (res) {
      if (res.data.success) {
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("AnalysersRefresh");
        _this2.show = false;
      } else {}
    });
  }
}), _name$components$prop);

/***/ }),

/***/ "OEXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},[_c('vuestic-scrollbar',[_c('ul',{staticClass:"sidebar-menu"},_vm._l((_vm.sidebarItems),function(item){return _c('li',{key:item.name,on:{"click":function($event){_vm.setDropdownDefaultIzbor()}}},[(item.path)?_c('router-link',{class:{'sidebar-link': item.meta.class === 'primary', 
            'sidebar-link-warning': item.meta.class === 'warning', 
            'sidebar-link-danger': item.meta.class === 'danger',
            'sidebar-link-info': item.meta.class === 'info'
          },attrs:{"to":item.path,"target":item.meta.newWindow ? '_blank' : '_self'},on:{"click":function($event){_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("\n          "+_vm._s(item.meta.title)+"\n        ")]):_c('a',{staticClass:"sidebar-link",class:{'sidebar-link-danger expanded': item.meta.expanded && item.meta.class === 'danger',
            'sidebar-link-info expanded': item.meta.expanded && item.meta.class === 'info' ,
            'sidebar-link-danger': !item.meta.expanded && item.meta.class === 'danger',
            'sidebar-link-info': !item.meta.expanded && item.meta.class === 'info'
          },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("\n          "+_vm._s(item.meta.title)+"\n          "),_c('i',{staticClass:"expand-icon fa fa-angle-down"})]),_vm._v(" "),_c('expanding',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(item.meta.expanded),expression:"item.meta.expanded"}],staticClass:"sidebar-submenu in"},_vm._l((item.children),function(childItem){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(childItem.meta.show),expression:"childItem.meta.show"}],key:childItem.name,on:{"click":function($event){_vm.setDropdownDefaultIzbor()}}},[_c('router-link',{staticClass:"sidebar-link sidebar-submenu-link",attrs:{"to":childItem.path,"target":childItem.meta.newWindow ? '_blank' : '_self'}},[_vm._v(_vm._s(childItem.meta.title))])],1)}))])],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OM6/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OMRV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OMi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalComment_vue__ = __webpack_require__("+mFV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2840be63_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalComment_vue__ = __webpack_require__("RUzi");
function injectStyle (ssrContext) {
  __webpack_require__("/RS4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2840be63_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "OPFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__ = __webpack_require__("WHJM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4ce8a259_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__ = __webpack_require__("8pBa");
function injectStyle (ssrContext) {
  __webpack_require__("h8Ez")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ce8a259"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4ce8a259_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OR0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var ddToggle = el.querySelector(".dropdown-toggle");
    var ddMenu = el.querySelector(".dropdown-menu");
    var closeOnMenuClick = binding.modifiers.closeOnMenuClick;

    ddToggle.addEventListener("click", function (evt) {
      evt.preventDefault();
      var isShown = el.classList.contains("show");
      setTimeout(function () {
        el.classList.toggle("show", !isShown);
        ddMenu.classList.toggle("show", !isShown);
      });
    });

    window.addEventListener("click", function () {
      el.classList.remove("show");
      ddMenu.classList.remove("show");
    });

    ddMenu.addEventListener("click", function (evt) {
      if (!closeOnMenuClick) {
        evt.stopPropagation();
      }
    });
  }
});

/***/ }),

/***/ "OXUU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('fieldset',[(_vm.izbor === 'datr')?_c('div',[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datumrodjenja),expression:"datumrodjenja"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"edrp-input-icon-left","title":" ","name":"edrp-input-icon-left","required":""},domProps:{"value":(_vm.datumrodjenja)},on:{"input":function($event){if($event.target.composing){ return; }_vm.datumrodjenja=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"edrp-input-icon-left"}},[_vm._v(_vm._s("DD.MM.GGGG"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])]):_vm._e(),_vm._v(" "),(_vm.izbor === 'god')?_c('div',[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.godiste),expression:"godiste"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"godp-input-icon-left","title":" ","name":"godp-input-icon-left","required":""},domProps:{"value":(_vm.godiste)},on:{"input":function($event){if($event.target.composing){ return; }_vm.godiste=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"godp-input-icon-left"}},[_vm._v(_vm._s("GGGG"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ime),expression:"ime"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"imep-input-icon-left","title":" ","name":"imep-input-icon-left","required":true},domProps:{"value":(_vm.ime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ime=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"imep-input-icon-left"}},[_vm._v(_vm._s("IME"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prezime),expression:"prezime"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"prezime-input-icon-left","title":" ","name":"prezime-input-icon-left","required":true},domProps:{"value":(_vm.prezime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prezime=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"prezime-input-icon-left"}},[_vm._v(_vm._s("PREZIME"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('vuestic-simple-select',{ref:"spolSelect",attrs:{"color":'red',"label":'SPOL',"name":"spol","required":true,"title":" ","options":_vm.spolovi},model:{value:(_vm.spol),callback:function ($$v) {_vm.spol=$$v},expression:"spol"}}),_vm._v(" "),_c('vuestic-simple-select',{ref:"purposeSelect",attrs:{"color":'red',"label":'SVRHA TESTIRANJA',"name":"purpose","required":true,"title":" ","options":_vm.purposes},model:{value:(_vm.purpose),callback:function ($$v) {_vm.purpose=$$v},expression:"purpose"}}),_vm._v(" "),_c('vuestic-simple-select',{ref:"izdavanjeSelect",attrs:{"color":'red',"label":'NALAZ IZDATI',"name":"izdavanje","required":false,"title":" ","options":_vm.izdavanja},model:{value:(_vm.izdavanje),callback:function ($$v) {_vm.izdavanje=$$v},expression:"izdavanje"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[(false)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-11"},[_c('div',{staticStyle:{"min-height":"14px"}}),_vm._v(" "),_c('fieldset',[_c('postavke-radio-button',{attrs:{"label":'DATUM ROĐENJA',"id":'datr',"value":'datr',"name":'disabled-radio',"disabled":false},model:{value:(_vm.izbor),callback:function ($$v) {_vm.izbor=$$v},expression:"izbor"}}),_vm._v(" "),_c('postavke-radio-button',{attrs:{"label":'GODINA ROĐENJA',"id":'god',"value":'god',"name":'disabled-radio',"disabled":true},model:{value:(_vm.izbor),callback:function ($$v) {_vm.izbor=$$v},expression:"izbor"}})],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passport),expression:"passport"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"passport-input-icon-left","title":" ","name":"passport-input-icon-left","required":""},domProps:{"value":(_vm.passport)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passport=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"passport-input-icon-left"}},[_vm._v(_vm._s("IDENTIFIKACIJSKI DOKUMENT"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('vuestic-simple-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.default_route === '/registracija'),expression:"$store.state.default_route === '/registracija'"}],ref:"analysisSelect",attrs:{"label":'Željena analiza',"name":"analysis","required":false,"title":" ","options":_vm.analyses},model:{value:(_vm.analysis),callback:function ($$v) {_vm.analysis=$$v},expression:"analysis"}}),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenAdress),expression:"chosenAdress"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"prezp-input-icon-left","title":" ","name":"prezp-input-icon-left","required":""},domProps:{"value":(_vm.chosenAdress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chosenAdress=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"prezp-input-icon-left"}},[_vm._v(_vm._s("ADRESA STANOVANJA"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefon),expression:"telefon"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"telep-input-icon-left","title":" ","name":"telep-input-icon-left","required":""},domProps:{"value":(_vm.telefon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefon=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"telep-input-icon-left"}},[_vm._v(_vm._s("KONTAKT TELEFON (3876xxxxxxx)"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"emep-input-icon-left","title":" ","name":"emep-input-icon-left","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"emep-input-icon-left"}},[_vm._v(_vm._s("KONTAKT E-MAIL"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('vuestic-multi-select',{ref:"languageSelect",attrs:{"label":'JEZIK NALAZA',"name":"language","required":true,"title":" ","options":_vm.languages},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"on-cancel":_vm.onCancel,"color":"#4ae387","is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(false)?_c('button',{on:{"click":function($event){$event.preventDefault();_vm.Test($event)}}},[_vm._v("\n                        "+_vm._s("Loading...")+"\n                      ")]):_vm._e()])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.cancel}},[_vm._v("\n                    "+_vm._s(_vm.cancelText)+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.invalid)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":true},on:{"~click":function($event){_vm.ok($event)}}},[_vm._v("                   \n                    "+_vm._s(_vm.okText)+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons && !_vm.invalid)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":(_vm.pacijentbezsimptoma == false &&
                        _vm.povišenatjelesnatemperatura == false &&
                        _vm.suhikašalj == false &&
                        _vm.umor == false &&
                        _vm.bolovi == false &&
                        _vm.grlobolja == false &&
                        _vm.proljev == false &&
                        _vm.konjunktivitis == false &&
                        _vm.glavobolja == false &&
                        _vm.gubitakosjetaokusailimirisa == false &&
                        _vm.osipilipromjenabojeprstijunarukamailinogama == false &&
                        _vm.otežanodisanjeiligubitakdaha == false &&
                        _vm.bolilipritisakuprsima == false &&
                        _vm.gubitaksposobnostigovorailikretanja == false) ||
                        



















                      (!Number.isInteger(_vm.dateofb) &&
                        _vm.dateofb.length != 8 &&
                        _vm.izbor === 'datr') ||
                      (!Number.isInteger(_vm.godiste) &&
                        _vm.godiste.length != 4 &&
                        _vm.izbor === 'god') ||
                      _vm.ime.trim() == '' ||
                      _vm.prezime.trim() == '' ||
                      _vm.spol.trim() == '' ||
                      _vm.purpose.trim() == '' ||
                      _vm.izdavanje.trim() == ''},on:{"~click":function($event){_vm.ok($event)}}},[_vm._v("\n                   \n                    "+_vm._s(_vm.okText)+"\n                  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oe0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: Number
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },

  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      this.selected = optionValue;
      this.$emit('items-per-page', this.selected);
    }
  }
});

/***/ }),

/***/ "OgkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-radio-button form-check radio abc-radio",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checkState},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[(!_vm.checkState)?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#333"}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(
        _vm.checkState &&
        _vm.label != 'DATUM ROĐENJA' &&
        _vm.label != 'GODINA ROĐENJA' &&
        _vm.label != 'DATE OF BIRTH' &&
        _vm.label != 'YEAR OF BIRTH' &&
        _vm.label != 'GEBURTSDATUM' &&
        _vm.label != 'GEBURTSJAHR' &&
        _vm.label != 'Bosanski jezik' &&
        _vm.label != 'Engleski jezik' &&
        _vm.label != 'Njemački jezik' &&
        _vm.label != 'Bosnian language' &&
        _vm.label != 'English language' &&
        _vm.label != 'German language' &&
        _vm.label != 'Bosnische Sprache' &&
        _vm.label != 'Englische Sprache' &&
        _vm.label != 'Deutsche Sprache'
      )?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#4ae387"}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),(
        _vm.checkState &&
        (_vm.label === 'DATUM ROĐENJA' ||
          _vm.label === 'GODINA ROĐENJA' ||
          _vm.label === 'DATE OF BIRTH' ||
          _vm.label === 'YEAR OF BIRTH' ||
          _vm.label === 'GEBURTSDATUM' ||
          _vm.label === 'GEBURTSJAHR' ||
          _vm.label === 'Bosanski jezik' ||
          _vm.label === 'Engleski jezik' ||
          _vm.label === 'Njemački jezik' ||
          _vm.label === 'Bosnian language' ||
          _vm.label === 'English language' ||
          _vm.label === 'German language' ||
          _vm.label === 'Bosnische Sprache' ||
          _vm.label === 'Englische Sprache' ||
          _vm.label === 'Deutsche Sprache')
      )?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OhG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_Samples_js__ = __webpack_require__("Zavi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_Samples_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__functions_Samples_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");


var _methods;





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-edit",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      ruler: false,
      duration: 500,

      ime: "",
      prezime: "",
      jmbg: "",
      spol: "",

      lokacija: "",
      drstanje: "",
      menstc: "",
      anticoag: "",
      menopauza: "",

      jmbgObj: {},
      jmbgDan: "",
      jmbgMjesec: "",
      jmbgGodina: "",
      ukGodina: "",

      tip: "",

      sekcija: [],
      izabraniTestovi: [],
      sviTestovi: [],
      sviRezultati: [],
      basSviTestovi: [],
      testovi: [],

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: (_methods = {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.EditSample();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.GetSample();
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    EditSample: function EditSample() {},
    GetSample: function GetSample() {
      var _this = this;

      this.ruler = false;
      this.izabraniTestovi = [];
      this.sviTestovi = [];
      this.basSviTestovi = [];
      this.testovi = [];

      __WEBPACK_IMPORTED_MODULE_1__config_config_js__["C" /* http */].get("uzorci/show/" + this.$store.state.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        _this.ime = res.data.uzorak.patient.ime;
        _this.prezime = res.data.uzorak.patient.prezime;
        _this.jmbg = res.data.uzorak.patient.jmbg;
        _this.spol = res.data.uzorak.patient.spol;

        _this.lokacija = res.data.uzorak.lokacija.lokacija;
        _this.drstanje = res.data.uzorak.trudnica;
        _this.menstc = res.data.uzorak.menstc;
        _this.anticoag = res.data.uzorak.anticoag;
        _this.menopauza = res.data.uzorak.menopauza;
        _this.tip = res.data.uzorak.type;
        _this.sekcija = res.data.uzorak.sekcija;
        _this.izabraniTestovi = res.data.uzorak.tests;
        _this.sviRezultati = res.data.rezultat.rezultati;
        _this.ukupnaStarost();

        var tmp = "";

        if (res.data.uzorak.tip != "") {
          tmp = res.data.uzorak.tip;
        } else {
          tmp = res.data.rezultat.rezultati[0].labassay.tip;
        }

        __WEBPACK_IMPORTED_MODULE_1__config_config_js__["C" /* http */].post("/uzorci/labassay/tip", {
          sekcija: _this.sekcija,
          token: _this.$store.state.token,
          tip: res.data.rezultat.rezultati[0].labassay.tip,
          site: _this.$store.state.site
        }).then(function (res) {
          if (res.data.success === false) {
            _this.sviTestovi = [];
          } else {
            _this.sviTestovi = [];

            res.data.testovi.forEach(function (element) {
              _this.basSviTestovi.push({
                labassay: element._id,
                ime_testa: element.naziv,
                cijena: element.price,
                analit: element.analit,
                sekcija: element.sekcija,
                manual: element.manual,
                calculated: element.calculated,
                calculatedTests: element.calculatedTests
              });

              if (Object(__WEBPACK_IMPORTED_MODULE_2__functions_Samples_js__["Selection"])(_this.$store.state.site, element.analit, _this.ukGodina, _this.spol, _this.drstanje, _this.menopauza)[1]) {
                _this.sviTestovi.push({
                  disabled: element.disabled,
                  labassay: element._id,
                  ime_testa: element.naziv,
                  cijena: element.price,
                  analit: element.analit,
                  sekcija: element.sekcija,
                  manual: element.manual,
                  calculated: element.calculated,
                  calculatedTests: element.calculatedTests
                });
              }
            });
          }
        }).then(function (res) {
          var editable = true;
          _this.sviTestovi.forEach(function (element) {
            _this.izabraniTestovi.forEach(function (izabrani) {
              if (izabrani.labassay._id === element.labassay) {
                editable = false;

                _this.sviRezultati.forEach(function (rez) {
                  if (rez.labassay._id === element.labassay) {
                    if (rez.rezultat[rez.rezultat.length - 1].rezultat_f != "") {
                      editable = true;
                    }
                  }
                });

                _this.dodajTestInit(element.labassay, element.ime_testa, izabrani.labassay.manual, izabrani.status_t, editable);
              }
            });
          });

          for (var i = _this.sviTestovi.length - 1; i >= 0; i--) {
            for (var j = 0; j < _this.izabraniTestovi.length; j++) {
              if (_this.sviTestovi[i] && _this.sviTestovi[i].labassay === _this.izabraniTestovi[j].labassay._id) {
                _this.sviTestovi.splice(i, 1);
              }
            }
          }
        }).then(function (res) {
          _this.ruler = true;
          _this.show = true;
        });
      });
    },
    removeDuplicates: function removeDuplicates(originalArray, prop) {
      var newArray = [];
      var lookupObject = {};

      for (var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }

      for (i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "EditSample", function EditSample() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__config_config_js__["C" /* http */].post("/uzorci/update", {
      sid: this.$store.state.sid,
      jmbg: this.jmbg,
      testovi: this.testovi,
      token: this.$store.state.token,
      site: this.$store.state.site,
      spol: this.spol,
      trudnica: this.drstanje,
      menstc: this.menstc,
      anticoag: this.anticoag,
      menopauza: this.menopauza,
      jmbgObj: this.jmbgObj
    }).then(function (res) {
      if (res.data.success === true) {
        _this2.toastText = "Uzorak uspješno izmijenjen!";
        _this2.toastIcon = "fa-check";
        _this2.toastPosition = "top-right";
        _this2.className = "vuestic-toast-primary";

        _this2.showToast(_this2.toastText, {
          icon: _this2.toastIcon,
          position: _this2.toastPosition,
          duration: _this2.toastDuration,
          fullWidth: _this2.isToastFullWidth,
          className: _this2.className
        });

        _this2.show = false;
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Edited", _this2.$store.state.sid);
      } else {
        _this2.toastText = "Greška prilikom izmjene uzorka!";
        _this2.toastIcon = "fa-remove";
        _this2.toastPosition = "top-right";
        _this2.className = "vuestic-toast-danger";

        _this2.showToast(_this2.toastText, {
          icon: _this2.toastIcon,
          position: _this2.toastPosition,
          duration: _this2.toastDuration,
          fullWidth: _this2.isToastFullWidth,
          className: _this2.className
        });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "ukupnaStarost", function ukupnaStarost() {
    var str = "";
    var tmp = "";
    this.jmbgDan = this.jmbg.slice(0, 2);
    this.jmbgMjesec = this.jmbg.slice(2, 4);
    this.jmbgGodina = this.jmbg.slice(4, 7);

    if (this.jmbgGodina[0] === "9") {
      str = "1";
      tmp = this.jmbgGodina;
      this.jmbgGodina = str.concat(tmp);
    } else if (this.jmbgGodina[0] === "0") {
      str = "2";
      tmp = this.jmbgGodina;
      this.jmbgGodina = str.concat(tmp);
    } else {}

    var date = this.jmbgGodina + "-" + this.jmbgMjesec + "-" + this.jmbgDan;
    this.jmbgObj = this.dateDiff(date);
    this.ukGodina = this.jmbgObj.years + 1;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "dateDiff", function dateDiff(date) {
    date = date.split("-");
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    var day = today.getDate();
    var yy = parseInt(date[0]);
    var mm = parseInt(date[1]);
    var dd = parseInt(date[2]);
    var years, months, days;

    months = month - mm;

    if (day < dd) {
      months = months - 1;
    }

    years = year - yy;

    if (month * 100 + day < mm * 100 + dd) {
      years = years - 1;
      months = months + 12;
    }

    days = Math.floor((today.getTime() - new Date(yy + years, mm + months - 1, dd).getTime()) / (24 * 60 * 60 * 1000));

    return {
      years: years,
      months: months,
      days: days
    };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "dodajTestInit", function dodajTestInit(event, ime, manual, status, editable) {
    var _this3 = this;

    if (this.testovi.length < 1) {
      this.placeholder = "";
    }

    var manual = false;
    var calculated = false;
    var kalkuliraniTestovi = [];
    var sekc = "";
    var anlit = "";
    var cost = "";

    if (!this.testovi.filter(function (test) {
      return test.labassay === event;
    }).length > 0) {
      this.sviTestovi.forEach(function (element) {
        if (event === element.labassay) {
          sekc = element.sekcija;
          anlit = element.analit;
          cost = element.cijena;
        }

        if (element.manual && event === element.labassay) {
          manual = true;
        }

        if (element.calculated && event === element.labassay) {
          calculated = true;

          element.calculatedTests.forEach(function (kalk) {
            kalk.sekcija = element.sekcija;
            kalk.calculated = false;
            kalk.calculatedTests = [];
            kalk.cijena = "0";
            kalk.disable = true;

            _this3.basSviTestovi.forEach(function (bastest) {
              if (bastest.labassay === kalk.labassay) {
                kalk.cijena = bastest.cijena;
                kalk.analit = bastest.analit;
              }
            });

            if (!_this3.testovi.filter(function (test) {
              return test.labassay === kalk.labassay;
            }).length > 0) {
              _this3.testovi.push(kalk);
            }

            kalkuliraniTestovi.push(kalk);
          });
        }
      });

      this.testovi.push({
        disable: editable,
        labassay: event,
        ime_testa: ime,
        cijena: cost,
        analit: anlit,
        sekcija: sekc,
        manual: manual,
        calculated: calculated,
        calculatedTests: kalkuliraniTestovi
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "dodajTest", function dodajTest(event) {
    var _this4 = this;

    if (this.testovi.length < 1) {
      this.placeholder = "";
    }
    var manual = false;
    var calculated = false;
    var kalkuliraniTestovi = [];
    var sekc = "";
    var anlit = "";
    var cost = "";

    if (!this.testovi.filter(function (test) {
      return test.labassay === event.target.id;
    }).length > 0) {
      this.sviTestovi.forEach(function (element) {
        if (event.target.id === element.labassay) {
          sekc = element.sekcija;
          anlit = element.analit;
          cost = element.cijena;
        }
        if (element.manual && event.target.id === element.labassay) {
          manual = true;
        }
        if (element.calculated && event.target.id === element.labassay) {
          calculated = true;

          element.calculatedTests.forEach(function (kalk) {
            kalk.sekcija = element.sekcija;
            kalk.calculated = false;
            kalk.calculatedTests = [];
            kalk.cijena = "0";

            _this4.basSviTestovi.forEach(function (bastest) {
              if (bastest.labassay === kalk.labassay) {
                kalk.cijena = bastest.cijena;
                kalk.analit = bastest.analit;
              }
            });

            if (!_this4.testovi.filter(function (test) {
              return test.labassay === kalk.labassay;
            }).length > 0) {
              _this4.testovi.push(kalk);
            }

            kalkuliraniTestovi.push(kalk);
            document.getElementById(kalk.labassay).className = "btn btn-info btn-micro";
          });
        }
      });

      this.testovi.push({
        labassay: event.target.id,
        ime_testa: event.target.innerText,
        cijena: cost,
        analit: anlit,
        sekcija: sekc,
        manual: manual,
        calculated: calculated,
        calculatedTests: kalkuliraniTestovi
      });

      document.getElementById(event.target.id).className = "btn btn-info btn-micro";
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "izbaciTest", function izbaciTest(event, disable) {
    if (disable != undefined && disable) {
      this.toastText = "Test nije moguće ukloniti!";
      this.toastIcon = "fa-warning";
      this.toastPosition = "top-right";
      this.className = "vuestic-toast-warning";

      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth,
        className: this.className
      });
    } else {
      if (this.testovi.length < 2) {
        this.toastText = "Test nije moguće ukloniti. Zatvorite prozor i obrišite uzorak.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else {
        var alert = false;
        var izbaciti = event.target.getAttribute("name");
        var count = 0;

        this.testovi.forEach(function (element) {
          if (element.calculated) {
            element.calculatedTests.forEach(function (kalk) {
              if (izbaciti === kalk.labassay) {
                count++;
              }
            });
          }
        });

        if (count > 0) {
          alert = false;
          this.toastText = "Test nije moguće ukloniti!";
          this.toastIcon = "fa-warning";
          this.toastPosition = "top-right";
          this.className = "vuestic-toast-warning";

          this.showToast(this.toastText, {
            icon: this.toastIcon,
            position: this.toastPosition,
            duration: this.toastDuration,
            fullWidth: this.isToastFullWidth,
            className: this.className
          });
        } else {
          alert = true;
        }

        if (alert) {
          if (this.testovi.length < 2) {
            this.placeholder = "Izaberite testove";
          }
          this.test = event.target.innerText;
          for (var i = 0; i < this.testovi.length; i++) {
            if (this.testovi[i].labassay === event.target.getAttribute("name")) {
              this.testovi.splice(i, 1);
              break;
            }
          }
          if (event.target.className === "btn btn-primary btn-micro") {
            document.getElementById(event.target.getAttribute("name")).className = "btn btn-primary btn-micro";
          }
          if (event.target.className === "btn btn-secondary btn-micro") {
            document.getElementById(event.target.getAttribute("name")).className = "btn btn-secondary btn-micro";
          }
          if (event.target.className === "btn btn-warning btn-micro") {
            document.getElementById(event.target.getAttribute("name")).className = "btn btn-warning btn-micro";
          }
        }
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "klasaTesta", function klasaTesta(naziv, manual, calculated) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__functions_Samples_js__["Selection"])(this.$store.state.site, naziv, "", "", "", "", manual, calculated);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "showTest", function showTest(site, analit, godina, spol, drstanje, menopauza, manual, calculated) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__functions_Samples_js__["Selection"])(site, analit, godina, spol, drstanje, menopauza, manual, calculated);
  }), _methods)
});

/***/ }),

/***/ "OlZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "patient-evaluation-multi",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    multiparam_izbornik: {
      type: Array,
      default: [""]
    },
    multiparam_izbor: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      table: true,
      duration: 500,
      window: {
        width: 0,
        height: 0
      },
      parametar: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("Switch", function () {
      _this.table = true;
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("graph");
    });
  },
  created: function created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("Switch");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    multiparam_izbor: function multiparam_izbor() {
      this.parametar = this.multiparam_izbor;
    },
    parametar: function parametar() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Parametar", this.parametar);
    },
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    ShowGraph: function ShowGraph() {
      this.table = true;
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("graph");
    },
    ShowTable: function ShowTable() {
      this.table = false;
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("table");
    },
    cancel: function cancel() {
      var _this2 = this;

      this.$emit("cancel");
      this.show = false;

      setTimeout(function () {
        _this2.table = true;
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("graph");
      }, 500);

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.parametar = this.multiparam_izbornik[0];
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.parametar = "";
      this.show = false;
      this.table = true;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "OoXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload-single-item"},[_c('div',{staticClass:"file-upload-single-item-name"},[_vm._v(_vm._s(_vm.file.name))]),_vm._v(" "),_c('button',{staticClass:"btn-text btn-text--primary",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('remove')}}},[_vm._v(_vm._s(_vm.$t('fileUpload.delete')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oviz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "patient-edit",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    timestamp: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    patient: {
      type: Object,
      default: function _default() {
        return {
          _id: "",
          entry_disabled: false,
          izdavanje: "",
          duhan: "",
          dijabetes: "",
          symptoms: {
            pacijentbezsimptoma: true,
            povišenatjelesnatemperatura: false,
            suhikašalj: false,
            umor: false,
            bolovi: false,
            grlobolja: false,
            proljev: false,
            konjunktivitis: false,
            glavobolja: false,
            gubitakosjetaokusailimirisa: false,
            osipilipromjenabojeprstijunarukamailinogama: false,
            otežanodisanjeiligubitakdaha: false,
            bolilipritisakuprsima: false,
            gubitaksposobnostigovorailikretanja: false
          },
          purpose: "",
          analysis: "",
          referenca: "",
          note: "",
          passport: "",
          language: [""],
          telefon: "",
          email: "",
          adresa: "",
          created_at: null,
          updated_at: null,
          created_by: "",
          updated_by: "",
          jmbg: "",
          ime: "",
          prezime: "",
          spol: "",
          site: "",
          __v: 0
        };
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      izbor: "datr",
      jmbg: "",
      dateofb: "",
      datumrodjenja: "",
      godiste: "",
      languages: ["Bosanski jezik", "Engleski jezik", "Njemački jezik"],

      purpose: "",
      purposes: ["Putovanje", "Procjena zdravstvenog stanja", "Kontakt sa zaraženom osobom"],
      analysis: "",
      analyses: ["", "COVID-19 RT-PCR Test", "COVID-19 Antigen Test"],

      izdavanje: "",
      izdavanja: ["DANAS", "SUTRA"],

      ime: "",
      prezime: "",
      spol: "",
      spolovi: ["MUŠKI", "ŽENSKI"],
      adresa: "",
      cities: [],
      telefon: "",
      email: "",

      invalid: true,

      isLoading: false,
      fullPage: true,

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      pacijentbezsimptoma: true
    };
  },


  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("/postavke/sajtovi/" + this.$store.state.site, {
      token: this.$store.state.token
    }).then(function (res) {
      if (res.data.sajt.mjesta != undefined) {
        res.data.sajt.mjesta.forEach(function (element) {
          _this.cities.push(element);
        });
      }
    }).then(function (res) {
      _this.cities.sort(function (a, b) {
        return a.toLowerCase() == b.toLowerCase() ? 0 : +(a.toLowerCase() > b.toLowerCase()) || -1;
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {

    jmbg: function jmbg() {
      if (this.jmbg.length < 13) {} else if (this.jmbg.length === 13) {
        if (this.izbor === "jmbg" && !this.validateDate(this.jmbg)) {} else if (this.izbor === "datr" && !this.validateDate(this.jmbg)) {} else if (this.izbor === "god" && !this.validateYear(this.godiste)) {} else if (this.izbor === "nodata" && !this.validateJMBG(this.jmbg)) {} else {
          if (true) {
            __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("/uzorci/patient", {
              jmbg: this.jmbg,
              token: this.$store.state.token,
              site: this.$store.state.site
            }).then(function (res) {});
          }
        }
      } else if (this.jmbg.length > 13) {
        this.jmbg = this.jmbg.slice(0, 13);
      }
    },
    datumrodjenja: function datumrodjenja() {
      this.datumrodjenja = this.datumrodjenja.replace(" ", "");
      this.datumrodjenja = this.datumrodjenja.replace("..", ".");

      if (!isNaN(this.datumrodjenja.substring(0, 2)) && this.datumrodjenja.length === 2) {
        this.datumrodjenja = this.datumrodjenja.substring(0, 2).replace(".", "") + ".";
      }

      if (this.datumrodjenja.length === 4 && !isNaN(this.datumrodjenja.slice(2, 4) && this.datumrodjenja.includes("."))) {
        var dot1 = this.datumrodjenja.split(".");
        var ldot1 = dot1.length;

        if (ldot1 > 1) {
          var qdate1 = this.datumrodjenja.split(".");

          if (qdate1[1].length === 2) {
            this.datumrodjenja = qdate1[0] + "." + qdate1[1] + ".";
          }
        }
      }

      if (this.datumrodjenja.length === 5 && !isNaN(this.datumrodjenja.slice(3, 5) && this.datumrodjenja.includes("."))) {
        var dot2 = this.datumrodjenja.split(".");
        var ldot2 = dot2.length;

        if (ldot2 > 1) {
          var qdate2 = this.datumrodjenja.split(".");

          if (qdate2[1].length === 2) {
            this.datumrodjenja = qdate2[0] + "." + qdate2[1] + ".";
          }
        }
      }

      if (this.datumrodjenjadatumrodjenja != "") {
        var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\.](0?[1-9]|1[012])[\.]\d{4}$/;
      }

      if (this.datumrodjenja.match(dateformat)) {
        var opera1 = this.datumrodjenja.split(".");
        var lopera1 = opera1.length;

        if (lopera1 > 1) {
          var pdate = this.datumrodjenja.split(".");
        }

        if (pdate[0].length === 1) {
          pdate[0] = "0" + pdate[0];
        }

        if (pdate[1].length === 1) {
          pdate[1] = "0" + pdate[1];
        }

        this.dateofb = pdate[0] + pdate[1] + pdate[2];

        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);

        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            this.dateofb = "";
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            this.dateofb = "";
            return false;
          }
          if (lyear == true && dd > 29) {
            this.dateofb = "";
            return false;
          }
        }
        if (this.validateYear(yy)) {
          this.dateofb = "";
          return false;
        }
      } else {
        this.dateofb = "";
        return false;
      }
    },

    dateofb: function dateofb() {
      if (this.dateofb.length < 8) {} else if (this.dateofb.length == 8) {
        if (!this.validateDateOfBirth(this.dateofb)) {
          this.invalid = true;
        } else {
          this.jmbg = this.dateofb.slice(0, 4) + this.dateofb.slice(5, 8) + this.getRandomInt(100000, 999999);

          this.invalid = false;
        }
      } else if (this.dateofb.length > 8) {
        this.dateofb = this.dateofb.slice(0, 8);
      }
    },
    godiste: function godiste() {
      if (this.godiste.length < 4) {} else if (this.godiste.length == 4) {
        if (this.validateYear(this.godiste)) {
          this.jmbg = "0000" + this.godiste.slice(1, 4) + this.getRandomInt(100000, 999999);
        } else {}
      } else if (this.godiste.length > 4) {
        this.godiste = this.godiste.slice(0, 4);
      }
    },

    invalid: function invalid() {},

    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    Test: function Test() {
      var _this2 = this;

      this.isLoading = true;

      setTimeout(function () {
        _this2.isLoading = false;
      }, 2000);
    },
    onCancel: function onCancel() {},
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.Save();
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.jmbg = this.patient.jmbg;

      this.godiste = this.patient.jmbg.substring(4, 7);
      switch (this.godiste[0]) {
        case "9":
          this.godiste = "1" + this.godiste;
          break;
        case "0":
          this.godiste = "2" + this.godiste;
          break;
        default:
          break;
      }

      this.datumrodjenja = this.patient.jmbg.substring(0, 2) + "." + this.patient.jmbg.substring(2, 4) + "." + this.godiste;

      this.dateofb = this.patient.jmbg.substring(0, 4) + this.godiste;

      this.show = true;

      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    getRandomInt: function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);

      return Math.floor(Math.random() * (max - min)) + min;
    },
    validateJMBG: function validateJMBG(jmbg) {
      return (/^\d{4}[9,0]{1}\d{8}$/.test(String(jmbg)) || /^\d{4}[9,0]{1}\d{7}[P]{1}$/.test(String(jmbg))
      );
    },
    validateYear: function validateYear(year) {
      var text = /^[0-9]+$/;
      if (year != 0) {
        if (year != "" && !text.test(year)) {
          return false;
        }

        if (year.length != 4) {
          return false;
        }
        var current_year = new Date().getFullYear();
        if (year < 1921 || year > current_year) {
          return false;
        }
        return true;
      }
    },
    validateDate: function validateDate(inputText) {
      if (inputText[4] === "9") {
        var control = "1";
      } else if (inputText[4] === "0") {
        var control = "2";
      } else {
        return false;
      }

      if (!this.validateYear(control + inputText[4] + inputText[5] + inputText[6])) {
        return false;
      }

      inputText = inputText[0] + inputText[1] + "-" + inputText[2] + inputText[3] + "-" + control + inputText[4] + inputText[5] + inputText[6];

      var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

      if (inputText.match(dateformat)) {
        var opera1 = inputText.split("/");
        var opera2 = inputText.split("-");
        var lopera1 = opera1.length;
        var lopera2 = opera2.length;

        if (lopera1 > 1) {
          var pdate = inputText.split("/");
        } else if (lopera2 > 1) {
          var pdate = inputText.split("-");
        }
        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);

        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            return false;
          }
          if (lyear == true && dd > 29) {
            return false;
          }
        }
      } else {
        return false;
      }
      return true;
    },
    validateDateOfBirth: function validateDateOfBirth(inputText) {
      var godiste = inputText[4] + inputText[5] + inputText[6] + inputText[7];
      inputText = inputText[0] + inputText[1] + "-" + inputText[2] + inputText[3] + "-" + godiste;

      if (!this.validateYear(godiste)) {
        return false;
      }

      var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

      if (inputText.match(dateformat)) {
        var opera1 = inputText.split("/");
        var opera2 = inputText.split("-");
        var lopera1 = opera1.length;
        var lopera2 = opera2.length;

        if (lopera1 > 1) {
          var pdate = inputText.split("/");
        } else if (lopera2 > 1) {
          var pdate = inputText.split("-");
        }
        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);

        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            return false;
          }
          if (lyear == true && dd > 29) {
            return false;
          }
        }
      } else {
        return false;
      }
      return true;
    },
    Save: function Save() {
      var _this3 = this;

      switch (this.izbor) {
        case "god":
          this.jmbg = "0000" + this.godiste.substring(this.godiste.length - 3) + this.patient.jmbg.substring(this.patient.jmbg.length - 6);

          break;
        case "datr":
          this.jmbg = this.dateofb.substring(0, 4) + this.dateofb.substring(this.dateofb.length - 3) + this.patient.jmbg.substring(this.patient.jmbg.length - 6);

          break;
        default:
          break;
      }

      this.ime = this.patient.ime;
      this.prezime = this.patient.prezime;
      this.spol = this.patient.spol;
      this.adresa = this.patient.adresa;
      this.telefon = this.patient.telefon;
      this.email = this.patient.email;
      this.purpose = this.patient.purpose;
      this.analysis = this.patient.analysis;
      this.izdavanje = this.patient.izdavanje;

      if (this.ime.trim() === "" || this.prezime.trim() === "" || this.spol.trim() === "" || this.purpose.trim() === "") {
        this.toastText = "Unesite obavezna polja.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else {

        if (this.adresa.trim() === "") {
          this.adresa = "";
        }
        if (this.telefon.trim() === "") {
          this.telefon = "";
        }
        if (this.email.trim() === "") {
          this.email = "";
        }

        if (this.validateJMBG(this.jmbg)) {
          var item = true;

          __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("pacijenti/unos/find", {
            jmbg: this.jmbg,
            token: this.$store.state.token,
            site: this.$store.state.site
          }).then(function (res) {
            _this3.isLoading = true;

            if (_this3.adresa.trim() === "") {
              _this3.adresa = "";
            }
            if (_this3.telefon.trim() === "") {
              _this3.telefon = "";
            }
            if (_this3.email.trim() === "") {
              _this3.email = "";
            }

            console.log("Spašavam izmjene...");
            console.log("Timestamp: " + _this3.timestamp);
            if (item) {
              __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("pacijenti/detalji/update/" + _this3.patient._id, {
                id: _this3.patient._id,
                timestamp: _this3.timestamp,
                jmbg: _this3.jmbg.trim(),
                ime: _this3.ime.toUpperCase().trim(),
                prezime: _this3.prezime.toUpperCase().trim(),

                spol: _this3.spol.toUpperCase().trim(),
                duhan: "",
                dijabetes: "",
                symptoms: _this3.patient.symptoms,

                purpose: _this3.purpose,
                analysis: _this3.analysis,
                izdavanje: _this3.izdavanje,

                note: _this3.patient.note,
                passport: _this3.patient.passport.trim(),
                language: _this3.patient.language,

                telefon: _this3.telefon.trim(),
                email: _this3.email.trim(),
                adresa: _this3.adresa.trim(),
                site: _this3.$store.state.site,
                token: _this3.$store.state.token
              }).then(function (res) {
                if (res.data.success) {
                  _this3.isLoading = false;
                  __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Set", _this3.patient);
                  _this3.show = false;
                  window.removeEventListener("keyup", _this3.listenKeyUp);
                } else {
                  _this3.isLoading = false;
                }
              });
            }
          });
        } else {
          this.jmbg = this.patient.jmbg;

          if (this.patient.jmbg.slice(0, 4) === "0000") {
            this.godiste = "";

            this.godiste = this.patient.jmbg.substring(4, 7);
            switch (this.godiste[0]) {
              case "9":
                this.godiste = "1" + this.godiste;
                break;
              case "0":
                this.godiste = "2" + this.godiste;
                break;
              default:
                break;
            }

            this.izbor = "god";
          } else {
            this.godiste = "";

            this.godiste = this.patient.jmbg.substring(4, 7);
            switch (this.godiste[0]) {
              case "9":
                this.godiste = "1" + this.godiste;
                break;
              case "0":
                this.godiste = "2" + this.godiste;
                break;
              default:
                break;
            }

            this.datumrodjenja = this.patient.jmbg.substring(0, 2) + "." + this.patient.jmbg.substring(2, 4) + "." + this.godiste;

            this.dateofb = this.patient.jmbg.substring(0, 4) + this.godiste;

            this.izbor = "datr";
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "OyUw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OzME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P2Ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticInputSelect_vue__ = __webpack_require__("IPbX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731f888b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticInputSelect_vue__ = __webpack_require__("8cWt");
function injectStyle (ssrContext) {
  __webpack_require__("OAnZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticInputSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731f888b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticInputSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "P8Jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: Number
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },

  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      this.selected = optionValue;
      this.$emit('items-per-page', this.selected);
    }
  }
});

/***/ }),

/***/ "PFUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__("Tk3j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_329507a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Message_vue__ = __webpack_require__("8t2g");
function injectStyle (ssrContext) {
  __webpack_require__("2Y6a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_329507a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PIt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PLYV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalControlAparati_vue__ = __webpack_require__("rMiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b81cd8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalControlAparati_vue__ = __webpack_require__("Ur5X");
function injectStyle (ssrContext) {
  __webpack_require__("CI71")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalControlAparati_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b81cd8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalControlAparati_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PRyy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PSgA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pn5t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('fieldset',[(_vm.izbor === 'datr')?_c('div',[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datumrodjenja),expression:"datumrodjenja"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"udrp-input-icon-left","title":" ","name":"udrp-input-icon-left","required":""},domProps:{"value":(_vm.datumrodjenja)},on:{"input":function($event){if($event.target.composing){ return; }_vm.datumrodjenja=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"udrp-input-icon-left"}},[_vm._v(_vm._s("DDMMGGGG"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])]):_vm._e(),_vm._v(" "),(_vm.izbor === 'god')?_c('div',[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.godiste),expression:"godiste"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"godp-input-icon-left","title":" ","name":"godp-input-icon-left","required":""},domProps:{"value":(_vm.godiste)},on:{"input":function($event){if($event.target.composing){ return; }_vm.godiste=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"godp-input-icon-left"}},[_vm._v(_vm._s("GGGG"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patient.ime),expression:"patient.ime"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"ime-input-icon-left","title":" ","name":"ime-input-icon-left","required":""},domProps:{"value":(_vm.patient.ime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.patient, "ime", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"ime-input-icon-left"}},[_vm._v(_vm._s("IME"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patient.prezime),expression:"patient.prezime"}],staticStyle:{"color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"prp-input-icon-left","title":" ","name":"prp-input-icon-left","required":""},domProps:{"value":(_vm.patient.prezime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.patient, "prezime", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"},attrs:{"for":"prp-input-icon-left"}},[_vm._v(_vm._s("PREZIME"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('vuestic-simple-select',{ref:"spolSelect",attrs:{"color":'red',"label":'SPOL',"name":"spol","required":true,"title":" ","options":_vm.spolovi},model:{value:(_vm.patient.spol),callback:function ($$v) {_vm.$set(_vm.patient, "spol", $$v)},expression:"patient.spol"}}),_vm._v(" "),_c('vuestic-simple-select',{ref:"purposeSelect",attrs:{"color":'red',"label":'SVRHA TESTIRANJA',"name":"purpose","required":true,"title":" ","options":_vm.purposes},model:{value:(_vm.patient.purpose),callback:function ($$v) {_vm.$set(_vm.patient, "purpose", $$v)},expression:"patient.purpose"}}),_vm._v(" "),_c('vuestic-simple-select',{ref:"izdavanjeSelect",attrs:{"color":'red',"label":'NALAZ IZDATI',"name":"izdavanje","required":false,"title":" ","options":_vm.izdavanja},model:{value:(_vm.patient.izdavanje),callback:function ($$v) {_vm.$set(_vm.patient, "izdavanje", $$v)},expression:"patient.izdavanje"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patient.passport),expression:"patient.passport"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"id-input-icon-left","title":" ","name":"id-input-icon-left","required":""},domProps:{"value":(_vm.patient.passport)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.patient, "passport", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"id-input-icon-left"}},[_vm._v(_vm._s("IDENTIFIKACIJSKI DOKUMENT"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patient.adresa),expression:"patient.adresa"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"imp-input-icon-left","title":" ","name":"imp-input-icon-left","required":""},domProps:{"value":(_vm.patient.adresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.patient, "adresa", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"imp-input-icon-left"}},[_vm._v(_vm._s("ADRESA STANOVANJA"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patient.telefon),expression:"patient.telefon"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"tlp-input-icon-left","title":" ","name":"tlp-input-icon-left","required":""},domProps:{"value":(_vm.patient.telefon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.patient, "telefon", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"tlp-input-icon-left"}},[_vm._v(_vm._s("KONTAKT TELEFON (3876xxxxxxx)"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patient.email),expression:"patient.email"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"emp-input-icon-left","title":" ","name":"emp-input-icon-left","required":""},domProps:{"value":(_vm.patient.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.patient, "email", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"emp-input-icon-left"}},[_vm._v(_vm._s("KONTAKT E-MAIL"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('vuestic-multi-select',{ref:"languageSelect",attrs:{"label":'JEZIK NALAZA',"name":"spol","required":true,"title":" ","options":_vm.languages},model:{value:(_vm.patient.language),callback:function ($$v) {_vm.$set(_vm.patient, "language", $$v)},expression:"patient.language"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"on-cancel":_vm.onCancel,"color":"#4ae387","is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(false)?_c('button',{on:{"click":function($event){$event.preventDefault();_vm.Test($event)}}},[_vm._v("\n                        "+_vm._s("Loading...")+"\n                      ")]):_vm._e()])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v("\n                    "+_vm._s(_vm.cancelText)+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.invalid)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":true},on:{"~click":function($event){_vm.ok($event)}}},[_vm._v("\n                    "+_vm._s(_vm.okText)+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons && !_vm.invalid)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":(_vm.pacijentbezsimptoma == false &&
                        _vm.patient.symptoms.povišenatjelesnatemperatura == false &&
                        _vm.patient.symptoms.suhikašalj == false &&
                        _vm.patient.symptoms.umor == false &&
                        _vm.patient.symptoms.bolovi == false &&
                        _vm.patient.symptoms.grlobolja == false &&
                        _vm.patient.symptoms.proljev == false &&
                        _vm.patient.symptoms.konjunktivitis == false &&
                        _vm.patient.symptoms.glavobolja == false &&
                        _vm.patient.symptoms.gubitakosjetaokusailimirisa == false &&
                        _vm.patient.symptoms
                          .osipilipromjenabojeprstijunarukamailinogama ==
                          false &&
                        _vm.patient.symptoms.otežanodisanjeiligubitakdaha ==
                          false &&
                        _vm.patient.symptoms.bolilipritisakuprsima == false &&
                        _vm.patient.symptoms.gubitaksposobnostigovorailikretanja ==
                          false) ||
                      (!Number.isInteger(_vm.dateofb) &&
                        _vm.dateofb.length != 8 &&
                        _vm.izbor === 'datr') ||
                      (!Number.isInteger(_vm.godiste) &&
                        _vm.godiste.length != 4 &&
                        _vm.izbor === 'god') ||
                      (_vm.patient.ime != undefined && _vm.patient.ime.trim() == '') ||
                      (_vm.patient.prezime != undefined &&
                        _vm.patient.prezime.trim() == '') ||
                      (_vm.patient.spol != undefined &&
                        _vm.patient.spol.trim() == '') ||
                      (_vm.patient.purpose != undefined &&
                        _vm.patient.purpose.trim() == '') ||
                      (_vm.patient.izdavanje != undefined &&
                        _vm.patient.izdavanje.trim() == '')},on:{"click":_vm.ok}},[_vm._v("\n                    "+_vm._s(_vm.okText)+"\n                  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PpPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__ = __webpack_require__("JC9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a2b8c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__ = __webpack_require__("1N8W");
function injectStyle (ssrContext) {
  __webpack_require__("yfOW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06a2b8c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a2b8c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q+RX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("ixkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eab9465_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("Eioc");
function injectStyle (ssrContext) {
  __webpack_require__("RQYk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5eab9465"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eab9465_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q0RY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "anaassay-delete",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("AnaAssayHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("AnaAssayHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("AnaAssayDelete");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "Q4Rp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__ = __webpack_require__("gvyn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35cd2788_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__ = __webpack_require__("LkEG");
function injectStyle (ssrContext) {
  __webpack_require__("4d+n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35cd2788_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q8YL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-sm dropdown-toggle",attrs:{"id":"itemsPerPageBtn","type":"button","data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+" per page\n    "),_c('i',{staticClass:"ion-ios-arrow-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value)+" per page")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QI9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("oK+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a68450e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("wChe");
function injectStyle (ssrContext) {
  __webpack_require__("0us4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a68450e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QJEt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-table",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      window: {
        width: 0,
        height: 0
      },
      timeRange: {
        timeOd: "",
        timeDo: ""
      },
      configOd: {
        minDate: new Date("2019-09-01"),
        maxDate: new Date(),
        enableTime: true,
        minuteIncrement: 1,
        time_24hr: true,
        inline: false,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      },
      configDo: {
        minDate: new Date("2019-09-01"),
        maxDate: new Date().fp_incr(1),
        enableTime: true,
        minuteIncrement: 1,
        time_24hr: true,
        inline: false,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      },
      configBasics: {
        minDate: new Date("2019-09-01"),
        maxDate: new Date().fp_incr(1),
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      },
      dateBasics: "",
      mobile: false,

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("TableSelected", function () {});
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("TableDateData", function (data) {
      _this.timeRange.timeOd = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.from.slice(0, 10) + " " + data.from.slice(11, 16));
      _this.timeRange.timeDo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.to.slice(0, 10) + " " + data.to.slice(11, 16));
    });
  },
  created: function created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("TableSelected");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("TableDateData");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("Switch");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    },
    dateBasics: function dateBasics() {
      if (this.mobile) {
        var from = this.dateBasics + "T00:00:00.000Z";
        var to = this.dateBasics + "T23:59:59.000Z";
        var data = {
          data: "Date range changed.",
          from: from,
          to: to
        };
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("TableDateRange", data);
      }
    }
  },
  methods: {
    timeOdClosed: function timeOdClosed(event) {
      if (this.timeRange.timeOd != "" && this.timeRange.timeDo != "" && new Date(this.timeRange.timeOd) < new Date(this.timeRange.timeDo)) {
        var from = this.timeRange.timeOd.replace(" ", "T").concat(":00.000Z");
        var to = this.timeRange.timeDo.replace(" ", "T").concat(":00.000Z");
        var data = {
          data: "Date range changed.",
          from: from,
          to: to
        };

        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("TableDateRange", data);
      } else {
        this.toastText = "Invalid date range.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-left";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      }
    },
    timeDoClosed: function timeDoClosed(event) {
      if (this.timeRange.timeOd != "" && this.timeRange.timeDo != "" && new Date(this.timeRange.timeOd) < new Date(this.timeRange.timeDo)) {
        var from = this.timeRange.timeOd.replace(" ", "T").concat(":00.000Z");
        var to = this.timeRange.timeDo.replace(" ", "T").concat(":00.000Z");
        var data = {
          data: "Date range changed.",
          from: from,
          to: to
        };
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("TableDateRange", data);
      } else {
        this.toastText = "Invalid date range.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-left";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      }
    },
    Test: function Test(event) {
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("TableDateRange", "Date range changed.");
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 800) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("TableModalClosed");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.dateBasics = this.timeRange.timeOd.slice(1, 11);
      this.mobile = false;

      if (this.window.width < 800) {
        this.mobile = true;
      }

      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "QJYV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner"},[_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-circle",style:(_vm.circleStyle)},[_vm._v("\n      ●\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QToP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RBqZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlDeleteModal_vue__ = __webpack_require__("dIkL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da94a0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlDeleteModal_vue__ = __webpack_require__("IEFh");
function injectStyle (ssrContext) {
  __webpack_require__("WOE5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5da94a0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlDeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da94a0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlDeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RDsl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"widget-header",staticStyle:{"position":"relative"}},[(_vm.spol === 'MUŠKI')?_c('div',{staticStyle:{"color":"#4ab2e3"}},[_c('i',{staticClass:"fa fa-mars"}),_vm._v(" \n    ")]):_vm._e(),_vm._v(" "),(_vm.spol === 'ŽENSKI')?_c('div',{staticStyle:{"color":"#db76df"}},[_c('i',{staticClass:"fa fa-venus"}),_vm._v(" \n    ")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.headerText))]),_vm._v(" "),_c('div',{staticStyle:{"width":"35%"}},[(_vm.datum != '')?_c('span',{class:{'green': _vm.datum.trim() === _vm.today.trim(), 'red': _vm.datum.trim() != _vm.today.trim()},attrs:{"id":_vm.datum}},[_vm._v("\n       "+_vm._s(' | ')+_vm._s(_vm.datum)+"\n      "),(false)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.pagination && _vm.main && _vm.window.width > 800)?_c('div',{staticClass:"col-md-2 pull-right",staticStyle:{"position":"absolute","right":"20px"}},[(false)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[(_vm.rezultati_length > 1 && _vm.data_pid > _vm.data_min)?_c('i',{staticClass:"fa fa-backward pull-left",on:{"click":function($event){$event.preventDefault();_vm.Prethodni()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_pid === _vm.data_min)?_c('i',{staticClass:"fa fa-step-backward pull-left stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()]),_vm._v(" "),(_vm.rezultati_length > 1)?_c('div',{class:{'center green': _vm.datum.trim() === _vm.today.trim(), 'center red': _vm.datum.trim() != _vm.today.trim()},staticStyle:{"font-size":"22px"},on:{"click":function($event){$event.preventDefault();_vm.Find()}}},[_c('sup',[_vm._v(_vm._s(_vm.data_pid)+"/"+_vm._s(_vm.data_length))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.rezultati_length > 1 && _vm.data_length > _vm.data_pid)?_c('i',{staticClass:"fa fa-forward pull-right",on:{"click":function($event){$event.preventDefault();_vm.Sljedeci()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_length == _vm.data_pid && _vm.data_pid > 0)?_c('i',{staticClass:"fa fa-step-forward pull-right stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pagination && _vm.main && _vm.window.width <= 800)?_c('div',{staticClass:"widget-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[(_vm.rezultati_length > 1 && _vm.data_pid > _vm.data_min)?_c('i',{staticClass:"fa fa-backward pull-left",on:{"click":function($event){$event.preventDefault();_vm.Prethodni()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_pid === _vm.data_min)?_c('i',{staticClass:"fa fa-step-backward pull-left stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()]),_vm._v(" "),(_vm.rezultati_length > 1)?_c('div',{class:{'center green': _vm.datum.trim() === _vm.today.trim(), 'center red': _vm.datum.trim() != _vm.today.trim()},staticStyle:{"font-size":"22px"},on:{"click":function($event){$event.preventDefault();_vm.Find()}}},[_c('sup',[_vm._v(_vm._s(_vm.data_pid)+"/"+_vm._s(_vm.data_length))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.rezultati_length > 1 && _vm.data_length > _vm.data_pid)?_c('i',{staticClass:"fa fa-forward pull-right",on:{"click":function($event){$event.preventDefault();_vm.Sljedeci()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_length == _vm.data_pid && _vm.data_pid > 0)?_c('i',{staticClass:"fa fa-step-forward pull-right stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RLg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__ = __webpack_require__("VLQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b6c102ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__ = __webpack_require__("QJYV");
function injectStyle (ssrContext) {
  __webpack_require__("ko1K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6c102ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b6c102ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ROOH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-accordion-obrada",
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "RQYk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RUzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.komentar),expression:"komentar"}],attrs:{"type":"text","required":""},domProps:{"value":(_vm.komentar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.komentar=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s("Komentar"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RcJ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "narucioci",
  path: "/narucioci",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("narucioci/narucioci"),
  meta: {
    default: false,
    title: "Group email",
    class: "primary",
    show: false,
    iconClass: "glyphicon glyphicon-envelope",
    requiredAuth: true
  }
});

/***/ }),

/***/ "Rdfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__ = __webpack_require__("gVv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");


var _name$components$prop;





/* harmony default export */ __webpack_exports__["a"] = (_name$components$prop = {
  name: "json-edit-labassay",
  components: {
    vueJsonEditor: __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__["a" /* default */]
  },
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      jsonData: {},
      labassay: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$on("JsonEditOpen", function (data) {
      _this.jsonData = data;
      _this.obj = data;
      _this.show = true;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$off("JsonEditOpen");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "methods", {
  onJsonChange: function onJsonChange(value) {
    this.labassay = value;
  },
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    this.LabAssayEdit();
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  LabAssayEdit: function LabAssayEdit() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("assays/lab/edit", {
      labassay: this.labassay,
      token: this.$store.state.token,
      site: this.$store.state.site
    }).then(function (res) {
      if (res.data.success) {
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("LabAssayRefresh");
        _this2.show = false;
      } else {}
    });
  }
}), _name$components$prop);

/***/ }),

/***/ "Rn6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__ = __webpack_require__("2c2N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__ = __webpack_require__("2653");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-category',
  components: { SquareWithIcon: __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__["default"], VuesticCheckbox: __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__["default"] },
  data: function data() {
    return {
      isOpenCached: false
    };
  },

  watch: {
    isOpen: {
      handler: function handler(isOpen) {
        this.isOpenCached = isOpen;
      },

      immediate: true
    }
  },
  props: {
    label: {
      type: [String, Number],
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxIconClass: function checkboxIconClass() {
      return this.isOpenCached ? 'ion ion-md-remove' : 'ion ion-md-add';
    }
  },
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.isOpenCached = false;
      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.isOpenCached = true;
      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "RoBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],attrs:{"type":"text","id":"simple-textarea","required":""},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"simple-textarea"}},[_vm._v(_vm._s('Unesite komentar'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RptW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S0HY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadSingleItem_vue__ = __webpack_require__("kD2f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9edfb98e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadSingleItem_vue__ = __webpack_require__("OoXj");
function injectStyle (ssrContext) {
  __webpack_require__("56vn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadSingleItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9edfb98e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadSingleItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "S34v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "kalibracija-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    labassay: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("KalibracijaHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("KalibracijaHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("Kalibracija");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "S483":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-all-results",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "S5Qx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHli":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SIDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"jsoneditor-vue"}),_vm._v(" "),(_vm.showBtns!==false)?_c('div',{staticClass:"jsoneditor-btns"},[_c('button',{staticClass:"json-save-btn",attrs:{"type":"button","disabled":_vm.error},on:{"click":function($event){_vm.onSave()}}},[_vm._v(_vm._s(_vm.locale[_vm.lang].save))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SRTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var dropdownToggle = el.querySelector(".dropdown-toggle");
    var dropdownToggleInput = el.querySelector(".dropdown-toggle input");
    var dropdownMenu = el.querySelector(".dropdown-menu");
    var dropdownItem = el.querySelector(".dropdown-menu-content");
    var dropdownIon = el.querySelector(".ion");
    var closeOnMenuClick = binding.modifiers.closeOnMenuClick;
    var isBlocked = binding.modifiers.isBlocked;
    if (dropdownToggle) {
      dropdownToggle.addEventListener("click", function (event) {
        event.preventDefault();
        var isShown = el.classList.contains("show");
        setTimeout(function () {
          if (isBlocked) {
            if (!isShown) {
              dropdownIon.classList.add("ion-ios-arrow-up");
              el.classList.toggle("show", !isShown);
              dropdownMenu.classList.toggle("show", !isShown);
            }
          } else {
            el.classList.toggle("show", !isShown);
            dropdownMenu.classList.toggle("show", !isShown);
          }
        });
      });
    }

    el.removeShow = function (event) {
      if (event.target !== dropdownToggleInput) {
        if (dropdownIon) {
          if (dropdownIon.classList.contains("ion-ios-arrow-up")) {
            dropdownIon.classList.remove("ion-ios-arrow-up");
          }
        }
        el.classList.remove("show");
        dropdownMenu.classList.remove("show");
      }
    };

    window.addEventListener("click", el.removeShow);
    if (dropdownMenu) {
      dropdownMenu.addEventListener("click", function (evt) {
        if (!closeOnMenuClick) {
          evt.stopPropagation();
        }
      });
    }

    if (dropdownItem) {
      dropdownItem.addEventListener("click", function () {
        if (dropdownIon) {
          if (dropdownIon.classList.contains("ion-ios-arrow-up")) {
            dropdownIon.classList.remove("ion-ios-arrow-up");
          }
        }
        dropdownMenu.classList.remove("show");
        el.classList.remove("show");
      });
    }
  },
  unbind: function unbind(el) {
    window.removeEventListener("click", el.removeShow);
  }
});

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Scc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },

  name: "vuestic-widget-control",

  props: {
    headerText: {
      type: String,
      default: ""
    },
    lotText: {
      type: String,
      default: ""
    },
    multi: {
      type: String,
      default: ""
    },
    datum: {
      type: String,
      default: ""
    },
    today: {
      type: String,
      default: ""
    }
  },
  created: function created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
});

/***/ }),

/***/ "Sdwi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sg7X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "So8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden)?_c('div',{staticClass:"vuestic-alert alert",class:_vm.alertClass},[_vm._t("default"),_vm._v(" "),(_vm.withCloseBtn)?_c('i',{staticClass:"fa fa-close alert-close",on:{"click":function($event){_vm.hide()}}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SsKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("yMvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49ee4731_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("Fv2p");
function injectStyle (ssrContext) {
  __webpack_require__("rxEm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49ee4731"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49ee4731_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "T1D7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"looping-rhombuses-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{staticClass:"rhombus",style:(rs),attrs:{"ikey":index}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T31c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-medium-editor"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("+s3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27f4b160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("sH8p");
function injectStyle (ssrContext) {
  __webpack_require__("YPZh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27f4b160"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27f4b160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "T7xy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TIR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s('ZATVORI'))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQVY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('novi-produkt',{on:{"new-produkt":_vm.unosProdukta}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.brStr,"datum":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:cell-clicked":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.prikaziDetalje([args]);
},"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1),_vm._v(" "),_c('vuestic-modal-produkt',{ref:"largeModalProdukt",attrs:{"show":_vm.show,"medium":true,"okText":_vm.potvrdi,"cancelText":_vm.odustani},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s('Unos produkta'))]),_vm._v(" "),_c('div',{staticClass:"form-elements"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"})])])]),_vm._v(" "),_c('patient-edit',{ref:"modalProduktEdit",attrs:{"show":_vm.show,"medium":true,"okText":_vm.potvrdi,"cancelText":_vm.odustani,"patient":_vm.patient_data},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s('Pacijent: ')+"\n      "),_c('span',{staticStyle:{"color":"#4ae387"}},[_vm._v(_vm._s(_vm.patient_data.ime)+" "+_vm._s(_vm.patient_data.prezime))])]),_vm._v(" "),_c('div',{staticClass:"form-elements"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TS+I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapsePatientInfo_vue__ = __webpack_require__("p3Qa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fbdb906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapsePatientInfo_vue__ = __webpack_require__("9V83");
function injectStyle (ssrContext) {
  __webpack_require__("dwJF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapsePatientInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fbdb906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapsePatientInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TTyb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tea9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlReferences_vue__ = __webpack_require__("c3nr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eee8c142_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlReferences_vue__ = __webpack_require__("HcFy");
function injectStyle (ssrContext) {
  __webpack_require__("Bg4O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eee8c142"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlReferences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eee8c142_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlReferences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ThK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__ = __webpack_require__("mC5g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c7ff2ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiPicker_vue__ = __webpack_require__("LTu2");
function injectStyle (ssrContext) {
  __webpack_require__("YIv3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c7ff2ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c7ff2ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Tk3j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextMessage = __webpack_require__("K/BQ");

var _TextMessage2 = _interopRequireDefault(_TextMessage);

var _FileMessage = __webpack_require__("pAjY");

var _FileMessage2 = _interopRequireDefault(_FileMessage);

var _EmojiMessage = __webpack_require__("xemH");

var _EmojiMessage2 = _interopRequireDefault(_EmojiMessage);

var _TypingMessage = __webpack_require__("oSDv");

var _TypingMessage2 = _interopRequireDefault(_TypingMessage);

var _SystemMessage = __webpack_require__("LYnd");

var _SystemMessage2 = _interopRequireDefault(_SystemMessage);

var _chatIcon = __webpack_require__("d1QR");

var _chatIcon2 = _interopRequireDefault(_chatIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    TextMessage: _TextMessage2.default,
    FileMessage: _FileMessage2.default,
    EmojiMessage: _EmojiMessage2.default,
    TypingMessage: _TypingMessage2.default,
    SystemMessage: _SystemMessage2.default
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    chatImageUrl: {
      type: String,
      default: _chatIcon2.default
    },
    colors: {
      type: Object,
      required: true
    },
    authorName: {
      type: String
    }
  },
  methods: {
    sentColorsStyle: function sentColorsStyle() {
      return {
        color: this.colors.sentMessage.text,
        backgroundColor: this.colors.sentMessage.bg
      };
    },
    receivedColorsStyle: function receivedColorsStyle() {
      return {
        color: this.colors.receivedMessage.text,
        backgroundColor: this.colors.receivedMessage.bg
      };
    },
    determineMessageColors: function determineMessageColors() {
      return this.message.author === 'me' ? this.sentColorsStyle() : this.receivedColorsStyle();
    }
  }
};

/***/ }),

/***/ "Tp06":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TqEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),

/***/ "TsB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDelete_vue__ = __webpack_require__("DrVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4555b857_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDelete_vue__ = __webpack_require__("t3JD");
function injectStyle (ssrContext) {
  __webpack_require__("hb8G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4555b857_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Tub+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "patient-evaluation-single",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      table: true,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    ShowGraph: function ShowGraph() {
      this.table = true;
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("graph");
    },
    ShowTable: function ShowTable() {
      this.table = false;
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("table");
    },
    cancel: function cancel() {
      var _this = this;

      this.$emit("cancel");
      this.show = false;

      setTimeout(function () {
        _this.table = true;
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("graph");
      }, 500);

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      this.table = true;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "U/uR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UBYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-dropdown dropdown navbar-dropdown"},[(_vm.allSitesID.length  > 1)?_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}]},[_c('a',{staticClass:"language-dropdown-button dropdown-toggle",attrs:{"href":"#"}},[_c('span',{ref:"close",staticClass:"flag-icon flag-icon-large",class:_vm.sitePickClass(_vm.currentSite())},[_vm._v(_vm._s(_vm.izbor === '' ? _vm.initSiteName : _vm.izborPrikaz))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_vm._l((_vm.options),function(option,id){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.izbor === ''),expression:"izbor === ''"}],key:id,staticClass:"dropdown-item",class:{ 'active': option.sifra === _vm.initSite[0].sifra },on:{"click":function($event){_vm.setSite(option.sifra)}}},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v(_vm._s(option.name))])])}),_vm._v(" "),_vm._l((_vm.options),function(option,id){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.izbor != ''),expression:"izbor != ''"}],key:id,staticClass:"dropdown-item",class:{ 'active': option.id === _vm.izabraniSiteId },on:{"click":function($event){_vm.setSite(option.sifra)}}},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v(_vm._s(option.name))])])})],2)]):_vm._e(),_vm._v(" "),(_vm.allSitesID.length < 2)?_c('div',[_c('a',{staticClass:"language-dropdown-button dropdown-toggle",attrs:{"href":"#"}},[_c('span',{ref:"close",staticClass:"flag-icon flag-icon-large",class:_vm.sitePickClass(_vm.currentSite())},[_vm._v(_vm._s(_vm.initSiteName))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_vm._l((_vm.options),function(option,id){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.izbor === ''),expression:"izbor === ''"}],key:id,staticClass:"dropdown-item",class:{ 'active': option.sifra === _vm.initSite[0].sifra }},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v(_vm._s(option.name))])])}),_vm._v(" "),_vm._l((_vm.options),function(option,id){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.izbor != ''),expression:"izbor != ''"}],key:id,staticClass:"dropdown-item",class:{ 'active': option.sifra === _vm.currentSite() }},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v(_vm._s(option.name))])])})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UFbH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UK0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadUndo_vue__ = __webpack_require__("sBaB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1984a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadUndo_vue__ = __webpack_require__("zHPK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadUndo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1984a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadUndo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UW5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__ = __webpack_require__("H65f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_024eedb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__ = __webpack_require__("F78L");
function injectStyle (ssrContext) {
  __webpack_require__("7ksE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-024eedb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_024eedb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "UWEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticTag_vue__ = __webpack_require__("aTa4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-tag-group",
  props: {
    removable: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    type: {
      type: String,
      default: ""
    },
    uzorak: {
      type: String,
      default: ""
    },
    bundle: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VuesticTag: __WEBPACK_IMPORTED_MODULE_0__VuesticTag_vue__["default"]
  },
  methods: {
    removeTag: function removeTag(tagIndex, item, uzorak) {
      if (typeof item === "string") {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ControlTestRemove", item, uzorak);

        if (this.value.length < 2) {
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ControlEntryRemove", uzorak);
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("removeTest", item, uzorak);
      }

      this.$emit("input", this.value.filter(function (item, i) {
        return i !== tagIndex;
      }));
    }
  }
});

/***/ }),

/***/ "Uf0Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UfMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDatePicker_vue__ = __webpack_require__("hF3+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7307f69e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDatePicker_vue__ = __webpack_require__("elJ3");
function injectStyle (ssrContext) {
  __webpack_require__("hbbw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7307f69e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuItems", function() { return menuItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleWithoutAnimation", function() { return toggleWithoutAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebarOpened", function() { return sidebarOpened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "palette", function() { return palette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAuthenticated", function() { return isAuthenticated; });
var menuItems = function menuItems(state) {
  return state.menu.items;
};
var sidebarOpened = function sidebarOpened(state) {
  return state.app.sidebar.opened;
};
var toggleWithoutAnimation = function toggleWithoutAnimation(state) {
  return state.app.sidebar.withoutAnimation;
};
var config = function config(state) {
  return state.app.config;
};
var palette = function palette(state) {
  return state.app.config.palette;
};
var isLoading = function isLoading(state) {
  return state.app.isLoading;
};

var user = function user(state) {
  return state.user;
};
var isAuthenticated = function isAuthenticated(state) {
  return state.token !== null;
};



/***/ }),

/***/ "Um6W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Up4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{ 'no-header': !_vm.headerText }},[(_vm.headerText)?_c('div',{staticClass:"widget-header",staticStyle:{"position":"relative"}},[(_vm.multi === 'Multi')?_c('div',{staticStyle:{"color":"#4ab2e3"}}):_vm._e(),_vm._v(" "),(_vm.multi === 'Single')?_c('div',{staticStyle:{"color":"#db76df"}}):_vm._e(),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"#adb3b9"}},[_vm._v(_vm._s("Naziv kontrole: "))]),_vm._v(_vm._s(_vm.headerText))]),_vm._v(" "),_c('div',{staticStyle:{"width":"35%"}},[(_vm.datum != '')?_c('span',{class:{
          green: _vm.datum.trim() === _vm.today.trim(),
          red: _vm.datum.trim() != _vm.today.trim(),
        },attrs:{"id":_vm.datum}},[_vm._v("\n         "+_vm._s(" | ")+_vm._s(_vm.datum)+"\n       \n      ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.lotText)?_c('div',{staticClass:"widget-header",staticStyle:{"position":"relative"}},[_c('div',[_c('span',{staticStyle:{"color":"#adb3b9"}},[_vm._v(_vm._s("LOT: "))]),_vm._v(_vm._s(_vm.lotText))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UpdR":
/***/ (function(module, exports) {

module.exports = {"auth":{"agree":"I agree to","alreadyJoined":"Already joined?","createAccount":"Create account","createNewAccount":"Create account","email":"Email","login":"Login","password":"Password","signUp":"Sign Up","termsOfUse":"Terms of Use.","welcome":"Welcome!"},"breadcrumbs":{"home":"Home"},"buttons":{"advanced":"Icons, Groups, Dropdowns","button":"BUTTON","colors":"Colors","disabled":"DISABLED","dropdown":"DROPDOWN","hover":"HOVER","main":"Primary & Secondary Buttons","micro":"MICRO","pressed":"PRESSED","small":"SMALL"},"charts":{"horizontalBarChart":"Horizontal Bar Chart","verticalBarChart":"Vertical Bar Chart","lineChart":"Line Chart","pieChart":"Pie Chart","donutChart":"Donut Chart","bubbleChart":"Bubble Chart"},"dashboard":{"dataVisualization":"Data Visualization","success":"SUCCESS","successMessage":"You successfully read this important alert message.","elements":"Elements","features":"Features","setupProfile":"Setup Profile","teamMembers":"Team Members","usersAndMembers":"Users & Members","versions":"Versions"},"fileUpload":{"advancedMediaGallery":"Advanced, Media Gallery","advancedUploadList":"Advanced, Upload List","mediaGallery":"Media Gallery","uploadList":"Upload List","single":"Single","dragNdropFiles":"Drag’n’drop files or","uploadedOn":"Uploaded on","fileDeleted":"File was successfully deleted","undo":"Undo","preview":"Preview","delete":"Delete","deleteFile":"Delete file","uploadFile":"Upload file","uploadMedia":"Upload media","addAttachment":"Add attachment","modalTitle":"File validation","modalText":"File type is incorrect!"},"notificationsPage":{"alerts":{"title":"Alerts","success":"SUCCESS","successMessage":"You successfully read this important alert message.","info":"INFO","infoMessage":"This alert needs your attention, but it's not super important.","warning":"WARNING","warningMessage":"Better check yourself, you're not looking too good.","danger":"DANGER","dangerMessage":"Change a few things up and try submitting again."}},"extra":{"tabs":{"title":"Tabs","maps":"Maps","overview":"Overview","setupProfile":"Setup Profile"},"chat":"Chat","profileCard":"Profile Card"},"forms":{"controls":{"female":"Female","male":"Male","title":"Checkboxes, Radios, Switches","radioDisabled":"Disabled Radio","radio":"Radio","subscribe":"Subscribe to newsletter"},"inputs":{"emailValidatedSuccess":"Email (validated with success)","emailValidated":"Email (validated)","inputWithIcon":"Input With Icon","inputWithButton":"Input With Button","inputWithClearButton":"Input With Clear Button","inputWithRoundButton":"Input With Round Button","textInput":"Text Input","textInputWithDescription":"Text Input (with description)","textArea":"Text Area","title":"Inputs","upload":"UPLOAD"},"mediumEditor":{"title":"Medium Editor"},"selects":{"country":"Country Select","countryMulti":"Country Multi Select","multi":"Multi Select","simple":"Simple Select","title":"Selects"},"wizard":{"name":"Name","completed":"Wizard completed!","confirmSelection":"Confirm selection","rich":"Rich Wizard","simple":"Simple Wizard","stepOne":"Step 1. Name","stepTwo":"Step 2. Country","stepThree":"Step 3. Confirm","verticalRich":"Vertical Rich Wizard","verticalSimple":"Vertical Simple Wizard"}},"grid":{"desktop":"Desktop Grid","fixed":"Fixed Grid","offsets":"Offsets","responsive":"Responsive Grid"},"icons":{"back":"Back to icons","none":"No icons found","search":"Icon search","title":"Icons"},"spinners":{"title":"Spinners","poweredBy":"Powered by"},"language":{"english":"English","spanish":"Spanish"},"menu":{"auth":"Auth","buttons":"Buttons","charts":"Charts","dashboard":"Dashboard","extra":"Extra","formElements":"Form Elements","forms":"Forms","formWizards":"Form Wizards","mediumEditor":"Medium Editor","grid":"Grid","icons":"Icons","spinners":"Spinners","login":"Login","maps":"Maps","modals":"Modals","notifications":"Notifications","progressBars":"Progress Bars","signUp":"Sign up","statistics":"Statistics","tables":"Tables","typography":"Typography","uiElements":"UI Elements"},"messages":{"all":"See all messages","new":"New messages from {name}"},"modal":{"cancel":"CANCEL","close":"CLOSE","confirm":"CONFIRM","large":"Large","largeTitle":"Large Modal","medium":"Medium","mediumTitle":"Medium Modal","small":"Small","smallTitle":"Small Modal","static":"Static","staticMessage":"This is a static modal, backdrop click will not close it.","staticTitle":"Static Modal","title":"Modals"},"notifications":{"all":"See all notifications","sentMessage":"{name} sent you a message","uploadedZip":"{name} uploaded a new Zip file with {type}","startedTopic":"{name} started a new topic"},"progressBars":{"basic":"Basic","basicVertical":"Basic Vertical","circle":"Circle","colorFulTitle":"Colorful Bars","thin":"Thin","thinVertical":"Thin Vertical","thick":"Thick","title":"Progress Bars"},"tables":{"basic":"Basic Table","styled":"Colors, Icons, Labels","advanced":"Search & Pagination","headings":{"city":"City","email":"Email","name":"Name","score":"Score"}},"user":{"language":"Change Language","logout":"Logout","profile":"My Profile"}}

/***/ }),

/***/ "Ur5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V/fp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("9lA7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b7007a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("A05I");
function injectStyle (ssrContext) {
  __webpack_require__("oE55")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7b7007a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b7007a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "V85T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V9Re":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VAWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__ = __webpack_require__("e8Tw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a7e6cf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__ = __webpack_require__("xO5a");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a7e6cf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VLQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: 'red'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "VQ5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{
      'vuestic-collapse__header--no-header': _vm.noHeader,
    },on:{"click":function($event){_vm.onHeaderClick()}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-primary' : _vm.level === 10, 
      'vuestic-collapse__header__button btn btn-warning': _vm.level === 2,
      'vuestic-collapse__header__button btn btn-danger': _vm.level === 0,
      'vuestic-collapse__header__button btn btn-info': _vm.level === 1}},[_vm._t("header")],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VV2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pid),expression:"pid"}],staticStyle:{"font-size":"18px","color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.pid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pid=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Redni broj pacijenta'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":isNaN(_vm.pid) || _vm.pid == '' || _vm.pid > _vm.data_length},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VVeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_expanding_src_Expanding__ = __webpack_require__("OPFe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sidebar",

  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_expanding_src_Expanding__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    expand: "toggleExpandMenuItem"
  }), {
    toggleMenuItem: function toggleMenuItem(item) {
      if (item.children) {
        this.expand({
          menuItem: item,
          expand: !item.meta.expanded
        });
      }
    },
    setDropdownDefaultIzbor: function setDropdownDefaultIzbor() {
      var current = this.$router.currentRoute.path;
      if (current.includes("obrada/pregled")) {
        this.$store.dispatch("dropdownChange", "RADNA LISTA");
        this.$store.dispatch("filterChange", "");
        this.$store.dispatch("FilterBarChange", "");
      } else {
        this.$store.dispatch("dropdownChange", "DANAS");
        this.$store.dispatch("filterChange", "");
        this.$store.dispatch("FilterBarChange", "");
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    menuItems: "menuItems"
  }), {

    sidebarItems: function sidebarItems() {
      if (this.$store.state.access === undefined) {
        return false;
      } else {
        return this.menuItems.filter(function (i) {
          return i.meta.show;
        });
      }
    }
  }),
  beforeCreate: function beforeCreate() {
    var _this = this;

    var link = this.$store.state.userId;
    var token = this.$store.state.token;

    if (token != null) {
      if (!this.$store.state.userId.includes("@")) {
        link = link + "@";
      }
      var index = link.indexOf("@");
      link = link.substring(0, index);

      __WEBPACK_IMPORTED_MODULE_3__config_config_js__["C" /* http */].post("users/" + link, {
        email: this.$store.state.userId,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        _this.userImage = res.data.data.link;
        _this.isRole = res.data.data.role;
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].i18n.set(res.data.user.postavke.language);
      });
    }
  },
  watch: {
    $route: function $route(route) {
      var _this2 = this;

      var parent = _findMatchingParentMenuItem.call(this, route.name) || {};
      this.menuItems.forEach(function (item) {
        _this2.expand({
          menuItem: item,
          expand: parent.name === item.name
        });
      });
    }
  },
  data: function data() {
    return {
      show: false,
      isRole: ""
    };
  }
});

function _findMatchingParentMenuItem(itemName) {
  var parentItem = void 0;
  this.menuItems.forEach(function (item) {
    parentItem = item.children && item.children.find(function (child) {
      return child.name === itemName;
    }) ? item : parentItem;
  });
  return parentItem;
}

/***/ }),

/***/ "Vhfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-profile-card d-flex flex-column align-items-center"},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.photoSource}})]),_vm._v(" "),_c('h5',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticClass:"location"},[_c('span',{staticClass:"icon glyphicon glyphicon-map-marker"}),_vm._v(" "+_vm._s(_vm.location))]),_vm._v(" "),_c('div',{staticClass:"social"},[(_vm.social.facebook)?_c('a',{staticClass:"icon brandico brandico-facebook-rect",attrs:{"href":'http://' + _vm.social.facebook,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.instagram)?_c('a',{staticClass:"icon brandico brandico-instagram",attrs:{"href":'http://' + _vm.social.instagram,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.twitter)?_c('a',{staticClass:"icon brandico brandico-twitter",attrs:{"href":'http://' + _vm.social.twitter,"target":"_blank"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vlq6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vo2z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    onChange: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    _handleClick: function _handleClick(e) {
      e.target.value = null;
    },
    _handleChange: function _handleChange(e) {
      this.onChange(e.target.files[0]);
    }
  }
};

/***/ }),

/***/ "W07a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W7LE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WHJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),

/***/ "WM4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-handshake",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("PartnerChanged", function () {

      _this.show = false;
    });
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("PartnerChanged");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");

      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PartnerChange");

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "WOE5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WPif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WQZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue__ = __webpack_require__("1q7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f44d09b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserInput_vue__ = __webpack_require__("BAbm");
function injectStyle (ssrContext) {
  __webpack_require__("eVzt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f44d09b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  sidebar: {
    opened: false,
    withoutAnimation: false
  },
  config: {
    googleMaps: {
      apiKey: "AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ"
    },
    windowMatchSizeLg: "(min-width: 992px)",
    palette: {
      primary: "#4ae387",
      danger: "#e34a4a",
      info: "#4ab2e3",
      success: "#db76df",
      warning: "#f7cc36",
      white: "#fff",
      black: "#000",
      fontColor: "#34495e",
      transparent: "transparent",
      lighterGray: "#ddd"
    }
  },
  isLoading: true
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */], function (state) {
  if (document.documentElement.clientWidth < 992) {
    state.sidebar.opened = false;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_SIDEBAR */], function (state, opened) {
  state.sidebar.opened = opened;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* TOGGLE_WITHOUT_ANIMATION */], function (state, value) {
  state.sidebar.withoutAnimation = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "setLoading", function setLoading(state, isLoading) {
  state.isLoading = isLoading;
}), _mutations);

var actions = {
  closeMenu: function closeMenu(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */]);
  },
  toggleSidebar: function toggleSidebar(_ref2, opened) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_SIDEBAR */], opened);
  },
  isToggleWithoutAnimation: function isToggleWithoutAnimation(_ref3, value) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* TOGGLE_WITHOUT_ANIMATION */], value);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "Wc+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "WlTu":
/***/ (function(module, exports) {

module.exports = {"auth":{"agree":"Acepto","alreadyJoined":"Ya tienes una cuenta?","createAccount":"Create cuenta","createNewAccount":"Crear cuenta","email":"Email","login":"Iniciar sesión","password":"Contraseña","signUp":"Registrar","termsOfUse":"Los terminos de uso","welcome":"Bienvenido!"},"buttons":{"advanced":"Iconos, Grupos, Dropdowns","button":"BOTON","colors":"Colores","disabled":"DESHABILITADO","dropdown":"DESPLEGABLE","hover":"HOVER","main":"Botón Primario y Secundario","micro":"MICRO","pressed":"PRESIONADO","small":"PEQUEÑO"},"charts":{"bubbleChart":"Bubble Chart","donutChart":"Donut Chart","horizontalBarChart":"Horizontal Bar Chart","lineChart":"Line Chart","pieChart":"Pie Chart","verticalBarChart":"Vertical Bar Chart"},"dashboard":{"elements":"Elementos","success":"ÉXITO","successMessage":"Ha leído correctamente este mensaje de alerta importante.","teamMembers":"Miembros del Equipo","versions":"Versiones"},"fileUpload":{"advancedMediaGallery":"Avanzado, Galería de medios","advancedUploadList":"Avanzado, lista de carga","mediaGallery":"Galería media","uploadList":"Lista de carga","single":"Soltero","dragNdropFiles":"Arrastrar y soltar archivos","uploadedOn":"Subido en","fileDeleted":"El archivo fue eliminado exitosamente","undo":"Deshacer","preview":"Avance","delete":"Borrar","deleteFile":"Borrar archivo","uploadFile":"Subir archivo","uploadMedia":"Cargar medios","addAttachment":"Añadir un adjunto","modalTitle":"Validación de archivo","modalText":"El tipo de archivo es incorrecto!"},"notificationsPage":{"alerts":{"title":"Alerts","success":"ÉXITO","successMessage":"Ha leído correctamente este mensaje de alerta importante.","info":"INFO","infoMessage":"Esta alerta necesita tu atención, pero no es muy importante.","warning":"ADVERTENCIA","warningMessage":"Mejor compruébalo, esto no pinta bien.","danger":"PELIGRO","dangerMessage":"Cambiar algunas cosas e enviarlo de nuevo."}},"extra":{"tabs":{"title":"Tabs","maps":"Mapas","overview":"Visión de conjunto","setupProfile":"Perfil de Configuración"},"chat":"Chat","profileCard":"Tarjeta de Perfil"},"forms":{"controls":{"female":"Mujer","male":"Hombre","title":"Checkboxes, Radios, Switches","radioDisabled":"Radio Desactivado","radio":"Radio","subscribe":"Suscribirse a la newsletter"},"inputs":{"emailValidatedSuccess":"Email (validado con éxito)","emailValidated":"Email (validado)","inputWithIcon":"Input con Icono","inputWithButton":"Input con Boton","inputWithClearButton":"Input With Clear Button","inputWithRoundButton":"Input With Round Button","textInput":"Input de Texto","textInputWithDescription":"Input de Texto (con descripcion)","textArea":"Text Area","title":"Inputs","upload":"SUBIR"},"mediumEditor":{"title":"Medium Editor"},"selects":{"country":"País Select","countryMulti":"País Multi Select","multi":"Multi Select","simple":"Select Simple","title":"Selects"},"wizard":{"completed":"Asistente Completado!","confirmSelection":"Confirmar selección","name":"Nombre","rich":"Asistente Rico","simple":"Asistente Simple","stepOne":"Step 1. Nombre","stepTwo":"Step 2. País","stepThree":"Step 3. Confirmar","verticalRich":"Asistente Rico Vertical","verticalSimple":"Asistente Simple Vertical"}},"grid":{"fixed":"Grid Fijo","desktop":"Desktop Grid","responsive":"Responsive Grid","offsets":"Offsets"},"icons":{"back":"Volver a los iconos","none":"No se han encontrado iconos","search":"Búsqueda de iconos","title":"Iconos"},"language":{"english":"Ingles","spanish":"Español"},"menu":{"auth":"Autenticación","buttons":"Botones","charts":"Gráficos","dashboard":"Dashboard","extra":"Extra","formElements":"Elementos de un Formulario","forms":"Formularios","formWizards":"Asistente para Formularios","mediumEditor":"Medium Editor","grid":"Grid","icons":"Iconos","login":"Iniciar sesión","maps":"Mapas","modals":"Modals","notifications":"Notificaciones","progressBars":"Barras de Progreso","signUp":"Registrar","statistics":"Estadisticas","tables":"Tablas","typography":"Tipografía","uiElements":"Elementos UI"},"messages":{"all":"Ver todos los mensajes","new":"Nuevo mensajes de {name}"},"modal":{"cancel":"CANCELAR","close":"CERRAR","confirm":"CONFIRMAR","large":"Largo","largeTitle":"Modal Largo","medium":"Mediano","mediumTitle":"Modal Mediana","small":"Pequeño","static":"Estático","smallTitle":"Modal Pequeña","staticMessage":"Esto es un modal estático. No se cerrará haciendo clic en el fondo.","staticTitle":"Modal Estático","title":"Modals"},"notifications":{"all":"Ver todos los notificaciones","sentMessage":"{name} te ha mandado un mensaje","uploadedZip":"{name} ha subido un archivo Zip con {type}","startedTopic":"{name} ha creado una tema nueva"},"progressBars":{"basic":"Basico","basicVertical":"Basico y Vertical","circle":"Circular","colorFulTitle":"Barras Coloridas","thin":"Delgado","thinVertical":"Delgado Vertical","thick":"Grueso","title":"Barras de Progresso"},"tables":{"basic":"Tabla basica","styled":"Colores, Iconos, Etiquetas","advanced":"Búsqueda y Paginación","headings":{"city":"Ciudad","email":"Email","name":"Nombre","score":"Puntuación"}},"user":{"language":"Cambiar Idioma","profile":"Mi Perfil","logout":"Cerrar Sesión"}}

/***/ }),

/***/ "WoVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tag-group"},_vm._l((_vm.value),function(item,index){return _c('vuestic-tag',{key:index,attrs:{"name":item.name || item,"type":_vm.type || item.type,"removable":_vm.removable,"bundle":item.bundle || false},on:{"remove":function($event){_vm.removeTag(index, item, _vm.uzorak)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WqZV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wvsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMedium_vue__ = __webpack_require__("1ZnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2de1dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMedium_vue__ = __webpack_require__("NEvL");
function injectStyle (ssrContext) {
  __webpack_require__("zds3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e2de1dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMedium_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2de1dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMedium_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Wzot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__ = __webpack_require__("N6Uh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ddacc2ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__ = __webpack_require__("p7Oj");
function injectStyle (ssrContext) {
  __webpack_require__("YpCA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddacc2ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ddacc2ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "X14r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X44x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEdit_vue__ = __webpack_require__("OhG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de6b22e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEdit_vue__ = __webpack_require__("NNPt");
function injectStyle (ssrContext) {
  __webpack_require__("+FAq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de6b22e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XEVv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _escapeGoat = __webpack_require__("ZSNP");

var _escapeGoat2 = _interopRequireDefault(_escapeGoat);

var _autolinker = __webpack_require__("k/Ns");

var _autolinker2 = _interopRequireDefault(_autolinker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  },
  computed: {
    messageText: function messageText() {
      return _autolinker2.default.link(_escapeGoat2.default.escape(this.data.text), {
        className: 'chatLink',
        truncate: { length: 50, location: 'smart' }
      });
    }
  }
};

/***/ }),

/***/ "XFNM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__("sIlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569238fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__("eOMX");
function injectStyle (ssrContext) {
  __webpack_require__("NSkb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569238fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XG+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "animatedValue", "min", "max", "color", "startColor", "backgroundColor", "isActive"],
  computed: {
    backgroundImage: function backgroundImage() {
      var result = {};
      if (this.animatedValue < 50) {
        var nextDeg = 90 + 3.6 * this.animatedValue + "deg";
        result = "linear-gradient(90deg, " + this.startColor + " 50%, transparent 50%, transparent), linear-gradient(" + nextDeg + ", " + this.color + " 50%, " + this.startColor + " 50%, " + this.startColor + ")";
      } else {
        var _nextDeg = -90 + 3.6 * (this.animatedValue - 50) + "deg";
        result = "linear-gradient(" + _nextDeg + ", " + this.color + " 50%, transparent 50%, transparent), linear-gradient(270deg, " + this.color + " 50%, " + this.startColor + " 50%, " + this.startColor + ")";
      }
      return result;
    }
  }
});

/***/ }),

/***/ "XS62":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xc0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoviProdukt_vue__ = __webpack_require__("FWGN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5304555b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoviProdukt_vue__ = __webpack_require__("hEwb");
function injectStyle (ssrContext) {
  __webpack_require__("kzXT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5304555b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoviProdukt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5304555b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoviProdukt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Xiwu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.select && !_vm.povratak && !_vm.noButtons && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN')?_c('button',{staticClass:"btn btn-secondary-danger btn-micro",staticStyle:{"padding":"0.6px","padding-left":"3px"},on:{"click":function($event){$event.preventDefault();_vm.Update()}}},[_c('i',{staticClass:"fa fa-bug",on:{"click":function($event){$event.preventDefault();_vm.Update()}}})]):_vm._e(),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons && !_vm.povratak)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.povratak)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.Povratak}},[_vm._v(_vm._s("POVRATAK"))]):_vm._e(),_vm._v(" "),(!_vm.povratak && !_vm.noButtons && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN')?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":false},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e(),_vm._v(" "),(_vm.povratak && !_vm.noButtons && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN')?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":!_vm.empty},on:{"click":_vm.Spasi}},[_vm._v(_vm._s("SAČUVAJ"))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xkgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-tabs-bactery",
  props: ["names", "tab", "prikazi"],
  computed: {
    underscoreClass: function underscoreClass() {
      return "underscore-" + this.names.length + "-" + this.names.indexOf(this.currentActive);
    }
  },
  created: function created() {},

  watch: {
    currentActive: function currentActive() {
      if (this.currentActive != "name") {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("tabChanged", this.currentActive);
      } else {}
    }
  },
  methods: {
    Antibiotik: function Antibiotik() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Antibiotik", this.currentActive);
    },
    setActive: function setActive(name) {
      this.currentActive = name;
    }
  },
  data: function data() {
    return {
      currentActive: this.tab
    };
  }
});

/***/ }),

/***/ "Xl7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-reference",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Reference");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "Xn7x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.table)?_c('i',{staticClass:"vuestic-icon vuestic-icon-tables",staticStyle:{"color":"#4ae387"},on:{"click":function($event){$event.preventDefault();_vm.ShowTable()}}}):_vm._e(),_vm._v(" "),(!_vm.table)?_c('i',{staticClass:"vuestic-icon vuestic-icon-graph",staticStyle:{"color":"#4ae387"},on:{"click":function($event){$event.preventDefault();_vm.ShowGraph()}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XuBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XviT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xvo4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XzQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('vue-json-editor',{attrs:{"show-btns":false},on:{"json-change":_vm.onJsonChange},model:{value:(_vm.jsonData),callback:function ($$v) {_vm.jsonData=$$v},expression:"jsonData"}})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XznE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__ = __webpack_require__("KGMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1d7e992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__ = __webpack_require__("qjhy");
function injectStyle (ssrContext) {
  __webpack_require__("2EQz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1d7e992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Y1LF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-results-multi",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "Y6gc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y97U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YCi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalUzorci_vue__ = __webpack_require__("gmk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d14359c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalUzorci_vue__ = __webpack_require__("bv4V");
function injectStyle (ssrContext) {
  __webpack_require__("rnTf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalUzorci_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d14359c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalUzorci_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YDnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload-single-item"},[_c('div',{staticClass:"file-upload-single-item-name"},[_vm._v("\n    "+_vm._s(_vm.file.name)+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn-text btn-text--primary",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('remove')}}},[_vm._v("\n    "+_vm._s(_vm.$t('fileUpload.delete'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YHML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__ = __webpack_require__("2u3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5448a391_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__ = __webpack_require__("jzuk");
function injectStyle (ssrContext) {
  __webpack_require__("9gYv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5448a391"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5448a391_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YHTk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YIv3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YJBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "prijem",
  path: "/prijem",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("02_prijem/PregledPacijenta"),
  meta: {
    default: false,
    title: "Prijem pacijenta",
    class: "primary",
    show: false,
    iconClass: "fa fa-user",
    requiredAuth: true
  }
});

/***/ }),

/***/ "YPZh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YPtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"input-icon-left","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter()},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Pretraga'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YUFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_jsoneditor_css__ = __webpack_require__("uGPS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_jsoneditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_jsoneditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_jsoneditor__ = __webpack_require__("L6Z1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_jsoneditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_jsoneditor__);




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        value: [String, Number, Object, Array],
        showBtns: [Boolean],
        mode: {
            type: String,
            default: 'tree'
        },
        modes: {
            type: Array,
            default: function _default() {
                return ['tree', 'code', 'form', 'text', 'view'];
            }
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function handler(val) {
                if (!this.internalChange) {
                    this.setEditor(val);
                }
            },

            deep: true
        }
    },
    data: function data() {
        return {
            editor: null,
            error: false,
            json: this.value,
            internalChange: false,
            locale: {
                'it': {
                    save: 'SALVA'
                },
                'en': {
                    save: 'SAVE'
                },
                'zh': {
                    save: '保存'
                }
            }
        };
    },
    mounted: function mounted() {
        var self = this;

        var options = {
            mode: this.mode,
            modes: this.modes, onChange: function onChange() {
                try {
                    var json = self.editor.get();
                    self.json = json;
                    self.$emit('json-change', json);
                    self.internalChange = true;
                    self.$emit('input', json);
                    self.$nextTick(function () {
                        self.internalChange = false;
                    });
                } catch (e) {
                    self.$emit('has-error', e);
                }
            }
        };

        this.editor = new __WEBPACK_IMPORTED_MODULE_1__assets_jsoneditor___default.a(this.$el.querySelector('.jsoneditor-vue'), options, this.json);
    },

    methods: {
        onSave: function onSave() {
            this.$emit('json-save', this.json);
        },
        setEditor: function setEditor(value) {
            if (this.editor) this.editor.set(value);
        }
    }
});

/***/ }),

/***/ "YUx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("zkRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7366aad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("T1D7");
function injectStyle (ssrContext) {
  __webpack_require__("MGEg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7366aad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7366aad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YZh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioButton_vue__ = __webpack_require__("6Bok");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22e6ae48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButton_vue__ = __webpack_require__("OgkS");
function injectStyle (ssrContext) {
  __webpack_require__("CTCf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22e6ae48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22e6ae48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__ = __webpack_require__("ZEli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lazyLoading__ = __webpack_require__("77C1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_config_js__ = __webpack_require__("1wn0");







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: "*",
    redirect: { name: getDefaultRoute(__WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__["a" /* default */].state.items).name }
  }])
});

function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var login = {
    path: "/auth/login",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("auth/login/Login"),
    meta: {
      default: false,
      title: "login",
      requiredAuth: false
    }
  };

  var dashboard = {
    path: "/dashboard",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("dashboard/Dashboard"),
    meta: {
      default: false,
      title: "dashboard",
      requiredAuth: false
    }
  };

  var samples = {
    path: "/samples/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("02_samples/SamplesEntry"),
    props: true,
    meta: {
      title: "samples",
      requiredAuth: true
    }
  };

  var rtobrada = {
    path: "/rtobrada/rezultati/:patient/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("rtobrada/Obrada"),
    props: true,
    meta: {
      title: "rtobrada",
      requiredAuth: true
    }
  };

  var lpobrada = {
    path: "/lpobrada/rezultati/:patient/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("lpobrada/Obrada"),
    props: true,
    meta: {
      title: "lpobrada",
      requiredAuth: true
    }
  };

  var agobrada = {
    path: "/agobrada/rezultati/:patient/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("agobrada/Obrada"),
    props: true,
    meta: {
      title: "agobrada",
      requiredAuth: true
    }
  };

  var atobrada = {
    path: "/atobrada/rezultati/:patient/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("atobrada/Obrada"),
    props: true,
    meta: {
      title: "atobrada",
      requiredAuth: true
    }
  };

  var predracun = {
    path: "/obrada/predracun/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("obrada/predracun"),
    props: true,
    meta: {
      title: "predracun",
      requiredAuth: true
    }
  };

  var kontrole = {
    path: "/kontrole/obrada/rezultati",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("kontrole/pregled/Obrada"),
    props: true,
    meta: {
      title: "obrada",
      requiredAuth: true
    }
  };

  var nalazi = {
    path: "/nalazi/pregled/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("nalazi/pregled/nalaz"),
    props: true,
    meta: {
      title: "nalaz",
      requiredAuth: true
    }
  };

  var rtnalazi = {
    path: "/rtnalazi/pregled/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("rtnalazi/pregled/nalaz"),
    props: true,
    meta: {
      title: "rtnalaz",
      requiredAuth: true
    }
  };

  var lpnalazi = {
    path: "/lpnalazi/pregled/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("lpnalazi/pregled/nalaz"),
    props: true,
    meta: {
      title: "lpnalaz",
      requiredAuth: true
    }
  };

  var agnalazi = {
    path: "/agnalazi/pregled/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("agnalazi/pregled/nalaz"),
    props: true,
    meta: {
      title: "agnalaz",
      requiredAuth: true
    }
  };

  var atnalazi = {
    path: "/atnalazi/pregled/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("atnalazi/pregled/nalaz"),
    props: true,
    meta: {
      title: "atnalaz",
      requiredAuth: true
    }
  };

  var rtoutbox = {
    path: "/nalazi/outbox/rt/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("rtoutbox/nalaz"),
    props: true,
    meta: {
      title: "rtoutbox",
      requiredAuth: true
    }
  };

  var lpoutbox = {
    path: "/nalazi/outbox/lp/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("lpoutbox/nalaz"),
    props: true,
    meta: {
      title: "lpoutbox",
      requiredAuth: true
    }
  };

  var agoutbox = {
    path: "/nalazi/outbox/ag/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("agoutbox/nalaz"),
    props: true,
    meta: {
      title: "agoutbox",
      requiredAuth: true
    }
  };

  var atoutbox = {
    path: "/nalazi/outbox/at/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("atoutbox/nalaz"),
    props: true,
    meta: {
      title: "atoutbox",
      requiredAuth: true
    }
  };

  var evaluation = {
    path: "/evaluation/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("evaluation/Charts"),
    props: true,
    meta: {
      title: "evaluation",
      requiredAuth: true
    }
  };

  var loger = {
    path: "/loger/statistika",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("loger/pregled/pregled"),
    props: true,
    meta: {
      title: "loger",
      requiredAuth: true
    }
  };

  var registracija = {
    path: "/registracija",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("registracija/Registracija"),
    props: true,
    meta: {
      title: "registracija",
      requiredAuth: true
    }
  };

  var changelog = {
    path: "/changelog",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("changelog/changelog"),
    props: true,
    meta: {
      title: "changelog",
      requiredAuth: true
    }
  };

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes);
    }
  }

  routes.push(login);
  routes.push(dashboard);
  routes.push(samples);

  routes.push(rtobrada);
  routes.push(lpobrada);
  routes.push(agobrada);
  routes.push(atobrada);

  routes.push(rtnalazi);
  routes.push(lpnalazi);
  routes.push(agnalazi);
  routes.push(atnalazi);

  routes.push(kontrole);
  routes.push(predracun);
  routes.push(nalazi);

  routes.push(rtoutbox);
  routes.push(lpoutbox);
  routes.push(agoutbox);
  routes.push(atoutbox);

  routes.push(evaluation);
  routes.push(loger);
  routes.push(registracija);

  routes.push(changelog);
  return routes;
}

function getDefaultRoute() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var defaultRoute = void 0;

  menu.forEach(function (item) {
    if (item.meta.default) {
      defaultRoute = item;
    } else if (item.children) {
      var defaultChild = item.children.find(function (i) {
        return i.meta.default;
      });
      defaultRoute = defaultChild || defaultRoute;
    }
  });

  return defaultRoute;
}

router.beforeEach(function (to, from, next) {
  if (localStorage.getItem("token")) {
    next();
  } else {
    if (to.path !== "/auth/login") {
      if (to.path.indexOf("acme-challenge") !== -1) {
        __WEBPACK_IMPORTED_MODULE_5__config_config_js__["C" /* http */].get(to.path, {}).then(function (res) {});
      } else {
        router.push("/auth/login");
      }
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YcSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('vue-json-editor',{attrs:{"show-btns":false},on:{"json-change":_vm.onJsonChange},model:{value:(_vm.jsonData),callback:function ($$v) {_vm.jsonData=$$v},expression:"jsonData"}})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YeH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("l92n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d9f793c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("Cs+0");
function injectStyle (ssrContext) {
  __webpack_require__("MD5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d9f793c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d9f793c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YhNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("ZTcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145c4410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("C/sP");
function injectStyle (ssrContext) {
  __webpack_require__("6JMY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-145c4410"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145c4410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YirT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChatWindow = __webpack_require__("Jf5X");

var _ChatWindow2 = _interopRequireDefault(_ChatWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    showEmoji: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    open: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    titleImageUrl: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    onMessageWasSent: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    newMessagesCount: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    placeholder: {
      type: String,
      default: 'Write a reply'
    },
    showTypingIndicator: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    colors: {
      type: Object,
      required: false,
      validator: function validator(c) {
        return 'header' in c && 'bg' in c.header && 'text' in c.header && 'launcher' in c && 'bg' in c.launcher && 'messageList' in c && 'bg' in c.messageList && 'sentMessage' in c && 'bg' in c.sentMessage && 'text' in c.sentMessage && 'receivedMessage' in c && 'bg' in c.receivedMessage && 'text' in c.receivedMessage && 'userInput' in c && 'bg' in c.userInput && 'text' in c.userInput;
      },
      default: function _default() {
        return {
          header: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          launcher: {
            bg: '#4e8cff'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#f4f7f9',
            text: '#ffffff'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        };
      }
    },
    alwaysScrollToBottom: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  computed: {
    chatWindowTitle: function chatWindowTitle() {
      if (this.title !== '') {
        return this.title;
      }

      if (this.participants.length > 1) {
        return 'You, ' + this.participants[0].name + ' & others';
      } else {
        return 'You & ' + this.participants[0].name;
      }
    }
  },
  components: {
    ChatWindow: _ChatWindow2.default
  }
};

/***/ }),

/***/ "Ynsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-error-control",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "YoOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YpCA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YtNK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z4em":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeDeleteSites_vue__ = __webpack_require__("GnSh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e40bc9be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeDeleteSites_vue__ = __webpack_require__("m7ac");
function injectStyle (ssrContext) {
  __webpack_require__("Y6gc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeDeleteSites_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e40bc9be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeDeleteSites_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZEli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__statistika__ = __webpack_require__("LteM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prijem__ = __webpack_require__("YJBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__barcode__ = __webpack_require__("bB0B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__naljepnice__ = __webpack_require__("fa71");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__obrada__ = __webpack_require__("p5Q8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nalazi__ = __webpack_require__("HmjV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__email__ = __webpack_require__("cH+e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analize__ = __webpack_require__("Mwi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__narucioci__ = __webpack_require__("RcJ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__protokol__ = __webpack_require__("LTOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__changelog__ = __webpack_require__("u4eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reports__ = __webpack_require__("mFVy");
















var state = {
  items: [__WEBPACK_IMPORTED_MODULE_2__statistika__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__prijem__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__barcode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__naljepnice__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__obrada__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__nalazi__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__email__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__analize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__narucioci__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__protokol__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__changelog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__reports__["a" /* default */]]
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_EXPAND_MENU_ITEM */], function (state, payload) {
  var menuItem = payload.menuItem;
  var expand = payload.expand;
  if (menuItem.children && menuItem.meta) {
    menuItem.meta.expanded = expand;
  }
});

var actions = {
  toggleExpandMenuItem: function toggleExpandMenuItem(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_EXPAND_MENU_ITEM */], payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "ZQsF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    participants: {
      type: Array,
      required: true
    }
  }
};

/***/ }),

/***/ "ZTcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "filterBar",
  data: function data() {
    return {
      filterText: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("setFilterBar", function (data) {
      _this.filterText = data;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("setFilterBar");
  },

  methods: {
    doFilter: function doFilter(event) {
      this.$emit("filter", this.filterText, event);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("FilterBar", this.filterText);
    }
  }
});

/***/ }),

/***/ "ZTjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-multi",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('SaveMulti', this.sample);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "ZWOL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zavi":
/***/ (function(module, exports, __webpack_require__) {

var Samples = __webpack_require__("aNvS");

module.exports = {
  Selection: function Selection(site, test, godina, spol, drstanje, menopauza, manual, calculated) {
    return Samples.Return(test, godina, spol, drstanje, menopauza, manual, calculated);
  }
};

/***/ }),

/***/ "Zlq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZoX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'pixel-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                      ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                      0 ' + this.pixelSize * -1.5 + 'px 0 0\n                    '
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n      50% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n\n      75% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n      100% {\n        transform: rotate(360deg);\n      }';
    }
  }
});

/***/ }),

/***/ "ZsAS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "modal-commenting",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    komentar: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      comment: "",
      uzorak: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    komentar: function komentar(newVal, oldVal) {
      this.comment = newVal;
    },

    sample: function sample(newVal, oldVal) {
      this.uzorak = newVal;
    },

    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("setComment", this.uzorak, this.comment);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "ZzBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aCP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__ = __webpack_require__("Vo2z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_322e9be5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileIcons_vue__ = __webpack_require__("aTfw");
function injectStyle (ssrContext) {
  __webpack_require__("y/Ac")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-322e9be5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_322e9be5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileIcons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aF9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commenting_vue__ = __webpack_require__("ZsAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92f3e832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commenting_vue__ = __webpack_require__("RoBF");
function injectStyle (ssrContext) {
  __webpack_require__("ntpn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commenting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92f3e832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commenting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aHZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalAparati_vue__ = __webpack_require__("if6A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3849bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalAparati_vue__ = __webpack_require__("DLuW");
function injectStyle (ssrContext) {
  __webpack_require__("MSuV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalAparati_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3849bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalAparati_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aICY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aLFs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDcuOTcxIDQ3Ljk3MSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcuOTcxIDQ3Ljk3MTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik0yOC4yMjgsMjMuOTg2TDQ3LjA5Miw1LjEyMmMxLjE3Mi0xLjE3MSwxLjE3Mi0zLjA3MSwwLTQuMjQyYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBMMjMuOTg2LDE5Ljc0NEw1LjEyMSwwLjg4CgkJYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBjLTEuMTcyLDEuMTcxLTEuMTcyLDMuMDcxLDAsNC4yNDJsMTguODY1LDE4Ljg2NEwwLjg3OSw0Mi44NWMtMS4xNzIsMS4xNzEtMS4xNzIsMy4wNzEsMCw0LjI0MgoJCUMxLjQ2NSw0Ny42NzcsMi4yMzMsNDcuOTcsMyw0Ny45N3MxLjUzNS0wLjI5MywyLjEyMS0wLjg3OWwxOC44NjUtMTguODY0TDQyLjg1LDQ3LjA5MWMwLjU4NiwwLjU4NiwxLjM1NCwwLjg3OSwyLjEyMSwwLjg3OQoJCXMxLjUzNS0wLjI5MywyLjEyMS0wLjg3OWMxLjE3Mi0xLjE3MSwxLjE3Mi0zLjA3MSwwLTQuMjQyTDI4LjIyOCwyMy45ODZ6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+"

/***/ }),

/***/ "aNvS":
/***/ (function(module, exports) {

function Type(manual, calculated) {
  if (!manual && !calculated) {
    return ["Lab", true, true];
  } else if (manual && !calculated) {
    return ["Man", true, true];
  } else if (!manual && calculated) {
    return ["Calc", true, true];
  } else if (manual && calculated) {
    return ["Calc", true, true];
  }
}

module.exports = {
  Return: function Return(test, godina, spol, drstanje, menopauza, manual, calculated) {
    switch (test) {
      default:
        return Type(manual, calculated);
        break;
    }
  }
};

/***/ }),

/***/ "aOf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseControlAparati_vue__ = __webpack_require__("izwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563bbda1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseControlAparati_vue__ = __webpack_require__("G/Hy");
function injectStyle (ssrContext) {
  __webpack_require__("xIst")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseControlAparati_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563bbda1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseControlAparati_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aTa4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTag_vue__ = __webpack_require__("+XJn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b1bf830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTag_vue__ = __webpack_require__("LmDz");
function injectStyle (ssrContext) {
  __webpack_require__("EqRg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b1bf830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aTfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"htmlFor":"file-input"}},[_c('button',{staticClass:"sc-user-input--file-icon-wrapper",attrs:{"type":"button"}},[_c('svg',{staticClass:"sc-user-input--file-icon",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 37.393 37.393","enableBackground":"new 0 0 37.393 37.393"}},[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M20.807 10.22l-2.030-2.029-10.15 10.148c-1.682 1.681-1.682 4.408 0 6.089s4.408 1.681 6.090 0l12.18-12.178c2.804-2.802 2.804-7.346 0-10.148-2.802-2.803-7.347-2.803-10.149 0l-12.788 12.787c-0.009 0.009-0.019 0.018-0.027 0.026-3.909 3.909-3.909 10.245 0 14.153 3.908 3.908 10.246 3.908 14.156 0 0.009-0.009 0.016-0.018 0.026-0.027l0.001 0.001 8.729-8.728-2.031-2.029-8.729 8.727c-0.009 0.008-0.018 0.018-0.026 0.026-2.784 2.783-7.312 2.783-10.096 0-2.783-2.783-2.783-7.31 0-10.093 0.010-0.009 0.019-0.018 0.028-0.026l-0.001-0.002 12.79-12.786c1.678-1.679 4.411-1.679 6.090 0s1.678 4.411 0 6.089l-12.18 12.178c-0.56 0.56-1.47 0.56-2.030 0-0.559-0.559-0.559-1.47 0-2.029l10.15-10.149z"}})])]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"file-input"},on:{"change":_vm._handleChange,"click":_vm._handleClick}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aWyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__ = __webpack_require__("xU+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45316253_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__ = __webpack_require__("auOi");
function injectStyle (ssrContext) {
  __webpack_require__("JlW8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45316253"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45316253_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aXY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-radio-button',
  props: {
    label: String,
    value: {
      type: String,
      default: '',
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      default: undefined
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  mounted: function mounted() {
    if (this.checked && !this.checkState) {
      this.toggle();
    }
  },

  methods: {
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      this.$emit('input', this.checkState ? '' : this.value);
    }
  },
  computed: {
    checkState: function checkState() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    },
    additionalClasses: function additionalClasses() {
      return ['abc-radio-' + this.brandColor];
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.checkState) {
        this.toggle();
      }
    }
  }
});

/***/ }),

/***/ "aXvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalStatic_vue__ = __webpack_require__("8sJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdba0754_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalStatic_vue__ = __webpack_require__("Mv1F");
function injectStyle (ssrContext) {
  __webpack_require__("Hwru")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalStatic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdba0754_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalStatic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aj+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__ = __webpack_require__("aXY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a0d642d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__ = __webpack_require__("5OGY");
function injectStyle (ssrContext) {
  __webpack_require__("PSgA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a0d642d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "anct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__ = __webpack_require__("yuAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e02844a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__ = __webpack_require__("O1gf");
function injectStyle (ssrContext) {
  __webpack_require__("mLBn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e02844a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "auOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('vue-json-editor',{attrs:{"show-btns":false},on:{"json-change":_vm.onJsonChange},model:{value:(_vm.jsonData),callback:function ($$v) {_vm.jsonData=$$v},expression:"jsonData"}})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "axM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__ = __webpack_require__("yDzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6780d16c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__ = __webpack_require__("/AIn");
function injectStyle (ssrContext) {
  __webpack_require__("dLbN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6780d16c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "azLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vuesticScrollbar",staticClass:"vuestic-scrollbar"},[_c('div',{ref:"scrollbarWrapper",staticClass:"scrollbar-wrapper"},[_c('div',{ref:"scrollbarContent",staticClass:"scrollbar-content",on:{"wheel":_vm.scroll,"touchstart":_vm.startDrag,"touchmove":_vm.onDrag,"touchend":_vm.stopDrag,"transitionend":_vm.onContentResize}},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"track",staticClass:"track"},[_c('div',{ref:"thumb",staticClass:"thumb"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b6US":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__ = __webpack_require__("3Bfb");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-file-upload-list-item',
  components: {
    VuesticFileUploadUndo: __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__["default"]
  },
  props: {
    file: {
      type: Object
    }
  },
  data: function data() {
    return {
      removed: false
    };
  },

  methods: {
    showFilePreview: function showFilePreview() {},
    removeFile: function removeFile() {
      var _this = this;

      this.removed = true;
      setTimeout(function () {
        if (_this.removed) {
          _this.$emit('remove');
          _this.removed = false;
        }
      }, 2000);
    },
    recoverFile: function recoverFile() {
      this.removed = false;
    }
  }
});

/***/ }),

/***/ "b6wd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__ = __webpack_require__("NoHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__ = __webpack_require__("AKm5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__ = __webpack_require__("+S+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__ = __webpack_require__("+UQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__ = __webpack_require__("q30D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__ = __webpack_require__("eDOj");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chart',
  props: ['data', 'options', 'type'],
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__["a" /* default */],
    VerticalBarChart: __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__["a" /* default */],
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__["a" /* default */],
    DonutChart: __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__["a" /* default */],
    BubbleChart: __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__["a" /* default */]
  }
});

/***/ }),

/***/ "bALl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: "table table-striped",
    ascendingIcon: "entypo entypo-up-dir",
    descendingIcon: "entypo entypo-down-dir"
  },
  pagination: {
    wrapperClass: "btn-group",
    activeClass: "focus",
    disabledClass: "disabled",
    pageClass: "btn btn-primary hide-not-focused-btn",
    linkClass: "btn btn-primary pagination-link-btn",
    icons: {
      first: "fa fa-angle-double-left",
      prev: "fa fa-angle-left",
      next: "fa fa-angle-right",
      last: "fa fa-angle-double-right"
    }
  }
});

/***/ }),

/***/ "bB0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "barcode",
  path: "/barcode",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("barcode/barcode"),
  meta: {
    default: false,
    title: "Prijem uzorka",
    class: "primary",
    show: false,
    iconClass: "fa fa-flask",
    requiredAuth: true
  }
});

/***/ }),

/***/ "bCs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-line"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bD1Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__ = __webpack_require__("inpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8ea6f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__ = __webpack_require__("O/de");
function injectStyle (ssrContext) {
  __webpack_require__("lQuO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c8ea6f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8ea6f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bFkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bGbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'spring-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        0% {\n          border-width: ' + this.size / 7 + 'px;\n        }\n        25% {\n          border-width: ' + this.size / 23.33 + 'px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ' + this.size / 7 + 'px;\n        }\n        75% {\n          border-width: ' + this.size / 23.33 + 'px;\n         }\n        100% {\n         border-width: ' + this.size / 7 + 'px;\n        }';
    }
  }
});

/***/ }),

/***/ "bPBZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bhip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



var toastOptions = {
  theme: "none",
  position: "bottom-center",
  className: "vuestic-toast",
  iconPack: "fontawesome",
  duration: 2500
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_toasted___default.a, toastOptions);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showToast: function showToast(msg, options) {
      this.$toasted.show(msg, options);
    }
  }
});

/***/ }),

/***/ "bi26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "postavke-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    labassay: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("PostavkeModalHide", function () {
      _this.show = false;
    });
  },


  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("PostavkeModalHide");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");

      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PostavkeModalInsert");

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PostavkeModalCancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "bjG+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "btIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadGalleryItem_vue__ = __webpack_require__("IyLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddbc39e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadGalleryItem_vue__ = __webpack_require__("5kXa");
function injectStyle (ssrContext) {
  __webpack_require__("HPkg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadGalleryItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddbc39e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadGalleryItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bv4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bvuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-mail-control",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Mail");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "c3nr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "control-ref-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("ControlReferencesModalHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("ControlReferencesModalHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("ControlReferencesModalConfirm");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("UređivanjeRefresh");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "cD2K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    }
  },
  methods: {
    toggleUserList: function toggleUserList() {
      this.inUserList = !this.inUserList;
      this.$emit("userList", this.inUserList);
    }
  },
  data: function data() {
    return {
      inUserList: false
    };
  }
};

/***/ }),

/***/ "cH+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "email",
  meta: {
    expanded: false,
    title: "Elektronska pošta",
    class: "primary",
    show: false,
    iconClass: "glyphicon glyphicon-envelope"
  },
  children: [{
    name: "rt-email",
    path: "/nalazi/outbox/rt",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("rtoutbox/outbox"),
    meta: {
      title: "CoV2 RT PCR pošta",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "lp-email",
    path: "/nalazi/outbox/lp",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("lpoutbox/outbox"),
    meta: {
      title: "CoV2 RT LAMP pošta",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "ag-email",
    path: "/nalazi/outbox/ag",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("agoutbox/outbox"),
    meta: {
      title: "CoV2 Antigen pošta",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "at-email",
    path: "/nalazi/outbox/at",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("atoutbox/outbox"),
    meta: {
      title: "CoV2 Antitijela pošta",
      show: false,
      requiredAuth: true
    }
  }]
});

/***/ }),

/***/ "cPXL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cWTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-node',
  props: {
    selected: {
      type: Boolean,
      default: false
    }

  }
});

/***/ }),

/***/ "cXS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-partneri-info",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ModalCancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "cbR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "mikrobiologija-edit-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    edit_data: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("MikrobiologijaModalHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("MikrobiologijaModalHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");

    switch (this.edit_data) {
      case "analiza":
        var disable_close = false;
        if (this.closeable) {
          disable_close = false;
        } else {
          disable_close = true;
        }
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalEditAnalize", disable_close);
        break;
      case "bakterija":
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalEditBakterije");
        break;
      case "antibiogram":
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalEditAntibiogrami");
        break;
      case "antibiotik":
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalEditAntibiotici");
        break;

      default:
        this.show = false;

        break;
    }

    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");

    switch (this.edit_data) {
      case "analiza":
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalCancelAnalize");
        break;
      case "bakterija":
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalCancelBakterije");
        break;
      case "antibiogram":
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalCancelAntibiogrami");
        break;
      case "antibiotik":
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("MikrobiologijaModalCancelAntibiotici");
        break;

      default:
        this.show = false;

        break;
    }

    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "cdlS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrugoStanje_vue__ = __webpack_require__("NKsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ca1424_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrugoStanje_vue__ = __webpack_require__("wvaw");
function injectStyle (ssrContext) {
  __webpack_require__("8EQH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35ca1424"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrugoStanje_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ca1424_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrugoStanje_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cfdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__ = __webpack_require__("y3Nu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f29fdb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__ = __webpack_require__("So8z");
function injectStyle (ssrContext) {
  __webpack_require__("+3qH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f29fdb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f29fdb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cmXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cwUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fieldset',[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.LN),expression:"LN"}],ref:"lnInput",attrs:{"onpaste":"return false;","autocomplete":"off","id":"pln-input-icon-left","title":" ","name":"pln-input-icon-left","required":""},domProps:{"value":(_vm.LN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.LN=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"pln-input-icon-left"}},[_vm._v(_vm._s('LN'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),(_vm.postoji && !_vm.invalid)?_c('div',[_c('h5',[_vm._v(_vm._s('Uneseni LN je već registriran!'))]),_vm._v(" "),_c('h5',[_vm._v("\n                            "+_vm._s('Produkt:')+"\n                            "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.produkt_data))])]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.invalid)?_c('div',[_c('h5',[_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.error_msg))])]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.opis),expression:"opis"}],attrs:{"id":"popis-input-icon-left","title":" ","name":"popis-input-icon-left","required":""},domProps:{"value":(_vm.opis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.opis=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"popis-input-icon-left"}},[_vm._v(_vm._s('Unesite opis produkta'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('vuestic-simple-select',{ref:"jedinicaSelect",attrs:{"label":'Unesite jedinicu mjere',"name":"jedinica","required":true,"title":" ","options":_vm.jedinice},model:{value:(_vm.jedinica),callback:function ($$v) {_vm.jedinica=$$v},expression:"jedinica"}}):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sadrzaj),expression:"sadrzaj"}],attrs:{"id":"psadrzaj-input-icon-left","title":" ","name":"psadrzaj-input-icon-left","required":""},domProps:{"value":(_vm.sadrzaj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sadrzaj=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"psadrzaj-input-icon-left"}},[_vm._v(_vm._s('Unesite sadržaj pakovanja'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nivo),expression:"nivo"}],attrs:{"id":"pnivo-input-icon-left","title":" ","name":"pnivo-input-icon-left","required":""},domProps:{"value":(_vm.nivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nivo=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"pnivo-input-icon-left"}},[_vm._v(_vm._s('Unesite nivo za upozorenje'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.danadoroka),expression:"danadoroka"}],attrs:{"id":"pdanadoroka-input-icon-left","title":" ","name":"pdanadoroka-input-icon-left","required":""},domProps:{"value":(_vm.danadoroka)},on:{"input":function($event){if($event.target.composing){ return; }_vm.danadoroka=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"pdanadoroka-input-icon-left"}},[_vm._v(_vm._s('Unesite upozorenje do roka'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zasnaziv),expression:"zasnaziv"}],attrs:{"id":"pzasnaziv-input-icon-left","title":" ","name":"pzasnaziv-input-icon-left","required":""},domProps:{"value":(_vm.zasnaziv)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zasnaziv=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"pzasnaziv-input-icon-left"}},[_vm._v(_vm._s('Unesite zaštićeni naziv produkta'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fieldset',[(!_vm.postoji && !_vm.invalid)?_c('vuestic-simple-select',{ref:"proizvodjacSelect",attrs:{"label":"Proizvođač","name":"proizvodjac","required":true,"title":" ","options":_vm.backProizvodjaci},model:{value:(_vm.chosenProizvodjac),callback:function ($$v) {_vm.chosenProizvodjac=$$v},expression:"chosenProizvodjac"}}):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('vuestic-simple-select',{ref:"zemljaSelect",attrs:{"label":"Zemlja porijekla","name":"zemlja","required":true,"title":" ","options":_vm.zemlje},model:{value:(_vm.chosenZemlja),callback:function ($$v) {_vm.chosenZemlja=$$v},expression:"chosenZemlja"}}):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('vuestic-simple-select',{ref:"klasaSelect",attrs:{"label":"Klasa","name":"klasa","required":true,"title":" ","options":_vm.klase},model:{value:(_vm.chosenKlasa),callback:function ($$v) {_vm.chosenKlasa=$$v},expression:"chosenKlasa"}}):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('vuestic-simple-select',{ref:"programSelect",attrs:{"label":"Program","name":"program","required":true,"title":" ","options":_vm.programi},model:{value:(_vm.chosenProgram),callback:function ($$v) {_vm.chosenProgram=$$v},expression:"chosenProgram"}}):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('vuestic-simple-select',{ref:"platformaSelect",attrs:{"label":"Platforma","name":"platforma","required":true,"title":" ","options":_vm.platforme},model:{value:(_vm.chosenPlatforma),callback:function ($$v) {_vm.chosenPlatforma=$$v},expression:"chosenPlatforma"}}):_vm._e(),_vm._v(" "),(!_vm.postoji && !_vm.invalid)?_c('vuestic-simple-select',{ref:"ojSelect",attrs:{"label":"OJ","name":"oj","required":true,"title":" ","options":_vm.OJs},model:{value:(_vm.chosenOJ),callback:function ($$v) {_vm.chosenOJ=$$v},expression:"chosenOJ"}}):_vm._e()],1)])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && !_vm.postoji && !_vm.invalid)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":(_vm.izbor === 'LN' && _vm.LN.length < 3) || (_vm.izbor === 'opis' && _vm.opis.length < 3)},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.postoji)?_c('button',{staticClass:"btn btn-secondary-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.Prijem()}}},[_c('span',{staticClass:"fa fa-flask"}),_vm._v("\n                  "+_vm._s('Prijem')+"\n                ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d1QR":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSIxNy41MTgiIGN5PSIxNy41MTgiIHI9IjE3LjUxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2LjUyIDU1KSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "d4/x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__ = __webpack_require__("whi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d5ace2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__ = __webpack_require__("T31c");
function injectStyle (ssrContext) {
  __webpack_require__("W07a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d5ace2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "d9vy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMicroBactery_vue__ = __webpack_require__("mSnZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8cf9ec8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMicroBactery_vue__ = __webpack_require__("Xiwu");
function injectStyle (ssrContext) {
  __webpack_require__("fGmA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8cf9ec8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMicroBactery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8cf9ec8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMicroBactery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dC4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload-container"},[_c('div',{staticClass:"vuestic-file-upload-container__field",class:{'vuestic-file-upload-container__field--dropzone': _vm.dropzone}},[(_vm.dropzone)?_c('div',{staticClass:"vuestic-file-upload-container__field__text",attrs:{"title":''}},[_vm._v(_vm._s('Drop excel file here or'))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-micro",attrs:{"title":'',"type":"button"}},[_vm._v(_vm._s('Browse'))]),_vm._v(" "),_c('input',{ref:"fieldInput",staticClass:"vuestic-file-upload-container__field__input",attrs:{"title":'',"type":"file","accept":_vm.fileTypes,"multiple":_vm.type !== 'single'},on:{"change":_vm.changeFieldValue}})]),_vm._v(" "),_c('div',{staticClass:"vuestic-file-upload-container__main"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dIkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "control-delete-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("ControlDeleteModalHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("ControlDeleteModalHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("ControlDelete");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "dIvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("fom4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17dad2de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("bCs5");
function injectStyle (ssrContext) {
  __webpack_require__("AGve")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17dad2de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17dad2de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dJjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeAccordion_vue__ = __webpack_require__("6SPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec73070_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeAccordion_vue__ = __webpack_require__("I32p");
function injectStyle (ssrContext) {
  __webpack_require__("u1UZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeAccordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec73070_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeAccordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dLbN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dRu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-profile-card',
  props: ['photoSource', 'name', 'location', 'social']
});

/***/ }),

/***/ "dTIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFixedHeader)?_c('div',[_c('div',{staticClass:"vuetable-head-wrapper"},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{class:['vuetable-th-'+field.name, field.titleClass,  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]}),_vm._v(" "),(_vm.scrollVisible)?_c('th',{staticClass:"vuetable-gutter-col",style:({width: _vm.scrollBarWidth})}):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"vuetable-body-wrapper",style:({height: _vm.tableHeight})},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]},[_c('colgroup',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[[_c('col',{class:['vuetable-th-'+field.name, field.titleClass],style:({width: field.width}),attrs:{"id":'_col_' + field.name}})]]:_vm._e()]})],2),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{class:_vm.onRowClass(item, index),attrs:{"item-index":index,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(index))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":index,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:index,rowField:field.sortField})],2):_vm._e()]:[_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.renderNormalField(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('transition',{attrs:{"name":_vm.detailRowTransition}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":index}})],1)])],1):_vm._e()]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields}},[_vm._v(_vm._s(_vm.noDataTemplate))])])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?_c('td',[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])])]):_c('table',{class:['vuetable', _vm.css.tableClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{class:['vuetable-th-'+field.name, field.titleClass,  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{class:_vm.onRowClass(item, index),attrs:{"item-index":index,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(index))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":index,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:index,rowField:field.sortField})],2):_vm._e()]:[(_vm.hasCallback(field))?_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.callCallback(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}}):_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.getObjectValue(item, field.name, ''))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('transition',{attrs:{"name":_vm.detailRowTransition}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":index}})],1)])],1):_vm._e()]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?_c('td',[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dbhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionObrada_vue__ = __webpack_require__("n5qd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f682946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccordionObrada_vue__ = __webpack_require__("MPEU");
function injectStyle (ssrContext) {
  __webpack_require__("4j/T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionObrada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f682946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccordionObrada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dbim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-widget-bubble",

  props: {
    headerText: {
      type: String,
      default: ""
    },
    datum_rodjenja: {
      type: String,
      default: ""
    },
    patient: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "dpoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPartneriInfo_vue__ = __webpack_require__("cXS/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_196866ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPartneriInfo_vue__ = __webpack_require__("RptW");
function injectStyle (ssrContext) {
  __webpack_require__("Um6W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPartneriInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_196866ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPartneriInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dq31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__ = __webpack_require__("kl3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_288cd93a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__ = __webpack_require__("dTIV");
function injectStyle (ssrContext) {
  __webpack_require__("V9Re")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-288cd93a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_288cd93a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dtfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'POTVRDI'
    },
    cancelText: {
      type: String,
      default: 'ODUSTANI'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary btn-sm'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-warning btn-sm'
    },
    zatvori: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      zatvor: this.zatvori
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    ok: function ok() {

      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('sacuvajAnalite');
      this.$emit('ok');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yes', true);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yesRacun', true, this.transition);

      this.show = false;
    },
    cancel: function cancel() {
      this.$emit('cancel');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('no', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseNo', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseKo', false);
      this.show = false;
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
    }
  }
});

/***/ }),

/***/ "dwJF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e8Tw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kewler__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-pre-loader',
  methods: {
    getPrevious: function getPrevious(index) {
      if (index === 0) return this.points.length - 1;else return index - 1;
    },
    getNext: function getNext(index) {
      if (index + 1 === this.points.length) {
        return 0;
      } else {
        return index + 1;
      }
    },
    setNextLighten: function setNextLighten(index) {
      var lighten = this.points[index].lighten;
      this.points[index].lighten = lighten === 8 ? 1 : lighten + 1;
    },
    draw: function draw() {
      var _this = this;

      var ctx = this.context;
      ctx.clearRect(0, 0, 140, 104);
      var padding = 4;
      this.points.forEach(function (point) {
        ctx.beginPath();
        var delta = _this.radius + padding;
        ctx.arc(point.x + delta, point.y + delta, _this.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = _this.color(Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["lightness"])(point.lighten / 10 * 35))();
        ctx.fill();
      });
      var main = this.points[this.mainIndex];
      var delta = this.mainRadius - this.radius + padding;
      ctx.beginPath();
      ctx.arc(main.x + delta, main.y + delta, this.mainRadius, 0, Math.PI * 2, false);
      ctx.fillStyle = this.color();
      ctx.fill();
      ctx.closePath();
    },
    calculate: function calculate() {
      this.mainIndex = this.getNext(this.mainIndex);
      var prevIndex = this.mainIndex;
      for (var i = 0; i <= 7; i++) {
        prevIndex = this.getPrevious(prevIndex);
        this.setNextLighten(prevIndex);
      }
    },
    update: function update() {
      this.calculate();
      this.draw();
    },
    animate: function animate() {
      this.interval = setInterval(this.update, 30);
    },
    stop: function stop() {
      clearInterval(this.interval);
    }
  },
  mounted: function mounted() {
    this.context = this.$refs.canvas.getContext('2d');
    this.points = this.points.map(function (point) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        lighten: 8
      }, point);
    });
    for (var i = 1; i <= 7; i++) {
      this.points[this.mainIndex - i].lighten = i;
    }
    this.draw();
    this.animate();
  },
  data: function data() {
    return {
      points: __webpack_require__("/QL9"),
      color: Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["color"])(this.$store.state.app.config.palette.primary),
      mainIndex: 7,
      context: {},
      radius: 4,
      mainRadius: 8,
      interval: {}
    };
  }
});

/***/ }),

/***/ "eBYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__ = __webpack_require__("laTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1e818edb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__ = __webpack_require__("l+bF");
function injectStyle (ssrContext) {
  __webpack_require__("IPD5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e818edb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1e818edb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eDOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "eLCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "postavke-collapse",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 10
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("CollapseAllSites", function () {
      _this.collapse();
    });
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("CollapseAllUsers", function () {
      _this.collapse();
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("CollapseAllSites");
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("CollapseAllUsers");
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + "px";

      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    onHeaderClick: function onHeaderClick() {
      this.toggle();
      this.accordion.onChildChange(this, this.show);
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "eOMX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-time","config":_vm.config},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range"}},[_vm._v(_vm._s('Datum i vrijeme'))])],1)])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eT2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eVzt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "egNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-checkbox form-check abc-checkbox",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ehbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-micro-result",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    neg: {
      type: Boolean,
      default: true
    },
    pos: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("CloseMicroResult", function () {
      _this.show = false;
    });
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("CloseMicroResult");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("MicroResult");
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("CancelMicroResult");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    Reset: function Reset() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ResetResultSelection");
    }
  }
});

/***/ }),

/***/ "elJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-flatpickr-component',_vm._g({staticClass:"vuestic-date-picker",class:{'has-value': _vm.valueProxy && _vm.valueProxy.length},attrs:{"config":_vm.fullConfig},model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}},_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "emdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("tWOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6589e50b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("+hx1");
function injectStyle (ssrContext) {
  __webpack_require__("Sg7X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6589e50b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "enb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eudO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ex6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEmailService_vue__ = __webpack_require__("HDUi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f5bf206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEmailService_vue__ = __webpack_require__("I4TD");
function injectStyle (ssrContext) {
  __webpack_require__("fEWJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEmailService_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f5bf206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEmailService_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fBe1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPatient_vue__ = __webpack_require__("HzoN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebf49af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPatient_vue__ = __webpack_require__("tUiU");
function injectStyle (ssrContext) {
  __webpack_require__("LG8r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ebf49af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPatient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebf49af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPatient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fCl3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-micro-reset",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("CloseMicroReset", function () {
      _this.show = false;
    });
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("CloseMicroReset");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("MicroReset");
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "fDiC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fEWJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fGmA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fMGo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--text",style:(_vm.messageColors)},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.messageText)}}),_vm._v(" "),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:({color: _vm.messageColors.color})},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fQTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-comment",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    comment: {
      type: Array,
      default: function _default() {
        [];
      }
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      komentar: "",
      komentari: [],
      komentariGet: [],
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].get("assays/settings?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
      _this.komentariGet = res.data.settings[0].komentari;
    });
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.Comment();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {

      switch (this.comment[0].tip) {

        case "CoV2 RT PCR":
          this.komentari = this.komentariGet[0];
          break;

        case "CoV2 RT LAMP":
          this.komentari = this.komentariGet[0];
          break;

        case "CoV2 Antigen":
          this.komentari = this.komentariGet[1];
          break;

        default:
          this.komentari = this.komentariGet[2];
          break;
      }
      this.GetComment();
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    GetComment: function GetComment() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].get("uzorci/komentar/" + this.$store.state.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        _this2.komentar = res.data.komentar;
        _this2.show = true;
      });
    },
    Comment: function Comment() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].post("uzorci/komentar/" + this.$store.state.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {
        komentar: this.komentar
      }).then(function (res) {
        _this3.show = false;
      });
    }
  }
});

/***/ }),

/***/ "fU/A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fa71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "naljepnice",
  path: "/naljepnice",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("naljepnice/naljepnice"),
  meta: {
    default: false,
    title: "Statusi uzoraka",
    class: "primary",
    show: false,
    iconClass: "vuestic-icon vuestic-icon-time",
    requiredAuth: true
  }
});

/***/ }),

/***/ "fom4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "g+Tt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sars-modal-calendar",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    vrijeme: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      time: "",
      uzorak: "",
      config: {
        maxDate: new Date(),
        enableTime: true,
        inline: true,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      }
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    vrijeme: function vrijeme(newVal, oldVal) {
      this.time = newVal;
    },

    sample: function sample(newVal, oldVal) {
      this.uzorak = newVal;
    },

    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("setCalendarObrada", this.time);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      var _this = this;

      this.$emit("cancel");
      this.show = false;
      setTimeout(function () {
        _this.time = _this.vrijeme;
      }, 300);

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "g+VA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gVv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_json_editor_vue__ = __webpack_require__("YUFg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03099d1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_json_editor_vue__ = __webpack_require__("SIDT");
function injectStyle (ssrContext) {
  __webpack_require__("cPXL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03099d1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_json_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03099d1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_json_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gXy1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(((_vm.neg || _vm.pos) && _vm.sample.status === 'ZAPRIMLJEN'))?_c('i',{staticClass:"glyphicon glyphicon-erase",staticStyle:{"color":"#e34a4a"},on:{"dblclick":function($event){$event.preventDefault();_vm.Reset()}}}):_vm._e(),_vm._v(" "),((!_vm.neg && !_vm.pos))?_c('i',{staticClass:"glyphicon glyphicon-erase",staticStyle:{"color":"#acb5be"}}):_vm._e(),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":!_vm.neg && !(_vm.pos && _vm.selected)},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gbz1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "glDe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-control-collapse",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noHeader: Boolean,
    naziv: {
      type: String,
      default: ""
    }
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      hitan: false
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    }
  },
  mounted: function mounted() {
    this.toggle();
    this.accordion.onChildChange(this, this.show);
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + "px";

      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    onHeaderClick: function onHeaderClick(event) {
      switch (event.target.id) {
        case "remove":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("ControlEntryRemove", this.naziv);
          break;
        case "":
          break;
        default:
          this.toggle();
          this.accordion.onChildChange(this, this.show);
          break;
      }
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "glov":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "filterBar",
  data: function data() {
    return {
      filterText: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("SetFilterFromLabAssay", function (data) {
      if (_this.filterText != data) {
        _this.filterText = data;
        _this.doFilter(_this.filterText);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("SetFilterFromLabAssay");
  },

  methods: {
    doFilter: function doFilter() {
      this.$emit("filter", this.filterText);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SetFilterFromAnaAssay", this.filterText);
    }
  }
});

/***/ }),

/***/ "gmk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-uzorci",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Partials");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "gpVI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqwV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gvyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-feed',
  props: ['initialPosts'],
  methods: {
    removePost: function removePost(target) {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var post = _step.value;

          if (post !== target) {
            result.push(post);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.posts = result;
    }
  },
  data: function data() {
    return {
      posts: this.initialPosts
    };
  }
});

/***/ }),

/***/ "h+W8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "h/wX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("LWtl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adbd895_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("x50E");
function injectStyle (ssrContext) {
  __webpack_require__("Av+w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6adbd895"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adbd895_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "h8Ez":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h93A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hELG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hEwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-secondary-warning btn-micro",staticStyle:{"text-transform":"none","color":"#e34a4a"},on:{"click":function($event){$event.preventDefault();_vm.NewProdukt($event)}}},[_c('i',{staticClass:"fa fa-user",staticStyle:{"font-size":"16px"}}),_vm._v("\n    "+_vm._s(' Novi produkt')+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hF3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__ = __webpack_require__("B+20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-date-picker',
  components: {
    VueFlatpickrComponent: __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default.a
  },
  props: {
    value: {
      required: true
    },
    config: {
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    valueProxy: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    fullConfig: function fullConfig() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultConfig, this.config);
    },
    defaultConfig: function defaultConfig() {
      return {
        nextArrow: '<span aria-hidden="true" class="ion ion-ios-arrow-forward"></span>',
        prevArrow: '<span aria-hidden="true" class="ion ion-ios-arrow-back"></span>'
      };
    }
  }
});

/***/ }),

/***/ "hF5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__ = __webpack_require__("8yMI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b79538c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__ = __webpack_require__("FJtU");
function injectStyle (ssrContext) {
  __webpack_require__("9LJy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b79538c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hLur":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hb4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-exclamation",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "hb8G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hbbw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hwPc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i/0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("MEVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2a6dd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("nnXA");
function injectStyle (ssrContext) {
  __webpack_require__("lEqn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2a6dd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i1PP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientEdit_vue__ = __webpack_require__("Oviz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bec8762e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientEdit_vue__ = __webpack_require__("Pn5t");
function injectStyle (ssrContext) {
  __webpack_require__("WqZV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bec8762e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i50y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__ = __webpack_require__("UK0m");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-file-upload-list-item",
  components: {
    VuesticFileUploadUndo: __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__["default"]
  },
  props: {
    file: {
      type: Object
    }
  },
  data: function data() {
    return {
      removed: false
    };
  },

  methods: {
    showFilePreview: function showFilePreview() {},
    removeFile: function removeFile() {
      var _this = this;

      this.removed = true;
      setTimeout(function () {
        if (_this.removed) {
          _this.$emit("remove");
          _this.removed = false;
        }
      }, 2000);
    },
    recoverFile: function recoverFile() {
      this.removed = false;
    }
  }
});

/***/ }),

/***/ "iCmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_local_data__ = __webpack_require__("prz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_data_table_styles__ = __webpack_require__("MHMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datatable_components_FilterBar_vue__ = __webpack_require__("V/fp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datatable_components_NoviProdukt_vue__ = __webpack_require__("Xc0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_main_js__ = __webpack_require__("NHnr");













var originalData = __WEBPACK_IMPORTED_MODULE_3__data_local_data__["a" /* default */].data;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("novi-produkt", __WEBPACK_IMPORTED_MODULE_6__datatable_components_NoviProdukt_vue__["default"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "produkt-table",

  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_5__datatable_components_FilterBar_vue__["default"],
    NewProdukt: __WEBPACK_IMPORTED_MODULE_6__datatable_components_NoviProdukt_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__["a" /* default */]
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      tableData: __WEBPACK_IMPORTED_MODULE_3__data_local_data__["a" /* default */],
      perPage: "",
      brStr: 10,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_4__data_data_table_styles__["a" /* default */],
      pacijent: {},
      show: true,
      potvrdi: "SAČUVAJ",
      odustani: "ZATVORI",
      patient_data: {},

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.onFilterSet(this.$store.state.filter);
    __WEBPACK_IMPORTED_MODULE_9__src_main_js__["bus"].$on("Set", function (data) {
      _this.onFilterSet(data.ime + " " + data.prezime);
    });
    __WEBPACK_IMPORTED_MODULE_9__src_main_js__["bus"].$on("novi-produkt", function (data) {
      _this.$refs.largeModalProdukt.open();
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_9__src_main_js__["bus"].$off("Set");
    __WEBPACK_IMPORTED_MODULE_9__src_main_js__["bus"].$off("novi-produkt");
  },

  watch: {},
  methods: {
    unosProdukta: function unosProdukta() {},

    prikaziDetalje: function prikaziDetalje(args) {
      var niz = args[0];

      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "detalji") {
          this.pacijent = niz[0].id;
          this.Patient();
        }
        if (niz[1].name === "prijem") {
          __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push("/samples/" + args[0][0].id);
        }
        if (niz[1].name === "icon") {
          if (this.$store.state.access.level < 1) {
            __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push("/evaluation/" + args[0][0].id);
          }
        }
      }
    },
    Patient: function Patient() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_8__config_config_js__["C" /* http */].get("pacijenti/detalji/" + this.pacijent + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        if (res.data.pacijent.jmbg != undefined) {
          _this2.patient_data = res.data.pacijent;
          _this2.$refs.modalProduktEdit.open();
        }
      });
    },
    onFilterSet: function onFilterSet(filterText, event) {
      var _this3 = this;

      this.filterString = "";

      this.filterString = filterText;

      if (event != undefined && filterText.trim() != '') {

        if (this.apiMode) {
          this.moreParams = {
            filter: filterText
          };
        } else {
          var txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function (item) {
            return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
          });
        }

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
          return _this3.$refs.vuetable.refresh();
        });
      } else {

        if (this.apiMode) {
          this.moreParams = {
            filter: filterText
          };
        } else {
          var _txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function (item) {
            return item.name.search(_txt) >= 0 || item.email.search(_txt) >= 0;
          });
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
          return _this3.$refs.vuetable.refresh();
        });
      }
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "iE2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle progress-bar",style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"overlay",style:('background-color: ' + _vm.backgroundColor + '; color: ' + _vm.color)},[_c('span',[_vm._v(_vm._s(_vm.animatedValue+'%'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iKIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-viber-service",
  props: {
    viberData: {
      type: Object,
      default: function _default() {
        return {
          timestamp: "",
          uzorak: "",
          telefon: "",
          valid: false,
          protokol: "",
          ime: "",
          prezime: "",
          godiste: "",
          spol: ""
        };
      }
    },
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      isLoading: false,
      fullPage: true,

      ba: true,
      en: true,
      de: true
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    Test: function Test() {
      var _this = this;

      this.isLoading = true;

      setTimeout(function () {
        _this.isLoading = false;
      }, 2000);
    },
    onCancel: function onCancel() {},
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      var _this2 = this;

      this.$emit("ok");

      this.isLoading = true;


      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["C" /* http */].post("nalazi/viber/service", {
        token: this.$store.state.token,
        site: this.$store.state.site,
        viberData: this.viberData,
        jezici: {
          ba: this.ba,
          en: this.en,
          de: this.de
        }
      }).then(function (res) {

        _this2.show = false;
        _this2.isLoading = false;
        window.removeEventListener("keyup", _this2.listenKeyUp);

        if (res.data.success) {} else {}
      });
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      this.isLoading = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.ba = true;
      this.en = true;
      this.de = true;
      this.show = true;

      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "iLsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__ = __webpack_require__("GI4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4b0f8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__ = __webpack_require__("4JfL");
function injectStyle (ssrContext) {
  __webpack_require__("Iai+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b4b0f8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4b0f8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iMRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadList_vue__ = __webpack_require__("FriM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e22148_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadList_vue__ = __webpack_require__("zNF9");
function injectStyle (ssrContext) {
  __webpack_require__("gqwV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e22148_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iRd/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iXN+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadList__ = __webpack_require__("iMRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadContainer__ = __webpack_require__("y/NP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-excel-file-upload",
  components: {
    VuesticFileUploadList: __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadList__["default"],
    VuesticFileUploadContainer: __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadContainer__["default"]
  },
  props: {
    type: {
      type: String,
      default: "list",
      validator: function validator(value) {
        return ["list", "gallery", "single"].indexOf(value) !== -1;
      }
    },
    fileTypes: {
      type: String,
      default: ""
    },
    dropzone: {
      type: Boolean,
      default: false
    },
    value: {
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    uploadFile: function uploadFile(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (this.fileTypes) {
        files = this.validateFileTypes(files);
      }
      this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files));

      __WEBPACK_IMPORTED_MODULE_4__main__["bus"].$emit("Excel", e);
    },
    removeFile: function removeFile(index) {
      this.files.splice(index, 1);
    },
    removeSingleFile: function removeSingleFile() {
      this.files = [];
    },
    validateFileTypes: function validateFileTypes(files) {
      var _this = this;

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)).filter(function (file) {
        var fileName = file.name;
        var extn = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
        if (_this.fileTypes.indexOf(extn) === -1) {
          _this.$refs.mediumModal.open();
        }
        return _this.fileTypes.indexOf(extn) !== -1;
      });
    }
  },
  computed: {
    files: {
      get: function get() {
        return this.value;
      },
      set: function set(files) {
        this.$emit("input", files);
      }
    }
  }
});

/***/ }),

/***/ "iZBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: String
    },
    range_max: {
      type: String,
      default: ""
    },
    range_min: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("setItemsPerPage", function (data) {

      var current = _this.$router.currentRoute.path;
      if (current.includes("obrada/pregled")) {
        _this.selectedItemsPerPage("RADNA LISTA");
      } else {
        _this.selectedItemsPerPage("DANAS");
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("setItemsPerPage");
  },

  watch: {
    range_min: function range_min() {
      if (this.range_min != "") {
        this.selected = "Svi Rezultati";
      }
    }
  },
  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("selectedItemsPerPage");
      this.selected = optionValue;
      this.$emit("items-per-page", this.selected);
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("ItemsPerPage", optionValue);
    }
  }
});

/***/ }),

/***/ "if6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-aparati",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "inpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__ = __webpack_require__("gVv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");


var _name$components$prop;





/* harmony default export */ __webpack_exports__["a"] = (_name$components$prop = {
  name: "json-edit-frizider",
  components: {
    vueJsonEditor: __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__["a" /* default */]
  },
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      jsonData: {},
      tab: "",
      obj: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$on("JsonEditFriziderOpen", function (data) {
      _this.jsonData = data;
      _this.obj = data;
      _this.show = true;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$off("JsonEditFriziderOpen");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "methods", {
  onJsonChange: function onJsonChange(value) {
    this.obj = value;
  },
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    this.FriziderEdit();
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  FriziderEdit: function FriziderEdit() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("loger/frizider/edit", {
      element: this.obj,
      token: this.$store.state.token,
      site: this.$store.state.site
    }).then(function (res) {
      if (res.data.success) {
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("FriziderRefresh");
        _this2.show = false;
      } else {}
    });
  }
}), _name$components$prop);

/***/ }),

/***/ "ip1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalResultsMulti_vue__ = __webpack_require__("Y1LF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52061a32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalResultsMulti_vue__ = __webpack_require__("Fp4S");
function injectStyle (ssrContext) {
  __webpack_require__("XS62")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalResultsMulti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52061a32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalResultsMulti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "itpM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadSingleItem_vue__ = __webpack_require__("9iQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0d74b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadSingleItem_vue__ = __webpack_require__("YDnd");
function injectStyle (ssrContext) {
  __webpack_require__("fMGo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadSingleItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0d74b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadSingleItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iuWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__ = __webpack_require__("OBvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74e7e5bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__ = __webpack_require__("XzQr");
function injectStyle (ssrContext) {
  __webpack_require__("w4zc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74e7e5bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JsonEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74e7e5bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JsonEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ixkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: Number
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },

  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      this.selected = optionValue;
      this.$emit('items-per-page', this.selected);
    }
  }
});

/***/ }),

/***/ "izwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-control-aparati",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;
      this.show = false;
    },
    emitHeader: function emitHeader(event) {},
    onHeaderClick: function onHeaderClick() {},
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "j2gj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"input-group"},[_c('vuestic-date-picker',{staticStyle:{"min-width":"18rem"},attrs:{"id":"date-picker-range","config":_vm.config},on:{"on-change":_vm.doSomethingOnChangeDateRange},model:{value:(_vm.datepicker.range),callback:function ($$v) {_vm.$set(_vm.datepicker, "range", $$v)},expression:"datepicker.range"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-calendar icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range"}},[_vm._v(_vm._s('Unesite opseg datuma'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j5pT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('table',{staticStyle:{"padding-top":"5px"}},[_c('tbody',_vm._l((_vm.participants),function(user){return _c('tr',{key:user.id},[_c('td',{staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"img-msg",attrs:{"src":user.imageUrl}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j8Lc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jDO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalReference_vue__ = __webpack_require__("Xl7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2661e4f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalReference_vue__ = __webpack_require__("aICY");
function injectStyle (ssrContext) {
  __webpack_require__("u2aT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalReference_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2661e4f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalReference_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jEUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("VVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6138f1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("OEXx");
function injectStyle (ssrContext) {
  __webpack_require__("zdfR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6138f1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jMFg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZUa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jgNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 200,
    'per_page': 50,
    'current_page': 1,
    'last_page': 4,
    'next_page_url': 'https://vuetable.ratiw.net/api/users?per_page=50&page=2',
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }, {
    'id': 2,
    'name': 'Mr. Enid Von PhD',
    'nickname': 'alias',
    'email': 'pollich.cecilia@example.com',
    'birthdate': '1990-09-18 00:00:00',
    'gender': 'M',
    'salary': '35978.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 2,
      'user_id': 2,
      'line1': '59732 Iva Spur Suite 468\nEast Hortenseton, VA 70087',
      'line2': 'Cayman Islands',
      'zipcode': '41967',
      'mobile': '1-913-407-7558x503',
      'fax': '(388)906-8002'
    }
  }, {
    'id': 3,
    'name': 'Colton Koch',
    'nickname': 'id',
    'email': 'little.myrna@example.net',
    'birthdate': '1968-10-29 00:00:00',
    'gender': 'F',
    'salary': '26278.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 3,
      'user_id': 3,
      'line1': '539 Conn Locks Suite 801\nTobinfort, IL 37047-5508',
      'line2': 'Antigua and Barbuda',
      'zipcode': '51722-4502',
      'mobile': '557.845.1830x844',
      'fax': '1-831-304-7444x73027'
    }
  }, {
    'id': 4,
    'name': 'Gregory Vandervort',
    'nickname': 'vel',
    'email': 'dock47@example.org',
    'birthdate': '1989-12-12 00:00:00',
    'gender': 'M',
    'salary': '25537.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 4,
      'user_id': 4,
      'line1': '916 Rosemary Forge\nKreigerton, MT 24207',
      'line2': 'Uganda',
      'zipcode': '67639-6707',
      'mobile': '766.431.9121',
      'fax': '(154)336-3674x08451'
    }
  }, {
    'id': 5,
    'name': 'Miss Rahsaan Heaney IV',
    'nickname': 'qui',
    'email': 'ugrady@example.org',
    'birthdate': '1995-11-27 00:00:00',
    'gender': 'F',
    'salary': '49003.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 21,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 5,
      'user_id': 5,
      'line1': '91792 Kertzmann Prairie Apt. 376\nLake Nakiaville, DC 98189',
      'line2': 'Jamaica',
      'zipcode': '10101-1450',
      'mobile': '07507519787',
      'fax': '+24(9)5120507985'
    }
  }, {
    'id': 6,
    'name': 'Ms. Crystel Zemlak IV',
    'nickname': 'reiciendis',
    'email': 'amari.rau@example.com',
    'birthdate': '1968-09-12 00:00:00',
    'gender': 'F',
    'salary': '12383.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 6,
      'user_id': 6,
      'line1': '97650 Scot Haven Apt. 160\nCrawfordmouth, ME 39767-7003',
      'line2': 'Finland',
      'zipcode': '88917',
      'mobile': '1-851-069-9234x9566',
      'fax': '(048)445-4691x33356'
    }
  }, {
    'id': 7,
    'name': 'Nona McDermott',
    'nickname': 'quaerat',
    'email': 'adrien.baumbach@example.org',
    'birthdate': '1985-10-01 00:00:00',
    'gender': 'F',
    'salary': '18512.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 31,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 7,
      'user_id': 7,
      'line1': '4332 Alvina Radial\nPort Darbyville, IA 63357',
      'line2': 'Barbados',
      'zipcode': '79679',
      'mobile': '(736)058-1324',
      'fax': '002.234.8466x49816'
    }
  }, {
    'id': 8,
    'name': 'Miss Genoveva Murazik V',
    'nickname': 'rerum',
    'email': 'ohettinger@example.net',
    'birthdate': '1988-10-19 00:00:00',
    'gender': 'F',
    'salary': '31209.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 28,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 8,
      'user_id': 8,
      'line1': '96418 Ritchie Mall Apt. 215\nLake Jessyca, VT 65970-8256',
      'line2': 'Netherlands Antilles',
      'zipcode': '94649-6628',
      'mobile': '472.825.7183',
      'fax': '400-507-7463'
    }
  }, {
    'id': 9,
    'name': 'Beulah Huels',
    'nickname': 'non',
    'email': 'stefan99@example.com',
    'birthdate': '1963-09-04 00:00:00',
    'gender': 'F',
    'salary': '36920.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 9,
      'user_id': 9,
      'line1': '18890 Carroll Lakes Suite 355\nUptonchester, UT 94878-0739',
      'line2': 'Hong Kong',
      'zipcode': '91204',
      'mobile': '831.652.0832',
      'fax': '(688)788-8947'
    }
  }, {
    'id': 10,
    'name': 'Zoe Klein',
    'nickname': 'ex',
    'email': 'ejacobson@example.org',
    'birthdate': '1990-04-19 00:00:00',
    'gender': 'F',
    'salary': '35616.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 10,
      'user_id': 10,
      'line1': '6721 Nader Summit\nLake Alana, MS 84476',
      'line2': 'Reunion',
      'zipcode': '77124-1459',
      'mobile': '1-129-438-6148',
      'fax': '(913)441-3846'
    }
  }, {
    'id': 11,
    'name': 'Vickie Kiehn',
    'nickname': 'assumenda',
    'email': 'ayost@example.com',
    'birthdate': '1988-04-20 00:00:00',
    'gender': 'F',
    'salary': '30790.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 11,
      'user_id': 11,
      'line1': '763 McCullough Ville\nNew Thomasstad, HI 64611',
      'line2': 'Oman',
      'zipcode': '00642',
      'mobile': '1-296-172-2126x275',
      'fax': '(559)203-8694'
    }
  }, {
    'id': 12,
    'name': 'Elwyn Herzog',
    'nickname': 'praesentium',
    'email': 'ckassulke@example.net',
    'birthdate': '1990-01-22 00:00:00',
    'gender': 'M',
    'salary': '35785.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 12,
      'user_id': 12,
      'line1': '65641 Baron Spurs Suite 988\nNorth Ivah, IA 92235',
      'line2': 'Nepal',
      'zipcode': '90316-7411',
      'mobile': '064.482.9432x9456',
      'fax': '05936098280'
    }
  }, {
    'id': 13,
    'name': 'Selena Hettinger',
    'nickname': 'et',
    'email': 'bashirian.hyman@example.net',
    'birthdate': '1981-10-01 00:00:00',
    'gender': 'F',
    'salary': '31836.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 13,
      'user_id': 13,
      'line1': '42272 Stoltenberg Points Suite 006\nLake Dustin, NH 70213-2043',
      'line2': 'Uganda',
      'zipcode': '60996-2982',
      'mobile': '(508)122-5892',
      'fax': '356-682-2023x07379'
    }
  }, {
    'id': 14,
    'name': 'Edwin Beier',
    'nickname': 'eos',
    'email': 'janis71@example.org',
    'birthdate': '1978-10-13 00:00:00',
    'gender': 'M',
    'salary': '11902.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 14,
      'user_id': 14,
      'line1': '362 Trantow Loop Apt. 150\nLake Marafurt, DC 27926',
      'line2': 'Gabon',
      'zipcode': '36943-1099',
      'mobile': '033-386-4972x26066',
      'fax': '1-363-037-1381'
    }
  }, {
    'id': 15,
    'name': 'Lexi Braun MD',
    'nickname': 'autem',
    'email': 'dusty74@example.net',
    'birthdate': '1971-12-07 00:00:00',
    'gender': 'F',
    'salary': '11927.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 45,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 15,
      'user_id': 15,
      'line1': '6737 Schimmel Crossing Suite 720\nShieldsberg, AK 44558',
      'line2': 'Tanzania',
      'zipcode': '75615',
      'mobile': '338.920.3112',
      'fax': '(467)912-6668'
    }
  }, {
    'id': 16,
    'name': 'Jovany Spencer',
    'nickname': 'fugit',
    'email': 'gbogisich@example.org',
    'birthdate': '1974-04-23 00:00:00',
    'gender': 'F',
    'salary': '44686.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 16,
      'user_id': 16,
      'line1': '97237 Emory Mission\nWelchview, DE 65827-8746',
      'line2': 'Turkmenistan',
      'zipcode': '17948',
      'mobile': '(163)991-1609x963',
      'fax': '104.893.7648'
    }
  }, {
    'id': 17,
    'name': 'Prof. Maci Anderson DVM',
    'nickname': 'dolorem',
    'email': 'btorp@example.com',
    'birthdate': '1988-03-30 00:00:00',
    'gender': 'M',
    'salary': '25055.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 17,
      'user_id': 17,
      'line1': '7584 Lucinda Mill\nNew Kaitlyn, WV 63380-4289',
      'line2': 'Gibraltar',
      'zipcode': '51150-2800',
      'mobile': '(977)115-7349',
      'fax': '652-788-4860x1180'
    }
  }, {
    'id': 18,
    'name': 'Joel Kulas MD',
    'nickname': 'sed',
    'email': 'phoebe.sauer@example.org',
    'birthdate': '1992-10-26 00:00:00',
    'gender': 'F',
    'salary': '11650.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 18,
      'user_id': 18,
      'line1': '992 Williamson Passage Apt. 910\nBradleyborough, MO 93100-9439',
      'line2': 'Cambodia',
      'zipcode': '20591-3066',
      'mobile': '+64(7)3402369877',
      'fax': '08960801902'
    }
  }, {
    'id': 19,
    'name': 'Mr. Dawson Greenholt',
    'nickname': 'nostrum',
    'email': 'asawayn@example.org',
    'birthdate': '1963-08-23 00:00:00',
    'gender': 'F',
    'salary': '46962.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 19,
      'user_id': 19,
      'line1': '8444 Abraham Isle\nEast Chaunceychester, HI 78625-4417',
      'line2': 'Qatar',
      'zipcode': '47870-8012',
      'mobile': '797-274-3187x45557',
      'fax': '(461)432-8205'
    }
  }, {
    'id': 20,
    'name': 'Prof. Lloyd Green',
    'nickname': 'velit',
    'email': 'laila.hintz@example.org',
    'birthdate': '1970-10-31 00:00:00',
    'gender': 'M',
    'salary': '12928.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 20,
      'user_id': 20,
      'line1': '89766 O\'Connell Falls\nSouth Kadenshire, NJ 78754-6650',
      'line2': 'Nigeria',
      'zipcode': '37859',
      'mobile': '1-457-536-1138',
      'fax': '+98(5)0101745942'
    }
  }, {
    'id': 21,
    'name': 'Shayna Morar',
    'nickname': 'rerum',
    'email': 'wfay@example.org',
    'birthdate': '1991-01-24 00:00:00',
    'gender': 'F',
    'salary': '22638.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 21,
      'user_id': 21,
      'line1': '6066 Weissnat Run Apt. 578\nMurazikmouth, SD 62877-3174',
      'line2': 'Brunei Darussalam',
      'zipcode': '69261',
      'mobile': '(487)423-0151x5127',
      'fax': '784-058-9197'
    }
  }, {
    'id': 22,
    'name': 'Krista Schulist',
    'nickname': 'qui',
    'email': 'gregoria.jakubowski@example.com',
    'birthdate': '1974-08-16 00:00:00',
    'gender': 'F',
    'salary': '49345.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 22,
      'user_id': 22,
      'line1': '331 Gerlach Course Suite 090\nKovacekchester, RI 18017',
      'line2': 'Sri Lanka',
      'zipcode': '37165',
      'mobile': '653-487-3061x91119',
      'fax': '370-709-1750'
    }
  }, {
    'id': 23,
    'name': 'Leone Lemke',
    'nickname': 'repellat',
    'email': 'ltorphy@example.com',
    'birthdate': '1975-06-27 00:00:00',
    'gender': 'M',
    'salary': '17560.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 23,
      'user_id': 23,
      'line1': '4371 Ward Village Suite 848\nLake Madalynton, IN 44643',
      'line2': 'Ukraine',
      'zipcode': '71848',
      'mobile': '174-502-0881x50649',
      'fax': '02683328099'
    }
  }, {
    'id': 24,
    'name': 'Dr. Willie Kemmer II',
    'nickname': 'quasi',
    'email': 'ivy51@example.net',
    'birthdate': '1987-04-06 00:00:00',
    'gender': 'F',
    'salary': '35370.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 30,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 24,
      'user_id': 24,
      'line1': '235 Hassie Mountain\nAnikaborough, ID 20678-4354',
      'line2': 'Thailand',
      'zipcode': '94264-9132',
      'mobile': '624.042.8382x12243',
      'fax': '274.716.7226x171'
    }
  }, {
    'id': 25,
    'name': 'Deonte Lebsack',
    'nickname': 'nesciunt',
    'email': 'alisa83@example.net',
    'birthdate': '1993-01-26 00:00:00',
    'gender': 'M',
    'salary': '32725.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 25,
      'user_id': 25,
      'line1': '793 Lakin Haven\nLake Citlalliborough, DE 85031-4862',
      'line2': 'Chad',
      'zipcode': '52396-8822',
      'mobile': '(950)170-8013',
      'fax': '119.675.5485x79062'
    }
  }, {
    'id': 26,
    'name': 'Prof. Shayne Nader',
    'nickname': 'voluptas',
    'email': 'bosco.shaina@example.net',
    'birthdate': '1993-10-26 00:00:00',
    'gender': 'F',
    'salary': '9844.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 23,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 26,
      'user_id': 26,
      'line1': '0330 Smith Mountains\nLorinetown, NY 96547-9723',
      'line2': 'Syrian Arab Republic',
      'zipcode': '85415',
      'mobile': '1-212-704-6685',
      'fax': '516-893-8515'
    }
  }, {
    'id': 27,
    'name': 'Prof. Kennith Kertzmann',
    'nickname': 'alias',
    'email': 'satterfield.jonathan@example.com',
    'birthdate': '1992-01-31 00:00:00',
    'gender': 'F',
    'salary': '41950.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 27,
      'user_id': 27,
      'line1': '901 Hauck Extensions\nKeaganborough, VA 47392',
      'line2': 'Comoros',
      'zipcode': '54147-7615',
      'mobile': '1-274-179-2031x915',
      'fax': '867-583-0812x6728'
    }
  }, {
    'id': 28,
    'name': 'Miss Meagan O\'Keefe',
    'nickname': 'corporis',
    'email': 'tracy.barrows@example.com',
    'birthdate': '1967-05-04 00:00:00',
    'gender': 'M',
    'salary': '41803.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 28,
      'user_id': 28,
      'line1': '29077 Avis Isle Apt. 208\nGrahamberg, MI 62485-6694',
      'line2': 'Cocos (Keeling) Islands',
      'zipcode': '56090-7671',
      'mobile': '(718)856-9319x55184',
      'fax': '(777)055-4685x56167'
    }
  }, {
    'id': 29,
    'name': 'Prof. Edward Pagac MD',
    'nickname': 'quia',
    'email': 'gerhard65@example.org',
    'birthdate': '1973-09-22 00:00:00',
    'gender': 'F',
    'salary': '22896.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 29,
      'user_id': 29,
      'line1': '697 Crona Mall\nPeteville, WA 54497',
      'line2': 'Saudi Arabia',
      'zipcode': '07560-8569',
      'mobile': '788-579-8208',
      'fax': '041-521-9215'
    }
  }, {
    'id': 30,
    'name': 'Samantha Weissnat',
    'nickname': 'est',
    'email': 'crystel66@example.net',
    'birthdate': '1974-07-11 00:00:00',
    'gender': 'M',
    'salary': '18805.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 30,
      'user_id': 30,
      'line1': '79984 Deckow Run\nEast Victoria, UT 33736',
      'line2': 'Lithuania',
      'zipcode': '95964-8864',
      'mobile': '681.200.3099',
      'fax': '(567)652-4322x61475'
    }
  }, {
    'id': 31,
    'name': 'Dr. Gilbert Ward',
    'nickname': 'dolorum',
    'email': 'sandrine06@example.net',
    'birthdate': '1984-08-22 00:00:00',
    'gender': 'F',
    'salary': '16644.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 32,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 31,
      'user_id': 31,
      'line1': '996 Schuppe Glen\nTurcottetown, ID 40821-7190',
      'line2': 'Thailand',
      'zipcode': '09965-7576',
      'mobile': '1-938-263-0257x47178',
      'fax': '1-997-727-3198x4363'
    }
  }, {
    'id': 32,
    'name': 'Mike West',
    'nickname': 'laudantium',
    'email': 'jborer@example.net',
    'birthdate': '1974-11-07 00:00:00',
    'gender': 'M',
    'salary': '35728.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 32,
      'user_id': 32,
      'line1': '69942 Leannon Glen\nEast Mathilde, IL 89584-5633',
      'line2': 'Afghanistan',
      'zipcode': '02041-8706',
      'mobile': '(506)349-9443x7244',
      'fax': '1-357-689-8479x3729'
    }
  }, {
    'id': 33,
    'name': 'Prof. Isabell Cruickshank I',
    'nickname': 'recusandae',
    'email': 'ondricka.lurline@example.org',
    'birthdate': '1982-06-15 00:00:00',
    'gender': 'F',
    'salary': '44574.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 33,
      'user_id': 33,
      'line1': '875 Logan Summit Suite 033\nJerodport, NY 45166',
      'line2': 'Kiribati',
      'zipcode': '64763',
      'mobile': '1-548-943-8405x460',
      'fax': '+88(4)9493664736'
    }
  }, {
    'id': 34,
    'name': 'Prof. Lonny Rath',
    'nickname': 'nihil',
    'email': 'rfeest@example.net',
    'birthdate': '1969-04-23 00:00:00',
    'gender': 'F',
    'salary': '19949.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 34,
      'user_id': 34,
      'line1': '43006 Gaylord Drives\nCummerataville, MA 14032-6378',
      'line2': 'Georgia',
      'zipcode': '88459',
      'mobile': '(877)526-6771',
      'fax': '(724)630-5418'
    }
  }, {
    'id': 35,
    'name': 'Santina Medhurst MD',
    'nickname': 'suscipit',
    'email': 'ila24@example.net',
    'birthdate': '1965-11-04 00:00:00',
    'gender': 'F',
    'salary': '36323.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 51,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 35,
      'user_id': 35,
      'line1': '47345 Imelda Mission Suite 257\nAllyshire, IA 85430-2783',
      'line2': 'Gambia',
      'zipcode': '26853',
      'mobile': '(441)229-8922',
      'fax': '(789)908-0620x15912'
    }
  }, {
    'id': 36,
    'name': 'Jeff Lehner',
    'nickname': 'quo',
    'email': 'jarred77@example.com',
    'birthdate': '1975-05-18 00:00:00',
    'gender': 'F',
    'salary': '48462.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 36,
      'user_id': 36,
      'line1': '49133 Tremaine Cape Suite 189\nQuitzonview, SC 07967-6920',
      'line2': 'Serbia',
      'zipcode': '96642',
      'mobile': '313.254.8635x06428',
      'fax': '194.681.7297x74202'
    }
  }, {
    'id': 37,
    'name': 'Samanta Pfeffer',
    'nickname': 'officia',
    'email': 'fgoyette@example.net',
    'birthdate': '1974-08-27 00:00:00',
    'gender': 'F',
    'salary': '19601.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 37,
      'user_id': 37,
      'line1': '1313 Verdie Square\nNorth Giovanna, MI 27962',
      'line2': 'Guyana',
      'zipcode': '77776',
      'mobile': '(321)705-8910',
      'fax': '(392)460-5663x665'
    }
  }, {
    'id': 38,
    'name': 'Ofelia Torp',
    'nickname': 'a',
    'email': 'ericka44@example.net',
    'birthdate': '1981-09-01 00:00:00',
    'gender': 'M',
    'salary': '33149.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 38,
      'user_id': 38,
      'line1': '45335 Albina View\nCharlottefort, AK 57789',
      'line2': 'Afghanistan',
      'zipcode': '54947-9310',
      'mobile': '09097085723',
      'fax': '1-567-446-3094'
    }
  }, {
    'id': 39,
    'name': 'Mrs. Margarete Raynor',
    'nickname': 'quia',
    'email': 'jlegros@example.net',
    'birthdate': '1977-03-12 00:00:00',
    'gender': 'M',
    'salary': '21951.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 40,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 39,
      'user_id': 39,
      'line1': '288 Hamill Knolls\nMaximoburgh, NC 50971',
      'line2': 'Zimbabwe',
      'zipcode': '00474',
      'mobile': '1-165-445-8956x699',
      'fax': '164-395-7526x1304'
    }
  }, {
    'id': 40,
    'name': 'Mr. Brant Howell V',
    'nickname': 'perspiciatis',
    'email': 'franecki.gerald@example.org',
    'birthdate': '1964-03-01 00:00:00',
    'gender': 'M',
    'salary': '41552.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 40,
      'user_id': 40,
      'line1': '3411 Deckow Crossing\nVernonport, MI 32272-8542',
      'line2': 'Bolivia',
      'zipcode': '00960',
      'mobile': '(998)729-9537',
      'fax': '(606)461-9736'
    }
  }, {
    'id': 41,
    'name': 'Reilly Ruecker DVM',
    'nickname': 'ad',
    'email': 'ldeckow@example.net',
    'birthdate': '1975-07-17 00:00:00',
    'gender': 'M',
    'salary': '22709.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 41,
      'user_id': 41,
      'line1': '39181 Runolfsson Pines Apt. 102\nCedrickchester, MD 73430-4755',
      'line2': 'Haiti',
      'zipcode': '08208-7956',
      'mobile': '625-483-9111x773',
      'fax': '196-367-9338'
    }
  }, {
    'id': 42,
    'name': 'Zachery McDermott',
    'nickname': 'molestiae',
    'email': 'gladyce84@example.com',
    'birthdate': '1992-04-17 00:00:00',
    'gender': 'F',
    'salary': '32354.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 42,
      'user_id': 42,
      'line1': '18735 Quigley Springs\nCarterview, NE 29126-7625',
      'line2': 'Chad',
      'zipcode': '61676-5075',
      'mobile': '172.676.4844x42744',
      'fax': '129.383.7365x233'
    }
  }, {
    'id': 43,
    'name': 'Heloise Kulas',
    'nickname': 'aut',
    'email': 'kessler.helen@example.net',
    'birthdate': '1962-12-11 00:00:00',
    'gender': 'M',
    'salary': '45086.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 54,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 43,
      'user_id': 43,
      'line1': '38208 Dolores Turnpike Apt. 887\nWintheiserton, FL 72054-2578',
      'line2': 'Lithuania',
      'zipcode': '51634-6449',
      'mobile': '1-161-626-3235x57765',
      'fax': '360-278-9045x9316'
    }
  }, {
    'id': 44,
    'name': 'Norma Dibbert',
    'nickname': 'amet',
    'email': 'eudora36@example.net',
    'birthdate': '1971-01-21 00:00:00',
    'gender': 'F',
    'salary': '15661.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 44,
      'user_id': 44,
      'line1': '15405 Haag Haven Suite 047\nBrakusland, WV 81778',
      'line2': 'British Virgin Islands',
      'zipcode': '56087-0885',
      'mobile': '08227730599',
      'fax': '1-079-566-2337x670'
    }
  }, {
    'id': 45,
    'name': 'Immanuel Auer',
    'nickname': 'quia',
    'email': 'halvorson.theodora@example.org',
    'birthdate': '1978-06-06 00:00:00',
    'gender': 'M',
    'salary': '15862.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 45,
      'user_id': 45,
      'line1': '59888 Dare Ridge\nSouth Annamaeton, CA 94659',
      'line2': 'Mexico',
      'zipcode': '56689-3824',
      'mobile': '523.579.8757x9825',
      'fax': '688.695.5156x073'
    }
  }, {
    'id': 46,
    'name': 'Lamont Borer',
    'nickname': 'expedita',
    'email': 'trantow.neoma@example.com',
    'birthdate': '1992-06-26 00:00:00',
    'gender': 'M',
    'salary': '12544.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 46,
      'user_id': 46,
      'line1': '974 Brannon Circle Suite 674\nSchroedermouth, NM 66911',
      'line2': 'Malawi',
      'zipcode': '74027',
      'mobile': '887.196.2530x875',
      'fax': '220.398.6969'
    }
  }, {
    'id': 47,
    'name': 'Brooke Purdy',
    'nickname': 'cupiditate',
    'email': 'bhermiston@example.net',
    'birthdate': '1966-11-19 00:00:00',
    'gender': 'M',
    'salary': '14457.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 47,
      'user_id': 47,
      'line1': '916 Durgan Harbor\nWest Tonyborough, MN 08368',
      'line2': 'Serbia',
      'zipcode': '25234',
      'mobile': '(821)777-8137x4048',
      'fax': '(398)917-7496x84537'
    }
  }, {
    'id': 48,
    'name': 'Dr. Leo Dach',
    'nickname': 'et',
    'email': 'camila.ward@example.com',
    'birthdate': '1968-01-11 00:00:00',
    'gender': 'F',
    'salary': '40278.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 49,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 48,
      'user_id': 48,
      'line1': '434 Dariana Terrace\nSouth Brettbury, NC 66080-2445',
      'line2': 'Latvia',
      'zipcode': '81749-2523',
      'mobile': '1-988-628-9566x4627',
      'fax': '916.932.2071x569'
    }
  }, {
    'id': 49,
    'name': 'Krystal Langosh',
    'nickname': 'voluptatum',
    'email': 'pacocha.yesenia@example.org',
    'birthdate': '1983-02-18 00:00:00',
    'gender': 'M',
    'salary': '9305.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 49,
      'user_id': 49,
      'line1': '012 Josiane Flats Suite 650\nKatelynntown, MD 70053',
      'line2': 'Rwanda',
      'zipcode': '75946-8166',
      'mobile': '(556)620-0323x81232',
      'fax': '1-466-040-3197x6274'
    }
  }, {
    'id': 50,
    'name': 'Florence Greenfelder',
    'nickname': 'odit',
    'email': 'kenyatta.oconnell@example.com',
    'birthdate': '1978-08-20 00:00:00',
    'gender': 'F',
    'salary': '36980.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 50,
      'user_id': 50,
      'line1': '295 Donna Plaza Apt. 186\nHintzview, GA 44706',
      'line2': 'Greenland',
      'zipcode': '03127',
      'mobile': '1-044-098-3635x9446',
      'fax': '1-753-472-6796'
    }
  }]
});

/***/ }),

/***/ "jhTK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jzLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("lfQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b615788_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("Ai/i");
function injectStyle (ssrContext) {
  __webpack_require__("NXUR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b615788"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b615788_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jzbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jzuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle-1",style:(_vm.circle1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle-2",style:(_vm.circle2Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k09c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kD2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-file-upload-single-item",
  props: {
    file: {
      type: Object
    }
  }
});

/***/ }),

/***/ "kEJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__ = __webpack_require__("0Ohc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_68e26646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiIcon_vue__ = __webpack_require__("2iES");
function injectStyle (ssrContext) {
  __webpack_require__("jMFg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68e26646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_68e26646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kFeL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-samples-entry",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noHeader: Boolean,
    uzorak: {
      type: String,
      default: ""
    },
    komentar: {
      type: String,
      default: ""
    },
    vrijeme: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: []
    }
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      hitan: false
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },

    tags: function tags(newVal, oldVal) {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("headerKlik", this.uzorak);
    }
  },
  mounted: function mounted() {
    this.toggle();
    this.accordion.onChildChange(this, this.show);
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + "px";

      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    onHeaderClick: function onHeaderClick(event) {
      switch (event.target.id) {
        case "remove":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryRemove", this.uzorak);
          break;
        case "commenting":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryCommenting", this.uzorak, this.komentar);
          break;
        case "calendar":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryCalendar", this.uzorak, this.vrijeme);
          break;
        case "star-o":
          this.hitan = true;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryUrgent", this.uzorak);
          break;
        case "star":
          this.hitan = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryRemoveUrgent", this.uzorak);
          break;
        case "":
          break;
        default:
          this.toggle();
          this.accordion.onChildChange(this, this.show);
          break;
      }
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "kH5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__ = __webpack_require__("NpL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_28ae3244_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__ = __webpack_require__("knaZ");
function injectStyle (ssrContext) {
  __webpack_require__("AprI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28ae3244"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_28ae3244_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "kHgk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabAssayEditModal_vue__ = __webpack_require__("NOeY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a9fc7a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabAssayEditModal_vue__ = __webpack_require__("97fV");
function injectStyle (ssrContext) {
  __webpack_require__("FiEX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a9fc7a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabAssayEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a9fc7a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabAssayEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kIqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--emoji"},[_vm._v(_vm._s(_vm.data.emoji))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kNVQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload-container"},[_c('div',{staticClass:"vuestic-file-upload-container__field",class:{'vuestic-file-upload-container__field--dropzone': _vm.dropzone}},[(_vm.dropzone)?_c('div',{staticClass:"vuestic-file-upload-container__field__text"},[_vm._v("\n      "+_vm._s(_vm.$t('fileUpload.dragNdropFiles'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-micro",attrs:{"type":"button"}},[_vm._v("\n      "+_vm._s(_vm.$t('fileUpload.uploadFile'))+"\n    ")]),_vm._v(" "),_c('input',{ref:"fieldInput",staticClass:"vuestic-file-upload-container__field__input",attrs:{"type":"file","accept":_vm.fileTypes,"multiple":_vm.type !== 'single'},on:{"change":_vm.changeFieldValue}})]),_vm._v(" "),_c('div',{staticClass:"vuestic-file-upload-container__main"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kT3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "kUjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kXTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN')?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kdSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabAssayDelete_vue__ = __webpack_require__("0H+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18ecbae4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabAssayDelete_vue__ = __webpack_require__("xlMs");
function injectStyle (ssrContext) {
  __webpack_require__("KIUp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18ecbae4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabAssayDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18ecbae4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabAssayDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "khvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("9k8d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f810879_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("E72U");
function injectStyle (ssrContext) {
  __webpack_require__("3N/s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f810879"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f810879_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kl3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_main_js__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: Object,
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page',

          rt: 'rt',
          ag: 'ag',
          at: 'at',

          datum: 'datum',
          token: 'token',
          site: 'site'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: function _default() {
        return 10;
      }
    },
    datum: {
      type: String,
      default: function _default() {
        return '';
      }
    },

    rt: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    ag: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    at: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    token: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    site: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    initialPage: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {

        return '<br><h6 style="color: #4ae387">Nema dostupnih podataka.</h6>';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {

        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {

      if (this.tableData != null && this.tableData.length < 1) {
        __WEBPACK_IMPORTED_MODULE_1__src_main_js__["bus"].$emit('tableData', this.tableData.length);
      }

      if (this.tableData != null) {
        __WEBPACK_IMPORTED_MODULE_1__src_main_js__["bus"].$emit('noData', this.tableData.length);
      }

      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      this.apiMode = false;
      if (Array.isArray(data)) {
        this.tableData = data;
        return;
      }

      this.fireEvent('loading');

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        return title + ' ' + this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"');
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAllQueryParams();

      this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_0_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};
      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;
      params[this.queryParams.datum] = this.datum;

      params[this.queryParams.rt] = this.rt;
      params[this.queryParams.ag] = this.ag;
      params[this.queryParams.at] = this.at;

      params[this.queryParams.token] = this.token;
      params[this.queryParams.site] = this.site;

      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] == 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }

      return result;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      this.loadData();
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        console.log('data mode: array');
        this.setData(this.data);
      } else {
        this.normalizeSortOrder();
        this.setData(this.dataManager(this.sortOrder, this.makePagination()));
      }
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    }
  }
});

/***/ }),

/***/ "knaZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"semipolar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ko1K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kzXT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+bF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hollow-dots-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.dotsStyles),function(ds,index){return _c('div',{key:index,staticClass:"dot",style:(ds)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l/ha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MikrobiologijaEdit_vue__ = __webpack_require__("cbR0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a78738c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MikrobiologijaEdit_vue__ = __webpack_require__("+BQL");
function injectStyle (ssrContext) {
  __webpack_require__("u8au")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a78738c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MikrobiologijaEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a78738c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MikrobiologijaEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "l/id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateRange_vue__ = __webpack_require__("z3ES");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea9e4a78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateRange_vue__ = __webpack_require__("j2gj");
function injectStyle (ssrContext) {
  __webpack_require__("3p4r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea9e4a78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateRange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea9e4a78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateRange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "l92n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "lEqn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lGLK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lQuO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lXZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "bactery-radio-button",
  props: {
    label: String,
    value: {
      type: String,
      default: "",
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      default: undefined
    },
    brandColor: {
      type: String,
      default: "danger",
      validator: function validator(value) {
        return ["primary", "secondary", "success", "info", "warning", "danger"].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: "modelValue",
    event: "input"
  },
  mounted: function mounted() {
    if (this.checked && !this.checkState) {
      this.toggle();
    }
  },

  methods: {
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      this.$emit("input", this.checkState ? "" : this.value);
    }
  },
  computed: {
    checkState: function checkState() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    },
    additionalClasses: function additionalClasses() {
      return ["abc-radio-" + this.brandColor];
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.checkState) {
        this.toggle();
      }
    }
  }
});

/***/ }),

/***/ "laTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),

/***/ "lfQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "lhlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__ = __webpack_require__("bGbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d0898b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__ = __webpack_require__("mrOd");
function injectStyle (ssrContext) {
  __webpack_require__("ruEV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d0898b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d0898b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","C:\\apps\\node\\atom\\client"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"C:\\apps\\node\\atom\\client","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ "llqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload-list-item d-flex",class:{'file-upload-list-item--undo': _vm.removed}},[(_vm.removed)?_c('div',{staticClass:"va-row"},[_c('div',{staticClass:"flex md12"},[_c('vuestic-file-upload-undo',{on:{"recover":_vm.recoverFile}})],1)]):_c('div',{staticClass:"va-row align--center"},[_c('div',{staticClass:"file-upload-list-item__name flex xs12 lg3 ellipsis"},[_vm._v("\n      "+_vm._s(_vm.file.name)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"file-upload-list-item__size flex xs12 lg3"},[_vm._v("\n      "+_vm._s(_vm.file.size)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"file-upload-list-item__date flex xs12 lg4"},[_c('span',[_vm._v(_vm._s(_vm.$t('fileUpload.uploadedOn'))+" "+_vm._s(_vm.file.date))])]),_vm._v(" "),_c('div',{staticClass:"file-upload-list-item__button-container flex xs12 lg2"},[_c('button',{staticClass:"btn-text btn-text--primary",attrs:{"type":"button"},on:{"click":_vm.removeFile}},[_vm._v("\n        "+_vm._s(_vm.$t('fileUpload.delete'))+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lpwG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadListItem_vue__ = __webpack_require__("b6US");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02a7bc88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadListItem_vue__ = __webpack_require__("llqJ");
function injectStyle (ssrContext) {
  __webpack_require__("hLur")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02a7bc88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lwql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("cD2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a67f894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("oJAF");
function injectStyle (ssrContext) {
  __webpack_require__("YtNK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a67f894"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a67f894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "m+st":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m7ac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mC5g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emojiJs = __webpack_require__("mwJQ");

var _emojiJs2 = _interopRequireDefault(_emojiJs);

var _emojiData = __webpack_require__("VMA9");

var _emojiData2 = _interopRequireDefault(_emojiData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      emojiData: _emojiData2.default,
      emojiConvertor: new _emojiJs2.default()
    };
  },

  props: {
    onBlur: {
      type: Function,
      required: true
    },
    onEmojiPicked: {
      type: Function,
      required: true
    }
  },
  methods: {
    emojiClicked: function emojiClicked(emoji) {
      this.onEmojiPicked(emoji);
      this.$refs.domNode.blur();
    }
  },
  mounted: function mounted() {
    var elem = this.$refs.domNode;
    elem.style.opacity = 0;
    window.requestAnimationFrame(function () {
      elem.style.transition = 'opacity 350ms';
      elem.style.opacity = 1;
    });
    this.$refs.domNode.focus();
    this.emojiConvertor.init_env();
  }
};

/***/ }),

/***/ "mFVy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "reports",
  path: "/reports",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("reports/Reports"),
  meta: {
    default: false,
    title: "Izvještaji",
    class: "primary",
    show: false,
    iconClass: "vuestic-icon vuestic-icon-statistics",
    requiredAuth: true
  }
});

/***/ }),

/***/ "mLBn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mSnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-micro-bactery",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    povratak: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    },
    empty: {
      type: Boolean,
      default: false
    },
    update: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("CloseMicroBactery", function () {
      _this.show = false;
    });
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("CloseMicroBactery");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("MicroBactery");
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("CancelMicroBactery");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    Povratak: function Povratak() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PovratakMicroBactery");
    },
    Spasi: function Spasi() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("SpasiMicroBactery");
    },
    Update: function Update() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("UpdateMicroBactery");
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "mUJ2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./02_prijem/BadgeColumn.vue": [
		"FZu8",
		267
	],
	"./02_prijem/PacijentsTable.vue": [
		"o4Af"
	],
	"./02_prijem/PatientEdit.vue": [
		"i1PP"
	],
	"./02_prijem/PregledPacijenta.vue": [
		"PQ/p",
		61
	],
	"./02_prijem/datatable-components/FilterBar.vue": [
		"FqBD"
	],
	"./02_prijem/datatable-components/NewPatient.vue": [
		"fBe1"
	],
	"./02_samples/Calendar.vue": [
		"XFNM"
	],
	"./02_samples/Commenting.vue": [
		"aF9h"
	],
	"./02_samples/DrugoStanje.vue": [
		"cdlS"
	],
	"./02_samples/Patient.vue": [
		"uCDW"
	],
	"./02_samples/SamplesEntry.vue": [
		"LeGz",
		12
	],
	"./agnalazi/pregled/BadgeColumn.vue": [
		"9ExJ",
		266
	],
	"./agnalazi/pregled/VuesticModalData.vue": [
		"wb9z",
		265
	],
	"./agnalazi/pregled/VuesticModalViberService.vue": [
		"uYMx",
		264
	],
	"./agnalazi/pregled/nalaz.vue": [
		"fwmx",
		54
	],
	"./agnalazi/pregled/pregled.vue": [
		"mF03",
		53
	],
	"./agobrada/BadgeColumn.vue": [
		"/rOx",
		263
	],
	"./agobrada/Obrada.vue": [
		"3CRN",
		27
	],
	"./agobrada/components/RadioButtonBactery.vue": [
		"J1PU",
		262
	],
	"./agobrada/components/VuesticAccordionObrada.vue": [
		"kKWW",
		261
	],
	"./agobrada/components/VuesticCollapseAparati.vue": [
		"zcJ3",
		260
	],
	"./agobrada/components/VuesticCollapseNalaz.vue": [
		"Od7i",
		259
	],
	"./agobrada/components/VuesticCollapseObrada.vue": [
		"r6Ok",
		258
	],
	"./agobrada/components/VuesticCollapseUzorak.vue": [
		"M/C5",
		257
	],
	"./agobrada/components/VuesticModalAllResults.vue": [
		"RVHh",
		256
	],
	"./agobrada/components/VuesticModalAparati.vue": [
		"Tz/+",
		255
	],
	"./agobrada/components/VuesticModalComment.vue": [
		"sns9",
		254
	],
	"./agobrada/components/VuesticModalDelete.vue": [
		"LTz0",
		253
	],
	"./agobrada/components/VuesticModalEdit.vue": [
		"NQJ8",
		80
	],
	"./agobrada/components/VuesticModalError.vue": [
		"lt4c",
		252
	],
	"./agobrada/components/VuesticModalEvaluationMulti.vue": [
		"9Smm",
		251
	],
	"./agobrada/components/VuesticModalEvaluationSingle.vue": [
		"S1ri",
		250
	],
	"./agobrada/components/VuesticModalExclamation.vue": [
		"VwFJ",
		249
	],
	"./agobrada/components/VuesticModalFind.vue": [
		"V1oE",
		248
	],
	"./agobrada/components/VuesticModalHandshake.vue": [
		"ODWQ",
		247
	],
	"./agobrada/components/VuesticModalMail.vue": [
		"blzS",
		246
	],
	"./agobrada/components/VuesticModalMicroBactery.vue": [
		"Nr+m",
		245
	],
	"./agobrada/components/VuesticModalMicroReset.vue": [
		"drqu",
		244
	],
	"./agobrada/components/VuesticModalMicroResult.vue": [
		"4Zz+",
		243
	],
	"./agobrada/components/VuesticModalMulti.vue": [
		"Eg+s",
		242
	],
	"./agobrada/components/VuesticModalReference.vue": [
		"QCSw",
		241
	],
	"./agobrada/components/VuesticModalResultsMulti.vue": [
		"DN/Z",
		240
	],
	"./agobrada/components/VuesticModalUzorci.vue": [
		"8Nqd",
		239
	],
	"./agobrada/components/VuesticTabsBactery.vue": [
		"JRcf",
		238
	],
	"./agobrada/predracun.vue": [
		"OTr4",
		74
	],
	"./agobrada/table.vue": [
		"0RdJ",
		52
	],
	"./agoutbox/BadgeColumn.vue": [
		"FNCR",
		237
	],
	"./agoutbox/nalaz.vue": [
		"0lri",
		51
	],
	"./agoutbox/outbox.vue": [
		"Y4tr",
		50
	],
	"./anaassays/AnaAssayDelete.vue": [
		"67kX"
	],
	"./anaassays/AnaAssayEditModal.vue": [
		"I2KX"
	],
	"./anaassays/AnaAssayRefMulti.vue": [
		"rsSg"
	],
	"./anaassays/AnaAssayRefSingle.vue": [
		"p8Pd"
	],
	"./anaassays/Analize.vue": [
		"EJVh",
		60
	],
	"./anaassays/BadgeColumn.vue": [
		"RpZZ",
		236
	],
	"./anaassays/vuestic-datatable/VuesticDataTable.vue": [
		"27Vx"
	],
	"./anaassays/vuestic-datatable/datatable-components/FilterBar.vue": [
		"Aw6H"
	],
	"./anaassays/vuestic-datatable/datatable-components/ItemsPerPage.vue": [
		"Q+RX"
	],
	"./analize/Analize.vue": [
		"tKSd",
		13
	],
	"./analysers/Analysers.vue": [
		"+3Qv",
		235
	],
	"./analysers/JsonEdit.vue": [
		"iuWn"
	],
	"./assays/AnaAssay.vue": [
		"vOS3",
		234
	],
	"./assays/Assays.vue": [
		"NW75",
		5
	],
	"./assays/Calculated.vue": [
		"hDDw",
		233
	],
	"./assays/LabAssay.vue": [
		"Fzc7",
		232
	],
	"./assays/Panel.vue": [
		"njgj",
		231
	],
	"./assays/Specif.vue": [
		"zL4m",
		230
	],
	"./atnalazi/pregled/BadgeColumn.vue": [
		"IYtU",
		229
	],
	"./atnalazi/pregled/VuesticModalData.vue": [
		"BOvO",
		228
	],
	"./atnalazi/pregled/VuesticModalViberService.vue": [
		"zUKR",
		227
	],
	"./atnalazi/pregled/nalaz.vue": [
		"8U0A",
		49
	],
	"./atnalazi/pregled/pregled.vue": [
		"IeE2",
		48
	],
	"./atobrada/BadgeColumn.vue": [
		"1sxI",
		226
	],
	"./atobrada/Obrada.vue": [
		"x1P+",
		26
	],
	"./atobrada/components/RadioButtonBactery.vue": [
		"P5fJ",
		225
	],
	"./atobrada/components/VuesticAccordionObrada.vue": [
		"PR2L",
		224
	],
	"./atobrada/components/VuesticCollapseAparati.vue": [
		"jtB1",
		223
	],
	"./atobrada/components/VuesticCollapseNalaz.vue": [
		"D0Cf",
		222
	],
	"./atobrada/components/VuesticCollapseObrada.vue": [
		"u8vG",
		221
	],
	"./atobrada/components/VuesticCollapseUzorak.vue": [
		"w0Dt",
		220
	],
	"./atobrada/components/VuesticModalAllResults.vue": [
		"z/mY",
		219
	],
	"./atobrada/components/VuesticModalAparati.vue": [
		"bdW3",
		218
	],
	"./atobrada/components/VuesticModalComment.vue": [
		"U7Tm",
		217
	],
	"./atobrada/components/VuesticModalDelete.vue": [
		"erR6",
		216
	],
	"./atobrada/components/VuesticModalEdit.vue": [
		"oR2u",
		79
	],
	"./atobrada/components/VuesticModalError.vue": [
		"unrd",
		215
	],
	"./atobrada/components/VuesticModalEvaluationMulti.vue": [
		"0g33",
		214
	],
	"./atobrada/components/VuesticModalEvaluationSingle.vue": [
		"fNbW",
		213
	],
	"./atobrada/components/VuesticModalExclamation.vue": [
		"mavQ",
		212
	],
	"./atobrada/components/VuesticModalFind.vue": [
		"o0tD",
		211
	],
	"./atobrada/components/VuesticModalHandshake.vue": [
		"QGSX",
		210
	],
	"./atobrada/components/VuesticModalMail.vue": [
		"pfKR",
		209
	],
	"./atobrada/components/VuesticModalMicroBactery.vue": [
		"aCL1",
		208
	],
	"./atobrada/components/VuesticModalMicroReset.vue": [
		"GA03",
		207
	],
	"./atobrada/components/VuesticModalMicroResult.vue": [
		"J7H0",
		206
	],
	"./atobrada/components/VuesticModalMulti.vue": [
		"jb0p",
		205
	],
	"./atobrada/components/VuesticModalReference.vue": [
		"ApRd",
		204
	],
	"./atobrada/components/VuesticModalResultsMulti.vue": [
		"oE4H",
		203
	],
	"./atobrada/components/VuesticModalUzorci.vue": [
		"EncR",
		202
	],
	"./atobrada/components/VuesticTabsBactery.vue": [
		"ATXU",
		201
	],
	"./atobrada/predracun.vue": [
		"ts5d",
		73
	],
	"./atobrada/table.vue": [
		"wazc",
		47
	],
	"./atoutbox/BadgeColumn.vue": [
		"btFW",
		200
	],
	"./atoutbox/nalaz.vue": [
		"C2R2",
		46
	],
	"./atoutbox/outbox.vue": [
		"ZYoY",
		45
	],
	"./auth/login/Login.vue": [
		"mEJK",
		199
	],
	"./barcode/barcode.vue": [
		"9EFr",
		198
	],
	"./changelog/BadgeColumn.vue": [
		"4nEF",
		197
	],
	"./changelog/changelog.vue": [
		"KS9d",
		72
	],
	"./dashboard/Dashboard.vue": [
		"UE3e",
		196
	],
	"./evaluation/BadgeColumn.vue": [
		"Opgt",
		195
	],
	"./evaluation/Charts.vue": [
		"5MUk",
		75
	],
	"./evaluation/VuesticSimpleSelect.vue": [
		"emdL"
	],
	"./evaluation/VuesticWidget.vue": [
		"093r"
	],
	"./excel/Import.vue": [
		"uqQK",
		6
	],
	"./excel/vuestic-file-upload/VuesticFileUpload.vue": [
		"EysA"
	],
	"./excel/vuestic-file-upload/VuesticFileUploadContainer.vue": [
		"y/NP"
	],
	"./excel/vuestic-file-upload/VuesticFileUploadGalleryItem.vue": [
		"u0Ca"
	],
	"./excel/vuestic-file-upload/VuesticFileUploadList.vue": [
		"iMRR"
	],
	"./excel/vuestic-file-upload/VuesticFileUploadListItem.vue": [
		"5Bk1"
	],
	"./excel/vuestic-file-upload/VuesticFileUploadSingleItem.vue": [
		"S0HY"
	],
	"./excel/vuestic-file-upload/VuesticFileUploadUndo.vue": [
		"UK0m"
	],
	"./integracija/postavke/JsonEdit.vue": [
		"xepX",
		194
	],
	"./integracija/postavke/postavke.vue": [
		"zeEM",
		193
	],
	"./integracija/pregled/BadgeColumn.vue": [
		"YmQY",
		192
	],
	"./integracija/pregled/pregled.vue": [
		"Ep5s",
		44
	],
	"./inventar/izlaz/IzlazTable.vue": [
		"Jsi0",
		22
	],
	"./inventar/izlaz/components/BadgeColumn.vue": [
		"zTSY",
		191
	],
	"./inventar/izlaz/components/FilterBar.vue": [
		"EVqp",
		190
	],
	"./inventar/izlaz/components/ItemsPerPage.vue": [
		"peZk",
		189
	],
	"./inventar/izlaz/izlaz.vue": [
		"9bK1",
		188
	],
	"./inventar/izlaz/main.vue": [
		"pYsc",
		3
	],
	"./inventar/izlaz/pregled.vue": [
		"KfKH",
		11
	],
	"./inventar/postavke/BadgeColumn.vue": [
		"G1Kd",
		187
	],
	"./inventar/postavke/iJsonEdit.vue": [
		"7ekj",
		186
	],
	"./inventar/postavke/iRadioButton.vue": [
		"zA7v",
		185
	],
	"./inventar/postavke/ipostavkeModal.vue": [
		"Abmo",
		184
	],
	"./inventar/postavke/postavke.vue": [
		"ZDEm",
		15
	],
	"./inventar/produkti/BadgeColumn.vue": [
		"JICp",
		183
	],
	"./inventar/produkti/Produkt.vue": [
		"oxgk"
	],
	"./inventar/produkti/ProduktEdit.vue": [
		"zcgw",
		182
	],
	"./inventar/produkti/ProduktTable.vue": [
		"w5Sz"
	],
	"./inventar/produkti/datatable-components/FilterBar.vue": [
		"V/fp"
	],
	"./inventar/produkti/datatable-components/NoviProdukt.vue": [
		"Xc0m"
	],
	"./inventar/produkti/pregled.vue": [
		"1j8C",
		59
	],
	"./inventar/stanje/NarudzbenicaTable.vue": [
		"6Yia",
		21
	],
	"./inventar/stanje/StanjeTable.vue": [
		"H8yy",
		20
	],
	"./inventar/stanje/components/BadgeColumn.vue": [
		"PWXZ",
		181
	],
	"./inventar/stanje/components/FilterBar.vue": [
		"t2Uv",
		180
	],
	"./inventar/stanje/components/ItemsPerPage.vue": [
		"R5Zy",
		179
	],
	"./inventar/stanje/narudzbenica.vue": [
		"LfjR",
		178
	],
	"./inventar/stanje/narudzbenica/BadgeColumn.vue": [
		"gmKO",
		177
	],
	"./inventar/stanje/narudzbenica/FilterBar.vue": [
		"n3s2",
		176
	],
	"./inventar/stanje/narudzbenica/ItemsPerPage.vue": [
		"1WlO",
		175
	],
	"./inventar/stanje/pregled.vue": [
		"VUJT",
		9
	],
	"./inventar/stanje/preglednarudzbenica.vue": [
		"chCn",
		10
	],
	"./inventar/stanje/stanje.vue": [
		"Lh/U",
		0
	],
	"./inventar/ugovori/UgovorTable.vue": [
		"5uNU",
		19
	],
	"./inventar/ugovori/components/BadgeColumn.vue": [
		"LL6E",
		174
	],
	"./inventar/ugovori/components/FilterBar.vue": [
		"w1iQ",
		173
	],
	"./inventar/ugovori/components/ItemsPerPage.vue": [
		"plvo",
		172
	],
	"./inventar/ugovori/pregled.vue": [
		"PoKz",
		8
	],
	"./inventar/ugovori/ugovor.vue": [
		"9Q91",
		2
	],
	"./inventar/ugovori/unos.vue": [
		"c4Wi",
		171
	],
	"./inventar/ulaz/UlazTable.vue": [
		"nHBi",
		18
	],
	"./inventar/ulaz/components/BadgeColumn.vue": [
		"1fhw",
		170
	],
	"./inventar/ulaz/components/FilterBar.vue": [
		"Pq0j",
		169
	],
	"./inventar/ulaz/components/ItemsPerPage.vue": [
		"L/lf",
		168
	],
	"./inventar/ulaz/main.vue": [
		"hLGk",
		1
	],
	"./inventar/ulaz/pregled.vue": [
		"R0wK",
		7
	],
	"./inventar/ulaz/ulaz.vue": [
		"PfN8",
		167
	],
	"./kontrole/charts/main.vue": [
		"DY72",
		166
	],
	"./kontrole/definicija/Edit.vue": [
		"S/7H",
		58
	],
	"./kontrole/definicija/Multi.vue": [
		"0l7F",
		82
	],
	"./kontrole/definicija/Table/BadgeColumn.vue": [
		"WkHc",
		165
	],
	"./kontrole/definicija/Table/edit-datatable/VuesticDataTable.vue": [
		"y4Rm"
	],
	"./kontrole/definicija/Table/edit-datatable/datatable-components/FilterBar.vue": [
		"h/wX"
	],
	"./kontrole/definicija/Table/edit-datatable/datatable-components/ItemsPerPage.vue": [
		"n+XL"
	],
	"./kontrole/definicija/components/ControlDeleteModal.vue": [
		"RBqZ"
	],
	"./kontrole/definicija/components/ControlEditModal.vue": [
		"nDS2"
	],
	"./kontrole/definicija/components/ControlReferences.vue": [
		"Tea9"
	],
	"./kontrole/definicija/components/VuesticAccordionControlAparati.vue": [
		"vaSp"
	],
	"./kontrole/definicija/components/VuesticCollapseControlAparati.vue": [
		"aOf9"
	],
	"./kontrole/definicija/components/VuesticModalControlAparati.vue": [
		"PLYV"
	],
	"./kontrole/definicija/main.vue": [
		"RYYo",
		16
	],
	"./kontrole/pregled/BadgeColumn.vue": [
		"SWvW",
		164
	],
	"./kontrole/pregled/Obrada.vue": [
		"aO/P",
		57
	],
	"./kontrole/pregled/components/AccordionObrada.vue": [
		"dbhT"
	],
	"./kontrole/pregled/components/CollapseObrada.vue": [
		"nYBL"
	],
	"./kontrole/pregled/components/ModalComment.vue": [
		"OMi/"
	],
	"./kontrole/pregled/components/ModalDelete.vue": [
		"TsB5"
	],
	"./kontrole/pregled/components/ModalError.vue": [
		"+jAE"
	],
	"./kontrole/pregled/components/VuesticModalMail.vue": [
		"xq+h"
	],
	"./kontrole/pregled/components/VuesticWidget.vue": [
		"9aYE"
	],
	"./kontrole/pregled/table.vue": [
		"ugNQ",
		43
	],
	"./kontrole/unos/components/VuesticAccordion.vue": [
		"ow+/"
	],
	"./kontrole/unos/components/VuesticCollapse.vue": [
		"7CmO"
	],
	"./kontrole/unos/main.vue": [
		"3hHZ",
		81
	],
	"./labassays/BadgeColumn.vue": [
		"eeaT",
		163
	],
	"./labassays/JsonEdit.vue": [
		"8E1A"
	],
	"./labassays/LabAssayDelete.vue": [
		"kdSQ"
	],
	"./labassays/LabAssayEditModal.vue": [
		"kHgk"
	],
	"./labassays/LabAssays.vue": [
		"xd2h",
		56
	],
	"./labassays/MultiModal.vue": [
		"NA/e"
	],
	"./labassays/vuestic-datatable/VuesticDataTable.vue": [
		"SsKA"
	],
	"./labassays/vuestic-datatable/datatable-components/FilterBar.vue": [
		"khvK"
	],
	"./labassays/vuestic-datatable/datatable-components/ItemsPerPage.vue": [
		"I8H2"
	],
	"./layout/AuthLayout.vue": [
		"v6Pz"
	],
	"./layout/Layout.vue": [
		"i/0a"
	],
	"./layout/navbar/ChangePassword.vue": [
		"MwJD"
	],
	"./layout/navbar/InitialPassword.vue": [
		"6E+c"
	],
	"./layout/navbar/Navbar.vue": [
		"QI9S"
	],
	"./layout/sidebar/Sidebar.vue": [
		"jEUr"
	],
	"./loger/postavke/JsonEdit.vue": [
		"bD1Z"
	],
	"./loger/postavke/KalibracijaModal.vue": [
		"3JiH"
	],
	"./loger/postavke/VuesticModal.vue": [
		"Iwbm",
		162
	],
	"./loger/postavke/postavke.vue": [
		"aAaQ",
		161
	],
	"./loger/pregled/BadgeColumn.vue": [
		"HDNw",
		160
	],
	"./loger/pregled/PregledInfoWidgets.vue": [
		"f+xO",
		55
	],
	"./loger/pregled/VuesticModalGraph.vue": [
		"MRkw"
	],
	"./loger/pregled/VuesticModalTable.vue": [
		"9QRd"
	],
	"./loger/pregled/pregled.vue": [
		"1rCd",
		17
	],
	"./lpnalazi/pregled/BadgeColumn.vue": [
		"3JgX",
		159
	],
	"./lpnalazi/pregled/VuesticModalData.vue": [
		"cW4z",
		158
	],
	"./lpnalazi/pregled/VuesticModalViberService.vue": [
		"+gs4",
		157
	],
	"./lpnalazi/pregled/nalaz.vue": [
		"QfBS",
		42
	],
	"./lpnalazi/pregled/pregled.vue": [
		"PRb+",
		41
	],
	"./lpobrada/BadgeColumn.vue": [
		"imKX",
		156
	],
	"./lpobrada/Obrada.vue": [
		"1CWe",
		25
	],
	"./lpobrada/components/RadioButtonBactery.vue": [
		"1m1S",
		155
	],
	"./lpobrada/components/VuesticAccordionObrada.vue": [
		"5YEd",
		154
	],
	"./lpobrada/components/VuesticCollapseAparati.vue": [
		"FgHz",
		153
	],
	"./lpobrada/components/VuesticCollapseNalaz.vue": [
		"jRPE",
		152
	],
	"./lpobrada/components/VuesticCollapseObrada.vue": [
		"Tczu",
		151
	],
	"./lpobrada/components/VuesticCollapseUzorak.vue": [
		"ff7E",
		150
	],
	"./lpobrada/components/VuesticModalAllResults.vue": [
		"Hh17",
		149
	],
	"./lpobrada/components/VuesticModalAparati.vue": [
		"CBaF",
		148
	],
	"./lpobrada/components/VuesticModalComment.vue": [
		"F4OJ",
		147
	],
	"./lpobrada/components/VuesticModalDelete.vue": [
		"UE/v",
		146
	],
	"./lpobrada/components/VuesticModalEdit.vue": [
		"bhPJ",
		78
	],
	"./lpobrada/components/VuesticModalError.vue": [
		"CzEe",
		145
	],
	"./lpobrada/components/VuesticModalEvaluationMulti.vue": [
		"9uwX",
		144
	],
	"./lpobrada/components/VuesticModalEvaluationSingle.vue": [
		"/lji",
		143
	],
	"./lpobrada/components/VuesticModalExclamation.vue": [
		"/wLV",
		142
	],
	"./lpobrada/components/VuesticModalFind.vue": [
		"woYo",
		141
	],
	"./lpobrada/components/VuesticModalHandshake.vue": [
		"Ia8u",
		140
	],
	"./lpobrada/components/VuesticModalMail.vue": [
		"GCVV",
		139
	],
	"./lpobrada/components/VuesticModalMicroBactery.vue": [
		"Esrf",
		138
	],
	"./lpobrada/components/VuesticModalMicroReset.vue": [
		"6++c",
		137
	],
	"./lpobrada/components/VuesticModalMicroResult.vue": [
		"+eoa",
		136
	],
	"./lpobrada/components/VuesticModalMulti.vue": [
		"NEQJ",
		135
	],
	"./lpobrada/components/VuesticModalReference.vue": [
		"AD5A",
		134
	],
	"./lpobrada/components/VuesticModalResultsMulti.vue": [
		"xoL5",
		133
	],
	"./lpobrada/components/VuesticModalUzorci.vue": [
		"GCjt",
		132
	],
	"./lpobrada/components/VuesticTabsBactery.vue": [
		"0lwq",
		131
	],
	"./lpobrada/predracun.vue": [
		"iwj2",
		71
	],
	"./lpobrada/table.vue": [
		"p+xB",
		40
	],
	"./lpoutbox/BadgeColumn.vue": [
		"BsUr",
		130
	],
	"./lpoutbox/nalaz.vue": [
		"FeXZ",
		39
	],
	"./lpoutbox/outbox.vue": [
		"3ad6",
		38
	],
	"./mikrobiologija/Analize.vue": [
		"a8Z+",
		129
	],
	"./mikrobiologija/Antibiogrami.vue": [
		"0a5L",
		128
	],
	"./mikrobiologija/Antibiotici.vue": [
		"FGPK",
		127
	],
	"./mikrobiologija/Bakterije.vue": [
		"OGw0",
		126
	],
	"./mikrobiologija/Mikrobiologija.vue": [
		"wLfM",
		14
	],
	"./mikrobiologija/MikrobiologijaEdit.vue": [
		"l/ha"
	],
	"./nalazi/outbox/BadgeColumn.vue": [
		"k/kZ",
		125
	],
	"./nalazi/outbox/nalaz.vue": [
		"jYLl",
		37
	],
	"./nalazi/outbox/outbox.vue": [
		"0GYA",
		36
	],
	"./nalazi/pregled/BadgeColumn.vue": [
		"tl1j",
		124
	],
	"./nalazi/pregled/VuesticModalData.vue": [
		"n9rL"
	],
	"./nalazi/pregled/VuesticModalEmailService.vue": [
		"ex6s"
	],
	"./nalazi/pregled/VuesticModalViberService.vue": [
		"+1re"
	],
	"./nalazi/pregled/nalaz.vue": [
		"e2jv",
		35
	],
	"./nalazi/pregled/pregled.vue": [
		"RHzI",
		34
	],
	"./naljepnice/BadgeColumn.vue": [
		"i7tf",
		123
	],
	"./naljepnice/naljepnice.vue": [
		"m+bX",
		70
	],
	"./narucioci/BadgeColumn.vue": [
		"LYKJ",
		122
	],
	"./narucioci/narucioci.vue": [
		"eF6p",
		69
	],
	"./obrada/BadgeColumn.vue": [
		"XMpX",
		121
	],
	"./obrada/Calendar.vue": [
		"mzx/"
	],
	"./obrada/Obrada.vue": [
		"0fl9",
		24
	],
	"./obrada/components/RadioButtonBactery.vue": [
		"niIE"
	],
	"./obrada/components/VuesticAccordionObrada.vue": [
		"zrkU"
	],
	"./obrada/components/VuesticCollapseAparati.vue": [
		"rJt6"
	],
	"./obrada/components/VuesticCollapseNalaz.vue": [
		"1GIG"
	],
	"./obrada/components/VuesticCollapseObrada.vue": [
		"w6AR"
	],
	"./obrada/components/VuesticCollapseUzorak.vue": [
		"plIL"
	],
	"./obrada/components/VuesticModalAllResults.vue": [
		"noGi"
	],
	"./obrada/components/VuesticModalAparati.vue": [
		"aHZh"
	],
	"./obrada/components/VuesticModalComment.vue": [
		"497r"
	],
	"./obrada/components/VuesticModalDelete.vue": [
		"B58c"
	],
	"./obrada/components/VuesticModalEdit.vue": [
		"X44x"
	],
	"./obrada/components/VuesticModalError.vue": [
		"nXZ0"
	],
	"./obrada/components/VuesticModalEvaluationMulti.vue": [
		"qQ6B"
	],
	"./obrada/components/VuesticModalEvaluationSingle.vue": [
		"xYBa"
	],
	"./obrada/components/VuesticModalExclamation.vue": [
		"LijO"
	],
	"./obrada/components/VuesticModalFind.vue": [
		"xAIc"
	],
	"./obrada/components/VuesticModalHandshake.vue": [
		"G+1C"
	],
	"./obrada/components/VuesticModalMail.vue": [
		"x5pt"
	],
	"./obrada/components/VuesticModalMicroBactery.vue": [
		"d9vy"
	],
	"./obrada/components/VuesticModalMicroReset.vue": [
		"IHTr"
	],
	"./obrada/components/VuesticModalMicroResult.vue": [
		"5H7z"
	],
	"./obrada/components/VuesticModalMulti.vue": [
		"4dey"
	],
	"./obrada/components/VuesticModalReference.vue": [
		"jDO0"
	],
	"./obrada/components/VuesticModalResultsMulti.vue": [
		"ip1w"
	],
	"./obrada/components/VuesticModalUzorci.vue": [
		"YCi8"
	],
	"./obrada/components/VuesticTabsBactery.vue": [
		"9xgs"
	],
	"./obrada/predracun.vue": [
		"AJNn",
		68
	],
	"./obrada/table.vue": [
		"puYy",
		33
	],
	"./partneri/VuesticModalPartneriDelete.vue": [
		"AFOn"
	],
	"./partneri/VuesticModalPartneriEdit.vue": [
		"/DkG"
	],
	"./partneri/VuesticModalPartneriInfo.vue": [
		"dpoI"
	],
	"./partneri/partneri.vue": [
		"QYON",
		120
	],
	"./postavke/BadgeColumn.vue": [
		"5t8X",
		119
	],
	"./postavke/JsonEdit.vue": [
		"aWyB"
	],
	"./postavke/Korisnici.vue": [
		"AbIx",
		67
	],
	"./postavke/LaboratorijskeAnalize.vue": [
		"JCwT",
		66
	],
	"./postavke/OpstePostavke.vue": [
		"ENyu",
		65
	],
	"./postavke/Postavke.vue": [
		"CHAf",
		4
	],
	"./postavke/PostavkeModal.vue": [
		"oIp1"
	],
	"./postavke/RadioButton.vue": [
		"YZh0"
	],
	"./postavke/SiteModal.vue": [
		"t9OK"
	],
	"./postavke/Sites.vue": [
		"aFxD",
		64
	],
	"./postavke/UserModal.vue": [
		"we+w"
	],
	"./postavke/postavkeAccordion.vue": [
		"dJjZ"
	],
	"./postavke/postavkeCollapse.vue": [
		"tPNP"
	],
	"./postavke/postavkeDeleteSites.vue": [
		"Z4em"
	],
	"./postavke/postavkeDeleteUsers.vue": [
		"+KPY"
	],
	"./protokol/protokol.vue": [
		"oxuL",
		118
	],
	"./registracija/Registracija.vue": [
		"b3XW",
		117
	],
	"./reports/Reports.vue": [
		"GFu2",
		77
	],
	"./reports/VuesticModal.vue": [
		"shI0"
	],
	"./rtnalazi/pregled/BadgeColumn.vue": [
		"41E/",
		116
	],
	"./rtnalazi/pregled/VuesticModalData.vue": [
		"4qcN",
		115
	],
	"./rtnalazi/pregled/VuesticModalViberService.vue": [
		"95Pl",
		114
	],
	"./rtnalazi/pregled/nalaz.vue": [
		"2SRU",
		32
	],
	"./rtnalazi/pregled/pregled.vue": [
		"YItV",
		31
	],
	"./rtobrada/BadgeColumn.vue": [
		"1S1n",
		113
	],
	"./rtobrada/Obrada.vue": [
		"0wdt",
		23
	],
	"./rtobrada/components/RadioButtonBactery.vue": [
		"gQ87",
		112
	],
	"./rtobrada/components/VuesticAccordionObrada.vue": [
		"EpC2",
		111
	],
	"./rtobrada/components/VuesticCollapseAparati.vue": [
		"drCJ",
		110
	],
	"./rtobrada/components/VuesticCollapseNalaz.vue": [
		"xwCo",
		109
	],
	"./rtobrada/components/VuesticCollapseObrada.vue": [
		"yyo+",
		108
	],
	"./rtobrada/components/VuesticCollapseUzorak.vue": [
		"lxLT",
		107
	],
	"./rtobrada/components/VuesticModalAllResults.vue": [
		"WFCL",
		106
	],
	"./rtobrada/components/VuesticModalAparati.vue": [
		"lwkl",
		105
	],
	"./rtobrada/components/VuesticModalComment.vue": [
		"iWR4",
		104
	],
	"./rtobrada/components/VuesticModalDelete.vue": [
		"VTi1",
		103
	],
	"./rtobrada/components/VuesticModalEdit.vue": [
		"nV/B",
		76
	],
	"./rtobrada/components/VuesticModalError.vue": [
		"WmI4",
		102
	],
	"./rtobrada/components/VuesticModalEvaluationMulti.vue": [
		"Ikj+",
		101
	],
	"./rtobrada/components/VuesticModalEvaluationSingle.vue": [
		"uLi2",
		100
	],
	"./rtobrada/components/VuesticModalExclamation.vue": [
		"FosO",
		99
	],
	"./rtobrada/components/VuesticModalFind.vue": [
		"oZcl",
		98
	],
	"./rtobrada/components/VuesticModalHandshake.vue": [
		"fPzI",
		97
	],
	"./rtobrada/components/VuesticModalMail.vue": [
		"S7p5",
		96
	],
	"./rtobrada/components/VuesticModalMicroBactery.vue": [
		"R34k",
		95
	],
	"./rtobrada/components/VuesticModalMicroReset.vue": [
		"Arvz",
		94
	],
	"./rtobrada/components/VuesticModalMicroResult.vue": [
		"EmoK",
		93
	],
	"./rtobrada/components/VuesticModalMulti.vue": [
		"ugeO",
		92
	],
	"./rtobrada/components/VuesticModalReference.vue": [
		"7vS7",
		91
	],
	"./rtobrada/components/VuesticModalResultsMulti.vue": [
		"Rk0t",
		90
	],
	"./rtobrada/components/VuesticModalUzorci.vue": [
		"JO+o",
		89
	],
	"./rtobrada/components/VuesticTabsBactery.vue": [
		"QV5X",
		88
	],
	"./rtobrada/predracun.vue": [
		"UTP8",
		63
	],
	"./rtobrada/table.vue": [
		"8/Qu",
		30
	],
	"./rtoutbox/BadgeColumn.vue": [
		"0CoQ",
		87
	],
	"./rtoutbox/nalaz.vue": [
		"uT3r",
		29
	],
	"./rtoutbox/outbox.vue": [
		"p4JX",
		28
	],
	"./statistika/Dashboard.vue": [
		"A9sE",
		62
	],
	"./statistika/DashboardInfoWidgets.vue": [
		"y7UV",
		86
	],
	"./statistika/DataVisualisation.vue": [
		"LfGC",
		85
	],
	"./tables/BadgeColumn.vue": [
		"csLD",
		84
	],
	"./users/registration.vue": [
		"zexp",
		83
	],
	"./vuestic-components/vuestic-alert/VuesticAlert.vue": [
		"cfdX"
	],
	"./vuestic-components/vuestic-chart/VuesticChart.vue": [
		"+Uuv"
	],
	"./vuestic-components/vuestic-chat/VuesticChat.vue": [
		"oXux"
	],
	"./vuestic-components/vuestic-checkbox/VuesticCheckbox.vue": [
		"2653"
	],
	"./vuestic-components/vuestic-collapse/VuesticAccordionPatientInfo.vue": [
		"xAVG"
	],
	"./vuestic-components/vuestic-collapse/VuesticAccordionSamplesEntry.vue": [
		"4S38"
	],
	"./vuestic-components/vuestic-collapse/VuesticCollapsePatientInfo.vue": [
		"TS+I"
	],
	"./vuestic-components/vuestic-collapse/VuesticCollapseSamplesEntry.vue": [
		"pmVg"
	],
	"./vuestic-components/vuestic-datatable/VuesticDataTable.vue": [
		"tZ2u"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/DateRange.vue": [
		"l/id"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/FilterBar.vue": [
		"YhNO"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/ItemsPerPage.vue": [
		"IbS2"
	],
	"./vuestic-components/vuestic-date-picker/VuesticDatePicker.demo.vue": [
		"rAWp",
		272
	],
	"./vuestic-components/vuestic-date-picker/VuesticDatePicker.vue": [
		"UfMP"
	],
	"./vuestic-components/vuestic-feed/VuesticFeed.vue": [
		"Q4Rp"
	],
	"./vuestic-components/vuestic-file-upload/VuesticFileUpload.vue": [
		"sELh"
	],
	"./vuestic-components/vuestic-file-upload/VuesticFileUploadContainer.vue": [
		"z0Ym"
	],
	"./vuestic-components/vuestic-file-upload/VuesticFileUploadGalleryItem.vue": [
		"btIS"
	],
	"./vuestic-components/vuestic-file-upload/VuesticFileUploadList.vue": [
		"maDQ"
	],
	"./vuestic-components/vuestic-file-upload/VuesticFileUploadListItem.vue": [
		"lpwG"
	],
	"./vuestic-components/vuestic-file-upload/VuesticFileUploadSingleItem.vue": [
		"itpM"
	],
	"./vuestic-components/vuestic-file-upload/VuesticFileUploadUndo.vue": [
		"3Bfb"
	],
	"./vuestic-components/vuestic-input-select/VuesticInputSelect.vue": [
		"P2Ka"
	],
	"./vuestic-components/vuestic-medium-editor/VuesticMediumEditor.vue": [
		"d4/x"
	],
	"./vuestic-components/vuestic-modal/VuesticModal.vue": [
		"NG7M"
	],
	"./vuestic-components/vuestic-modal/VuesticModalMedium.vue": [
		"Wvsm"
	],
	"./vuestic-components/vuestic-modal/VuesticModalStatic.vue": [
		"aXvH"
	],
	"./vuestic-components/vuestic-multi-select/VuesticMultiSelect.vue": [
		"IqWy"
	],
	"./vuestic-components/vuestic-popover/VuesticPopover.vue": [
		"wf/P"
	],
	"./vuestic-components/vuestic-preloader/VuesticPreLoader.vue": [
		"VAWW"
	],
	"./vuestic-components/vuestic-profile-card/VuesticProfileCard.vue": [
		"74xX"
	],
	"./vuestic-components/vuestic-progress-bar/VuesticProgressBar.vue": [
		"XznE"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/CircleProgressBar.vue": [
		"pqzW"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/HorizontalProgressBar.vue": [
		"CneO"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/VerticalProgressBar.vue": [
		"axM2"
	],
	"./vuestic-components/vuestic-radio-button/VuesticRadioButton.vue": [
		"aj+k"
	],
	"./vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue": [
		"/7ZL"
	],
	"./vuestic-components/vuestic-simple-select/VuesticSimpleSelect.vue": [
		"/LRh"
	],
	"./vuestic-components/vuestic-site/SiteDropdown.vue": [
		"4ZaD"
	],
	"./vuestic-components/vuestic-social-news/VuesticSocialNews.vue": [
		"anct"
	],
	"./vuestic-components/vuestic-switch/VuesticSwitch.vue": [
		"rhzU"
	],
	"./vuestic-components/vuestic-tabs/VuesticTabs.vue": [
		"LtNJ"
	],
	"./vuestic-components/vuestic-tag/VuesticTag.vue": [
		"aTa4"
	],
	"./vuestic-components/vuestic-tag/VuesticTagGroup.vue": [
		"L2/I"
	],
	"./vuestic-components/vuestic-tooltip/VuesticTooltip.vue": [
		"PpPr"
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeCategory.demo.vue": [
		"go2Q",
		271
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeCategory.vue": [
		"MCoA"
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeNode.demo.vue": [
		"tQYc",
		270
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeNode.vue": [
		"FY6O"
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeRoot.demo.vue": [
		"3gam",
		269
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeRoot.vue": [
		"hF5N"
	],
	"./vuestic-components/vuestic-tree-view/vuestic-div-checkbox/SquareWithIcon.demo.vue": [
		"606c",
		268
	],
	"./vuestic-components/vuestic-tree-view/vuestic-div-checkbox/SquareWithIcon.vue": [
		"2c2N"
	],
	"./vuestic-components/vuestic-widget/VuesticWidget.vue": [
		"Dmbe"
	],
	"./vuestic-components/vuestic-wizard/VuesticWizard.vue": [
		"8/T/"
	],
	"./vuestic-components/vuestic-wizard/indicators/RichHorizontalIndicator.vue": [
		"dIvT"
	],
	"./vuestic-components/vuestic-wizard/indicators/RichVerticalIndicator.vue": [
		"iLsn"
	],
	"./vuestic-components/vuestic-wizard/indicators/SimpleHorizontalIndicator.vue": [
		"jzLZ"
	],
	"./vuestic-components/vuestic-wizard/indicators/SimpleVerticalIndicator.vue": [
		"0GMg"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "mWYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('en', __webpack_require__("UpdR"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('es', __webpack_require__("WlTu"));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set('en');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.fallback('en');

/***/ }),

/***/ "maDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadList_vue__ = __webpack_require__("qui1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f74555_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadList_vue__ = __webpack_require__("1dsE");
function injectStyle (ssrContext) {
  __webpack_require__("/D4u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f74555_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mpwI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__ = __webpack_require__("jzLZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__ = __webpack_require__("dIvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__ = __webpack_require__("iLsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__ = __webpack_require__("0GMg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__ = __webpack_require__("41de");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard',
  props: {
    steps: {},
    wizardType: {
      type: String,
      default: 'simple'
    },
    wizardLayout: {
      type: String,
      default: 'horizontal'
    },
    lastStepLabel: { default: 'Confirm' },
    onNext: {},
    onBack: {}
  },
  data: function data() {
    return {
      currentStep: 0,
      wizardCompleted: false,
      wizardCompletedSlotName: 'wizardCompleted',
      orientationBreakPoint: 767,
      computedLayout: this.wizardLayout
    };
  },

  components: {
    SimpleHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__["default"],
    RichHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__["default"],
    RichVerticalIndicator: __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__["default"],
    SimpleVerticalIndicator: __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__["default"]
  },
  directives: {
    orientationHandler: __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__["a" /* default */]
  },
  computed: {
    currentSlot: function currentSlot() {
      var slotName = this.steps[this.currentStep].slot;
      if (this.wizardCompleted) {
        slotName = this.wizardCompletedSlotName;
      }
      return slotName;
    },
    backEnabled: function backEnabled() {
      return this.currentStep !== 0;
    }
  },
  created: function created() {
    this.$on('wizardLayoutChange', this.updateLayout);
  },

  methods: {
    updateLayout: function updateLayout(layout) {
      this.computedLayout = layout;
    },
    goNext: function goNext() {
      this.currentStepOnNext();
      if (!this.isLastStep() && this.isCurrentStepValid()) {
        this.currentStep++;
      }
    },
    goBack: function goBack() {
      this.currentStepOnBack();
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    completeWizard: function completeWizard() {
      this.wizardCompleted = true;
      this.goNext();
    },
    isLastStep: function isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    currentStepOnNext: function currentStepOnNext() {
      var step = this.steps[this.currentStep];
      if (step.onNext) {
        step.onNext();
      }
    },
    currentStepOnBack: function currentStepOnBack() {
      var step = this.steps[this.currentStep];
      if (step.onBack) {
        step.onBack();
      }
    },
    isCurrentStepValid: function isCurrentStepValid() {
      return this.steps[this.currentStep].isValid();
    },
    isStepShown: function isStepShown(step) {
      return step.slot === this.currentSlot && !this.wizardCompleted;
    }
  }
});

/***/ }),

/***/ "mrOd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spring-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spring-spinner-part top",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})]),_vm._v(" "),_c('div',{staticClass:"spring-spinner-part bottom",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mzx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__("g+Tt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02a5f322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__("/9IN");
function injectStyle (ssrContext) {
  __webpack_require__("1Zso")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02a5f322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "n+XL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("Oe0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8f00e7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("wdYp");
function injectStyle (ssrContext) {
  __webpack_require__("lGLK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8f00e7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8f00e7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "n/7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "multi-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    labassay: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("LabAssayHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("LabAssayHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("LabAssayClose");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "n5qd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-accordion-obrada-control",
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "n9rL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalData_vue__ = __webpack_require__("IAGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc8aca92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalData_vue__ = __webpack_require__("D92/");
function injectStyle (ssrContext) {
  __webpack_require__("bjG+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc8aca92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nD4s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nDS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlEditModal_vue__ = __webpack_require__("CZ96");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bce61bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlEditModal_vue__ = __webpack_require__("enb6");
function injectStyle (ssrContext) {
  __webpack_require__("CmQI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bce61bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nXZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalError_vue__ = __webpack_require__("BUP9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e013b34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalError_vue__ = __webpack_require__("iRd/");
function injectStyle (ssrContext) {
  __webpack_require__("1k1c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e013b34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nYBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapseObrada_vue__ = __webpack_require__("qwMU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934d3d06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapseObrada_vue__ = __webpack_require__("0vre");
function injectStyle (ssrContext) {
  __webpack_require__("5DLM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-934d3d06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapseObrada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934d3d06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapseObrada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nhR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-graph",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      window: {
        width: 0,
        height: 0
      },
      timeRange: {
        timeOd: "",
        timeDo: ""
      },
      configOd: {
        minDate: new Date("2019-09-01"),
        maxDate: new Date(),
        enableTime: true,
        minuteIncrement: 1,
        time_24hr: true,
        inline: false,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      },
      configDo: {
        minDate: new Date("2019-09-01"),
        maxDate: new Date().fp_incr(1),
        enableTime: true,
        minuteIncrement: 1,
        time_24hr: true,
        inline: false,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      },
      configBasics: {
        minDate: new Date("2019-09-01"),
        maxDate: new Date().fp_incr(1),
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      },
      dateBasics: "",
      mobile: false,

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("GraphSelected", function () {});
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("GraphDateData", function (data) {
      _this.timeRange.timeOd = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.from.slice(0, 10) + " " + data.from.slice(11, 16));
      _this.timeRange.timeDo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.to.slice(0, 10) + " " + data.to.slice(11, 16));
    });
  },
  created: function created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("GraphSelected");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("GraphDateData");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("Switch");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    },
    dateBasics: function dateBasics() {
      if (this.mobile) {
        var from = this.dateBasics + "T00:00:00.000Z";
        var to = this.dateBasics + "T23:59:59.000Z";
        var data = {
          data: "Date range changed.",
          from: from,
          to: to
        };
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("GraphDateRange", data);
      }
    }
  },
  methods: {
    timeOdClosed: function timeOdClosed(event) {
      if (this.timeRange.timeOd != "" && this.timeRange.timeDo != "" && new Date(this.timeRange.timeOd) < new Date(this.timeRange.timeDo)) {
        var from = this.timeRange.timeOd.replace(" ", "T").concat(":00.000Z");
        var to = this.timeRange.timeDo.replace(" ", "T").concat(":00.000Z");
        var data = {
          data: "Date range changed.",
          from: from,
          to: to
        };

        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("GraphDateRange", data);
      } else {
        this.toastText = "Invalid date range.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-left";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      }
    },
    timeDoClosed: function timeDoClosed(event) {
      if (this.timeRange.timeOd != "" && this.timeRange.timeDo != "" && new Date(this.timeRange.timeOd) < new Date(this.timeRange.timeDo)) {
        var from = this.timeRange.timeOd.replace(" ", "T").concat(":00.000Z");
        var to = this.timeRange.timeDo.replace(" ", "T").concat(":00.000Z");
        var data = {
          data: "Date range changed.",
          from: from,
          to: to
        };
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("GraphDateRange", data);
      } else {
        this.toastText = "Invalid date range.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-left";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      }
    },
    Test: function Test(event) {
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("GraphDateRange", "Date range changed.");
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 800) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("GraphModalClosed");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.dateBasics = this.timeRange.timeOd.slice(1, 11);
      this.mobile = false;

      if (this.window.width < 800) {
        this.mobile = true;
      }

      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "niIE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioButtonBactery_vue__ = __webpack_require__("lXZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf151b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButtonBactery_vue__ = __webpack_require__("w4Y+");
function injectStyle (ssrContext) {
  __webpack_require__("vBhc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fbf151b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioButtonBactery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf151b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButtonBactery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nnXA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],class:_vm.classObject},[_c('navbar'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_c('main',{staticClass:"content",attrs:{"id":"content","role":"main"}},[_c('vuestic-pre-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],ref:"preLoader",staticClass:"pre-loader"}),_vm._v(" "),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],key:_vm.$route.fullPath})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "noGi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalAllResults_vue__ = __webpack_require__("S483");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d23d5ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalAllResults_vue__ = __webpack_require__("4W1X");
function injectStyle (ssrContext) {
  __webpack_require__("QToP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalAllResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d23d5ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalAllResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "noQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el) {
    var getWindowMatch = function getWindowMatch() {
      return window.matchMedia(__WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.config.windowMatchSizeLg).matches;
    };

    var prevMatchlg = getWindowMatch();

    el.addEventListener("transitionend", function () {
      __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch("isToggleWithoutAnimation", false);
    });

    window.addEventListener("resize", function () {
      if (getWindowMatch() && !prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch("toggleSidebar", true);
      } else if (!getWindowMatch() && prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch("isToggleWithoutAnimation", true);
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch("toggleSidebar", false);
      }
      prevMatchlg = getWindowMatch();
    });
  }
});

/***/ }),

/***/ "ntpn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nuWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload-list-item d-flex",class:{'file-upload-list-item--undo': _vm.removed}},[(_vm.removed)?_c('div',{staticClass:"va-row"},[_c('div',{staticClass:"flex md12"},[_c('vuestic-file-upload-undo',{on:{"recover":_vm.recoverFile}})],1)]):_c('div',{staticClass:"va-row align--center"},[_c('div',{staticClass:"file-upload-list-item__name flex xs12 lg3 ellipsis"},[_vm._v(_vm._s(_vm.file.name))]),_vm._v(" "),_c('div',{staticClass:"file-upload-list-item__size flex xs12 lg3"},[_vm._v(_vm._s(_vm.file.size))]),_vm._v(" "),_c('div',{staticClass:"file-upload-list-item__date flex xs12 lg4"},[_c('span',[_vm._v(_vm._s(_vm.$t('fileUpload.uploadedOn'))+" "+_vm._s(_vm.file.date))])]),_vm._v(" "),_c('div',{staticClass:"file-upload-list-item__button-container flex xs12 lg2"},[_c('button',{staticClass:"btn-text btn-text--primary",attrs:{"type":"button"},on:{"click":_vm.removeFile}},[_vm._v(_vm._s(_vm.$t('fileUpload.delete')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o4Af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PacijentsTable_vue__ = __webpack_require__("4/yE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feccb2ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PacijentsTable_vue__ = __webpack_require__("Dgy8");
function injectStyle (ssrContext) {
  __webpack_require__("Hy37")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-feccb2ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PacijentsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feccb2ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PacijentsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oE55":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oFf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__ = __webpack_require__("UK0m");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "file-upload-gallery-item",
  components: {
    VuesticFileUploadUndo: __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadUndo__["default"]
  },
  data: function data() {
    return {
      previewImage: "",
      removed: false
    };
  },

  props: {
    file: {
      default: {}
    }
  },
  watch: {
    file: function file() {
      this.convertToImg();
    }
  },
  methods: {
    removeImage: function removeImage() {
      var _this = this;

      this.removed = true;
      setTimeout(function () {
        if (_this.removed) {
          _this.$emit("remove");
          _this.removed = false;
        }
      }, 2000);
    },
    recoverImage: function recoverImage() {
      this.removed = false;
    },
    convertToImg: function convertToImg() {
      var _this2 = this;

      var reader = new FileReader();
      var imageFileTypes = ["/png", "/jpg", "/jpeg", "/gif"];
      reader.readAsDataURL(this.file.image);
      reader.onload = function (e) {
        for (var i = 0; i < imageFileTypes.length; i++) {
          if (e.target.result.indexOf(imageFileTypes[i]) >= 0) {
            _this2.previewImage = e.target.result;
          }
        }
      };
    }
  },
  computed: {
    notGalleryItemClass: function notGalleryItemClass() {
      return {
        "file-upload-gallery-item_not-image": !this.previewImage
      };
    }
  },
  mounted: function mounted() {
    this.convertToImg();
  }
});

/***/ }),

/***/ "oIp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostavkeModal_vue__ = __webpack_require__("bi26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dacd68d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostavkeModal_vue__ = __webpack_require__("xvgY");
function injectStyle (ssrContext) {
  __webpack_require__("MSY6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3dacd68d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostavkeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dacd68d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostavkeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oJ4h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oJAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-header",style:({background: _vm.colors.header.bg, color: _vm.colors.header.text})},[(_vm.imageUrl)?_c('img',{staticClass:"sc-header--img",attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sc-header--title",on:{"click":_vm.toggleUserList}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('div',{staticClass:"sc-header--close-button",on:{"click":_vm.onClose}},[_c('img',{attrs:{"src":__webpack_require__("xc3+"),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oK+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_epic_spinners__ = __webpack_require__("pyJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuestic_components_vuestic_site_SiteDropdown_vue__ = __webpack_require__("4ZaD");













/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: true,
      hidden_old: true,
      hidden_new: true,
      hidden_confirm: true,
      userImage: "",
      isRole: "",

      reload: true,

      staraSifra: "",
      novaSifra: "",
      potvrdaSifra: "",

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  name: "navbar",

  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_3_directives_Dropdown__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["sidebarOpened", "toggleWithoutAnimation"]), {
    currentLanguage: function currentLanguage() {}
  }),
  components: {
    AtomSpinner: __WEBPACK_IMPORTED_MODULE_4_epic_spinners__["a" /* AtomSpinner */],
    SiteDropdown: __WEBPACK_IMPORTED_MODULE_8__vuestic_components_vuestic_site_SiteDropdown_vue__["default"]
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["closeMenu", "toggleSidebar", "isToggleWithoutAnimation"]), {
    Logout: function Logout() {
      this.$store.dispatch("logout");
    },
    Dashboard: function Dashboard(e) {},
    setSite: function setSite(site) {
      this.$refs.languageModal.cancel();
    },

    Password: function Password() {
      this.$refs.staticChangePassword.open();
      this.$refs.close.click();
    },
    ShowPassword: function ShowPassword() {
      var passwordField_old = null;
      var passwordField_new = null;
      var passwordField_confirm = null;

      passwordField_old = document.querySelector("#oldPassword");
      this.hidden_old = false;
      passwordField_new = document.querySelector("#newPassword");
      this.hidden_new = false;
      passwordField_confirm = document.querySelector("#confirmPassword");
      this.hidden_confirm = false;

      passwordField_old.setAttribute("type", "text");
      passwordField_new.setAttribute("type", "text");
      passwordField_confirm.setAttribute("type", "text");
    },
    HidePassword: function HidePassword() {
      var passwordField_old = null;
      var passwordField_new = null;
      var passwordField_confirm = null;

      passwordField_old = document.querySelector("#oldPassword");
      this.hidden_old = true;
      passwordField_new = document.querySelector("#newPassword");
      this.hidden_new = true;
      passwordField_confirm = document.querySelector("#confirmPassword");
      this.hidden_confirm = true;

      passwordField_old.setAttribute("type", "password");
      passwordField_new.setAttribute("type", "password");
      passwordField_confirm.setAttribute("type", "password");
    },
    izmjeniSifru: function izmjeniSifru() {
      var _this = this;

      var item = true;
      if (this.novaSifra.trim() === "" || this.potvrdaSifra.trim() === "" || this.staraSifra === "") {
        item = false;
        this.toastText = "Sva polja su obavezna.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else if (this.novaSifra.length < 6) {
        item = false;
        this.toastText = "Šifra nije validna.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
        return;
      } else if (this.novaSifra != this.potvrdaSifra) {
        item = false;
        this.toastText = "Nova šifra nije validirana.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
        return;
      } else {}

      if (item) {
        __WEBPACK_IMPORTED_MODULE_6__config_config_js__["C" /* http */].post("users/sifra", {
          email: this.$store.state.userId,
          password: this.staraSifra,
          novaSifra: this.novaSifra,
          potvrdaSifra: this.potvrdaSifra,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.message === "Greška na mongodb.") {
            _this.toastText = "Greška prilikom upisa.";
            _this.toastIcon = "fa-remove";
            _this.toastPosition = "top-right";
            _this.className = "vuestic-toast-danger";

            _this.showToast(_this.toastText, {
              icon: _this.toastIcon,
              position: _this.toastPosition,
              duration: _this.toastDuration,
              fullWidth: _this.isToastFullWidth,
              className: _this.className
            });
          }
          if (res.data.message === "Info") {
            _this.toastText = "Trenutna šifra nije ispravna.";
            _this.toastIcon = "fa-warning";
            _this.toastPosition = "top-right";
            _this.className = "vuestic-toast-warning";

            _this.showToast(_this.toastText, {
              icon: _this.toastIcon,
              position: _this.toastPosition,
              duration: _this.toastDuration,
              fullWidth: _this.isToastFullWidth,
              className: _this.className
            });
          }

          if (res.data.message === "Ok") {
            _this.novaSifra = "";
            _this.potvrdaSifra = "";
            _this.staraSifra = "";
            _this.toastText = "Izmjena uspješno obavljena.";
            _this.toastIcon = "fa-check";
            _this.toastPosition = "top-right";
            _this.className = "vuestic-toast-primary";

            _this.showToast(_this.toastText, {
              icon: _this.toastIcon,
              position: _this.toastPosition,
              duration: _this.toastDuration,
              fullWidth: _this.isToastFullWidth,
              className: _this.className
            });

            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("ChangePasswordModalHide");
            _this.HidePassword("oldPassword");
            _this.HidePassword("newPassword");
            _this.HidePassword("confirmPassword");
          }
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    if (this.$store.state.expired) {
      setTimeout(function () {
        _this2.$refs.staticChangePassword.open();
      }, 1000);
    }

    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$on("ChangePassword", function () {
      _this2.izmjeniSifru();
    });

    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$on("_HidePassword", function () {
      _this2.HidePassword();
    });

    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$on("_ShowPassword", function () {
      _this2.ShowPassword();
    });

    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$on("ChangePasswordCancel", function () {
      _this2.staraSifra = "";
      _this2.novaSifra = "";
      _this2.potvrdaSifra = "";
      _this2.HidePassword();
    });

    var link = this.$store.state.userId;
    var token = this.$store.state.token;

    if (token != null) {
      if (!this.$store.state.userId.includes("@")) {
        link = link + "@";
      }
      var index = link.indexOf("@");
      link = link.substring(0, index);

      __WEBPACK_IMPORTED_MODULE_6__config_config_js__["C" /* http */].post("users/" + link, {
        email: this.$store.state.userId,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        _this2.userImage = res.data.data.link;
        _this2.isRole = res.data.data.role;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$off("ChangePassword");
    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$off("ChangePasswordCancel");
    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$off("_HidePassword");
    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$off("_ShowPassword");
  },

  watch: {}
});

/***/ }),

/***/ "oMxY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oRYY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oSDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__ = __webpack_require__("8UFG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3d13d6f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TypingMessage_vue__ = __webpack_require__("zCHh");
function injectStyle (ssrContext) {
  __webpack_require__("/dqC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d13d6f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3d13d6f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TypingMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oXux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__ = __webpack_require__("zt5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415a61fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__ = __webpack_require__("x+xx");
function injectStyle (ssrContext) {
  __webpack_require__("9ULZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-415a61fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415a61fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oft1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ooJ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "otT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__ = __webpack_require__("YhNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datatable_components_DateRange_vue__ = __webpack_require__("l/id");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datatable_components_ItemsPerPage_vue__ = __webpack_require__("IbS2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_local_data__ = __webpack_require__("zlyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_datatable_data_data_table_styles__ = __webpack_require__("CHUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_main_js__ = __webpack_require__("NHnr");















var originalData = __WEBPACK_IMPORTED_MODULE_6__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-data-table",
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__["default"],
    DateRange: __WEBPACK_IMPORTED_MODULE_3__datatable_components_DateRange_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_4__datatable_components_ItemsPerPage_vue__["default"]
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      klijent: "",
      tableData: __WEBPACK_IMPORTED_MODULE_6__data_local_data__["a" /* default */],
      perPage: "RADNA LISTA",

      brStr: 10,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_datatable_data_data_table_styles__["a" /* default */],
      show: true,
      potvrdi: "POTVRDI",
      odustani: "ODUSTANI",
      patient: "",
      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      checkboxSixModel: "",
      samples: [],
      includedSamples: [],
      danas: "",
      modalTitle: "Izbor uzoraka ",
      izbor: "",
      uzorci: [],
      nouzorci: [],
      partials: {},
      partials_array: [],
      date_range: {
        min: "",
        max: ""
      },
      filterString: "",

      pacIme: "",
      pacPrezime: "",
      pacGodiste: "",
      symptoms: {
        pacijentbezsimptoma: false,
        povišenatjelesnatemperatura: false,
        suhikašalj: false,
        umor: false,
        bolovi: false,
        grlobolja: false,
        proljev: false,
        konjunktivitis: false,
        glavobolja: false,
        gubitakosjetaokusailimirisa: false,
        osipilipromjenabojeprstijunarukamailinogama: false,
        otežanodisanjeiligubitakdaha: false,
        bolilipritisakuprsima: false,
        gubitaksposobnostigovorailikretanja: false
      },
      pacAdresa: "",
      pacLokacija: "",
      note: "",

      viberData: {
        timestamp: "",
        uzorak: "",
        telefon: "",
        valid: false,
        protokol: "",
        ime: "",
        prezime: "",
        godiste: "",
        spol: ""
      },

      emailData: {
        timestamp: "",
        uzorak: "",
        email: "",
        valid: false,
        protokol: "",
        ime: "",
        prezime: "",
        godiste: "",
        spol: ""
      }
    };
  },
  created: function created() {

    this.datum();
    var current = this.$router.currentRoute.path;

    if (current.includes("obrada/pregled")) {
      this.$store.dispatch("dropdownChange", "RADNA LISTA");
      this.$emit("items-per-page", "RADNA LISTA");
      this.$store.dispatch("filterChange", "");
      this.$store.dispatch("FilterBarChange", "");
    } else if (current.includes("nalazi/pregled")) {
      this.$store.dispatch("dropdownChange", "DANAS");
      this.$emit("items-per-page", "DANAS");
      this.$store.dispatch("filterChange", "");
      this.$store.dispatch("FilterBarChange", "");
    } else {
      this.$store.dispatch("dropdownChange", "DANAS");
      this.$emit("items-per-page", "DANAS");
      this.$store.dispatch("filterChange", "");
      this.$store.dispatch("FilterBarChange", "");
    }

    this.perPage = this.$store.state.dropdown;
    this.onFilterSet(this.$store.state.filter);
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$router.currentRoute.path.includes("nalazi/pregled")) {
      __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$emit("setFilterBar", this.$store.state.pretraga.filterBar);


      if (this.$store.state.pretraga.dateRange.from[0] == "" && this.$store.state.pretraga.dateRange.to[0] == "" && this.$store.state.pretraga.itemsPerPage != "") {
        __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$emit("setItemsPerPage", this.$store.state.pretraga.itemsPerPage);
      }
    }

    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("UzorakFromCollapse", function (data) {
      console.log("From colapse");
      __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/pregled/" + data.sample);
    });

    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("FilterBar", function (data) {
      _this.$store.dispatch("FilterBarChange", data);
    });

    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("ItemsPerPage", function (data) {
      _this.$store.dispatch("ItemsPerPageChange", data);

      var data = {
        od: "",
        do: "",
        from: "",
        to: ""
      };
      _this.$store.dispatch("DateRangeChange", data);
    });

    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("DateRange", function (data) {
      _this.$store.dispatch("DateRangeChange", data);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$router.currentRoute.path.includes("nalazi/pregled")) {
      var data = {
        od: "",
        do: "",
        from: "",
        to: ""
      };

      this.$store.dispatch("FilterBarChange", "");
      this.$store.dispatch("ItemsPerPageChange", "DANAS");
      this.$store.dispatch("DateRangeChange", data);
      this.$store.dispatch("PaginationPageChange", "1");
    }

    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("UzorakFromCollapse");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("FilterBar");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("ItemsPerPage");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("DateRange");
  },

  methods: {
    UpdateSamples: function UpdateSamples() {},
    convertUTCDateToLocalDate: function convertUTCDateToLocalDate(date) {
      var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = date.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var sec = date.getSeconds();
      if (sec < 10) {
        sec = "0" + sec;
      }
      newDate.setHours(hours - offset);
      return hours + ":" + minutes + ":" + sec;
    },
    Test: function Test(date) {
      var datum = this.convertUTCDateToLocalDate(new Date(date));
      return datum;
    },

    catchDialog: function catchDialog(event) {
      var _this2 = this;

      this.$dialog.confirm('Jeste li sigurni da želite obrisati zapis? <strong style="color: #E34A4A;"><br>Brisanjem uzorka, brišete i pripadajuće mu rezultate!</strong>', {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var uzorakid = event.target.id;

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["C" /* http */].post("uzorci/delete", {
          id: event.target.id,
          email: _this2.$store.state.user,
          token: _this2.$store.state.token,
          site: _this2.$store.state.site
        }).then(function (res) {
          if (res.data.success === false) {
            _this2.toastText = "Greška prilikom brisanja!";
            _this2.toastIcon = "fa-remove";
            _this2.toastPosition = "top-right";
            _this2.className = "vuestic-toast-danger";

            _this2.showToast(_this2.toastText, {
              icon: _this2.toastIcon,
              position: _this2.toastPosition,
              duration: _this2.toastDuration,
              fullWidth: _this2.isToastFullWidth,
              className: _this2.className
            });
          } else {
            _this2.toastText = "Zapis uspješno obrisan!";
            _this2.toastIcon = "fa-check";
            _this2.toastPosition = "top-right";
            _this2.className = "vuestic-toast-primary";

            _this2.showToast(_this2.toastText, {
              icon: _this2.toastIcon,
              position: _this2.toastPosition,
              duration: _this2.toastDuration,
              fullWidth: _this2.isToastFullWidth,
              className: _this2.className
            });
            _this2.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    catchDialogKontrola: function catchDialogKontrola(event) {
      var _this3 = this;

      this.$dialog.confirm("Jeste li sigurni da želite obrisati zapis?", {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var kontrolaid = event.target.id;

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["C" /* http */].post("kontrole/pregled/delete/", {
          _id: event.target.id,
          site: _this3.$store.state.site,
          token: _this3.$store.state.token
        }).then(function (res) {
          if (res.data.success === false) {
            _this3.toastText = "Greška prilikom brisanja!";
            _this3.toastIcon = "fa-remove";
            _this3.toastPosition = "top-right";
            _this3.className = "vuestic-toast-danger";

            _this3.showToast(_this3.toastText, {
              icon: _this3.toastIcon,
              position: _this3.toastPosition,
              duration: _this3.toastDuration,
              fullWidth: _this3.isToastFullWidth,
              className: _this3.className
            });
          } else {
            _this3.toastText = "Zapis uspješno obrisan!";
            _this3.toastIcon = "fa-check";
            _this3.toastPosition = "top-right";
            _this3.className = "vuestic-toast-primary";

            _this3.showToast(_this3.toastText, {
              icon: _this3.toastIcon,
              position: _this3.toastPosition,
              duration: _this3.toastDuration,
              fullWidth: _this3.isToastFullWidth,
              className: _this3.className
            });
            _this3.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    catchDialogOutbox: function catchDialogOutbox(event) {
      var _this4 = this;

      this.$dialog.confirm("Jeste li sigurni da želite obrisati zapis?", {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var idNalaza = event.target.id;
        var eNalaz = event.target.getAttribute("name");

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["C" /* http */].post("outbox/delete", {
          email: _this4.$store.state.userId,
          token: _this4.$store.state.token,
          site: _this4.$store.state.site,
          status: true,
          idNalaza: idNalaza,
          eNalaz: eNalaz,
          flag: true
        }).then(function (res) {
          if (res.data.success === false) {
            _this4.toastText = "Greška prilikom brisanja!";
            _this4.toastIcon = "fa-remove";
            _this4.toastPosition = "top-right";
            _this4.className = "vuestic-toast-danger";

            _this4.showToast(_this4.toastText, {
              icon: _this4.toastIcon,
              position: _this4.toastPosition,
              duration: _this4.toastDuration,
              fullWidth: _this4.isToastFullWidth,
              className: _this4.className
            });
          } else {
            _this4.toastText = "Zapis uspješno obrisan!";
            _this4.toastIcon = "fa-check";
            _this4.toastPosition = "top-right";
            _this4.className = "vuestic-toast-primary";

            _this4.showToast(_this4.toastText, {
              icon: _this4.toastIcon,
              position: _this4.toastPosition,
              duration: _this4.toastDuration,
              fullWidth: _this4.isToastFullWidth,
              className: _this4.className
            });
            _this4.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    catchDialogNalaz: function catchDialogNalaz(event) {
      var _this5 = this;

      this.$dialog.confirm("Jeste li sigurni da želite obrisati zapis?", {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var idNalaza = event.target.id;

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["C" /* http */].post("nalazi/delete", {
          email: _this5.$store.state.userId,
          token: _this5.$store.state.token,
          site: _this5.$store.state.site,
          status: true,
          idNalaza: idNalaza,
          flag: true
        }).then(function (res) {
          if (res.data.success === false) {
            _this5.toastText = "Greška prilikom brisanja!";
            _this5.toastIcon = "fa-remove";
            _this5.toastPosition = "top-right";
            _this5.className = "vuestic-toast-danger";

            _this5.showToast(_this5.toastText, {
              icon: _this5.toastIcon,
              position: _this5.toastPosition,
              duration: _this5.toastDuration,
              fullWidth: _this5.isToastFullWidth,
              className: _this5.className
            });
          } else {
            _this5.toastText = "Zapis uspješno obrisan!";
            _this5.toastIcon = "fa-check";
            _this5.toastPosition = "top-right";
            _this5.className = "vuestic-toast-primary";

            _this5.showToast(_this5.toastText, {
              icon: _this5.toastIcon,
              position: _this5.toastPosition,
              duration: _this5.toastDuration,
              fullWidth: _this5.isToastFullWidth,
              className: _this5.className
            });
            _this5.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    objToString: function objToString(obj) {
      var str = "";
      for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
          str += p + "::" + obj[p] + "\n";
        }
      }
      return str;
    },

    prikaziDetalje: function prikaziDetalje(args) {
      var niz = args[0];

      if (niz[1].name === "icon" && niz[0].barcode != undefined) {}

      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "barkod") {
          this.printajBarcode(args, niz[2]);
        }
        if (niz[1].name === "izbrisi") {
          this.catchDialog(niz[2]);
        }
        if (niz[1].name === "izbrisiKontrolu") {
          this.catchDialogKontrola(niz[2]);
        }
        if (niz[1].name === "brisanje") {
          this.catchDialogNalaz(niz[2]);
        }
        if (niz[1].name === "brisanjeOutbox") {
          this.catchDialogOutbox(niz[2]);
        }
        if (niz[1].name === "integracija") {
          __WEBPACK_IMPORTED_MODULE_9__config_config_js__["C" /* http */].post("api/retry", {
            id: niz[2].target.id,
            token: this.$store.state.token,
            site: this.$store.state.site
          }).then(function (res) {});
        }
        if (niz[1].name === "barcodes") {
          __WEBPACK_IMPORTED_MODULE_9__config_config_js__["C" /* http */].get("/rezultati/odobravanje/barcodes/" + niz[2].target.id + "/" + niz[0].id + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site + "&date=" + niz[0].datum.replace(/\./g, "-"), {}).then(function (res) {
            res.data.results.forEach(function (element) {
              var godiste = element.patient.jmbg.substring(4, 7);
              switch (godiste[0]) {
                case "9":
                  godiste = "1" + godiste;
                  break;
                case "0":
                  godiste = "2" + godiste;
                  break;

                default:
                  break;
              }

              var datum = element.created_at.substring(0, 10).split("-");
              var vrijeme = element.created_at.split("T")[1].substring(0, 5);
              datum = datum[2] + "." + datum[1] + "." + datum[0].substring(2, 4);
              datum = datum + "" + vrijeme;
              var link = __WEBPACK_IMPORTED_MODULE_9__config_config_js__["D" /* server */] + "images/barcodes/" + element.id + ".png";
            });
          });
        }
        if (niz[1].name === "nalazipregled") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "en") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "de") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/pregled/" + niz[2].target.id + "_German");
        }

        if (niz[1].name === "rtnalazipregled") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rtnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "rten") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rtnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "rtde") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rtnalazi/pregled/" + niz[2].target.id + "_German");
        }

        if (niz[1].name === "lpnalazipregled") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/lpnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "lpen") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/lpnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "lpde") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/lpnalazi/pregled/" + niz[2].target.id + "_German");
        }

        if (niz[1].name === "agnalazipregled") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/agnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "agen") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/agnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "agde") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/agnalazi/pregled/" + niz[2].target.id + "_German");
        }

        if (niz[1].name === "atnalazipregled") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/atnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "aten") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/atnalazi/pregled/" + niz[2].target.id);
        }

        if (niz[1].name === "atde") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/atnalazi/pregled/" + niz[2].target.id + "_German");
        }

        if (niz[1].name === "viber") {

          if (!isNaN(niz[0].kontakt) && niz[0].kontakt.length > 10) {
            var valid = true;
          } else {
            var valid = false;
          }

          this.viberData = {
            timestamp: niz[0].timestamp,
            uzorak: niz[0].uzorak,
            telefon: niz[0].vKontakt,
            valid: valid,
            protokol: niz[0].protokol,
            ime: niz[0].pacijent.ime,
            prezime: niz[0].pacijent.prezime,
            godiste: niz[0].vGodiste,
            spol: niz[0].pacijent.spol
          };

          this.pacIme = niz[0].pacijent.ime;
          this.pacPrezime = niz[0].pacijent.prezime;
          this.pacGodiste = niz[0].godiste.replace("<span>", "").replace("</span>", "");
          this.pacAdresa = niz[0].pacijent.adresa.toUpperCase();
          this.pacLokacija = niz[0].lokacija;
          this.note = niz[0].pacijent.note.trim();

          this.$refs.staticModalViberService.open();
        }

        if (niz[1].name === "email") {

          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(niz[0].pacijent.email.trim())) {
            var valid = true;
          } else {
            var valid = false;
          }

          this.emailData = {
            timestamp: niz[0].timestamp,
            uzorak: niz[0].uzorak,
            email: niz[0].pacijent.email.trim(),
            valid: valid,
            protokol: niz[0].protokol,
            ime: niz[0].pacijent.ime,
            prezime: niz[0].pacijent.prezime,
            godiste: niz[0].vGodiste,
            spol: niz[0].pacijent.spol
          };

          this.pacIme = niz[0].pacijent.ime;
          this.pacPrezime = niz[0].pacijent.prezime;
          this.pacGodiste = niz[0].godiste.replace("<span>", "").replace("</span>", "");
          this.pacAdresa = niz[0].pacijent.adresa.toUpperCase();
          this.pacLokacija = niz[0].lokacija;
          this.note = niz[0].pacijent.note.trim();

          this.$refs.staticModalEmailService.open();
        }

        if (niz[1].name === "ime") {
          this.pacIme = niz[0].pacijent.ime;
          this.pacPrezime = niz[0].pacijent.prezime;

          this.symptoms = niz[0].pacijent.symptoms;

          if (args[0][0].ime.includes("fa fa-user-md")) {

            this.$refs.staticModalDataSymptoms.open();
          }
        }

        if (niz[1].name === "rtoutbox") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/outbox/rt/" + niz[2].target.id);
        }

        if (niz[1].name === "lpoutbox") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/outbox/lp/" + niz[2].target.id);
        }

        if (niz[1].name === "agoutbox") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/outbox/ag/" + niz[2].target.id);
        }

        if (niz[1].name === "atoutbox") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/outbox/at/" + niz[2].target.id);
        }

        if (niz[1].name === "outbox") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/outbox/" + niz[2].target.id);
        }

        if (niz[1].name === "racun") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/obrada/predracun/" + niz[2].target.id);
        }

        if (niz[1].name === "partneri") {
          if (niz[0].posiljaoc != null) {

            niz[0].uzorci.forEach(function (element) {});
          } else if (niz[0].narucioc != null) {
            niz[0].uzorci.forEach(function (element) {});
          } else {}
        }

        if (niz[1].name === "rtobrada") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rtobrada/rezultati/" + niz[0]._id + "/" + niz[0].id + "?date=" + niz[0].date);
        }

        if (niz[1].name === "lpobrada") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/lpobrada/rezultati/" + niz[0]._id + "/" + niz[0].id + "?date=" + niz[0].date);
        }

        if (niz[1].name === "agobrada") {

          if (this.$store.state.main === true && this.$store.state.site != "60ab76ecf68be9eab3d69e55") {
              this.$refs.staticModalNotAuthorizedEdit.open();
            } else {
            __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/agobrada/rezultati/" + niz[0]._id + "/" + niz[0].id + "?date=" + niz[0].date);
          }
        }

        if (niz[1].name === "atobrada") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/atobrada/rezultati/" + niz[0]._id + "/" + niz[0].id + "?date=" + niz[0].date);
        }

        if (niz[1].name === "kontrole") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push({
            path: "/kontrole/obrada/rezultati/",
            query: {
              kontrola: niz[0]._id
            }
          });
        }

        if (niz[1].name === "barcode") {
          var link = __WEBPACK_IMPORTED_MODULE_9__config_config_js__["D" /* server */] + "images/barcodes/kontrole/" + niz[0].control + ".png";
          var datum = niz[0].created.substring(0, 10).split("-");
          var vrijeme = niz[0].created.split("T")[1].substring(0, 5);

          datum = datum[2] + "." + datum[1] + "." + datum[0].substring(2, 4);
          datum = datum + "" + vrijeme;
        }

        if (niz[1].name === "partials") {
          this.partials = {};
          this.partials_array = [];
          this.partials.uzorci = niz[2].target.id;
          this.partials_array = this.partials.uzorci.split(",");
          this.partials.pacijent = niz[2].target.getAttribute("name");


          if (niz[2].target.id != "unavailable") {
            this.$refs.staticModalUzorci.open();
          }
        }
      }
    },
    izbrisiUzorak: function izbrisiUzorak(event) {
      var uzorakid = event.target.id;
    },
    printajBarcode: function printajBarcode(args, event) {
      __WEBPACK_IMPORTED_MODULE_9__config_config_js__["C" /* http */].get("uzorci/barcode/" + args[0][0].id + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {});
    },
    datum: function datum() {
      var d = new Date();
      var mjesec = d.getMonth() + 1;
      var dan = d.getUTCDate();
      if (dan < 10) {
        dan = "0" + dan;
      }
      if (mjesec < 10) {
        mjesec = "0" + mjesec;
      }
      this.perPage = d.getFullYear() + "-" + mjesec + "-" + dan;
      this.perPage = "RADNA LISTA";
    },
    onFilterSet: function onFilterSet(filterText, event) {
      var _this6 = this;

      this.filterString = "";

      this.filterString = filterText;

      if (event != undefined && filterText.trim() != "") {
        if (event.keyCode == 13) {
          if (this.apiMode) {
            this.moreParams = {
              filter: filterText,
              dateRangeMin: this.date_range.min,
              dateRangeMax: this.date_range.max
            };
          } else {
            var txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function (item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }

          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
            return _this6.$refs.vuetable.refresh();
          });
        } else {}
      } else {
        if (this.apiMode) {
          this.moreParams = {
            filter: filterText,
            dateRangeMin: this.date_range.min,
            dateRangeMax: this.date_range.max
          };
        } else {
          var _txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function (item) {
            return item.name.search(_txt) >= 0 || item.email.search(_txt) >= 0;
          });
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
          return _this6.$refs.vuetable.refresh();
        });
      }
    },
    onDateRangeSet: function onDateRangeSet(val1, val2) {
      var _this7 = this;

      this.date_range.min = val1;
      this.date_range.max = val2;
      if (this.apiMode) {
        this.moreParams = {
          filter: this.filterString,
          dateRangeMin: this.date_range.min,
          dateRangeMax: this.date_range.max
        };
      } else {
        var txt = new RegExp(filterText, "i");
        this.tableData.data = originalData.filter(function (item) {
          return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
        });
      }
      if (this.date_range.min != "" && this.date_range.max != "") {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
          return _this7.$refs.vuetable.refresh();
        });
      }
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this8 = this;

      this.date_range = {
        min: "",
        max: ""
      };

      this.moreParams = {
        filter: this.filterString,
        dateRangeMin: this.date_range.min,
        dateRangeMax: this.date_range.max
      };

      this.perPage = itemsPerPageValue;
      this.$store.dispatch("dropdownChange", this.perPage);

      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
        return _this8.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);

      if (!isNaN(page)) {
        this.$store.dispatch("PaginationPageChange", page.toString());
      } else {
        switch (page) {
          case "prev":
            break;
          case "next":
            break;

          default:
            break;
        }
      }
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });
        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }
      pagination = this.$refs.vuetable.makePagination(data.length);
      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "ow+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordion_vue__ = __webpack_require__("sOJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32642c84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordion_vue__ = __webpack_require__("sV9M");
function injectStyle (ssrContext) {
  __webpack_require__("gbz1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32642c84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oxgk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Produkt_vue__ = __webpack_require__("D2Jv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db008c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Produkt_vue__ = __webpack_require__("cwUq");
function injectStyle (ssrContext) {
  __webpack_require__("F//X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Produkt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db008c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Produkt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "p3Qa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-patient-info",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noHeader: Boolean,
    godiste: {
      type: String,
      default: ""
    },
    cijena: {
      type: Number,
      default: 0
    }
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + "px";

      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    onHeaderClick: function onHeaderClick() {},
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "p4Q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"widget-header"},[_c('i',{staticClass:"vuestic-icon vuestic-icon-statistics",staticStyle:{"font-size":"17px","color":"#4ae387"}},[_vm._v(" ")]),_vm._v("\n    "+_vm._s(_vm.headerText)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p5Q8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "obrada",
  meta: {
    expanded: false,
    title: "Obrada uzoraka",
    class: "primary",
    show: false,
    iconClass: "vuestic-icon vuestic-icon-ui-elements"
  },
  children: [{
    name: "rt-obrada",
    path: "/rtobrada/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("rtobrada/table"),
    meta: {
      title: "CoV2 RT PCR obrada",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "lp-obrada",
    path: "/lpobrada/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("lpobrada/table"),
    meta: {
      title: "CoV2 RT LAMP obrada",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "ag-obrada",
    path: "/agobrada/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("agobrada/table"),
    meta: {
      title: "CoV2 Antigen obrada",
      show: false,
      requiredAuth: true
    }
  }, {
    name: "at-obrada",
    path: "/atobrada/pregled",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("atobrada/table"),
    meta: {
      title: "CoV2 Antitijela obrada",
      show: false,
      requiredAuth: true
    }
  }]
});

/***/ }),

/***/ "p7Oj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flower-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"dots-container",style:(_vm.dotsContainerStyle)},[_c('div',{staticClass:"bigger-dot",style:(_vm.biggerDotStyle)},[_c('div',{staticClass:"smaller-dot",style:(_vm.smallerDotStyle)})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p8Pd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayRefSingle_vue__ = __webpack_require__("wIAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffa2f14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayRefSingle_vue__ = __webpack_require__("Zlq4");
function injectStyle (ssrContext) {
  __webpack_require__("OMRV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fffa2f14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayRefSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffa2f14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayRefSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pAjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__ = __webpack_require__("ooJ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4cdecdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileMessage_vue__ = __webpack_require__("2uoA");
function injectStyle (ssrContext) {
  __webpack_require__("D4l/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4cdecdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4cdecdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pMA6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".flatpickr-calendar{background:transparent;opacity:0;display:none;text-align:center;visibility:hidden;padding:0;-webkit-animation:none;animation:none;direction:ltr;border:0;font-size:14px;line-height:24px;border-radius:5px;position:absolute;width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-touch-action:manipulation;touch-action:manipulation;background:#fff;-webkit-box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,.08);box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,.08)}.flatpickr-calendar.inline,.flatpickr-calendar.open{opacity:1;max-height:640px;visibility:visible}.flatpickr-calendar.open{display:inline-block;z-index:99999}.flatpickr-calendar.animate.open{-webkit-animation:fpFadeInDown .3s cubic-bezier(.23,1,.32,1);animation:fpFadeInDown .3s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.inline{display:block;position:relative;top:2px}.flatpickr-calendar.static{position:absolute;top:calc(100% + 2px)}.flatpickr-calendar.static.open{z-index:999;display:block}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7){-webkit-box-shadow:none!important;box-shadow:none!important}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1){-webkit-box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-calendar .hasTime .dayContainer,.flatpickr-calendar .hasWeeks .dayContainer{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.flatpickr-calendar .hasWeeks .dayContainer{border-left:0}.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time{height:40px;border-top:1px solid #e6e6e6}.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{height:auto}.flatpickr-calendar:after,.flatpickr-calendar:before{position:absolute;display:block;pointer-events:none;border:solid transparent;content:\"\";height:0;width:0;left:22px}.flatpickr-calendar.rightMost:after,.flatpickr-calendar.rightMost:before{left:auto;right:22px}.flatpickr-calendar:before{border-width:5px;margin:0 -5px}.flatpickr-calendar:after{border-width:4px;margin:0 -4px}.flatpickr-calendar.arrowTop:after,.flatpickr-calendar.arrowTop:before{bottom:100%}.flatpickr-calendar.arrowTop:before{border-bottom-color:#e6e6e6}.flatpickr-calendar.arrowTop:after{border-bottom-color:#fff}.flatpickr-calendar.arrowBottom:after,.flatpickr-calendar.arrowBottom:before{top:100%}.flatpickr-calendar.arrowBottom:before{border-top-color:#e6e6e6}.flatpickr-calendar.arrowBottom:after{border-top-color:#fff}.flatpickr-calendar:focus{outline:0}.flatpickr-wrapper{position:relative;display:inline-block}.flatpickr-months{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-months .flatpickr-month{background:transparent;color:rgba(0,0,0,.9);fill:rgba(0,0,0,.9);height:28px;line-height:1;text-align:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.flatpickr-months .flatpickr-next-month,.flatpickr-months .flatpickr-prev-month{text-decoration:none;cursor:pointer;position:absolute;top:0;line-height:16px;height:28px;padding:10px;z-index:3;color:rgba(0,0,0,.9);fill:rgba(0,0,0,.9)}.flatpickr-months .flatpickr-next-month.disabled,.flatpickr-months .flatpickr-prev-month.disabled{display:none}.flatpickr-months .flatpickr-next-month i,.flatpickr-months .flatpickr-prev-month i{position:relative}.flatpickr-months .flatpickr-next-month.flatpickr-prev-month,.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month{left:0}.flatpickr-months .flatpickr-next-month.flatpickr-next-month,.flatpickr-months .flatpickr-prev-month.flatpickr-next-month{right:0}.flatpickr-months .flatpickr-next-month:hover,.flatpickr-months .flatpickr-prev-month:hover{color:#959ea9}.flatpickr-months .flatpickr-next-month:hover svg,.flatpickr-months .flatpickr-prev-month:hover svg{fill:#f64747}.flatpickr-months .flatpickr-next-month svg,.flatpickr-months .flatpickr-prev-month svg{width:14px;height:14px}.flatpickr-months .flatpickr-next-month svg path,.flatpickr-months .flatpickr-prev-month svg path{-webkit-transition:fill .1s;transition:fill .1s;fill:inherit}.numInputWrapper{position:relative;height:auto}.numInputWrapper input,.numInputWrapper span{display:inline-block}.numInputWrapper input{width:100%}.numInputWrapper input::-ms-clear{display:none}.numInputWrapper span{position:absolute;right:0;width:14px;padding:0 4px 0 2px;height:50%;line-height:50%;opacity:0;cursor:pointer;border:1px solid rgba(57,57,57,.15);-webkit-box-sizing:border-box;box-sizing:border-box}.numInputWrapper span:hover{background:rgba(0,0,0,.1)}.numInputWrapper span:active{background:rgba(0,0,0,.2)}.numInputWrapper span:after{display:block;content:\"\";position:absolute}.numInputWrapper span.arrowUp{top:0;border-bottom:0}.numInputWrapper span.arrowUp:after{border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:4px solid rgba(57,57,57,.6);top:26%}.numInputWrapper span.arrowDown{top:50%}.numInputWrapper span.arrowDown:after{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(57,57,57,.6);top:40%}.numInputWrapper span svg{width:inherit;height:auto}.numInputWrapper span svg path{fill:rgba(0,0,0,.5)}.numInputWrapper:hover{background:rgba(0,0,0,.05)}.numInputWrapper:hover span{opacity:1}.flatpickr-current-month{font-size:135%;line-height:inherit;font-weight:300;color:inherit;position:absolute;width:75%;left:12.5%;padding:6.16px 0 0;line-height:1;height:28px;display:inline-block;text-align:center;-webkit-transform:translateZ(0);transform:translateZ(0)}.flatpickr-current-month span.cur-month{font-family:inherit;font-weight:700;color:inherit;display:inline-block;margin-left:.5ch;padding:0}.flatpickr-current-month span.cur-month:hover{background:rgba(0,0,0,.05)}.flatpickr-current-month .numInputWrapper{width:6ch;width:7ch\\0;display:inline-block}.flatpickr-current-month .numInputWrapper span.arrowUp:after{border-bottom-color:rgba(0,0,0,.9)}.flatpickr-current-month .numInputWrapper span.arrowDown:after{border-top-color:rgba(0,0,0,.9)}.flatpickr-current-month input.cur-year{background:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;cursor:text;padding:0 0 0 .5ch;margin:0;display:inline-block;font-size:inherit;font-family:inherit;font-weight:300;line-height:inherit;height:auto;border:0;border-radius:0;vertical-align:initial}.flatpickr-current-month input.cur-year:focus{outline:0}.flatpickr-current-month input.cur-year[disabled],.flatpickr-current-month input.cur-year[disabled]:hover{font-size:100%;color:rgba(0,0,0,.5);background:transparent;pointer-events:none}.flatpickr-weekdays{background:transparent;text-align:center;overflow:hidden;width:100%;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:28px}.flatpickr-weekdays,.flatpickr-weekdays .flatpickr-weekdaycontainer{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-weekdays .flatpickr-weekdaycontainer,span.flatpickr-weekday{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}span.flatpickr-weekday{cursor:default;font-size:90%;background:transparent;color:rgba(0,0,0,.54);line-height:1;margin:0;text-align:center;display:block;font-weight:bolder}.dayContainer,.flatpickr-weeks{padding:1px 0 0}.flatpickr-days{position:relative;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;width:307.875px}.flatpickr-days:focus{outline:0}.dayContainer{padding:0;outline:0;text-align:left;width:307.875px;min-width:307.875px;max-width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-wrap:wrap;-ms-flex-pack:justify;-webkit-justify-content:space-around;justify-content:space-around;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}.dayContainer+.dayContainer{-webkit-box-shadow:-1px 0 0 #e6e6e6;box-shadow:-1px 0 0 #e6e6e6}.flatpickr-day{background:none;border:1px solid transparent;border-radius:150px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#393939;cursor:pointer;font-weight:400;width:14.2857143%;-webkit-flex-basis:14.2857143%;-ms-flex-preferred-size:14.2857143%;flex-basis:14.2857143%;max-width:39px;height:39px;line-height:39px;margin:0;display:inline-block;position:relative;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.flatpickr-day.inRange,.flatpickr-day.nextMonthDay.inRange,.flatpickr-day.nextMonthDay.today.inRange,.flatpickr-day.nextMonthDay:focus,.flatpickr-day.nextMonthDay:hover,.flatpickr-day.prevMonthDay.inRange,.flatpickr-day.prevMonthDay.today.inRange,.flatpickr-day.prevMonthDay:focus,.flatpickr-day.prevMonthDay:hover,.flatpickr-day.today.inRange,.flatpickr-day:focus,.flatpickr-day:hover{cursor:pointer;outline:0;background:#e6e6e6;border-color:#e6e6e6}.flatpickr-day.today{border-color:#959ea9}.flatpickr-day.today:focus,.flatpickr-day.today:hover{border-color:#959ea9;background:#959ea9;color:#fff}.flatpickr-day.endRange,.flatpickr-day.endRange.inRange,.flatpickr-day.endRange.nextMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.endRange:focus,.flatpickr-day.endRange:hover,.flatpickr-day.selected,.flatpickr-day.selected.inRange,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.selected:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange,.flatpickr-day.startRange.inRange,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.startRange:focus,.flatpickr-day.startRange:hover{background:#569ff7;-webkit-box-shadow:none;box-shadow:none;color:#fff;border-color:#569ff7}.flatpickr-day.endRange.startRange,.flatpickr-day.selected.startRange,.flatpickr-day.startRange.startRange{border-radius:50px 0 0 50px}.flatpickr-day.endRange.endRange,.flatpickr-day.selected.endRange,.flatpickr-day.startRange.endRange{border-radius:0 50px 50px 0}.flatpickr-day.endRange.startRange+.endRange:not(:nth-child(7n+1)),.flatpickr-day.selected.startRange+.endRange:not(:nth-child(7n+1)),.flatpickr-day.startRange.startRange+.endRange:not(:nth-child(7n+1)){-webkit-box-shadow:-10px 0 0 #569ff7;box-shadow:-10px 0 0 #569ff7}.flatpickr-day.endRange.startRange.endRange,.flatpickr-day.selected.startRange.endRange,.flatpickr-day.startRange.startRange.endRange{border-radius:50px}.flatpickr-day.inRange{border-radius:0;-webkit-box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-day.disabled,.flatpickr-day.disabled:hover,.flatpickr-day.nextMonthDay,.flatpickr-day.notAllowed,.flatpickr-day.notAllowed.nextMonthDay,.flatpickr-day.notAllowed.prevMonthDay,.flatpickr-day.prevMonthDay{color:rgba(57,57,57,.3);background:transparent;border-color:transparent;cursor:default}.flatpickr-day.disabled,.flatpickr-day.disabled:hover{cursor:not-allowed;color:rgba(57,57,57,.1)}.flatpickr-day.week.selected{border-radius:0;-webkit-box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7;box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7}.flatpickr-day.hidden{visibility:hidden}.rangeMode .flatpickr-day{margin-top:1px}.flatpickr-weekwrapper{display:inline-block;float:left}.flatpickr-weekwrapper .flatpickr-weeks{padding:0 12px;-webkit-box-shadow:1px 0 0 #e6e6e6;box-shadow:1px 0 0 #e6e6e6}.flatpickr-weekwrapper .flatpickr-weekday{float:none;width:100%;line-height:28px}.flatpickr-weekwrapper span.flatpickr-day,.flatpickr-weekwrapper span.flatpickr-day:hover{display:block;width:100%;max-width:none;color:rgba(57,57,57,.3);background:transparent;cursor:default;border:none}.flatpickr-innerContainer{display:block;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;overflow:hidden}.flatpickr-innerContainer,.flatpickr-rContainer{-webkit-box-sizing:border-box;box-sizing:border-box}.flatpickr-rContainer{display:inline-block;padding:0}.flatpickr-time{text-align:center;outline:0;display:block;height:0;line-height:40px;max-height:40px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-time:after{content:\"\";display:table;clear:both}.flatpickr-time .numInputWrapper{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:40%;height:40px;float:left}.flatpickr-time .numInputWrapper span.arrowUp:after{border-bottom-color:#393939}.flatpickr-time .numInputWrapper span.arrowDown:after{border-top-color:#393939}.flatpickr-time.hasSeconds .numInputWrapper{width:26%}.flatpickr-time.time24hr .numInputWrapper{width:49%}.flatpickr-time input{background:transparent;-webkit-box-shadow:none;box-shadow:none;border:0;border-radius:0;text-align:center;margin:0;padding:0;height:inherit;line-height:inherit;color:#393939;font-size:14px;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box}.flatpickr-time input.flatpickr-hour{font-weight:700}.flatpickr-time input.flatpickr-minute,.flatpickr-time input.flatpickr-second{font-weight:400}.flatpickr-time input:focus{outline:0;border:0}.flatpickr-time .flatpickr-am-pm,.flatpickr-time .flatpickr-time-separator{height:inherit;display:inline-block;float:left;line-height:inherit;color:#393939;font-weight:700;width:2%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}.flatpickr-time .flatpickr-am-pm{outline:0;width:18%;cursor:pointer;text-align:center;font-weight:400}.flatpickr-time .flatpickr-am-pm:focus,.flatpickr-time .flatpickr-am-pm:hover,.flatpickr-time input:focus,.flatpickr-time input:hover{background:#f3f3f3}.flatpickr-input[readonly]{cursor:pointer}@-webkit-keyframes fpFadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fpFadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}", "", {"version":3,"sources":["C:/Users/atom/Desktop/ATOM Projects/11 - SARS (Ostalo)/so_client/node_modules/flatpickr/dist/flatpickr.css"],"names":[],"mappings":"AAAA,oBACE,uBAAwB,AACxB,UAAW,AACX,aAAc,AACd,kBAAmB,AACnB,kBAAmB,AACnB,UAAW,AACX,uBAAwB,AAChB,eAAgB,AACxB,cAAe,AACf,SAAU,AACV,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,8BAA+B,AACvB,sBAAuB,AAC/B,8BAA+B,AAC3B,0BAA2B,AAC/B,gBAAiB,AACjB,gHAAsH,AAC9G,uGAA8G,CACvH,AACD,oDAEE,UAAW,AACX,iBAAkB,AAClB,kBAAoB,CACrB,AACD,yBACE,qBAAsB,AACtB,aAAe,CAChB,AACD,iCACE,6DAAqE,AAC7D,oDAA6D,CACtE,AACD,2BACE,cAAe,AACf,kBAAmB,AACnB,OAAS,CACV,AACD,2BACE,kBAAmB,AACnB,oBAAsB,CACvB,AACD,gCACE,YAAa,AACb,aAAe,CAChB,AACD,mHACE,kCAAoC,AAC5B,yBAA4B,CACrC,AACD,mHACE,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,uFAEE,gBAAiB,AACjB,6BAA8B,AAC9B,2BAA6B,CAC9B,AACD,4CACE,aAAe,CAChB,AACD,0DACE,YAAa,AACb,4BAA8B,CAC/B,AACD,uDACE,WAAa,CACd,AACD,qDAEE,kBAAmB,AACnB,cAAe,AACf,oBAAqB,AACrB,yBAA0B,AAC1B,WAAY,AACZ,SAAU,AACV,QAAS,AACT,SAAW,CACZ,AACD,yEAEE,UAAW,AACX,UAAY,CACb,AACD,2BACE,iBAAkB,AAClB,aAAe,CAChB,AACD,0BACE,iBAAkB,AAClB,aAAe,CAChB,AACD,uEAEE,WAAa,CACd,AACD,oCACE,2BAA6B,CAC9B,AACD,mCACE,wBAA0B,CAC3B,AACD,6EAEE,QAAU,CACX,AACD,uCACE,wBAA0B,CAC3B,AACD,sCACE,qBAAuB,CACxB,AACD,0BACE,SAAW,CACZ,AACD,mBACE,kBAAmB,AACnB,oBAAsB,CACvB,AACD,kBACE,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,YAAc,CACf,AACD,mCACE,uBAAwB,AACxB,qBAAuB,AACvB,oBAAsB,AACtB,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,gBAAiB,AACjB,mBAAoB,AACpB,eAAgB,AACZ,WAAY,AACR,MAAQ,CACjB,AACD,gFAEE,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,MAAS,AACT,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,UAAW,AACX,qBAAuB,AACvB,mBAAsB,CACvB,AACD,kGAEE,YAAc,CACf,AACD,oFAEE,iBAAmB,CACpB,AACD,0HAME,MAAQ,CAKT,AAKD,0HAME,OAAS,CAKV,AAKD,4FAEE,aAAe,CAChB,AACD,oGAEE,YAAc,CACf,AACD,wFAEE,WAAY,AACZ,WAAa,CACd,AACD,kGAEE,4BAA8B,AAC9B,oBAAsB,AACtB,YAAc,CACf,AACD,iBACE,kBAAmB,AACnB,WAAa,CACd,AACD,6CAEE,oBAAsB,CACvB,AACD,uBACE,UAAY,CACb,AACD,kCACE,YAAc,CACf,AACD,sBACE,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,oBAAqB,AACrB,WAAY,AACZ,gBAAiB,AACjB,UAAW,AACX,eAAgB,AAChB,oCAAsC,AACtC,8BAA+B,AACvB,qBAAuB,CAChC,AACD,4BACE,yBAA4B,CAC7B,AACD,6BACE,yBAA4B,CAC7B,AACD,4BACE,cAAe,AACf,WAAY,AACZ,iBAAmB,CACpB,AACD,8BACE,MAAO,AACP,eAAiB,CAClB,AACD,oCACE,kCAAmC,AACnC,mCAAoC,AACpC,0CAA4C,AAC5C,OAAS,CACV,AACD,gCACE,OAAS,CACV,AACD,sCACE,kCAAmC,AACnC,mCAAoC,AACpC,uCAAyC,AACzC,OAAS,CACV,AACD,0BACE,cAAe,AACf,WAAa,CACd,AACD,+BACE,mBAAsB,CACvB,AACD,uBACE,0BAA6B,CAC9B,AACD,4BACE,SAAW,CACZ,AACD,yBACE,eAAgB,AAChB,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,mBAAsB,AACtB,cAAe,AACf,YAAa,AACb,qBAAsB,AACtB,kBAAmB,AACnB,gCAA8C,AACtC,uBAAsC,CAC/C,AACD,wCACE,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,qBAAsB,AACtB,iBAAmB,AACnB,SAAW,CACZ,AACD,8CACE,0BAA6B,CAC9B,AACD,0CACE,UAAW,AACX,YAAa,AACb,oBAAsB,CACvB,AACD,6DACE,kCAAqC,CACtC,AACD,+DACE,+BAAkC,CACnC,AACD,wCACE,uBAAwB,AACxB,8BAA+B,AACvB,sBAAuB,AAC/B,cAAe,AACf,YAAa,AACb,mBAAqB,AACrB,SAAU,AACV,qBAAsB,AACtB,kBAAmB,AACnB,oBAAqB,AACrB,gBAAiB,AACjB,oBAAqB,AACrB,YAAa,AACb,SAAU,AACV,gBAAiB,AACjB,sBAAwB,CACzB,AACD,8CACE,SAAW,CACZ,AACD,0GAEE,eAAgB,AAChB,qBAAuB,AACvB,uBAAwB,AACxB,mBAAqB,CACtB,AACD,oBACE,uBAAwB,AACxB,kBAAmB,AACnB,gBAAiB,AACjB,WAAY,AAKZ,yBAA0B,AAC1B,2BAA4B,AACxB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAa,CACd,AACD,oEAVE,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,YAAc,CAgBf,AACD,uEALE,mBAAoB,AACpB,eAAgB,AACZ,WAAY,AACR,MAAQ,CAgBjB,AAdD,uBACE,eAAgB,AAChB,cAAe,AACf,uBAAwB,AACxB,sBAAwB,AACxB,cAAe,AACf,SAAU,AACV,kBAAmB,AACnB,cAAe,AAKf,kBAAoB,CACrB,AACD,+BAEE,eAAmB,CACpB,AACD,gBACE,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACzB,+BAAgC,AAC5B,qBAAsB,AAClB,uBAAwB,AAChC,eAAiB,CAClB,AACD,sBACE,SAAW,CACZ,AACD,cACE,UAAW,AACX,UAAW,AACX,gBAAiB,AACjB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,8BAA+B,AACvB,sBAAuB,AAC/B,qBAAsB,AACtB,oBAAqB,AACrB,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,uBAAwB,AAChB,eAAgB,AACxB,mBAAoB,AACpB,sBAAuB,AACvB,qCAAsC,AAC9B,6BAA8B,AACtC,gCAA8C,AACtC,wBAAsC,AAC9C,SAAW,CACZ,AACD,4BACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,eACE,gBAAiB,AACjB,6BAA8B,AAC9B,oBAAqB,AACrB,8BAA+B,AACvB,sBAAuB,AAC/B,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,+BAAgC,AAC5B,oCAAqC,AACjC,uBAAwB,AAChC,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,SAAU,AACV,qBAAsB,AACtB,kBAAmB,AACnB,wBAAyB,AACzB,+BAAgC,AAC5B,qBAAsB,AAClB,uBAAwB,AAChC,iBAAmB,CACpB,AACD,kYAYE,eAAgB,AAChB,UAAW,AACX,mBAAoB,AACpB,oBAAsB,CACvB,AACD,qBACE,oBAAsB,CACvB,AACD,sDAEE,qBAAsB,AACtB,mBAAoB,AACpB,UAAY,CACb,AACD,skBAkBE,mBAAoB,AACpB,wBAAyB,AACjB,gBAAiB,AACzB,WAAY,AACZ,oBAAsB,CACvB,AACD,2GAGE,2BAA6B,CAC9B,AACD,qGAGE,2BAA6B,CAC9B,AACD,2MAGE,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,sIAGE,kBAAoB,CACrB,AACD,uBACE,gBAAiB,AACjB,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,sNAOE,wBAA0B,AAC1B,uBAAwB,AACxB,yBAA0B,AAC1B,cAAgB,CACjB,AACD,sDAEE,mBAAoB,AACpB,uBAA0B,CAC3B,AACD,6BACE,gBAAiB,AACjB,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,sBACE,iBAAmB,CACpB,AACD,0BACE,cAAgB,CACjB,AACD,uBACE,qBAAsB,AACtB,UAAY,CACb,AACD,wCACE,eAAgB,AAChB,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,0CACE,WAAY,AACZ,WAAY,AACZ,gBAAkB,CACnB,AACD,0FAEE,cAAe,AACf,WAAY,AACZ,eAAgB,AAChB,wBAA0B,AAC1B,uBAAwB,AACxB,eAAgB,AAChB,WAAa,CACd,AACD,0BACE,cAAe,AACf,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,aAAc,AAGd,eAAiB,CAClB,AACD,gDAJE,8BAA+B,AACvB,qBAAuB,CAQhC,AALD,sBACE,qBAAsB,AACtB,SAAW,CAGZ,AACD,gBACE,kBAAmB,AACnB,UAAW,AACX,cAAe,AACf,SAAU,AACV,iBAAkB,AAClB,gBAAiB,AACjB,8BAA+B,AACvB,sBAAuB,AAC/B,gBAAiB,AACjB,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,YAAc,CACf,AACD,sBACE,WAAY,AACZ,cAAe,AACf,UAAY,CACb,AACD,iCACE,mBAAoB,AACpB,eAAgB,AACZ,WAAY,AACR,OAAQ,AAChB,UAAW,AACX,YAAa,AACb,UAAY,CACb,AACD,oDACE,2BAA6B,CAC9B,AACD,sDACE,wBAA0B,CAC3B,AACD,4CACE,SAAW,CACZ,AACD,0CACE,SAAW,CACZ,AACD,sBACE,uBAAwB,AACxB,wBAAyB,AACjB,gBAAiB,AACzB,SAAU,AACV,gBAAiB,AACjB,kBAAmB,AACnB,SAAU,AACV,UAAW,AACX,eAAgB,AAChB,oBAAqB,AACrB,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,8BAA+B,AACvB,qBAAuB,CAChC,AACD,qCACE,eAAkB,CACnB,AACD,8EAEE,eAAiB,CAClB,AACD,4BACE,UAAW,AACX,QAAU,CACX,AACD,2EAEE,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,oBAAqB,AACrB,cAAe,AACf,gBAAkB,AAClB,SAAU,AACV,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,0BAA2B,AACvB,2BAA4B,AACxB,iBAAmB,CAC5B,AACD,iCACE,UAAW,AACX,UAAW,AACX,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,sIAIE,kBAAoB,CACrB,AACD,2BACE,cAAgB,CACjB,AACD,gCACE,GACE,UAAW,AACX,yCAA4C,AACpC,gCAAoC,CAC7C,AACD,GACE,UAAW,AACX,gCAAwC,AAChC,uBAAgC,CACzC,CACF,AACD,wBACE,GACE,UAAW,AACX,yCAA4C,AACpC,gCAAoC,CAC7C,AACD,GACE,UAAW,AACX,gCAAwC,AAChC,uBAAgC,CACzC,CACF","file":"flatpickr.css","sourcesContent":[".flatpickr-calendar {\n  background: transparent;\n  opacity: 0;\n  display: none;\n  text-align: center;\n  visibility: hidden;\n  padding: 0;\n  -webkit-animation: none;\n          animation: none;\n  direction: ltr;\n  border: 0;\n  font-size: 14px;\n  line-height: 24px;\n  border-radius: 5px;\n  position: absolute;\n  width: 307.875px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  background: #fff;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);\n          box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);\n}\n.flatpickr-calendar.open,\n.flatpickr-calendar.inline {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n}\n.flatpickr-calendar.open {\n  display: inline-block;\n  z-index: 99999;\n}\n.flatpickr-calendar.animate.open {\n  -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n          animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.flatpickr-calendar.inline {\n  display: block;\n  position: relative;\n  top: 2px;\n}\n.flatpickr-calendar.static {\n  position: absolute;\n  top: calc(100% + 2px);\n}\n.flatpickr-calendar.static.open {\n  z-index: 999;\n  display: block;\n}\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n  -webkit-box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n          box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n.flatpickr-calendar .hasWeeks .dayContainer,\n.flatpickr-calendar .hasTime .dayContainer {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.flatpickr-calendar .hasWeeks .dayContainer {\n  border-left: 0;\n}\n.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {\n  height: 40px;\n  border-top: 1px solid #e6e6e6;\n}\n.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n  height: auto;\n}\n.flatpickr-calendar:before,\n.flatpickr-calendar:after {\n  position: absolute;\n  display: block;\n  pointer-events: none;\n  border: solid transparent;\n  content: '';\n  height: 0;\n  width: 0;\n  left: 22px;\n}\n.flatpickr-calendar.rightMost:before,\n.flatpickr-calendar.rightMost:after {\n  left: auto;\n  right: 22px;\n}\n.flatpickr-calendar:before {\n  border-width: 5px;\n  margin: 0 -5px;\n}\n.flatpickr-calendar:after {\n  border-width: 4px;\n  margin: 0 -4px;\n}\n.flatpickr-calendar.arrowTop:before,\n.flatpickr-calendar.arrowTop:after {\n  bottom: 100%;\n}\n.flatpickr-calendar.arrowTop:before {\n  border-bottom-color: #e6e6e6;\n}\n.flatpickr-calendar.arrowTop:after {\n  border-bottom-color: #fff;\n}\n.flatpickr-calendar.arrowBottom:before,\n.flatpickr-calendar.arrowBottom:after {\n  top: 100%;\n}\n.flatpickr-calendar.arrowBottom:before {\n  border-top-color: #e6e6e6;\n}\n.flatpickr-calendar.arrowBottom:after {\n  border-top-color: #fff;\n}\n.flatpickr-calendar:focus {\n  outline: 0;\n}\n.flatpickr-wrapper {\n  position: relative;\n  display: inline-block;\n}\n.flatpickr-months {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flatpickr-months .flatpickr-month {\n  background: transparent;\n  color: rgba(0,0,0,0.9);\n  fill: rgba(0,0,0,0.9);\n  height: 28px;\n  line-height: 1;\n  text-align: center;\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  overflow: hidden;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n  text-decoration: none;\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  line-height: 16px;\n  height: 28px;\n  padding: 10px;\n  z-index: 3;\n  color: rgba(0,0,0,0.9);\n  fill: rgba(0,0,0,0.9);\n}\n.flatpickr-months .flatpickr-prev-month.disabled,\n.flatpickr-months .flatpickr-next-month.disabled {\n  display: none;\n}\n.flatpickr-months .flatpickr-prev-month i,\n.flatpickr-months .flatpickr-next-month i {\n  position: relative;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n/*\n      /*rtl:begin:ignore*/\n/*\n      */\n  left: 0;\n/*\n      /*rtl:end:ignore*/\n/*\n      */\n}\n/*\n      /*rtl:begin:ignore*/\n/*\n      /*rtl:end:ignore*/\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n/*\n      /*rtl:begin:ignore*/\n/*\n      */\n  right: 0;\n/*\n      /*rtl:end:ignore*/\n/*\n      */\n}\n/*\n      /*rtl:begin:ignore*/\n/*\n      /*rtl:end:ignore*/\n.flatpickr-months .flatpickr-prev-month:hover,\n.flatpickr-months .flatpickr-next-month:hover {\n  color: #959ea9;\n}\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n  fill: #f64747;\n}\n.flatpickr-months .flatpickr-prev-month svg,\n.flatpickr-months .flatpickr-next-month svg {\n  width: 14px;\n  height: 14px;\n}\n.flatpickr-months .flatpickr-prev-month svg path,\n.flatpickr-months .flatpickr-next-month svg path {\n  -webkit-transition: fill 0.1s;\n  transition: fill 0.1s;\n  fill: inherit;\n}\n.numInputWrapper {\n  position: relative;\n  height: auto;\n}\n.numInputWrapper input,\n.numInputWrapper span {\n  display: inline-block;\n}\n.numInputWrapper input {\n  width: 100%;\n}\n.numInputWrapper input::-ms-clear {\n  display: none;\n}\n.numInputWrapper span {\n  position: absolute;\n  right: 0;\n  width: 14px;\n  padding: 0 4px 0 2px;\n  height: 50%;\n  line-height: 50%;\n  opacity: 0;\n  cursor: pointer;\n  border: 1px solid rgba(57,57,57,0.15);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.numInputWrapper span:hover {\n  background: rgba(0,0,0,0.1);\n}\n.numInputWrapper span:active {\n  background: rgba(0,0,0,0.2);\n}\n.numInputWrapper span:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n}\n.numInputWrapper span.arrowUp {\n  top: 0;\n  border-bottom: 0;\n}\n.numInputWrapper span.arrowUp:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid rgba(57,57,57,0.6);\n  top: 26%;\n}\n.numInputWrapper span.arrowDown {\n  top: 50%;\n}\n.numInputWrapper span.arrowDown:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid rgba(57,57,57,0.6);\n  top: 40%;\n}\n.numInputWrapper span svg {\n  width: inherit;\n  height: auto;\n}\n.numInputWrapper span svg path {\n  fill: rgba(0,0,0,0.5);\n}\n.numInputWrapper:hover {\n  background: rgba(0,0,0,0.05);\n}\n.numInputWrapper:hover span {\n  opacity: 1;\n}\n.flatpickr-current-month {\n  font-size: 135%;\n  line-height: inherit;\n  font-weight: 300;\n  color: inherit;\n  position: absolute;\n  width: 75%;\n  left: 12.5%;\n  padding: 6.16px 0 0 0;\n  line-height: 1;\n  height: 28px;\n  display: inline-block;\n  text-align: center;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n}\n.flatpickr-current-month span.cur-month {\n  font-family: inherit;\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  margin-left: 0.5ch;\n  padding: 0;\n}\n.flatpickr-current-month span.cur-month:hover {\n  background: rgba(0,0,0,0.05);\n}\n.flatpickr-current-month .numInputWrapper {\n  width: 6ch;\n  width: 7ch\\0;\n  display: inline-block;\n}\n.flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: rgba(0,0,0,0.9);\n}\n.flatpickr-current-month .numInputWrapper span.arrowDown:after {\n  border-top-color: rgba(0,0,0,0.9);\n}\n.flatpickr-current-month input.cur-year {\n  background: transparent;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: inherit;\n  cursor: text;\n  padding: 0 0 0 0.5ch;\n  margin: 0;\n  display: inline-block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 300;\n  line-height: inherit;\n  height: auto;\n  border: 0;\n  border-radius: 0;\n  vertical-align: initial;\n}\n.flatpickr-current-month input.cur-year:focus {\n  outline: 0;\n}\n.flatpickr-current-month input.cur-year[disabled],\n.flatpickr-current-month input.cur-year[disabled]:hover {\n  font-size: 100%;\n  color: rgba(0,0,0,0.5);\n  background: transparent;\n  pointer-events: none;\n}\n.flatpickr-weekdays {\n  background: transparent;\n  text-align: center;\n  overflow: hidden;\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 28px;\n}\n.flatpickr-weekdays .flatpickr-weekdaycontainer {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\nspan.flatpickr-weekday {\n  cursor: default;\n  font-size: 90%;\n  background: transparent;\n  color: rgba(0,0,0,0.54);\n  line-height: 1;\n  margin: 0;\n  text-align: center;\n  display: block;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  font-weight: bolder;\n}\n.dayContainer,\n.flatpickr-weeks {\n  padding: 1px 0 0 0;\n}\n.flatpickr-days {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  width: 307.875px;\n}\n.flatpickr-days:focus {\n  outline: 0;\n}\n.dayContainer {\n  padding: 0;\n  outline: 0;\n  text-align: left;\n  width: 307.875px;\n  min-width: 307.875px;\n  max-width: 307.875px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: inline-block;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  -ms-flex-pack: justify;\n  -webkit-justify-content: space-around;\n          justify-content: space-around;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  opacity: 1;\n}\n.dayContainer + .dayContainer {\n  -webkit-box-shadow: -1px 0 0 #e6e6e6;\n          box-shadow: -1px 0 0 #e6e6e6;\n}\n.flatpickr-day {\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 150px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #393939;\n  cursor: pointer;\n  font-weight: 400;\n  width: 14.2857143%;\n  -webkit-flex-basis: 14.2857143%;\n      -ms-flex-preferred-size: 14.2857143%;\n          flex-basis: 14.2857143%;\n  max-width: 39px;\n  height: 39px;\n  line-height: 39px;\n  margin: 0;\n  display: inline-block;\n  position: relative;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  text-align: center;\n}\n.flatpickr-day.inRange,\n.flatpickr-day.prevMonthDay.inRange,\n.flatpickr-day.nextMonthDay.inRange,\n.flatpickr-day.today.inRange,\n.flatpickr-day.prevMonthDay.today.inRange,\n.flatpickr-day.nextMonthDay.today.inRange,\n.flatpickr-day:hover,\n.flatpickr-day.prevMonthDay:hover,\n.flatpickr-day.nextMonthDay:hover,\n.flatpickr-day:focus,\n.flatpickr-day.prevMonthDay:focus,\n.flatpickr-day.nextMonthDay:focus {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.today {\n  border-color: #959ea9;\n}\n.flatpickr-day.today:hover,\n.flatpickr-day.today:focus {\n  border-color: #959ea9;\n  background: #959ea9;\n  color: #fff;\n}\n.flatpickr-day.selected,\n.flatpickr-day.startRange,\n.flatpickr-day.endRange,\n.flatpickr-day.selected.inRange,\n.flatpickr-day.startRange.inRange,\n.flatpickr-day.endRange.inRange,\n.flatpickr-day.selected:focus,\n.flatpickr-day.startRange:focus,\n.flatpickr-day.endRange:focus,\n.flatpickr-day.selected:hover,\n.flatpickr-day.startRange:hover,\n.flatpickr-day.endRange:hover,\n.flatpickr-day.selected.prevMonthDay,\n.flatpickr-day.startRange.prevMonthDay,\n.flatpickr-day.endRange.prevMonthDay,\n.flatpickr-day.selected.nextMonthDay,\n.flatpickr-day.startRange.nextMonthDay,\n.flatpickr-day.endRange.nextMonthDay {\n  background: #569ff7;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n  border-color: #569ff7;\n}\n.flatpickr-day.selected.startRange,\n.flatpickr-day.startRange.startRange,\n.flatpickr-day.endRange.startRange {\n  border-radius: 50px 0 0 50px;\n}\n.flatpickr-day.selected.endRange,\n.flatpickr-day.startRange.endRange,\n.flatpickr-day.endRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),\n.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),\n.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n  -webkit-box-shadow: -10px 0 0 #569ff7;\n          box-shadow: -10px 0 0 #569ff7;\n}\n.flatpickr-day.selected.startRange.endRange,\n.flatpickr-day.startRange.startRange.endRange,\n.flatpickr-day.endRange.startRange.endRange {\n  border-radius: 50px;\n}\n.flatpickr-day.inRange {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n          box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n.flatpickr-day.disabled,\n.flatpickr-day.disabled:hover,\n.flatpickr-day.prevMonthDay,\n.flatpickr-day.nextMonthDay,\n.flatpickr-day.notAllowed,\n.flatpickr-day.notAllowed.prevMonthDay,\n.flatpickr-day.notAllowed.nextMonthDay {\n  color: rgba(57,57,57,0.3);\n  background: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n.flatpickr-day.disabled,\n.flatpickr-day.disabled:hover {\n  cursor: not-allowed;\n  color: rgba(57,57,57,0.1);\n}\n.flatpickr-day.week.selected {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;\n          box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;\n}\n.flatpickr-day.hidden {\n  visibility: hidden;\n}\n.rangeMode .flatpickr-day {\n  margin-top: 1px;\n}\n.flatpickr-weekwrapper {\n  display: inline-block;\n  float: left;\n}\n.flatpickr-weekwrapper .flatpickr-weeks {\n  padding: 0 12px;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6;\n          box-shadow: 1px 0 0 #e6e6e6;\n}\n.flatpickr-weekwrapper .flatpickr-weekday {\n  float: none;\n  width: 100%;\n  line-height: 28px;\n}\n.flatpickr-weekwrapper span.flatpickr-day,\n.flatpickr-weekwrapper span.flatpickr-day:hover {\n  display: block;\n  width: 100%;\n  max-width: none;\n  color: rgba(57,57,57,0.3);\n  background: transparent;\n  cursor: default;\n  border: none;\n}\n.flatpickr-innerContainer {\n  display: block;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: hidden;\n}\n.flatpickr-rContainer {\n  display: inline-block;\n  padding: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.flatpickr-time {\n  text-align: center;\n  outline: 0;\n  display: block;\n  height: 0;\n  line-height: 40px;\n  max-height: 40px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flatpickr-time:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.flatpickr-time .numInputWrapper {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  width: 40%;\n  height: 40px;\n  float: left;\n}\n.flatpickr-time .numInputWrapper span.arrowUp:after {\n  border-bottom-color: #393939;\n}\n.flatpickr-time .numInputWrapper span.arrowDown:after {\n  border-top-color: #393939;\n}\n.flatpickr-time.hasSeconds .numInputWrapper {\n  width: 26%;\n}\n.flatpickr-time.time24hr .numInputWrapper {\n  width: 49%;\n}\n.flatpickr-time input {\n  background: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border: 0;\n  border-radius: 0;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: inherit;\n  line-height: inherit;\n  color: #393939;\n  font-size: 14px;\n  position: relative;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.flatpickr-time input.flatpickr-hour {\n  font-weight: bold;\n}\n.flatpickr-time input.flatpickr-minute,\n.flatpickr-time input.flatpickr-second {\n  font-weight: 400;\n}\n.flatpickr-time input:focus {\n  outline: 0;\n  border: 0;\n}\n.flatpickr-time .flatpickr-time-separator,\n.flatpickr-time .flatpickr-am-pm {\n  height: inherit;\n  display: inline-block;\n  float: left;\n  line-height: inherit;\n  color: #393939;\n  font-weight: bold;\n  width: 2%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-align-self: center;\n      -ms-flex-item-align: center;\n          align-self: center;\n}\n.flatpickr-time .flatpickr-am-pm {\n  outline: 0;\n  width: 18%;\n  cursor: pointer;\n  text-align: center;\n  font-weight: 400;\n}\n.flatpickr-time input:hover,\n.flatpickr-time .flatpickr-am-pm:hover,\n.flatpickr-time input:focus,\n.flatpickr-time .flatpickr-am-pm:focus {\n  background: #f3f3f3;\n}\n.flatpickr-input[readonly] {\n  cursor: pointer;\n}\n@-webkit-keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n            transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n            transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "pVgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sc-launcher",class:{opened: _vm.isOpen},style:({backgroundColor: _vm.colors.launcher.bg}),on:{"click":function($event){$event.preventDefault();_vm.isOpen ? _vm.close() : _vm.open()}}},[(_vm.newMessagesCount > 0 && !_vm.isOpen)?_c('div',{staticClass:"sc-new-messsages-count"},[_vm._v("\n      "+_vm._s(_vm.newMessagesCount)+"\n    ")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"sc-open-icon",attrs:{"src":__webpack_require__("xc3+")}}),_vm._v(" "),_c('img',{staticClass:"sc-closed-icon",attrs:{"src":__webpack_require__("9QaW")}})]),_vm._v(" "),_c('ChatWindow',{attrs:{"messageList":_vm.messageList,"onUserInputSubmit":_vm.onMessageWasSent,"participants":_vm.participants,"title":_vm.chatWindowTitle,"titleImageUrl":_vm.titleImageUrl,"isOpen":_vm.isOpen,"onClose":_vm.close,"showEmoji":_vm.showEmoji,"showFile":_vm.showFile,"placeholder":_vm.placeholder,"showTypingIndicator":_vm.showTypingIndicator,"colors":_vm.colors,"alwaysScrollToBottom":_vm.alwaysScrollToBottom}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pWYb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intersecting-circles-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinnerBlock",style:(_vm.spinnerBlockStyle)},_vm._l((_vm.circleStyles),function(cs,index){return _c('span',{key:index,staticClass:"circle",style:(cs)})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pd+I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "plIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseUzorak_vue__ = __webpack_require__("46z7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97a61e50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseUzorak_vue__ = __webpack_require__("v1IF");
function injectStyle (ssrContext) {
  __webpack_require__("MCxg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseUzorak_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97a61e50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseUzorak_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pmVg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseSamplesEntry_vue__ = __webpack_require__("kFeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292cd5a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseSamplesEntry_vue__ = __webpack_require__("t+wK");
function injectStyle (ssrContext) {
  __webpack_require__("zPX7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseSamplesEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292cd5a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseSamplesEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pqzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__ = __webpack_require__("XG+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3b6dd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__ = __webpack_require__("iE2n");
function injectStyle (ssrContext) {
  __webpack_require__("295n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3b6dd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pr2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "animatedValue", "min", "max", "color", "size", "isActive"],
  watch: {
    animatedValue: function animatedValue() {
      if (this.animatedValue === 100) {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Loaded");
      }
    }
  },
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "prz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 1,
    'per_page': 10,
    'current_page': 1,
    'last_page': 1,
    'next_page_url': null,
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }]
});

/***/ }),

/***/ "pvi4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[(_vm.color === 'default')?_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","name":_vm.name,"required":""},domProps:{"value":(_vm.displayValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]):_vm._e(),_vm._v(" "),(_vm.color != 'default')?_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'has-value': !!_vm.displayValue},staticStyle:{"color":"#e34a4a"},attrs:{"readonly":"","name":_vm.name,"required":""},domProps:{"value":(_vm.displayValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{key:option,staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.selectOption(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))])])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pxXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pzlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


var palette = __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.palette;

/* harmony default export */ __webpack_exports__["a"] = ({
  legend: {
    position: 'bottom',
    labels: {
      fontColor: palette.fontColor,
      fontFamily: 'sans-serif',
      fontSize: 14,
      padding: 20,
      usePointStyle: true
    }
  },
  tooltips: {
    bodyFontSize: 14,
    bodyFontFamily: 'sans-serif'
  },
  responsive: true,
  maintainAspectRatio: false
});

/***/ }),

/***/ "q30D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "qCsd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qHzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("h+W8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_121ee15d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("B4Pl");
function injectStyle (ssrContext) {
  __webpack_require__("U/uR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-121ee15d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_121ee15d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "qI/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qQ6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEvaluationMulti_vue__ = __webpack_require__("OlZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12079109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEvaluationMulti_vue__ = __webpack_require__("xuN7");
function injectStyle (ssrContext) {
  __webpack_require__("xdBg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEvaluationMulti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12079109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEvaluationMulti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qgs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload",class:{'vuestic-file-upload--dropzone': _vm.dropzone}},[_c('vuestic-file-upload-container',{attrs:{"type":_vm.type,"fileTypes":_vm.fileTypes,"dropzone":_vm.dropzone},on:{"upload":_vm.uploadFile}},[(_vm.files.length)?_c('vuestic-file-upload-list',{attrs:{"type":_vm.type,"files":_vm.files},on:{"remove":_vm.removeFile,"remove-single":_vm.removeSingleFile}}):_vm._e(),_vm._v(" "),_c('vuestic-modal-error',{ref:"mediumModal",attrs:{"no-buttons":false,"cancelText":"ZATVORI"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        "+_vm._s('')+"\n        "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s('415: Unsupported Format'))])]),_vm._v(" "),_c('div',[_c('h5',[_vm._v(_vm._s('Format nije podržan.'))])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qjhy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bar",staticClass:"vuestic-progress-bar"},[(_vm.type == 'horizontal')?_c('horizontal-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'vertical')?_c('vertical-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'circle')?_c('circle-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"color":_vm.color,"background-color":_vm.backgroundColor,"start-color":_vm.startColor,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qui1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadListItem__ = __webpack_require__("lpwG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadGalleryItem__ = __webpack_require__("btIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadSingleItem__ = __webpack_require__("itpM");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-file-upload-list',
  components: {
    VuesticFileUploadListItem: __WEBPACK_IMPORTED_MODULE_0__VuesticFileUploadListItem__["default"],
    VuesticFileUploadGalleryItem: __WEBPACK_IMPORTED_MODULE_1__VuesticFileUploadGalleryItem__["default"],
    VuesticFileUploadSingleItem: __WEBPACK_IMPORTED_MODULE_2__VuesticFileUploadSingleItem__["default"]
  },
  props: {
    type: {
      type: String
    },
    files: {
      default: null
    }
  },
  computed: {
    filesList: function filesList() {
      return this.files.map(this.convertFile);
    }
  },
  methods: {
    convertFile: function convertFile(file) {
      return {
        name: file.name,
        size: this.formatSize(file.size),
        date: this.formatDate(new Date()),
        image: file
      };
    },
    formatSize: function formatSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      var k = 1024;
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      return date.toLocaleDateString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
  }
});

/***/ }),

/***/ "qwLI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qwMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");


var _props;



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-obrada-control",
  props: (_props = {
    value: {
      type: Boolean,
      default: false
    },
    retest: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    aparat: {
      type: String,
      default: ""
    },
    sample: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "aparat", {
    type: Object,
    default: function _default() {
      return {};
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "noHeader", Boolean), _props),
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      expanded: false,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("SetClientHeight", function (sid) {
      if (_this.$slots.header[0].elm.id + _this.aparat._id === sid) {
        var bodyContent = _this.$refs.collapseBody;
        _this.clientHeight = _this.$slots.body[0].elm.clientHeight + 5 + "px";
        _this.onHeaderClick();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("SetClientHeight");
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      switch (event.target.id) {
        case "forward":
          this.expanded = true;
          break;
        case "trash":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("trash", this.sample);
          break;
        case "edit":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("edit", this.sample);
          break;
        case "comment":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("comment", this.sample);
          break;
        case "barcode":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("barcode", this.sample);
          break;
        case "backward":
          this.expanded = false;
          break;
        case "save":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("save", this.sample);
          break;
        case "retest":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("retest", this.sample);
          break;
        case "check":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("check", this.sample);
          break;
        case "verify":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("verify", this.sample);
          break;
        case "undo":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("undo", this.sample);
          break;
        case "unlock":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("unlock", this.sample);
          if (!this.show) {
            __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Sample", this.sample);
          } else {}
          break;
        case "pdf":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("pdf", this.sample);
          break;
        case "block":
          break;
        case "":
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Sample", this.sample);
          break;
        default:
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Sample", this.sample);
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("AllowClick", this.show);
          break;
      }
    },
    onHeaderClick: function onHeaderClick() {
      this.toggle();
      this.accordion.onChildChange(this, this.show);
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "qyF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.viber === false),expression:"$store.state.viber === false"}]},[_c('strong',[_vm._v(_vm._s("Nemate odgovarajuće privilegije."))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.viberData.valid && _vm.$store.state.viber === true),expression:"!viberData.valid && $store.state.viber === true"}]},[_c('strong',[_vm._v(_vm._s("Telefonski broj nije validan."))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viberData.valid && _vm.$store.state.viber === true),expression:"viberData.valid && $store.state.viber === true"}]},[_c('strong',[_vm._v(_vm._s("Telefonski broj :")+"  \n                   \n                   \n                   "),_c('span',{staticStyle:{"color":"#db76df"}},[_vm._v(_vm._s(_vm.viberData.telefon))])]),_vm._v(" "),_c('div',{staticStyle:{"min-height":"12px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ba),expression:"ba"}],staticClass:"form-check-input",attrs:{"id":"ba","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.ba)?_vm._i(_vm.ba,null)>-1:(_vm.ba)},on:{"change":function($event){var $$a=_vm.ba,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ba=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ba=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ba=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"ba"}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s("Bosanski jezik"))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.en),expression:"en"}],staticClass:"form-check-input",attrs:{"id":"en","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.en)?_vm._i(_vm.en,null)>-1:(_vm.en)},on:{"change":function($event){var $$a=_vm.en,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.en=$$a.concat([$$v]))}else{$$i>-1&&(_vm.en=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.en=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"en"}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s("Engleski jezik"))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.de),expression:"de"}],staticClass:"form-check-input",attrs:{"id":"de","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.de)?_vm._i(_vm.de,null)>-1:(_vm.de)},on:{"change":function($event){var $$a=_vm.de,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.de=$$a.concat([$$v]))}else{$$i>-1&&(_vm.de=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.de=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"de"}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s("Njemački jezik"))])])])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s("ZATVORI"))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled || !_vm.viberData.valid || _vm.isLoading || (!_vm.ba && !_vm.en && !_vm.de) || _vm.$store.state.viber === false},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"on-cancel":_vm.onCancel,"color":"#4ae387","is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(false)?_c('button',{on:{"click":function($event){$event.preventDefault();_vm.Test($event)}}},[_vm._v(_vm._s("Loading..."))]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r+1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-switch"},[_c('div',{staticClass:"vuestic-switch-option true-option",class:{'active': _vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(true)}}},[_vm._t("trueTitle")],2),_vm._v(" "),_c('div',{staticClass:"vuestic-switch-option false-option",class:{'active': !_vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(false)}}},[_vm._t("falseTitle")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r8Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "rJt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseAparati_vue__ = __webpack_require__("NG7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c91ded00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseAparati_vue__ = __webpack_require__("0okC");
function injectStyle (ssrContext) {
  __webpack_require__("oJ4h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseAparati_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c91ded00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseAparati_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rMiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-control-aparati",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "ZATVORI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "rh3O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rhzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__ = __webpack_require__("u1r+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256a1d98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__ = __webpack_require__("r+1b");
function injectStyle (ssrContext) {
  __webpack_require__("yZ5d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256a1d98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rnTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rsSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayRefMulti_vue__ = __webpack_require__("Bmn3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfb22fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayRefMulti_vue__ = __webpack_require__("kUjm");
function injectStyle (ssrContext) {
  __webpack_require__("Tp06")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dfb22fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaAssayRefMulti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfb22fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaAssayRefMulti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ruEV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rxEm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-file-upload-undo"
});

/***/ }),

/***/ "sELh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUpload_vue__ = __webpack_require__("FmeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dc0717_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUpload_vue__ = __webpack_require__("zyGe");
function injectStyle (ssrContext) {
  __webpack_require__("Hwjq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dc0717_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sH8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breeding-rhombus-spinner",style:(_vm.spinnerStyle)},[_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{key:index,staticClass:"rhombus",class:("child-" + (index + 1)),style:(rs)})}),_vm._v(" "),_c('div',{staticClass:"rhombus big",style:(_vm.bigRhombusStyle)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sIlG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "modal-calendar",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    vrijeme: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      time: "",
      uzorak: "",
      config: {
        maxDate: new Date(),
        enableTime: true,
        inline: true,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      }
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    vrijeme: function vrijeme(newVal, oldVal) {
      this.time = newVal;
    },

    sample: function sample(newVal, oldVal) {
      this.uzorak = newVal;
    },

    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("setCalendar", this.uzorak, this.time);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "sNHN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sOJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-control-accordion',
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "sV9M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sbxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.password),expression:"password"}],staticClass:"fa fa-eye icon-right input-icon",staticStyle:{"color":"#4ae387"},on:{"click":function($event){$event.preventDefault();_vm.Password('password')}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.password),expression:"!password"}],staticClass:"fa fa-eye-slash icon-right input-icon",staticStyle:{"color":"#e34a4a"},on:{"click":function($event){$event.preventDefault();_vm.Password('!password')}}})])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "shI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__ = __webpack_require__("4DkM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e54292a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__ = __webpack_require__("0GQG");
function injectStyle (ssrContext) {
  __webpack_require__("Lbox")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e54292a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sjuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tablePagination && _vm.tablePagination.last_page > 1),expression:"tablePagination && tablePagination.last_page > 1"}],class:_vm.css.wrapperClass},[_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(1)}}},[(_vm.css.icons.first != '')?_c('i',{class:[_vm.css.icons.first]}):_c('span',[_vm._v("«")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('prev')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.prev]}):_c('span',[_vm._v(" ‹")])]),_vm._v(" "),(_vm.notEnoughPages)?[_vm._l((_vm.totalPage),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){_vm.loadPage(n)}}})]})]:[_vm._l((_vm.windowSize),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart+n-1) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){_vm.loadPage(_vm.windowStart+n-1)}}})]})],_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('next')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.next]}):_c('span',[_vm._v("› ")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(_vm.totalPage)}}},[(_vm.css.icons.last != '')?_c('i',{class:[_vm.css.icons.last]}):_c('span',[_vm._v("»")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "szBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-accordion-patient-info",
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "t+wK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){$event.preventDefault();_vm.onHeaderClick($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{staticClass:"vuestic-collapse__header__button btn btn-danger",staticStyle:{"height":"40px","padding-top":"0.6rem","text-transform":"none"}},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"col-md-7 icon-bar pull-right"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-remove",attrs:{"id":"remove"}})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-commenting",attrs:{"id":"commenting"}})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"id":"calendar"}})]),_vm._v(" "),(!_vm.hitan)?_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-star-o",attrs:{"id":"star-o"}})]):_vm._e(),_vm._v(" "),(_vm.hitan)?_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-star",attrs:{"id":"star"}})]):_vm._e()])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t3JD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t9OK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteModal_vue__ = __webpack_require__("MV/r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88935296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteModal_vue__ = __webpack_require__("3/Lv");
function injectStyle (ssrContext) {
  __webpack_require__("97Tl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88935296"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88935296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tFDZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tMml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__ = __webpack_require__("h/wX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__ = __webpack_require__("n+XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_local_data__ = __webpack_require__("jgNs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__ = __webpack_require__("CHUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__("NHnr");












var originalData = __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-data-table-control-edit",
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__["default"]
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      tableData: __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */],
      perPage: 10,
      colorClasses: {},
      moreParams: { access: this.$store.state.access.level },
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__["a" /* default */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$on("UređivanjeRefresh", function () {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$off("UređivanjeRefresh");
  },

  methods: {
    Akcija: function Akcija(args) {
      var niz = args[0];

      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "reference") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("KontroleReference", niz[0]);
        } else if (niz[1].name === "uredi") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("KontroleUredi", niz[0]);
        } else if (niz[1].name === "akcija") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("KontroleAkcija", niz[0]);
        } else if (niz[1].name === "analizator") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("KontroleAnalizator", niz[0]);
        } else {}
      }
    },

    onFilterSet: function onFilterSet(filterText) {
      var _this2 = this;

      if (this.apiMode) {
        this.moreParams = {
          filter: filterText,
          access: this.$store.state.access.level
        };
      } else {
        var txt = new RegExp(filterText, "i");
        this.tableData.data = originalData.filter(function (item) {
          return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
        });
      }
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this3 = this;

      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "tP2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-building-square-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:{'clear': index && index % 3 === 0},style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPNP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeCollapse_vue__ = __webpack_require__("eLCv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037946dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeCollapse_vue__ = __webpack_require__("VQ5b");
function injectStyle (ssrContext) {
  __webpack_require__("fU/A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postavkeCollapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037946dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postavkeCollapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tUiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-secondary-warning btn-micro",staticStyle:{"text-transform":"none","color":"#e34a4a"},on:{"click":function($event){$event.preventDefault();_vm.NewPatient($event)}}},[_c('i',{staticClass:"fa fa-user",staticStyle:{"font-size":"16px"}}),_vm._v("\n    "+_vm._s(' Novi pacijent')+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tWOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_directives_Dropdown__ = __webpack_require__("SRTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-simple-select-bubble",
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0__vuestic_directives_Dropdown__["a" /* default */]
  },
  props: {
    label: String,
    options: Array,
    value: {
      default: "",
      required: true
    },
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: "simple-select"
    }
  },
  data: function data() {
    return {
      validated: false,
      displayValue: this.value || "",
      selectedValue: this.value
    };
  },

  watch: {
    value: {
      handler: function handler(value) {
        if (!value || !this.optionKey) {
          this.displayValue = value || "";
          this.selectedValue = value || "";
          return;
        }
        this.selectedValue = value[this.optionKey];
        this.displayValue = value[this.optionKey];
      },

      immediate: true
    }
  },
  computed: {
    filteredList: function filteredList() {
      var optionKey = this.optionKey;
      var displayValue = this.displayValue;
      if (displayValue === "") {
        return this.options;
      } else {
        return this.options.filter(function (item) {
          if (optionKey && item && item[optionKey]) {
            if (displayValue) {
              return item[optionKey].toLowerCase().search(displayValue.toLowerCase()) === 0;
            }
          } else {
            return (item + "").toLowerCase().search(displayValue.toLowerCase()) === 0;
          }
        });
      }
    },
    isClearable: function isClearable() {
      return this.clearable && this.selectedValue !== "" && this.displayValue !== "" && this.selectedValue !== undefined;
    },
    placeholder: function placeholder() {
      if (this.optionKey && this.selectedValue) {
        return this.selectedValue[this.optionKey];
      } else {
        return this.selectedValue;
      }
    }
  },
  methods: {
    onDropdownClose: function onDropdownClose() {
      if (!this.value) {
        this.displayValue = "";
      }
      if (this.value && this.optionKey) {
        this.displayValue = this.value[this.optionKey];
      }
    },
    toggleSelection: function toggleSelection(option) {
      this.isOptionSelected(option) ? this.unselectOption() : this.selectOption(option);
    },
    unselectOption: function unselectOption() {
      this.selectedValue = "";
      this.$emit("input", this.selectedValue);
    },
    showDropdown: function showDropdown() {
      this.displayValue = this.selectedValue;
    },
    isOptionSelected: function isOptionSelected(option) {
      if (this.optionKey) {
        return this.selectedValue === option[this.optionKey];
      } else {
        return this.selectedValue === option;
      }
    },
    selectOption: function selectOption(option) {
      if (!option) {
        this.displayValue = "";
      }
      if (option && this.optionKey) {
        this.displayValue = option[this.optionKey];
      }
      this.selectedValue = option;
      this.$emit("input", option);
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.value;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.value;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return "The " + this.name + " field is required";
    }
  }
});

/***/ }),

/***/ "tZ2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("otT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c4f1f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("Dvia");
function injectStyle (ssrContext) {
  __webpack_require__("6oRW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32c4f1f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c4f1f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tcEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "tdNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-square-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tjYl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadGalleryItem_vue__ = __webpack_require__("oFf2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245913b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadGalleryItem_vue__ = __webpack_require__("FUSO");
function injectStyle (ssrContext) {
  __webpack_require__("0fHG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadGalleryItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245913b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadGalleryItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "u0yM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal"},[(_vm.size != 'thick')?_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('width: ' + _vm.value + '%')},[(_vm.size == 'thick')?_c('span',{staticClass:"value",class:{hidden: _vm.animatedValue == _vm.min}},[_vm._v(_vm._s(_vm.animatedValue + '%'))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u1UZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u1r+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-switch',
  props: {
    value: Boolean
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },

  methods: {
    setValue: function setValue(newVal) {
      this.$emit('input', newVal);
    }
  }
});

/***/ }),

/***/ "u2aT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u4eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "changelog",
  path: "/changelog",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("changelog/changelog"),
  meta: {
    default: false,
    title: "Change Log",
    class: "primary",
    show: false,
    iconClass: "glyphicon glyphicon-erase",
    requiredAuth: true
  }
});

/***/ }),

/***/ "u8au":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uCDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Patient_vue__ = __webpack_require__("vgUD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baa56e1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Patient_vue__ = __webpack_require__("OXUU");
function injectStyle (ssrContext) {
  __webpack_require__("O5J4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Patient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baa56e1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Patient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uGPS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uM+q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      izbor: "",
      izborPrikaz: "",
      izborPrikazTmpSifra: "",
      izborPrikazTmpIme: "",
      izabraniSiteId: "",
      initSiteName: "",
      initSiteNameTmpSifra: "",
      initSiteNameTmpIme: "",
      initSite: [],
      rawSites: [],
      currentSiteID: "",
      allSitesID: [],
      window: {
        width: 0,
        height: 0
      },
      tmpSiteIzbor: ""
    };
  },

  name: "site-dropdown",

  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    var _this = this;

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.currentSiteID = this.$store.state.site;
    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("users/" + this.$store.state.userId, {
      email: this.$store.state.userId,
      token: this.$store.state.token,
      site: this.$store.state.site
    }).then(function (res) {
      if (res.data.message != undefined && res.data.message === "Niste autorizirani") {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/auth/login");
      }

      if (res.data.user != undefined) {
        _this.allSitesID = res.data.user.sites;
        _this.catchSection();
      }
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if (this.window.width > 1000) {
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("version", true);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("version", false);
      }

      if (this.window.width > 600) {
        this.izborPrikaz = this.izborPrikazTmpIme;
        this.initSiteName = this.initSiteNameTmpIme;
      } else if (this.window.width <= 600) {
        this.izborPrikaz = this.izborPrikazTmpSifra;
        this.initSiteName = this.initSiteNameTmpSifra;
      }
    },
    isPortrait: function isPortrait() {
      if (window.screen.width < window.screen.height) {
        return true;
      } else {
        return false;
      }
    },
    setSite: function setSite(locale) {
      var _this2 = this;

      this.$store.dispatch("filterChange", "");
      this.$store.dispatch("FilterBarChange", "");

      this.izbor = locale;
      this.options.forEach(function (element) {
        if (element.sifra === locale) {
          if (_this2.isPortrait()) {
            _this2.izborPrikaz = element.sifra;
            _this2.izabraniSiteId = element.id;
            _this2.izborPrikazTmpSifra = element.sifra;
            _this2.izborPrikazTmpIme = element.name;
          } else {
            _this2.izborPrikaz = element.name;
            _this2.izabraniSiteId = element.id;
            _this2.izborPrikazTmpSifra = element.sifra;
            _this2.izborPrikazTmpIme = element.name;
          }
        }
      });
      this.handleResize();

      this.$store.dispatch("siteChange", this.izabraniSiteId);
      this.$store.dispatch("siteClear");
      var current = this.$router.currentRoute.path;

      if (current.includes("rtnalazi/pregled")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/rtnalazi/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("lpnalazi/pregled")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/lpnalazi/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("agnalazi/pregled")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/agnalazi/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("atnalazi/pregled")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/atnalazi/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("nalazi/pregled")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/nalazi/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("nalazi/outbox/rt")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/nalazi/outbox/rt/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("nalazi/outbox/lp")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/nalazi/outbox/lp/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("nalazi/outbox/ag")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/nalazi/outbox/ag/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("nalazi/outbox/at")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/nalazi/outbox/at/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("rtobrada/") && !current.includes("kontrole/")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/rtobrada/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("lpobrada/") && !current.includes("kontrole/")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/lpobrada/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("agobrada/") && !current.includes("kontrole/")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/agobrada/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("atobrada/") && !current.includes("kontrole/")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/atobrada/pregled/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes("samples")) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/prijem/" + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      } else {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push(current + "?site=" + this.$store.state.site);
        this.$refs.close.click();
      }
    },
    currentSite: function currentSite() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.locale();
    },
    sitePickClass: function sitePickClass(sifra) {
      return "flag-icon-" + name;
    },

    catchSection: function catchSection() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].get("postavke/sajtovi/list?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        _this3.rawSites = res.data.sajtovi;
        var tmp = {};
        var tmpAll = {};
        if (_this3.rawSites != undefined) {}

        _this3.rawSites.forEach(function (element) {
          _this3.allSitesID.forEach(function (asite) {
            if (element._id === asite) {
              tmpAll.sifra = element.sifra;
              tmpAll.name = element.naziv;
              tmpAll.id = element._id;
              _this3.options.push(tmpAll);
              tmpAll = {};
            }
          });

          if (element._id === _this3.currentSiteID) {
            tmp.sifra = element.sifra;
            tmp.name = element.naziv;
            tmp.id = element._id;
            if (_this3.isPortrait()) {
              _this3.initSiteName = element.sifra;
              _this3.initSiteNameTmpSifra = element.sifra;
              _this3.initSiteNameTmpIme = element.naziv;
            } else {
              _this3.initSiteName = element.naziv;
              _this3.initSiteNameTmpSifra = element.sifra;
              _this3.initSiteNameTmpIme = element.naziv;
            }
            _this3.initSite.push(tmp);
          }
        });
        _this3.handleResize();
      });
    }
  }
});

/***/ }),

/***/ "uQbW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ub2Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{ 'vuestic-collapse__header--no-header': _vm.noHeader },on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{
        'vuestic-collapse__header__button btn btn-primary':
          _vm.sample.status === 'ODOBREN' || _vm.sample.status === 'VERIFICIRAN',
        'vuestic-collapse__header__button btn btn-warning':
          _vm.sample.status === 'U OBRADI',
        'vuestic-collapse__header__button btn btn-danger':
          _vm.sample.status === 'ZAPRIMLJEN',
        'vuestic-collapse__header__button btn btn-info':
          _vm.sample.status === 'REALIZOVAN',
      },staticStyle:{"text-transform":"none"}},[_vm._t("header"),_vm._v(" "),(
          _vm.sample.status === 'VERIFICIRAN' &&
          !_vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px","color":"#f7cc36"},attrs:{"id":_vm.id}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.sample.status != 'ODOBREN'),expression:"sample.status != 'ODOBREN'"}]},[_vm._v(_vm._s(" | ")+_vm._s(_vm.sample.status))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.sample.status === 'ODOBREN'),expression:"sample.status === 'ODOBREN'"}],staticStyle:{"color":"#ffffff"}},[_vm._v(_vm._s(" | ")+_vm._s("In progress..."))]),_vm._v(" "),(false)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(
          _vm.sample.status != 'VERIFICIRAN' &&
          !_vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px"},attrs:{"id":_vm.id}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.sample.status != 'ODOBREN'),expression:"sample.status != 'ODOBREN'"}]},[_vm._v(_vm._s(" | ")+_vm._s(_vm.sample.status))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.sample.status === 'ODOBREN'),expression:"sample.status === 'ODOBREN'"}],staticStyle:{"color":"#ffffff"}},[_vm._v(_vm._s(" | ")+_vm._s("In progress..."))])]):_vm._e(),_vm._v(" "),(
          _vm.sample.status === 'VERIFICIRAN' &&
          _vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px","color":"#f7cc36"},attrs:{"id":_vm.id}},[_vm._v("\n        "+_vm._s(" | ")+_vm._s(_vm.sample.tip.match(/\(([^)]+)\)/)[1])+"\n        "),(false)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(
          _vm.sample.status != 'VERIFICIRAN' &&
          _vm.sample.tip.includes('Mikrobiologija')
        )?_c('span',{staticStyle:{"font-size":"12px"},attrs:{"id":_vm.id}},[_vm._v(_vm._s(" | ")+_vm._s(_vm.sample.tip.match(/\(([^)]+)\)/)[1]))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-7 pull-right",staticStyle:{"margin-right":"20px"},attrs:{"id":"block"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            !_vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            !expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-forward fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"forward","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status === 'U OBRADI' &&
            _vm.$store.state.configuration.delete === true
          ),expression:"\n            show &&\n            expanded &&\n            sample.status === 'U OBRADI' &&\n            $store.state.configuration.delete === true\n          "}]},[_c('i',{staticClass:"fa fa-trash fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"trash","title":"Brisanje uzorka"}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status === 'U OBRADI' &&
            _vm.$store.state.configuration.delete === true
          ),expression:"\n            show &&\n            expanded &&\n            sample.status === 'U OBRADI' &&\n            $store.state.configuration.delete === true\n          "}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-commenting fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"comment","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN' && (
              _vm.$router.currentRoute.path.includes('rtobrada/rezultati') ||
            _vm.$router.currentRoute.path.includes('lpobrada/rezultati') || 1 === 1
            )              
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN' && (\n              $router.currentRoute.path.includes('rtobrada/rezultati') ||\n            $router.currentRoute.path.includes('lpobrada/rezultati') || 1 === 1\n            )              \n          "}]},[_c('i',{staticClass:"fa fa-calendar fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"calendar","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN' && (
              _vm.$router.currentRoute.path.includes('rtobrada/rezultati') ||
            _vm.$router.currentRoute.path.includes('lpobrada/rezultati') || 1 === 1
            )              
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN' && (\n              $router.currentRoute.path.includes('rtobrada/rezultati') ||\n            $router.currentRoute.path.includes('lpobrada/rezultati') || 1 === 1\n            )              \n          "}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-handshake-o fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"handshake","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-barcode fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"barcode","title":""}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.show &&
            _vm.expanded &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          ),expression:"\n            show &&\n            expanded &&\n            sample.status != 'ODOBREN' &&\n            sample.status != 'VERIFICIRAN'\n          "}]},[_c('i',{staticClass:"fa fa-step-backward fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"backward","title":""}})]),_vm._v(" "),(
            _vm.show &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          )?_c('span',[_c('i',{staticClass:"fa fa-check fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"check","title":""}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status != 'VERIFICIRAN')?_c('span',{staticClass:"col-md-3 pull-right",staticStyle:{"diplay":"inline-block","width":"25px"}},[_vm._v("  ")]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status === 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-lock fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"22px"},attrs:{"id":"unlock","title":""}})]):_vm._e(),_vm._v(" "),(!_vm.show && _vm.sample.status === 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-lock fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"22px","color":"#f7cc36"},attrs:{"id":"unlock","title":""}})]):_vm._e(),_vm._v(" "),(
            _vm.show &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN'
          )?_c('span',[_c('i',{staticClass:"fa fa-save fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"save","title":""}})]):_vm._e(),_vm._v(" "),(
            _vm.show &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN' &&
            _vm.retest
          )?_c('span',[_c('i',{staticClass:"fa fa-save fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"save","title":""}})]):_vm._e(),_vm._v(" "),(
            _vm.show &&
            _vm.sample.status != 'ODOBREN' &&
            _vm.sample.status != 'VERIFICIRAN' &&
            _vm.retest
          )?_c('span',[_c('i',{staticClass:"fa fa-refresh fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"retest","title":""}})]):_vm._e()])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uezS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue__ = __webpack_require__("ZQsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61b1b5f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserList_vue__ = __webpack_require__("j5pT");
function injectStyle (ssrContext) {
  __webpack_require__("j8Lc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61b1b5f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61b1b5f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uoTt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uu9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('items-per-page',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"options":_vm.itemsPerPage,"defaultPerPage":_vm.perPage},on:{"items-per-page":_vm.onItemsPerPage}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:pagination-data":_vm.onPaginationData,"vuetable:cell-clicked":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.Akcija([args]);
}}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uzyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "user-registration",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    labassay: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$on("UserRegistrationHide", function () {
      _this.show = false;
    });
  },


  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$off("UserRegistrationHide");
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");

      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("UserRegistrationInsert");

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("UserRegistrationCancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "v1IF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-primary' : true}},[_vm._t("header")],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v6Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__("GB0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934c02d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__("GUrv");
function injectStyle (ssrContext) {
  __webpack_require__("2V5g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934c02d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vAM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tabs"},[_c('div',{staticClass:"d-none d-md-block dm-lg-block dm-xl-block"},[_c('nav',{staticClass:"nav nav-pills row"},_vm._l((_vm.names),function(name){return _c('div',{key:name,staticClass:"nav-item col",class:{active: name === _vm.currentActive},on:{"click":function($event){_vm.setActive(name)}}},[_c('span',{staticClass:"nav-link"},[_c('h5',[_vm._v(_vm._s(name))])])])})),_vm._v(" "),_c('div',{staticClass:"track"},[_c('div',{class:_vm.underscoreClass})])]),_vm._v(" "),_c('vuestic-simple-select',{staticClass:"d-flex d-md-none d-lg-none d-xl-none simple-select",attrs:{"options":_vm.names},model:{value:(_vm.currentActive),callback:function ($$v) {_vm.currentActive=$$v},expression:"currentActive"}}),_vm._v(" "),_c('div',{staticClass:"tab-content"},_vm._l((_vm.names),function(name){return _c('div',{key:name,staticClass:"tab-pane",class:{active: name === _vm.currentActive}},[_vm._t(name)],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vBhc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vE+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-simple-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    options: Array,
    value: {},
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'simple-select'
    },
    color: {
      type: String,
      default: "default"
    }
  },
  mounted: function mounted() {
    this.updateDisplayValue(this.value);
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    isOptionSelected: function isOptionSelected(option) {
      return this.value === option;
    },
    selectOption: function selectOption(option) {
      this.updateDisplayValue(option);
      this.$emit('input', option);
    },
    updateDisplayValue: function updateDisplayValue(val) {
      this.displayValue = this.optionKey ? val[this.optionKey] : val;
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "vW50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("TqEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_595a976e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("pWYb");
function injectStyle (ssrContext) {
  __webpack_require__("YHTk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-595a976e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_595a976e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "vY2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-secondary' : _vm.final && _vm.final_pdf,
    'vuestic-collapse__header__button btn btn-secondary-danger' : _vm.final && !_vm.final_pdf }},[_vm._t("header"),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"#f7cc36"}},[_vm._v(_vm._s(' | ')+_vm._s(_vm.pacijent))]),_vm._v(" "),_c('div',{staticClass:"col-md-7 pull-right",staticStyle:{"margin-right":"20px"}},[_c('span',[(_vm.final_pdf)?_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#f7cc36"},attrs:{"id":"nalaz"}}):_vm._e(),_vm._v(" "),(!_vm.final_pdf)?_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#e34a4a"},attrs:{"id":"nalaz"}}):_vm._e()])])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vaSp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionControlAparati_vue__ = __webpack_require__("yY/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c726d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionControlAparati_vue__ = __webpack_require__("CiJ5");
function injectStyle (ssrContext) {
  __webpack_require__("K64j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionControlAparati_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c726d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionControlAparati_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vgUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-patient",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {

      purpose: "",
      purposes: ["Putovanje", "Procjena zdravstvenog stanja", "Kontakt sa zaraženom osobom"],
      analysis: "",
      analyses: ["", "COVID-19 RT-PCR Test", "COVID-19 Antigen Test"],

      izdavanje: "",
      izdavanja: ["DANAS", "SUTRA"],

      pacijentbezsimptoma: false,
      povišenatjelesnatemperatura: false,
      suhikašalj: false,
      umor: false,
      bolovi: false,
      grlobolja: false,
      proljev: false,
      konjunktivitis: false,
      glavobolja: false,
      gubitakosjetaokusailimirisa: false,
      osipilipromjenabojeprstijunarukamailinogama: false,
      otežanodisanjeiligubitakdaha: false,
      bolilipritisakuprsima: false,
      gubitaksposobnostigovorailikretanja: false,

      symptoms: {
        pacijentbezsimptoma: false,
        povišenatjelesnatemperatura: false,
        suhikašalj: false,
        umor: false,
        bolovi: false,
        grlobolja: false,
        proljev: false,
        konjunktivitis: false,
        glavobolja: false,
        gubitakosjetaokusailimirisa: false,
        osipilipromjenabojeprstijunarukamailinogama: false,
        otežanodisanjeiligubitakdaha: false,
        bolilipritisakuprsima: false,
        gubitaksposobnostigovorailikretanja: false
      },
      passport: "",
      language: [],
      languages: ["Bosanski jezik", "Engleski jezik", "Njemački jezik"],

      show: false,
      duration: 500,

      izbor: "datr",
      jmbg: "",
      dateofb: "",
      datumrodjenja: "",
      godiste: "",

      ime: "",
      prezime: "",
      spol: "",
      spolovi: ["MUŠKI", "ŽENSKI"],
      chosenAdress: "",
      cities: [],
      telefon: "",
      email: "",

      invalid: true,

      isLoading: false,
      fullPage: true,

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("/postavke/sajtovi/" + this.$store.state.site, {
      token: this.$store.state.token
    }).then(function (res) {
      if (res.data.sajt.mjesta != undefined) {
        res.data.sajt.mjesta.forEach(function (element) {
          if (element != "") {
            _this.cities.push(element);
          }
        });
      }
    }).then(function (res) {
      _this.cities.sort(function (a, b) {
        return a.toLowerCase() == b.toLowerCase() ? 0 : +(a.toLowerCase() > b.toLowerCase()) || -1;
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {

    purpose: function purpose() {

      if (this.purpose === "Putovanje" || this.purpose === "Procjena zdravstvenog stanja" || this.purpose === "Kontakt sa zaraženom osobom" || this.purpose != "") {

        this.pacijentbezsimptoma = true;

        if (this.pacijentbezsimptoma === true) {
          this.povišenatjelesnatemperatura = false;
          this.suhikašalj = false;
          this.umor = false;
          this.bolovi = false;
          this.grlobolja = false;
          this.proljev = false;
          this.konjunktivitis = false;
          this.glavobolja = false;
          this.gubitakosjetaokusailimirisa = false;
          this.osipilipromjenabojeprstijunarukamailinogama = false;
          this.otežanodisanjeiligubitakdaha = false;
          this.bolilipritisakuprsima = false;
          this.gubitaksposobnostigovorailikretanja = false;
        }
      } else {
        this.pacijentbezsimptoma = false;
        this.povišenatjelesnatemperatura = false;
        this.suhikašalj = false;
        this.umor = false;
        this.bolovi = false;
        this.grlobolja = false;
        this.proljev = false;
        this.konjunktivitis = false;
        this.glavobolja = false;
        this.gubitakosjetaokusailimirisa = false;
        this.osipilipromjenabojeprstijunarukamailinogama = false;
        this.otežanodisanjeiligubitakdaha = false;
        this.bolilipritisakuprsima = false;
        this.gubitaksposobnostigovorailikretanja = false;
      }
    },

    pacijentbezsimptoma: function pacijentbezsimptoma() {
      if (this.pacijentbezsimptoma === true) {
        this.povišenatjelesnatemperatura = false;
        this.suhikašalj = false;
        this.umor = false;
        this.bolovi = false;
        this.grlobolja = false;
        this.proljev = false;
        this.konjunktivitis = false;
        this.glavobolja = false;
        this.gubitakosjetaokusailimirisa = false;
        this.osipilipromjenabojeprstijunarukamailinogama = false;
        this.otežanodisanjeiligubitakdaha = false;
        this.bolilipritisakuprsima = false;
        this.gubitaksposobnostigovorailikretanja = false;
      }
    },

    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    },

    izbor: function izbor() {
      switch (this.izbor) {
        case "jmbg":
          this.jmbg = "";
          this.dateofb = "";
          this.datumrodjenja = "";
          this.godiste = "";

          break;

        case "datr":
          this.jmbg = "";
          this.dateofb = "";
          this.datumrodjenja = "";
          this.godiste = "";

          break;

        case "god":
          this.jmbg = "";
          this.dateofb = "";
          this.datumrodjenja = "";
          this.godiste = "";

          break;

        case "nodata":
          this.jmbg = "0101920" + this.getRandomInt(100000, 999999);
          this.dateofb = "";
          this.datumrodjenja = "";
          this.godiste = "";

          break;
      }
    },

    jmbg: function jmbg() {
      if (this.jmbg.length < 13) {} else if (this.jmbg.length === 13) {
        if (this.izbor === "jmbg" && !this.validateDate(this.jmbg)) {} else if (this.izbor === "datr" && !this.validateDate(this.jmbg)) {} else if (this.izbor === "god" && !this.validateYear(this.godiste)) {} else if (this.izbor === "nodata" && !this.validateJMBG(this.jmbg)) {} else {
          if (true) {
            __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("/uzorci/patient", {
              jmbg: this.jmbg,
              token: this.$store.state.token,
              site: this.$store.state.site
            }).then(function (res) {});
          }
        }
      } else if (this.jmbg.length > 13) {
        this.jmbg = this.jmbg.slice(0, 13);
      }
    },

    datumrodjenja: function datumrodjenja() {
      this.datumrodjenja = this.datumrodjenja.replace(" ", "");
      this.datumrodjenja = this.datumrodjenja.replace("..", ".");

      if (!isNaN(this.datumrodjenja.substring(0, 2)) && this.datumrodjenja.length === 2) {
        this.datumrodjenja = this.datumrodjenja.substring(0, 2).replace(".", "") + ".";
      }

      if (this.datumrodjenja.length === 4 && !isNaN(this.datumrodjenja.slice(2, 4) && this.datumrodjenja.includes("."))) {
        var dot1 = this.datumrodjenja.split(".");
        var ldot1 = dot1.length;

        if (ldot1 > 1) {
          var qdate1 = this.datumrodjenja.split(".");

          if (qdate1[1].length === 2) {
            this.datumrodjenja = qdate1[0] + "." + qdate1[1] + ".";
          }
        }
      }

      if (this.datumrodjenja.length === 5 && !isNaN(this.datumrodjenja.slice(3, 5) && this.datumrodjenja.includes("."))) {
        var dot2 = this.datumrodjenja.split(".");
        var ldot2 = dot2.length;

        if (ldot2 > 1) {
          var qdate2 = this.datumrodjenja.split(".");

          if (qdate2[1].length === 2) {
            this.datumrodjenja = qdate2[0] + "." + qdate2[1] + ".";
          }
        }
      }

      if (this.datumrodjenjadatumrodjenja != "") {
        var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\.](0?[1-9]|1[012])[\.]\d{4}$/;
      }

      if (this.datumrodjenja.match(dateformat)) {
        var opera1 = this.datumrodjenja.split(".");
        var lopera1 = opera1.length;

        if (lopera1 > 1) {
          var pdate = this.datumrodjenja.split(".");
        }

        if (pdate[0].length === 1) {
          pdate[0] = "0" + pdate[0];
        }

        if (pdate[1].length === 1) {
          pdate[1] = "0" + pdate[1];
        }

        this.dateofb = pdate[0] + pdate[1] + pdate[2];

        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);

        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            this.dateofb = "";
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            this.dateofb = "";
            return false;
          }
          if (lyear == true && dd > 29) {
            this.dateofb = "";
            return false;
          }
        }
        if (this.validateYear(yy)) {
          this.dateofb = "";
          return false;
        }
      } else {
        this.dateofb = "";
        return false;
      }
    },

    dateofb: function dateofb() {
      if (this.dateofb.length < 8) {} else if (this.dateofb.length == 8) {
        if (!this.validateDateOfBirth(this.dateofb)) {
          this.invalid = true;
        } else {
          this.jmbg = this.dateofb.slice(0, 4) + this.dateofb.slice(5, 8) + this.getRandomInt(100000, 999999);

          this.invalid = false;
        }
      } else if (this.dateofb.length > 8) {
        this.dateofb = this.dateofb.slice(0, 8);
      }
    },
    godiste: function godiste() {
      if (this.godiste.length < 4) {} else if (this.godiste.length == 4) {
        if (this.validateYear(this.godiste)) {
          this.jmbg = "0000" + this.godiste.slice(1, 4) + this.getRandomInt(100000, 999999);
        } else {}
      } else if (this.godiste.length > 4) {
        this.godiste = this.godiste.slice(0, 4);
      }
    },

    invalid: function invalid() {}
  },

  methods: {
    Test: function Test() {
      var _this2 = this;

      this.isLoading = true;

      setTimeout(function () {
        _this2.isLoading = false;
      }, 2000);
    },
    onCancel: function onCancel() {},
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.Save();
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    getRandomInt: function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);

      return Math.floor(Math.random() * (max - min)) + min;
    },
    validateJMBG: function validateJMBG(jmbg) {
      return (/^\d{4}[9,0]{1}\d{8}$/.test(String(jmbg)) || /^\d{4}[9,0]{1}\d{7}[P]{1}$/.test(String(jmbg))
      );
    },
    validateYear: function validateYear(year) {
      var text = /^[0-9]+$/;
      if (year != 0) {
        if (year != "" && !text.test(year)) {
          return false;
        }

        if (year.length != 4) {
          return false;
        }
        var current_year = new Date().getFullYear();
        if (year < 1921 || year > current_year) {
          return false;
        }
        return true;
      }
    },
    validateDate: function validateDate(inputText) {
      if (inputText[4] === "9") {
        var control = "1";
      } else if (inputText[4] === "0") {
        var control = "2";
      } else {
        return false;
      }

      if (!this.validateYear(control + inputText[4] + inputText[5] + inputText[6])) {
        return false;
      }

      inputText = inputText[0] + inputText[1] + "-" + inputText[2] + inputText[3] + "-" + control + inputText[4] + inputText[5] + inputText[6];

      var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

      if (inputText.match(dateformat)) {
        var opera1 = inputText.split("/");
        var opera2 = inputText.split("-");
        var lopera1 = opera1.length;
        var lopera2 = opera2.length;

        if (lopera1 > 1) {
          var pdate = inputText.split("/");
        } else if (lopera2 > 1) {
          var pdate = inputText.split("-");
        }
        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);

        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            return false;
          }
          if (lyear == true && dd > 29) {
            return false;
          }
        }
      } else {
        return false;
      }
      return true;
    },
    validateDateOfBirth: function validateDateOfBirth(inputText) {
      var godiste = inputText[4] + inputText[5] + inputText[6] + inputText[7];
      inputText = inputText[0] + inputText[1] + "-" + inputText[2] + inputText[3] + "-" + godiste;

      if (!this.validateYear(godiste)) {
        return false;
      }

      var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

      if (inputText.match(dateformat)) {
        var opera1 = inputText.split("/");
        var opera2 = inputText.split("-");
        var lopera1 = opera1.length;
        var lopera2 = opera2.length;

        if (lopera1 > 1) {
          var pdate = inputText.split("/");
        } else if (lopera2 > 1) {
          var pdate = inputText.split("-");
        }
        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);

        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            return false;
          }
          if (lyear == true && dd > 29) {
            return false;
          }
        }
      } else {
        return false;
      }
      return true;
    },
    Save: function Save() {
      var _this3 = this;

      if (this.ime.trim() === "" || this.prezime.trim() === "" || this.spol.trim() === "" || this.purpose.trim() === "") {
        this.toastText = "Unesite obavezna polja.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else {

        if (this.chosenAdress.trim() === "") {
          this.chosenAdress = "";
        }
        if (this.telefon.trim() === "") {
          this.telefon = "";
        }
        if (this.email.trim() === "") {
          this.email = "";
        }

        if (this.validateJMBG(this.jmbg)) {
          var jmbgPost = this.jmbg;
          var item = true;

          __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("pacijenti/unos/find", {
            jmbg: this.jmbg,
            token: this.$store.state.token,
            site: this.$store.state.site
          }).then(function (res) {}).then(function (res) {
            if (item) {

              _this3.isLoading = true;

              _this3.symptoms = {
                pacijentbezsimptoma: _this3.pacijentbezsimptoma,
                povišenatjelesnatemperatura: _this3.povišenatjelesnatemperatura,
                suhikašalj: _this3.suhikašalj,
                umor: _this3.umor,
                bolovi: _this3.bolovi,
                grlobolja: _this3.grlobolja,
                proljev: _this3.proljev,
                konjunktivitis: _this3.konjunktivitis,
                glavobolja: _this3.glavobolja,
                gubitakosjetaokusailimirisa: _this3.gubitakosjetaokusailimirisa,
                osipilipromjenabojeprstijunarukamailinogama: _this3.osipilipromjenabojeprstijunarukamailinogama,
                otežanodisanjeiligubitakdaha: _this3.otežanodisanjeiligubitakdaha,
                bolilipritisakuprsima: _this3.bolilipritisakuprsima,
                gubitaksposobnostigovorailikretanja: _this3.gubitaksposobnostigovorailikretanja
              };

              __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("pacijenti/unos/save", {

                jmbg: jmbgPost,
                ime: _this3.ime.toUpperCase().trim(),
                prezime: _this3.prezime.toUpperCase().trim(),

                spol: _this3.spol.trim(),
                duhan: "",
                dijabetes: "",

                purpose: _this3.purpose,
                analysis: _this3.analysis,
                izdavanje: _this3.izdavanje,
                referenca: (new Date().getTime() - new Date().getTimezoneOffset() * 60000).toString(),

                symptoms: _this3.symptoms,
                note: "",
                passport: _this3.passport.trim(),
                language: _this3.language,
                telefon: _this3.telefon.trim(),
                email: _this3.email.trim(),
                adresa: _this3.chosenAdress.trim(),
                site: _this3.$store.state.site,
                token: _this3.$store.state.token
              }).then(function (res) {

                if (res.data.success === false) {

                  _this3.isLoading = false;

                  _this3.toastText = "Greška prilikom upisa!";
                  _this3.toastIcon = "fa-remove";
                  _this3.toastPosition = "top-right";
                  _this3.className = "vuestic-toast-danger";

                  _this3.showToast(_this3.toastText, {
                    icon: _this3.toastIcon,
                    position: _this3.toastPosition,
                    duration: _this3.toastDuration,
                    fullWidth: _this3.isToastFullWidth,
                    className: _this3.className
                  });
                } else {

                  _this3.isLoading = false;

                  _this3.jmbg = "";
                  _this3.dateofb = "";
                  _this3.datumrodjenja = "";
                  _this3.godiste = "";
                  _this3.ime = "";
                  _this3.purpose = "";
                  _this3.analysis = "";
                  _this3.izdavanje = "";
                  _this3.prezime = "";
                  _this3.spol = "";
                  _this3.chosenAdress = "";
                  _this3.telefon = "";
                  _this3.email = "";
                  _this3.invalid = true;

                  _this3.show = false;

                  window.removeEventListener("keyup", _this3.listenKeyUp);

                  __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/samples/" + res.data.pacijent._id);
                }
              });
            }
          });
        } else {}
      }
    }
  }
});

/***/ }),

/***/ "vopJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pixel-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"pixel-spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w+sz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNTYgNTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2IDU2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJzdmdfMSI+CiAgIDxwYXRoIGlkPSJzdmdfMiIgZmlsbD0iI0U5RTlFMCIgZD0ibTM2Ljk4NSwwbC0yOS4wMjIsMGMtMC44MDgsMCAtMS40NjMsMC42NTUgLTEuNDYzLDEuOTI2bDAsNTMuMDc0YzAsMC4zNDUgMC42NTUsMSAxLjQ2MywxbDQwLjA3NCwwYzAuODA4LDAgMS40NjMsLTAuNjU1IDEuNDYzLC0xbDAsLTQyLjAyMmMwLC0wLjY5NiAtMC4wOTMsLTAuOTIgLTAuMjU3LC0xLjA4NWwtMTEuNjM2LC0xMS42MzZjLTAuMTY1LC0wLjE2NCAtMC4zODksLTAuMjU3IC0wLjYyMiwtMC4yNTd6Ii8+CiAgIDxwb2x5Z29uIGlkPSJzdmdfMyIgZmlsbD0iI0Q5RDdDQSIgcG9pbnRzPSIzNy41LDAuMTUxIDM3LjUsMTIgNDkuMzQ5LDEyICAiLz4KICAgPHBhdGggaWQ9InN2Z180IiBmaWxsPSIjOTVBNUE1IiBkPSJtNDguMDM3LDU2bC00MC4wNzQsMGMtMC44MDgsMCAtMS40NjMsLTAuNjU1IC0xLjQ2MywtMS40NjNsMCwtMTUuNTM3bDQzLDBsMCwxNS41MzdjMCwwLjgwOCAtMC42NTUsMS40NjMgLTEuNDYzLDEuNDYzeiIvPgogICA8cGF0aCBpZD0ic3ZnXzkiIGZpbGw9IiNDOEJEQjgiIGQ9Im0xOC41LDEzbC02LDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsNiwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18xMCIgZmlsbD0iI0M4QkRCOCIgZD0ibTIxLjUsMThsLTksMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw5LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogICA8cGF0aCBpZD0ic3ZnXzExIiBmaWxsPSIjQzhCREI4IiBkPSJtMjUuNSwxOGMtMC4yNiwwIC0wLjUyMSwtMC4xMSAtMC43MSwtMC4yOWMtMC4xODEsLTAuMTkgLTAuMjksLTAuNDQgLTAuMjksLTAuNzFzMC4xMDksLTAuNTIgMC4zLC0wLjcxYzAuMzYsLTAuMzcgMS4wNCwtMC4zNyAxLjQxLDBjMC4xOCwwLjE5IDAuMjksMC40NSAwLjI5LDAuNzFjMCwwLjI2IC0wLjExLDAuNTIgLTAuMjksMC43MWMtMC4xOSwwLjE4IC0wLjQ1LDAuMjkgLTAuNzEsMC4yOXoiLz4KICAgPHBhdGggaWQ9InN2Z18xMiIgZmlsbD0iI0M4QkRCOCIgZD0ibTM3LjUsMThsLTgsMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw4LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogICA8cGF0aCBpZD0ic3ZnXzEzIiBmaWxsPSIjQzhCREI4IiBkPSJtMTIuNSwzM2MtMC4yNiwwIC0wLjUyMSwtMC4xMSAtMC43MSwtMC4yOWMtMC4xODEsLTAuMTkgLTAuMjksLTAuNDUgLTAuMjksLTAuNzFjMCwtMC4yNiAwLjEwOSwtMC41MiAwLjI5LC0wLjcxYzAuMzcsLTAuMzcgMS4wNSwtMC4zNyAxLjQyLDAuMDFjMC4xOCwwLjE4IDAuMjksMC40NCAwLjI5LDAuN2MwLDAuMjYgLTAuMTEsMC41MiAtMC4yOSwwLjcxYy0wLjE5LDAuMTggLTAuNDUsMC4yOSAtMC43MSwwLjI5eiIvPgogICA8cGF0aCBpZD0ic3ZnXzE0IiBmaWxsPSIjQzhCREI4IiBkPSJtMjQuNSwzM2wtOCwwYy0wLjU1MywwIC0xLC0wLjQ0OCAtMSwtMXMwLjQ0NywtMSAxLC0xbDgsMGMwLjU1MywwIDEsMC40NDggMSwxcy0wLjQ0NywxIC0xLDF6Ii8+CiAgIDxwYXRoIGlkPSJzdmdfMTUiIGZpbGw9IiNDOEJEQjgiIGQ9Im00My41LDE4bC0yLDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsMiwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18xNiIgZmlsbD0iI0M4QkRCOCIgZD0ibTM0LjUsMjNsLTIyLDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsMjIsMGMwLjU1MywwIDEsMC40NDggMSwxcy0wLjQ0NywxIC0xLDF6Ii8+CiAgIDxwYXRoIGlkPSJzdmdfMTciIGZpbGw9IiNDOEJEQjgiIGQ9Im00My41LDIzbC02LDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsNiwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18xOCIgZmlsbD0iI0M4QkRCOCIgZD0ibTE2LjUsMjhsLTQsMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw0LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogICA8cGF0aCBpZD0ic3ZnXzE5IiBmaWxsPSIjQzhCREI4IiBkPSJtMzAuNSwyOGwtMTAsMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWwxMCwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18yMCIgZmlsbD0iI0M4QkRCOCIgZD0ibTQzLjUsMjhsLTksMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw5LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogIDwvZz4KICA8ZyBpZD0ic3ZnXzIxIi8+CiAgPGcgaWQ9InN2Z18yMiIvPgogIDxnIGlkPSJzdmdfMjMiLz4KICA8ZyBpZD0ic3ZnXzI0Ii8+CiAgPGcgaWQ9InN2Z18yNSIvPgogIDxnIGlkPSJzdmdfMjYiLz4KICA8ZyBpZD0ic3ZnXzI3Ii8+CiAgPGcgaWQ9InN2Z18yOCIvPgogIDxnIGlkPSJzdmdfMjkiLz4KICA8ZyBpZD0ic3ZnXzMwIi8+CiAgPGcgaWQ9InN2Z18zMSIvPgogIDxnIGlkPSJzdmdfMzIiLz4KICA8ZyBpZD0ic3ZnXzMzIi8+CiAgPGcgaWQ9InN2Z18zNCIvPgogIDxnIGlkPSJzdmdfMzUiLz4KPC9zdmc+"

/***/ }),

/***/ "w4Y+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-radio-button form-check radio abc-radio",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checkState},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[(!_vm.checkState)?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.checkState)?_c('span',{staticClass:"abc-label-text",staticStyle:{"color":"#e34a4a"}},[_c('strong',[_vm._v(_vm._s(_vm.label))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w4zc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w5Sz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProduktTable_vue__ = __webpack_require__("iCmj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fbe8ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProduktTable_vue__ = __webpack_require__("TQVY");
function injectStyle (ssrContext) {
  __webpack_require__("XuBg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9fbe8ac2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProduktTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fbe8ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProduktTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "w6AR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseObrada_vue__ = __webpack_require__("5JAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6615cfb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseObrada_vue__ = __webpack_require__("ub2Y");
function injectStyle (ssrContext) {
  __webpack_require__("eudO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6615cfb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseObrada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6615cfb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseObrada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "w6B+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wChe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.access != undefined),expression:"$store.state.access != undefined"}],staticClass:"navbar app-navbar navbar-toggleable-md"},[_c('div',{staticClass:"navbar-brand-container d-flex align-items-center justify-content-start"},[_c('atom-spinner',{attrs:{"animation-duration":1000,"size":40,"color":'#4ae387'}}),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"row navbar-container"},[_c('div',{staticClass:"menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col"},[(_vm.sidebarOpened && _vm.$store.state.default_route != '/registracija')?_c('a',{staticClass:"menu-icon i-menu-expanded",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebar(false)}}}):_vm._e(),_vm._v(" "),(!_vm.sidebarOpened && _vm.$store.state.default_route != '/registracija')?_c('a',{staticClass:"menu-icon i-menu-collapsed",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebar(true)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offset-lg-6"}),_vm._v(" "),_c('site-dropdown',{staticStyle:{"flex-direction":"row","display":"flex","white-space":"nowrap"}}),_vm._v(" "),_c('div',{staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.default_route != '/registracija'),expression:"$store.state.default_route != '/registracija'"}],staticClass:"i-nav-messages"})])]),_vm._v(" "),_c('div',{staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.default_route != '/registracija'),expression:"$store.state.default_route != '/registracija'"}],staticClass:"i-nav-notification"})])]),_vm._v(" "),(_vm.$store.state.default_route != '/registracija')?_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}},[(_vm.reload)?_c('span',{ref:"close",staticClass:"avatar-container"},[_c('img',{attrs:{"src":_vm.userImage + '?' + new Date().getTime()}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu last"},[_c('div',{staticClass:"dropdown-menu-content"},[_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.Password}},[_vm._v(_vm._s("Promjena šifre"))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.Logout}},[_vm._v(_vm._s(" Odjava"))])])])])]):_vm._e(),_vm._v(" "),(_vm.$store.state.default_route === '/registracija')?_c('div',{staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[(_vm.reload)?_c('span',{ref:"close",staticClass:"avatar-container"},[_c('img',{attrs:{"src":_vm.userImage + '?' + new Date().getTime()}})]):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('change-password',{ref:"staticChangePassword",attrs:{"show":_vm.show,"cancelText":"ODUSTANI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"color":"#4ae387"}},[_c('i',{staticClass:"fa fa-key",staticStyle:{"transform":"rotate(90deg)"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#acb5be"}},[_vm._v(_vm._s(" | Promjena šifre"))])])]),_vm._v(" "),_c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('fieldset',[_c('div',{staticClass:"form-group with-icon-right"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.staraSifra),expression:"staraSifra"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"oldPassword","title":" ","type":"password","name":"oldPassword","required":""},domProps:{"value":(_vm.staraSifra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.staraSifra=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-right"}},[_vm._v(_vm._s("Unesite trenutnu šifru"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-right"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.novaSifra),expression:"novaSifra"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"newPassword","title":" ","type":"password","name":"newPassword","required":""},domProps:{"value":(_vm.novaSifra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.novaSifra=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-right"}},[_vm._v(_vm._s("Unesite novu šifru"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-right"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.potvrdaSifra),expression:"potvrdaSifra"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"confirmPassword","title":" ","type":"password","name":"confirmPassword","required":""},domProps:{"value":(_vm.potvrdaSifra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.potvrdaSifra=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-right"}},[_vm._v(_vm._s("Potvrdite novu šifru"))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"})])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand"},[_c('i',{staticClass:"i-vuestic"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wIAY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");


var _name$props$data$moun;




/* harmony default export */ __webpack_exports__["a"] = (_name$props$data$moun = {
  name: "anaassay-ref-single",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("AnaAssayHide", function () {
      _this.show = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$off("AnaAssayHide");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$moun, "methods", {
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("AnaAssayEditRefSingle");
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("AnaAssayCancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  }
}), _name$props$data$moun);

/***/ }),

/***/ "wdYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-sm dropdown-toggle",attrs:{"id":"itemsPerPageBtn","type":"button","data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+" per page\n    "),_c('i',{staticClass:"ion-ios-arrow-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value)+" per page")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "we+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserModal_vue__ = __webpack_require__("uzyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7fdc29e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserModal_vue__ = __webpack_require__("NNU/");
function injectStyle (ssrContext) {
  __webpack_require__("8Z44")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7fdc29e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7fdc29e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wf/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__ = __webpack_require__("AWw/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f298088_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__ = __webpack_require__("1S2w");
function injectStyle (ssrContext) {
  __webpack_require__("E8+3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f298088"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f298088_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "whi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor__ = __webpack_require__("kLCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_medium_editor__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-medium-editor',

  props: {
    editorOptions: {
      type: Object,
      default: function _default() {
        return {
          buttonLabels: 'fontawesome',
          autoLink: true,
          toolbar: {
            buttons: ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3']
          }
        };
      }
    }
  },

  data: function data() {
    return {
      editor: null
    };
  },
  mounted: function mounted() {
    this.initEditor();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyEditor();
  },


  methods: {
    initEditor: function initEditor() {
      this.editor = new __WEBPACK_IMPORTED_MODULE_0_medium_editor___default.a(this.$el, this.editorOptions);
      this.$emit('initialized', this.editor);
    },
    destroyEditor: function destroyEditor() {
      this.editor.destroy();
    }
  }
});

/***/ }),

/***/ "wt/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wvaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.cancelClass,attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),(!_vm.okText.includes('!SHOW'))?_c('button',{class:_vm.okClass,attrs:{"type":"button"},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wyO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue__ = __webpack_require__("+N1L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_575b5228_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MessageList_vue__ = __webpack_require__("Jhtm");
function injectStyle (ssrContext) {
  __webpack_require__("jZUa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-575b5228"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_575b5228_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "x+xx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chat"},[_c('div',{directives:[{name:"sticky-scroll",rawName:"v-sticky-scroll",value:({animate: true, duration: 500}),expression:"{animate: true, duration: 500}"}],staticClass:"chat-body",style:({'height': _vm.height})},_vm._l((_vm.value),function(message){return _c('div',{staticClass:"chat-message",class:{'yours': message.yours, 'alien': !message.yours}},[_vm._v("\n       "+_vm._s(message.text)+"\n    ")])})),_vm._v(" "),_c('div',{staticClass:"chat-controls"},[_c('fieldset',[_c('div',{staticClass:"form-group form-group-w-btn"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputMessage),expression:"inputMessage"}],attrs:{"required":"","title":""},domProps:{"value":(_vm.inputMessage)},on:{"keypress":function($event){_vm.keyHandler($event)},"input":function($event){if($event.target.composing){ return; }_vm.inputMessage=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Your message")]),_c('i',{staticClass:"bar"})]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.sendMessage()}}},[_vm._v("Send")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x2GM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var browser = __webpack_require__("bJUU");
var erd = __webpack_require__("uk2G")();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-scrollbar',
  props: {
    speed: {
      default: 20
    }
  },
  methods: {
    calcSize: function calcSize() {
      this.isDown = this.isUp = false;
      this.maxHeight = parseFloat(this.wrapper.offsetHeight, 10);
      this.contentHeight = parseFloat(this.content.offsetHeight, 10);
      this.trackHeight = parseFloat(this.track.offsetHeight, 10);

      if (this.maxHeight / this.contentHeight * this.trackHeight < 10) {
        this.thumb.style.height = 10 + 'px';
      } else {
        this.thumb.style.height = this.maxHeight / this.contentHeight * this.trackHeight + 'px';
      }

      if (this.maxHeight / this.contentHeight < 1) {
        this.thumb.classList.add('active');
      } else {
        this.thumb.classList.remove('active');
      }
    },
    calcThumb: function calcThumb() {
      var currentMT = this.content.style.marginTop === '' ? 0 : parseInt(this.content.style.marginTop, 10);
      this.thumb.style.top = -currentMT / this.contentHeight * this.trackHeight + 'px';
    },
    onContentResize: function onContentResize() {
      var _this = this;

      var prevHeight = this.contentHeight;
      this.calcSize();
      this.calcThumb();

      this.content.style.transition = 'margin-top .3s linear';
      this.thumb.style.transition = 'top .3s linear';
      var handler = function handler(e) {
        if (e.propertyName === 'margin-top') {
          _this.content.style.transition = '';
          _this.calcSize();
          _this.calcThumb();
          _this.content.removeEventListener('transitionend', handler);
          _this.thumb.style.transition = '';
        }
      };
      this.content.addEventListener('transitionend', handler);

      this.setVertical(this.contentHeight - prevHeight);
    },
    startDrag: function startDrag(e) {
      this.isDragging = true;
      this.prevTouch = e.touches[0];
    },
    onDrag: function onDrag(e) {
      if (this.isDragging) {
        e.preventDefault();
        var touch = e.touches[0];
        var delta = this.prevTouch.clientY - touch.clientY;
        this.setVertical(delta);
        this.prevTouch = touch;
      }
    },
    stopDrag: function stopDrag(e) {
      this.isDragging = false;
    },
    scroll: function scroll(e) {
      var delta = e.deltaY * 0.01 * this.speed;
      if (browser.name === 'firefox') {
        delta *= 10;
      }
      this.setVertical(delta);
      e.preventDefault();
    },
    setVertical: function setVertical(delta) {
      if (this.isDown && delta > 0 || this.isUp && delta < 0 || this.contentHeight <= this.maxHeight) {
        return;
      }
      var currentMT = this.content.style.marginTop === '' ? 0 : parseFloat(this.content.style.marginTop, 10);
      var nextMT = 0;
      if (this.maxHeight - (currentMT - delta) > this.contentHeight && delta > 0) {
        nextMT = this.maxHeight - this.contentHeight;
        this.isDown = true;
      } else {
        this.isDown = false;
        if (currentMT - delta > 0) {
          this.isUp = true;
          nextMT = 0;
        } else {
          nextMT = currentMT - delta;
          this.isUp = false;
        }
      }

      this.content.style.marginTop = nextMT + 'px';
      this.calcThumb();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.track = this.$refs.track;
    this.thumb = this.$refs.thumb;
    this.content = this.$refs.scrollbarContent;
    this.wrapper = this.$refs.scrollbarWrapper;
    this.calcSize();
    this.calcThumb();
    erd.listenTo(this.content, function () {
      _this2.calcSize();
      _this2.calcThumb();
    });
  },
  beforeDestroy: function beforeDestroy() {
    erd.removeAllListeners(this.content);
  },
  data: function data() {
    return {
      wrapper: undefined,
      maxHeight: undefined,
      thumb: undefined,
      track: undefined,
      trackHeight: undefined,
      content: undefined,
      contentHeight: undefined,
      isDown: false,
      isUp: true,
      prevTouch: {},
      isDragging: false
    };
  }
});

/***/ }),

/***/ "x50E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"input-icon-left","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter()},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Pretraga'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x5pt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMail_vue__ = __webpack_require__("IwWG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b067bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMail_vue__ = __webpack_require__("7S+w");
function injectStyle (ssrContext) {
  __webpack_require__("nD4s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b067bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xAIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalFind_vue__ = __webpack_require__("ItL+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d186bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalFind_vue__ = __webpack_require__("VV2c");
function injectStyle (ssrContext) {
  __webpack_require__("oRYY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalFind_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d186bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalFind_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xAVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionPatientInfo_vue__ = __webpack_require__("szBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17685f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionPatientInfo_vue__ = __webpack_require__("ZWOL");
function injectStyle (ssrContext) {
  __webpack_require__("577M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionPatientInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17685f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionPatientInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xIst":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_layout_Layout__ = __webpack_require__("i/0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_AuthLayout__ = __webpack_require__("v6Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("VAWW");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    var _this = this;

    return {
      logout: setTimeout(function () {
        _this.$store.dispatch("setLogoutTimer", 0);
      }, this.$store.state.idleTime),
      messageStr: ""
    };
  },
  onIdle: function onIdle() {
    this.messageStr = "Sign out";
    this.$store.dispatch("logout");
  },
  onActive: function onActive() {
    this.messageStr = "Active";
    this.sessionExpiration();
  },

  components: {
    VuesticPreLoader: __WEBPACK_IMPORTED_MODULE_2__components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"],
    AuthLayout: __WEBPACK_IMPORTED_MODULE_1__components_layout_AuthLayout__["default"],
    Layout: __WEBPACK_IMPORTED_MODULE_0_components_layout_Layout__["default"]
  },
  computed: {
    isAuth: function isAuth() {
      return this.$route.path.match("auth");
    }
  },
  beforeCreate: function beforeCreate() {
    if (this.$store.state.access === undefined) {
      this.$store.dispatch("logout");
    } else {
      if (this.$store.state.access.level === null) {
        this.$store.dispatch("logout");
      }
    }
  },
  created: function created() {
    this.$store.dispatch("autoLogin");
  },
  mounted: function mounted() {
    window.addEventListener("beforeunload", function () {}, false);
  },

  methods: {
    clearLocalStorage: function clearLocalStorage(event) {
      if (event.currentTarget.performance.navigation.type == 0 || event.currentTarget.performance.navigation.type == 1) {
        this.$store.dispatch("logout");
      }
    },
    sessionExpiration: function sessionExpiration(event) {
      var _this2 = this;

      if (this.$store.state.idleTime != null) {
        if (!this.$route.path.includes("auth")) {
          localStorage.setItem("idleTime", this.$store.state.idleTime);
          clearTimeout(this.logout);
          this.logout = setTimeout(function () {
            _this2.$store.dispatch("setLogoutTimer", 0);
          }, this.$store.state.idleTime);
        }
      }
    }
  }
});

/***/ }),

/***/ "xM51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"fl-input-icon-left","title":" ","name":"fl-input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"fl-input-icon-left"}},[_vm._v(_vm._s('Pretraga'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xO5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-pre-loader"},[_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xU+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__ = __webpack_require__("gVv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");


var _name$components$prop;





/* harmony default export */ __webpack_exports__["a"] = (_name$components$prop = {
  name: "json-edit-postavke",
  components: {
    vueJsonEditor: __WEBPACK_IMPORTED_MODULE_1_vue_json_editor__["a" /* default */]
  },
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      jsonData: {},
      tab: "",
      obj: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$on("JsonEditPostavke", function (data) {
      _this.jsonData = data.element;
      _this.obj = data.element;
      _this.tab = data.tab;
      _this.show = true;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$off("JsonEditPostavke");
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "beforeDestroy", function beforeDestroy() {
  document.body.className = document.body.className.replace(/\s?modal-open/, "");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "watch", {
  show: function show(value) {
    if (value) {
      document.body.className += " modal-open";
    } else {
      window.setTimeout(function () {
        document.body.className = document.body.className.replace(/\s?modal-open/, "");
      }, this.duration);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "methods", {
  onJsonChange: function onJsonChange(value) {
    this.obj = value;
  },
  listenKeyUp: function listenKeyUp(event) {
    if (event.key === "Escape") {
      this.cancel();
    }
  },
  ok: function ok() {
    this.$emit("ok");
    this.EditJson();
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  cancel: function cancel() {
    this.$emit("cancel");
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  clickMask: function clickMask() {
    if (!this.force) {
      this.cancel();
    }
  },
  open: function open() {
    this.show = true;
    window.addEventListener("keyup", this.listenKeyUp);
  },
  close: function close() {
    this.show = false;
    window.removeEventListener("keyup", this.listenKeyUp);
  },
  EditJson: function EditJson() {
    var _this2 = this;

    switch (this.tab) {
      case "Sites":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/sites/edit", {
          element: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("SitesRefresh");
            _this2.show = false;
          }
        });

        break;
      case "Korisnici":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/users/edit", {
          element: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("KorisniciRefresh");
            _this2.show = false;
          }
        });
        break;

      case "Lokacije":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/lokacije/edit", {
          lokacija: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Doktori":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/doktori/edit", {
          doktor: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Mjesta":
        break;

      case "Sekcije":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/sekcije/edit", {
          sekcija: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Grupe testova":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/grupe/edit", {
          grupa: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Referentne grupe":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/refgr/edit", {
          ref_grupa: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Mjerne jedinice":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/jedinice/edit", {
          jedinica: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Tehnologije analizatora":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/tehnologije/edit", {
          tehnologija: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Tipovi analizatora":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/tipovi/edit", {
          tip: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Uzorci":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/uzorak/def/edit", {
          uzorak: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      case "Tipovi uzoraka":
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["C" /* http */].post("postavke/uzorak/edit", {
          uzorak: this.obj,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Refresh", _this2.tab);
            _this2.show = false;
          }
        });
        break;

      default:
        break;
    }
  }
}), _name$components$prop);

/***/ }),

/***/ "xYBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEvaluationSingle_vue__ = __webpack_require__("Tub+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d843c28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEvaluationSingle_vue__ = __webpack_require__("Xn7x");
function injectStyle (ssrContext) {
  __webpack_require__("bPBZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEvaluationSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d843c28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEvaluationSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xc3+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAMAAACxiD++AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUxpcf///////////////////////////////////////////////////////3EAnbYAAAAOdFJOUwADZ66SoQjEhnS7/gsNGQL7+wAAAKtJREFUKM+F01sOhCAQRNESFV/I/pc70Og0YJfyJbmHhBAbGGYHstw8IPV4EOGOmERYIhGpxyUAJxHSz/xlC+1FxE64qB1yj1ZID7oXsel+63ovnj2JXUXue+hvrcLugL+EdG+9XBG8X+Kl34J3YM1g/egvIvdx5EK691RIz78YEXdnQrst6m6JqemXmNo+D/WJNAyVePZWWL0WdlfB+l+UAQQReaAc65DB/wGsZgzLN0IQWAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "xdBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xemH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__ = __webpack_require__("Wc+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f375396c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiMessage_vue__ = __webpack_require__("kIqA");
function injectStyle (ssrContext) {
  __webpack_require__("uoTt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f375396c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f375396c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xlMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons && _vm.$store.state.access.level > 0)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s('ZATVORI'))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.$store.state.access.level < 1)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.$store.state.access.level < 1)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText)+"  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xlst":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xq+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMail_vue__ = __webpack_require__("bvuI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe9a8898_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMail_vue__ = __webpack_require__("KlZb");
function injectStyle (ssrContext) {
  __webpack_require__("JfBS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe9a8898_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xqvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xrBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__ = __webpack_require__("ZoX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3bc619a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__ = __webpack_require__("vopJ");
function injectStyle (ssrContext) {
  __webpack_require__("g+VA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bc619a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3bc619a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "xuN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"40px"}},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.window.width > 800)?_c('div',{staticClass:"col-md-4",staticStyle:{"position":"relative","right":"0px","top":"17.5px"}},[_c('vuestic-simple-select',{ref:"multiparamSelect",attrs:{"label":"Parametar","name":"multiparam","required":true,"title":" ","options":_vm.multiparam_izbornik},model:{value:(_vm.parametar),callback:function ($$v) {_vm.parametar=$$v},expression:"parametar"}})],1):_vm._e(),_vm._v(" "),(_vm.table)?_c('i',{staticClass:"vuestic-icon vuestic-icon-tables",staticStyle:{"color":"#4ae387"},on:{"click":function($event){$event.preventDefault();_vm.ShowTable()}}}):_vm._e(),_vm._v(" "),(!_vm.table)?_c('i',{staticClass:"vuestic-icon vuestic-icon-graph",staticStyle:{"color":"#4ae387"},on:{"click":function($event){$event.preventDefault();_vm.ShowGraph()}}}):_vm._e()])],2),_vm._v(" "),(_vm.window.width < 800)?_c('div',{staticClass:"modal-header",staticStyle:{"position":"relative","right":"0px","top":"20px"}},[_c('vuestic-simple-select',{ref:"multiparamSelect",attrs:{"label":"Parametar","name":"multiparam","required":true,"title":" ","options":_vm.multiparam_izbornik},model:{value:(_vm.parametar),callback:function ($$v) {_vm.parametar=$$v},expression:"parametar"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xvgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y/Ac":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y/NP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadContainer_vue__ = __webpack_require__("K+Y1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de70599a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadContainer_vue__ = __webpack_require__("dC4T");
function injectStyle (ssrContext) {
  __webpack_require__("13SH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de70599a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "y1+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue__ = __webpack_require__("YirT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bf8f21ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Launcher_vue__ = __webpack_require__("pVgP");
function injectStyle (ssrContext) {
  __webpack_require__("pd+I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf8f21ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bf8f21ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Launcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "y3Nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-alert',
  computed: {
    alertClass: function alertClass() {
      return {
        'with-close': this.withCloseBtn,
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info'
      };
    }
  },
  props: {
    type: {
      type: String,
      default: 'success'
    },
    withCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hidden: false
    };
  },

  methods: {
    hide: function hide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "y4Rm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("tMml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5543384d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("uu9r");
function injectStyle (ssrContext) {
  __webpack_require__("oMxY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5543384d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5543384d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yDzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "animatedValue", "min", "max", "color", "size", "isActive"],
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "yMvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__ = __webpack_require__("khvK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__ = __webpack_require__("I8H2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_local_data__ = __webpack_require__("0Hy0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__ = __webpack_require__("CHUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__("NHnr");












var originalData = __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-data-table-labassays",
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__["default"]
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      tableData: __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */],
      perPage: 10,
      colorClasses: {},
      moreParams: { access: this.$store.state.access.level },
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__["a" /* default */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$on("LabAssayRefresh", function () {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$off("LabAssayRefresh");
  },

  methods: {
    Double: function Double(args) {},

    Akcija: function Akcija(args) {
      var niz = args[0];

      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "multi") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("LabAssayMulti", niz[0]);
        } else if (niz[1].name === "uredi") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("LabAssayUredi", niz[0]);
        } else if (niz[1].name === "akcija") {
          __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("LabAssayAkcija", niz[0]);
        } else if (niz[1].name === "icon") {
          if (this.$store.state.access.level < 1) {
            __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$emit("EditJSON", niz[0].labassay);
          }
        } else {}
      }
    },

    onFilterSet: function onFilterSet(filterText) {
      var _this2 = this;

      if (this.apiMode) {
        this.moreParams = {
          filter: filterText,
          access: this.$store.state.access.level
        };
      } else {
        var txt = new RegExp(filterText, "i");
        this.tableData.data = originalData.filter(function (item) {
          return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
        });
      }
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this3 = this;

      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "yY/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-accordion-control-aparati',
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "yZ5d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yfOW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ykC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('items-per-page',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"options":_vm.itemsPerPage,"defaultPerPage":_vm.perPage},on:{"items-per-page":_vm.onItemsPerPage}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:pagination-data":_vm.onPaginationData,"vuetable:cell-clicked":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.Akcija([args]);
}}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yrBt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yuAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-social-news',
  props: ['news', 'url']
});

/***/ }),

/***/ "z0Ym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadContainer_vue__ = __webpack_require__("5i1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773350da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadContainer_vue__ = __webpack_require__("kNVQ");
function injectStyle (ssrContext) {
  __webpack_require__("gpVI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFileUploadContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773350da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFileUploadContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "z3ES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dateRange",
  data: function data() {
    return {
      datepicker: {
        range: null
      },
      config: {
        mode: "range",
        minDate: new Date("2020-11-01"),
        maxDate: new Date(),
        altFormat: "F j, Y",
        dateFormat: "d.m.Y",
        locale: {
          firstDayOfWeek: 1,
          rangeSeparator: " do ",
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("setDateRange", function (data) {
      _this.datepicker.range = [];
      _this.datepicker.range = [data.from[1], data.to[1]];
    });

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("selectedItemsPerPage", function () {
      _this.datepicker = {
        range: null
      };
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("setDateRange");
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("selectedItemsPerPage");

    this.$emit("date-range", "", "");
  },


  methods: {
    doSomethingOnChangeDateRange: function doSomethingOnChangeDateRange(input) {
      if (input[1] != undefined) {
        var godina1 = input[0].toString().substring(11, 15);
        var mjesec1 = input[0].toString().substring(4, 7);
        var dan1 = input[0].toString().substring(8, 10);

        var godina2 = input[1].toString().substring(11, 15);
        var mjesec2 = input[1].toString().substring(4, 7);
        var dan2 = input[1].toString().substring(8, 10);

        switch (mjesec1) {
          case "Jan":
            mjesec1 = "01";
            break;
          case "Feb":
            mjesec1 = "02";
            break;
          case "Mar":
            mjesec1 = "03";
            break;
          case "Apr":
            mjesec1 = "04";
            break;
          case "May":
            mjesec1 = "05";
            break;
          case "Jun":
            mjesec1 = "06";
            break;
          case "Jul":
            mjesec1 = "07";
            break;
          case "Aug":
            mjesec1 = "08";
            break;
          case "Sep":
            mjesec1 = "09";
            break;
          case "Oct":
            mjesec1 = "10";
            break;
          case "Nov":
            mjesec1 = "11";
            break;
          case "Dec":
            mjesec1 = "12";
            break;
          default:
            mjesec1 = "00";
            break;
        }

        switch (mjesec2) {
          case "Jan":
            mjesec2 = "01";
            break;
          case "Feb":
            mjesec2 = "02";
            break;
          case "Mar":
            mjesec2 = "03";
            break;
          case "Apr":
            mjesec2 = "04";
            break;
          case "May":
            mjesec2 = "05";
            break;
          case "Jun":
            mjesec2 = "06";
            break;
          case "Jul":
            mjesec2 = "07";
            break;
          case "Aug":
            mjesec2 = "08";
            break;
          case "Sep":
            mjesec2 = "09";
            break;
          case "Oct":
            mjesec2 = "10";
            break;
          case "Nov":
            mjesec2 = "11";
            break;
          case "Dec":
            mjesec2 = "12";
            break;
          default:
            mjesec2 = "00";
            break;
        }

        var datum1 = godina1 + "-" + mjesec1 + "-" + dan1;
        var datum2 = godina2 + "-" + mjesec2 + "-" + dan2;

        this.$emit("date-range", datum1, datum2);

        var data = {
          od: datum1,
          do: datum2,
          from: input[0],
          to: input[1]
        };

        __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("DateRange", data);
      }
    }
  }
});

/***/ }),

/***/ "zCHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-typing-indicator",style:(_vm.messageColors)},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zHPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload-undo"},[_vm._v("\n  "+_vm._s(_vm.$t('fileUpload.fileDeleted'))+"\n  "),_c('button',{staticClass:"btn-text btn-text--primary",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('recover')}}},[_vm._v(_vm._s(_vm.$t('fileUpload.undo'))+"?")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zHy1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zNF9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload",class:("vuestic-file-upload-" + _vm.type)},[(_vm.type === 'list')?_vm._l((_vm.filesList),function(file,index){return _c('vuestic-file-upload-list-item',{key:file.name,attrs:{"file":file},on:{"remove":function($event){_vm.$emit('remove', index)}}})}):_vm._e(),_vm._v(" "),(_vm.type === 'gallery')?[_c('div',{staticClass:"row"},_vm._l((_vm.filesList),function(file,index){return _c('div',{key:file.name,staticClass:"flex xl2 lg3 sm4"},[_c('vuestic-file-upload-gallery-item',{attrs:{"file":file},on:{"remove":function($event){_vm.$emit('remove', index)}}})],1)}))]:_vm._e(),_vm._v(" "),(_vm.type === 'single' && _vm.filesList.length)?_c('vuestic-file-upload-single-item',{attrs:{"file":_vm.filesList[_vm.filesList.length - 1]},on:{"remove":function($event){_vm.$emit('remove-single')}}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zPX7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zdfR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zds3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zkRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ }),

/***/ "zlyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 200,
    'per_page': 50,
    'current_page': 1,
    'last_page': 4,
    'next_page_url': 'https://vuetable.ratiw.net/api/users?per_page=50&page=2',
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }, {
    'id': 2,
    'name': 'Mr. Enid Von PhD',
    'nickname': 'alias',
    'email': 'pollich.cecilia@example.com',
    'birthdate': '1990-09-18 00:00:00',
    'gender': 'M',
    'salary': '35978.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 2,
      'user_id': 2,
      'line1': '59732 Iva Spur Suite 468\nEast Hortenseton, VA 70087',
      'line2': 'Cayman Islands',
      'zipcode': '41967',
      'mobile': '1-913-407-7558x503',
      'fax': '(388)906-8002'
    }
  }, {
    'id': 3,
    'name': 'Colton Koch',
    'nickname': 'id',
    'email': 'little.myrna@example.net',
    'birthdate': '1968-10-29 00:00:00',
    'gender': 'F',
    'salary': '26278.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 3,
      'user_id': 3,
      'line1': '539 Conn Locks Suite 801\nTobinfort, IL 37047-5508',
      'line2': 'Antigua and Barbuda',
      'zipcode': '51722-4502',
      'mobile': '557.845.1830x844',
      'fax': '1-831-304-7444x73027'
    }
  }, {
    'id': 4,
    'name': 'Gregory Vandervort',
    'nickname': 'vel',
    'email': 'dock47@example.org',
    'birthdate': '1989-12-12 00:00:00',
    'gender': 'M',
    'salary': '25537.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 4,
      'user_id': 4,
      'line1': '916 Rosemary Forge\nKreigerton, MT 24207',
      'line2': 'Uganda',
      'zipcode': '67639-6707',
      'mobile': '766.431.9121',
      'fax': '(154)336-3674x08451'
    }
  }, {
    'id': 5,
    'name': 'Miss Rahsaan Heaney IV',
    'nickname': 'qui',
    'email': 'ugrady@example.org',
    'birthdate': '1995-11-27 00:00:00',
    'gender': 'F',
    'salary': '49003.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 21,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 5,
      'user_id': 5,
      'line1': '91792 Kertzmann Prairie Apt. 376\nLake Nakiaville, DC 98189',
      'line2': 'Jamaica',
      'zipcode': '10101-1450',
      'mobile': '07507519787',
      'fax': '+24(9)5120507985'
    }
  }, {
    'id': 6,
    'name': 'Ms. Crystel Zemlak IV',
    'nickname': 'reiciendis',
    'email': 'amari.rau@example.com',
    'birthdate': '1968-09-12 00:00:00',
    'gender': 'F',
    'salary': '12383.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 6,
      'user_id': 6,
      'line1': '97650 Scot Haven Apt. 160\nCrawfordmouth, ME 39767-7003',
      'line2': 'Finland',
      'zipcode': '88917',
      'mobile': '1-851-069-9234x9566',
      'fax': '(048)445-4691x33356'
    }
  }, {
    'id': 7,
    'name': 'Nona McDermott',
    'nickname': 'quaerat',
    'email': 'adrien.baumbach@example.org',
    'birthdate': '1985-10-01 00:00:00',
    'gender': 'F',
    'salary': '18512.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 31,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 7,
      'user_id': 7,
      'line1': '4332 Alvina Radial\nPort Darbyville, IA 63357',
      'line2': 'Barbados',
      'zipcode': '79679',
      'mobile': '(736)058-1324',
      'fax': '002.234.8466x49816'
    }
  }, {
    'id': 8,
    'name': 'Miss Genoveva Murazik V',
    'nickname': 'rerum',
    'email': 'ohettinger@example.net',
    'birthdate': '1988-10-19 00:00:00',
    'gender': 'F',
    'salary': '31209.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 28,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 8,
      'user_id': 8,
      'line1': '96418 Ritchie Mall Apt. 215\nLake Jessyca, VT 65970-8256',
      'line2': 'Netherlands Antilles',
      'zipcode': '94649-6628',
      'mobile': '472.825.7183',
      'fax': '400-507-7463'
    }
  }, {
    'id': 9,
    'name': 'Beulah Huels',
    'nickname': 'non',
    'email': 'stefan99@example.com',
    'birthdate': '1963-09-04 00:00:00',
    'gender': 'F',
    'salary': '36920.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 9,
      'user_id': 9,
      'line1': '18890 Carroll Lakes Suite 355\nUptonchester, UT 94878-0739',
      'line2': 'Hong Kong',
      'zipcode': '91204',
      'mobile': '831.652.0832',
      'fax': '(688)788-8947'
    }
  }, {
    'id': 10,
    'name': 'Zoe Klein',
    'nickname': 'ex',
    'email': 'ejacobson@example.org',
    'birthdate': '1990-04-19 00:00:00',
    'gender': 'F',
    'salary': '35616.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 10,
      'user_id': 10,
      'line1': '6721 Nader Summit\nLake Alana, MS 84476',
      'line2': 'Reunion',
      'zipcode': '77124-1459',
      'mobile': '1-129-438-6148',
      'fax': '(913)441-3846'
    }
  }, {
    'id': 11,
    'name': 'Vickie Kiehn',
    'nickname': 'assumenda',
    'email': 'ayost@example.com',
    'birthdate': '1988-04-20 00:00:00',
    'gender': 'F',
    'salary': '30790.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 11,
      'user_id': 11,
      'line1': '763 McCullough Ville\nNew Thomasstad, HI 64611',
      'line2': 'Oman',
      'zipcode': '00642',
      'mobile': '1-296-172-2126x275',
      'fax': '(559)203-8694'
    }
  }, {
    'id': 12,
    'name': 'Elwyn Herzog',
    'nickname': 'praesentium',
    'email': 'ckassulke@example.net',
    'birthdate': '1990-01-22 00:00:00',
    'gender': 'M',
    'salary': '35785.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 12,
      'user_id': 12,
      'line1': '65641 Baron Spurs Suite 988\nNorth Ivah, IA 92235',
      'line2': 'Nepal',
      'zipcode': '90316-7411',
      'mobile': '064.482.9432x9456',
      'fax': '05936098280'
    }
  }, {
    'id': 13,
    'name': 'Selena Hettinger',
    'nickname': 'et',
    'email': 'bashirian.hyman@example.net',
    'birthdate': '1981-10-01 00:00:00',
    'gender': 'F',
    'salary': '31836.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 13,
      'user_id': 13,
      'line1': '42272 Stoltenberg Points Suite 006\nLake Dustin, NH 70213-2043',
      'line2': 'Uganda',
      'zipcode': '60996-2982',
      'mobile': '(508)122-5892',
      'fax': '356-682-2023x07379'
    }
  }, {
    'id': 14,
    'name': 'Edwin Beier',
    'nickname': 'eos',
    'email': 'janis71@example.org',
    'birthdate': '1978-10-13 00:00:00',
    'gender': 'M',
    'salary': '11902.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 14,
      'user_id': 14,
      'line1': '362 Trantow Loop Apt. 150\nLake Marafurt, DC 27926',
      'line2': 'Gabon',
      'zipcode': '36943-1099',
      'mobile': '033-386-4972x26066',
      'fax': '1-363-037-1381'
    }
  }, {
    'id': 15,
    'name': 'Lexi Braun MD',
    'nickname': 'autem',
    'email': 'dusty74@example.net',
    'birthdate': '1971-12-07 00:00:00',
    'gender': 'F',
    'salary': '11927.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 45,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 15,
      'user_id': 15,
      'line1': '6737 Schimmel Crossing Suite 720\nShieldsberg, AK 44558',
      'line2': 'Tanzania',
      'zipcode': '75615',
      'mobile': '338.920.3112',
      'fax': '(467)912-6668'
    }
  }, {
    'id': 16,
    'name': 'Jovany Spencer',
    'nickname': 'fugit',
    'email': 'gbogisich@example.org',
    'birthdate': '1974-04-23 00:00:00',
    'gender': 'F',
    'salary': '44686.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 16,
      'user_id': 16,
      'line1': '97237 Emory Mission\nWelchview, DE 65827-8746',
      'line2': 'Turkmenistan',
      'zipcode': '17948',
      'mobile': '(163)991-1609x963',
      'fax': '104.893.7648'
    }
  }, {
    'id': 17,
    'name': 'Prof. Maci Anderson DVM',
    'nickname': 'dolorem',
    'email': 'btorp@example.com',
    'birthdate': '1988-03-30 00:00:00',
    'gender': 'M',
    'salary': '25055.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 17,
      'user_id': 17,
      'line1': '7584 Lucinda Mill\nNew Kaitlyn, WV 63380-4289',
      'line2': 'Gibraltar',
      'zipcode': '51150-2800',
      'mobile': '(977)115-7349',
      'fax': '652-788-4860x1180'
    }
  }, {
    'id': 18,
    'name': 'Joel Kulas MD',
    'nickname': 'sed',
    'email': 'phoebe.sauer@example.org',
    'birthdate': '1992-10-26 00:00:00',
    'gender': 'F',
    'salary': '11650.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 18,
      'user_id': 18,
      'line1': '992 Williamson Passage Apt. 910\nBradleyborough, MO 93100-9439',
      'line2': 'Cambodia',
      'zipcode': '20591-3066',
      'mobile': '+64(7)3402369877',
      'fax': '08960801902'
    }
  }, {
    'id': 19,
    'name': 'Mr. Dawson Greenholt',
    'nickname': 'nostrum',
    'email': 'asawayn@example.org',
    'birthdate': '1963-08-23 00:00:00',
    'gender': 'F',
    'salary': '46962.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 19,
      'user_id': 19,
      'line1': '8444 Abraham Isle\nEast Chaunceychester, HI 78625-4417',
      'line2': 'Qatar',
      'zipcode': '47870-8012',
      'mobile': '797-274-3187x45557',
      'fax': '(461)432-8205'
    }
  }, {
    'id': 20,
    'name': 'Prof. Lloyd Green',
    'nickname': 'velit',
    'email': 'laila.hintz@example.org',
    'birthdate': '1970-10-31 00:00:00',
    'gender': 'M',
    'salary': '12928.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 20,
      'user_id': 20,
      'line1': '89766 O\'Connell Falls\nSouth Kadenshire, NJ 78754-6650',
      'line2': 'Nigeria',
      'zipcode': '37859',
      'mobile': '1-457-536-1138',
      'fax': '+98(5)0101745942'
    }
  }, {
    'id': 21,
    'name': 'Shayna Morar',
    'nickname': 'rerum',
    'email': 'wfay@example.org',
    'birthdate': '1991-01-24 00:00:00',
    'gender': 'F',
    'salary': '22638.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 21,
      'user_id': 21,
      'line1': '6066 Weissnat Run Apt. 578\nMurazikmouth, SD 62877-3174',
      'line2': 'Brunei Darussalam',
      'zipcode': '69261',
      'mobile': '(487)423-0151x5127',
      'fax': '784-058-9197'
    }
  }, {
    'id': 22,
    'name': 'Krista Schulist',
    'nickname': 'qui',
    'email': 'gregoria.jakubowski@example.com',
    'birthdate': '1974-08-16 00:00:00',
    'gender': 'F',
    'salary': '49345.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 22,
      'user_id': 22,
      'line1': '331 Gerlach Course Suite 090\nKovacekchester, RI 18017',
      'line2': 'Sri Lanka',
      'zipcode': '37165',
      'mobile': '653-487-3061x91119',
      'fax': '370-709-1750'
    }
  }, {
    'id': 23,
    'name': 'Leone Lemke',
    'nickname': 'repellat',
    'email': 'ltorphy@example.com',
    'birthdate': '1975-06-27 00:00:00',
    'gender': 'M',
    'salary': '17560.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 23,
      'user_id': 23,
      'line1': '4371 Ward Village Suite 848\nLake Madalynton, IN 44643',
      'line2': 'Ukraine',
      'zipcode': '71848',
      'mobile': '174-502-0881x50649',
      'fax': '02683328099'
    }
  }, {
    'id': 24,
    'name': 'Dr. Willie Kemmer II',
    'nickname': 'quasi',
    'email': 'ivy51@example.net',
    'birthdate': '1987-04-06 00:00:00',
    'gender': 'F',
    'salary': '35370.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 30,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 24,
      'user_id': 24,
      'line1': '235 Hassie Mountain\nAnikaborough, ID 20678-4354',
      'line2': 'Thailand',
      'zipcode': '94264-9132',
      'mobile': '624.042.8382x12243',
      'fax': '274.716.7226x171'
    }
  }, {
    'id': 25,
    'name': 'Deonte Lebsack',
    'nickname': 'nesciunt',
    'email': 'alisa83@example.net',
    'birthdate': '1993-01-26 00:00:00',
    'gender': 'M',
    'salary': '32725.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 25,
      'user_id': 25,
      'line1': '793 Lakin Haven\nLake Citlalliborough, DE 85031-4862',
      'line2': 'Chad',
      'zipcode': '52396-8822',
      'mobile': '(950)170-8013',
      'fax': '119.675.5485x79062'
    }
  }, {
    'id': 26,
    'name': 'Prof. Shayne Nader',
    'nickname': 'voluptas',
    'email': 'bosco.shaina@example.net',
    'birthdate': '1993-10-26 00:00:00',
    'gender': 'F',
    'salary': '9844.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 23,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 26,
      'user_id': 26,
      'line1': '0330 Smith Mountains\nLorinetown, NY 96547-9723',
      'line2': 'Syrian Arab Republic',
      'zipcode': '85415',
      'mobile': '1-212-704-6685',
      'fax': '516-893-8515'
    }
  }, {
    'id': 27,
    'name': 'Prof. Kennith Kertzmann',
    'nickname': 'alias',
    'email': 'satterfield.jonathan@example.com',
    'birthdate': '1992-01-31 00:00:00',
    'gender': 'F',
    'salary': '41950.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 27,
      'user_id': 27,
      'line1': '901 Hauck Extensions\nKeaganborough, VA 47392',
      'line2': 'Comoros',
      'zipcode': '54147-7615',
      'mobile': '1-274-179-2031x915',
      'fax': '867-583-0812x6728'
    }
  }, {
    'id': 28,
    'name': 'Miss Meagan O\'Keefe',
    'nickname': 'corporis',
    'email': 'tracy.barrows@example.com',
    'birthdate': '1967-05-04 00:00:00',
    'gender': 'M',
    'salary': '41803.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 28,
      'user_id': 28,
      'line1': '29077 Avis Isle Apt. 208\nGrahamberg, MI 62485-6694',
      'line2': 'Cocos (Keeling) Islands',
      'zipcode': '56090-7671',
      'mobile': '(718)856-9319x55184',
      'fax': '(777)055-4685x56167'
    }
  }, {
    'id': 29,
    'name': 'Prof. Edward Pagac MD',
    'nickname': 'quia',
    'email': 'gerhard65@example.org',
    'birthdate': '1973-09-22 00:00:00',
    'gender': 'F',
    'salary': '22896.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 29,
      'user_id': 29,
      'line1': '697 Crona Mall\nPeteville, WA 54497',
      'line2': 'Saudi Arabia',
      'zipcode': '07560-8569',
      'mobile': '788-579-8208',
      'fax': '041-521-9215'
    }
  }, {
    'id': 30,
    'name': 'Samantha Weissnat',
    'nickname': 'est',
    'email': 'crystel66@example.net',
    'birthdate': '1974-07-11 00:00:00',
    'gender': 'M',
    'salary': '18805.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 30,
      'user_id': 30,
      'line1': '79984 Deckow Run\nEast Victoria, UT 33736',
      'line2': 'Lithuania',
      'zipcode': '95964-8864',
      'mobile': '681.200.3099',
      'fax': '(567)652-4322x61475'
    }
  }, {
    'id': 31,
    'name': 'Dr. Gilbert Ward',
    'nickname': 'dolorum',
    'email': 'sandrine06@example.net',
    'birthdate': '1984-08-22 00:00:00',
    'gender': 'F',
    'salary': '16644.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 32,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 31,
      'user_id': 31,
      'line1': '996 Schuppe Glen\nTurcottetown, ID 40821-7190',
      'line2': 'Thailand',
      'zipcode': '09965-7576',
      'mobile': '1-938-263-0257x47178',
      'fax': '1-997-727-3198x4363'
    }
  }, {
    'id': 32,
    'name': 'Mike West',
    'nickname': 'laudantium',
    'email': 'jborer@example.net',
    'birthdate': '1974-11-07 00:00:00',
    'gender': 'M',
    'salary': '35728.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 32,
      'user_id': 32,
      'line1': '69942 Leannon Glen\nEast Mathilde, IL 89584-5633',
      'line2': 'Afghanistan',
      'zipcode': '02041-8706',
      'mobile': '(506)349-9443x7244',
      'fax': '1-357-689-8479x3729'
    }
  }, {
    'id': 33,
    'name': 'Prof. Isabell Cruickshank I',
    'nickname': 'recusandae',
    'email': 'ondricka.lurline@example.org',
    'birthdate': '1982-06-15 00:00:00',
    'gender': 'F',
    'salary': '44574.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 33,
      'user_id': 33,
      'line1': '875 Logan Summit Suite 033\nJerodport, NY 45166',
      'line2': 'Kiribati',
      'zipcode': '64763',
      'mobile': '1-548-943-8405x460',
      'fax': '+88(4)9493664736'
    }
  }, {
    'id': 34,
    'name': 'Prof. Lonny Rath',
    'nickname': 'nihil',
    'email': 'rfeest@example.net',
    'birthdate': '1969-04-23 00:00:00',
    'gender': 'F',
    'salary': '19949.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 34,
      'user_id': 34,
      'line1': '43006 Gaylord Drives\nCummerataville, MA 14032-6378',
      'line2': 'Georgia',
      'zipcode': '88459',
      'mobile': '(877)526-6771',
      'fax': '(724)630-5418'
    }
  }, {
    'id': 35,
    'name': 'Santina Medhurst MD',
    'nickname': 'suscipit',
    'email': 'ila24@example.net',
    'birthdate': '1965-11-04 00:00:00',
    'gender': 'F',
    'salary': '36323.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 51,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 35,
      'user_id': 35,
      'line1': '47345 Imelda Mission Suite 257\nAllyshire, IA 85430-2783',
      'line2': 'Gambia',
      'zipcode': '26853',
      'mobile': '(441)229-8922',
      'fax': '(789)908-0620x15912'
    }
  }, {
    'id': 36,
    'name': 'Jeff Lehner',
    'nickname': 'quo',
    'email': 'jarred77@example.com',
    'birthdate': '1975-05-18 00:00:00',
    'gender': 'F',
    'salary': '48462.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 36,
      'user_id': 36,
      'line1': '49133 Tremaine Cape Suite 189\nQuitzonview, SC 07967-6920',
      'line2': 'Serbia',
      'zipcode': '96642',
      'mobile': '313.254.8635x06428',
      'fax': '194.681.7297x74202'
    }
  }, {
    'id': 37,
    'name': 'Samanta Pfeffer',
    'nickname': 'officia',
    'email': 'fgoyette@example.net',
    'birthdate': '1974-08-27 00:00:00',
    'gender': 'F',
    'salary': '19601.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 37,
      'user_id': 37,
      'line1': '1313 Verdie Square\nNorth Giovanna, MI 27962',
      'line2': 'Guyana',
      'zipcode': '77776',
      'mobile': '(321)705-8910',
      'fax': '(392)460-5663x665'
    }
  }, {
    'id': 38,
    'name': 'Ofelia Torp',
    'nickname': 'a',
    'email': 'ericka44@example.net',
    'birthdate': '1981-09-01 00:00:00',
    'gender': 'M',
    'salary': '33149.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 38,
      'user_id': 38,
      'line1': '45335 Albina View\nCharlottefort, AK 57789',
      'line2': 'Afghanistan',
      'zipcode': '54947-9310',
      'mobile': '09097085723',
      'fax': '1-567-446-3094'
    }
  }, {
    'id': 39,
    'name': 'Mrs. Margarete Raynor',
    'nickname': 'quia',
    'email': 'jlegros@example.net',
    'birthdate': '1977-03-12 00:00:00',
    'gender': 'M',
    'salary': '21951.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 40,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 39,
      'user_id': 39,
      'line1': '288 Hamill Knolls\nMaximoburgh, NC 50971',
      'line2': 'Zimbabwe',
      'zipcode': '00474',
      'mobile': '1-165-445-8956x699',
      'fax': '164-395-7526x1304'
    }
  }, {
    'id': 40,
    'name': 'Mr. Brant Howell V',
    'nickname': 'perspiciatis',
    'email': 'franecki.gerald@example.org',
    'birthdate': '1964-03-01 00:00:00',
    'gender': 'M',
    'salary': '41552.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 40,
      'user_id': 40,
      'line1': '3411 Deckow Crossing\nVernonport, MI 32272-8542',
      'line2': 'Bolivia',
      'zipcode': '00960',
      'mobile': '(998)729-9537',
      'fax': '(606)461-9736'
    }
  }, {
    'id': 41,
    'name': 'Reilly Ruecker DVM',
    'nickname': 'ad',
    'email': 'ldeckow@example.net',
    'birthdate': '1975-07-17 00:00:00',
    'gender': 'M',
    'salary': '22709.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 41,
      'user_id': 41,
      'line1': '39181 Runolfsson Pines Apt. 102\nCedrickchester, MD 73430-4755',
      'line2': 'Haiti',
      'zipcode': '08208-7956',
      'mobile': '625-483-9111x773',
      'fax': '196-367-9338'
    }
  }, {
    'id': 42,
    'name': 'Zachery McDermott',
    'nickname': 'molestiae',
    'email': 'gladyce84@example.com',
    'birthdate': '1992-04-17 00:00:00',
    'gender': 'F',
    'salary': '32354.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 42,
      'user_id': 42,
      'line1': '18735 Quigley Springs\nCarterview, NE 29126-7625',
      'line2': 'Chad',
      'zipcode': '61676-5075',
      'mobile': '172.676.4844x42744',
      'fax': '129.383.7365x233'
    }
  }, {
    'id': 43,
    'name': 'Heloise Kulas',
    'nickname': 'aut',
    'email': 'kessler.helen@example.net',
    'birthdate': '1962-12-11 00:00:00',
    'gender': 'M',
    'salary': '45086.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 54,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 43,
      'user_id': 43,
      'line1': '38208 Dolores Turnpike Apt. 887\nWintheiserton, FL 72054-2578',
      'line2': 'Lithuania',
      'zipcode': '51634-6449',
      'mobile': '1-161-626-3235x57765',
      'fax': '360-278-9045x9316'
    }
  }, {
    'id': 44,
    'name': 'Norma Dibbert',
    'nickname': 'amet',
    'email': 'eudora36@example.net',
    'birthdate': '1971-01-21 00:00:00',
    'gender': 'F',
    'salary': '15661.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 44,
      'user_id': 44,
      'line1': '15405 Haag Haven Suite 047\nBrakusland, WV 81778',
      'line2': 'British Virgin Islands',
      'zipcode': '56087-0885',
      'mobile': '08227730599',
      'fax': '1-079-566-2337x670'
    }
  }, {
    'id': 45,
    'name': 'Immanuel Auer',
    'nickname': 'quia',
    'email': 'halvorson.theodora@example.org',
    'birthdate': '1978-06-06 00:00:00',
    'gender': 'M',
    'salary': '15862.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 45,
      'user_id': 45,
      'line1': '59888 Dare Ridge\nSouth Annamaeton, CA 94659',
      'line2': 'Mexico',
      'zipcode': '56689-3824',
      'mobile': '523.579.8757x9825',
      'fax': '688.695.5156x073'
    }
  }, {
    'id': 46,
    'name': 'Lamont Borer',
    'nickname': 'expedita',
    'email': 'trantow.neoma@example.com',
    'birthdate': '1992-06-26 00:00:00',
    'gender': 'M',
    'salary': '12544.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 46,
      'user_id': 46,
      'line1': '974 Brannon Circle Suite 674\nSchroedermouth, NM 66911',
      'line2': 'Malawi',
      'zipcode': '74027',
      'mobile': '887.196.2530x875',
      'fax': '220.398.6969'
    }
  }, {
    'id': 47,
    'name': 'Brooke Purdy',
    'nickname': 'cupiditate',
    'email': 'bhermiston@example.net',
    'birthdate': '1966-11-19 00:00:00',
    'gender': 'M',
    'salary': '14457.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 47,
      'user_id': 47,
      'line1': '916 Durgan Harbor\nWest Tonyborough, MN 08368',
      'line2': 'Serbia',
      'zipcode': '25234',
      'mobile': '(821)777-8137x4048',
      'fax': '(398)917-7496x84537'
    }
  }, {
    'id': 48,
    'name': 'Dr. Leo Dach',
    'nickname': 'et',
    'email': 'camila.ward@example.com',
    'birthdate': '1968-01-11 00:00:00',
    'gender': 'F',
    'salary': '40278.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 49,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 48,
      'user_id': 48,
      'line1': '434 Dariana Terrace\nSouth Brettbury, NC 66080-2445',
      'line2': 'Latvia',
      'zipcode': '81749-2523',
      'mobile': '1-988-628-9566x4627',
      'fax': '916.932.2071x569'
    }
  }, {
    'id': 49,
    'name': 'Krystal Langosh',
    'nickname': 'voluptatum',
    'email': 'pacocha.yesenia@example.org',
    'birthdate': '1983-02-18 00:00:00',
    'gender': 'M',
    'salary': '9305.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 49,
      'user_id': 49,
      'line1': '012 Josiane Flats Suite 650\nKatelynntown, MD 70053',
      'line2': 'Rwanda',
      'zipcode': '75946-8166',
      'mobile': '(556)620-0323x81232',
      'fax': '1-466-040-3197x6274'
    }
  }, {
    'id': 50,
    'name': 'Florence Greenfelder',
    'nickname': 'odit',
    'email': 'kenyatta.oconnell@example.com',
    'birthdate': '1978-08-20 00:00:00',
    'gender': 'F',
    'salary': '36980.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 50,
      'user_id': 50,
      'line1': '295 Donna Plaza Apt. 186\nHintzview, GA 44706',
      'line2': 'Greenland',
      'zipcode': '03127',
      'mobile': '1-044-098-3635x9446',
      'fax': '1-753-472-6796'
    }
  }]
});

/***/ }),

/***/ "zrkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionObrada_vue__ = __webpack_require__("ROOH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c43479e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionObrada_vue__ = __webpack_require__("G+DE");
function injectStyle (ssrContext) {
  __webpack_require__("8VRF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionObrada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c43479e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionObrada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zt5/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_directives_StickyScroll__ = __webpack_require__("NS1P");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chat',
  directives: { StickyScroll: __WEBPACK_IMPORTED_MODULE_0_directives_StickyScroll__["a" /* default */] },
  props: {
    value: {
      type: Array,
      default: []
    },
    height: {
      default: '20rem'
    }
  },
  data: function data() {
    return {
      inputMessage: ''
    };
  },

  methods: {
    keyHandler: function keyHandler(event) {
      if (event.keyCode === 13) {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage() {
      if (this.inputMessage) {
        this.$emit('input', this.value.concat({
          text: this.inputMessage,
          yours: true
        }));
        this.inputMessage = '';
      }
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  }
});

/***/ }),

/***/ "zyGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload",class:{'vuestic-file-upload--dropzone': _vm.dropzone}},[_c('vuestic-file-upload-container',{attrs:{"type":_vm.type,"fileTypes":_vm.fileTypes,"dropzone":_vm.dropzone},on:{"upload":_vm.uploadFile}},[(_vm.files.length)?_c('vuestic-file-upload-list',{attrs:{"type":_vm.type,"files":_vm.files},on:{"remove":_vm.removeFile,"remove-single":_vm.removeSingleFile}}):_vm._e(),_vm._v(" "),_c('vuestic-modal',{ref:"mediumModal",attrs:{"no-buttons":true}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('fileUpload.modalTitle')))]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.$t('fileUpload.modalText'))+"\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f5740cb36da15174b165.js